// Board Exam - Medical Conditions and Systemic Diseases
// Complete file with all 9 topics and questions

export const questions = {
  "1. Cardiovascular Disease and Oral Health": [
    {
      id: 26100,
      question: "Cardiovascular disease is responsible for what percentage of all deaths worldwide?",
      options: [
        "22%",
        "27%",
        "32%",
        "37%"
      ],
      correct: "C"
    },
    {
      id: 26101,
      question: "Hypertensive cardiovascular disease is also termed:",
      options: [
        "Silent killer",
        "Hidden threat",
        "Quiet danger",
        "Secret illness"
      ],
      correct: "A"
    },
    {
      id: 26102,
      question: "Stage 1 hypertension is defined as systolic pressure:",
      options: [
        "≥120 to 129 mm Hg",
        "≥130 to 139 mm Hg",
        "≥140 to 149 mm Hg",
        "≥150 to 159 mm Hg"
      ],
      correct: "B"
    },
    {
      id: 26103,
      question: "Stage 1 hypertension is defined as diastolic pressure:",
      options: [
        "≥70 to 79 mm Hg",
        "≥80 to 89 mm Hg",
        "≥90 to 99 mm Hg",
        "≥100 to 109 mm Hg"
      ],
      correct: "B"
    },
    {
      id: 26104,
      question: "Stage 2 hypertension is defined as systolic pressure:",
      options: [
        "≥130 mm Hg",
        "≥135 mm Hg",
        "≥140 mm Hg",
        "≥145 mm Hg"
      ],
      correct: "C"
    },
    {
      id: 26105,
      question: "Stage 2 hypertension is defined as diastolic pressure:",
      options: [
        "≥80 mm Hg",
        "≥85 mm Hg",
        "≥90 mm Hg",
        "≥95 mm Hg"
      ],
      correct: "C"
    },
    {
      id: 26106,
      question: "Nearly what percentage of people with high blood pressure do not have it under control?",
      options: [
        "35.6%",
        "40.6%",
        "45.6%",
        "50.6%"
      ],
      correct: "C"
    },
    {
      id: 26107,
      question: "High blood pressure is a substantial single risk factor for:",
      options: [
        "Diabetes and kidney disease",
        "TIA and stroke",
        "Cancer and arthritis",
        "Liver and lung disease"
      ],
      correct: "B"
    },
    {
      id: 26108,
      question: "The most common type of hypertension is:",
      options: [
        "Secondary hypertension",
        "Malignant hypertension",
        "Primary (essential) hypertension",
        "Isolated systolic hypertension"
      ],
      correct: "C"
    },
    {
      id: 26109,
      question: "Primary hypertension is characterized by:",
      options: [
        "Known underlying cause",
        "No known cause",
        "Kidney disease origin",
        "Medication-induced"
      ],
      correct: "B"
    },
    {
      id: 26110,
      question: "Secondary hypertension results from:",
      options: [
        "Unknown factors",
        "Genetic predisposition only",
        "Existing disease of cardiovascular, renal, adrenal, or neurologic systems",
        "Dietary factors alone"
      ],
      correct: "C"
    },
    {
      id: 26111,
      question: "Early clinical signs and symptoms of hypertension include:",
      options: [
        "Chest pain and nausea",
        "Occipital headaches and vision changes",
        "Shortness of breath and cough",
        "Swelling and weight gain"
      ],
      correct: "B"
    },
    {
      id: 26112,
      question: "The goal of hypertension treatment is to reduce and maintain diastolic pressure at:",
      options: [
        "79 mm Hg or lower",
        "84 mm Hg or lower",
        "89 mm Hg or lower",
        "94 mm Hg or lower"
      ],
      correct: "C"
    },
    {
      id: 26113,
      question: "Diuretics used for hypertension work by:",
      options: [
        "Increasing blood vessel size",
        "Modifying nerve activity",
        "Promoting renal excretion of water and sodium",
        "Reducing heart rate"
      ],
      correct: "C"
    },
    {
      id: 26114,
      question: "Sympatholytic agents used for hypertension work by:",
      options: [
        "Promoting fluid excretion",
        "Modifying sympathetic nerve activity",
        "Dilating blood vessels",
        "Reducing cholesterol"
      ],
      correct: "B"
    },
    {
      id: 26115,
      question: "Vasodilators used for hypertension work by:",
      options: [
        "Removing excess fluid",
        "Slowing heart rate",
        "Increasing blood vessel size and facilitating blood flow",
        "Reducing sodium absorption"
      ],
      correct: "C"
    },
    {
      id: 26116,
      question: "The major cause of coronary heart disease is:",
      options: [
        "Viral infection",
        "Atherosclerosis",
        "Autoimmune disorder",
        "Genetic mutation"
      ],
      correct: "B"
    },
    {
      id: 26117,
      question: "Atherosclerosis is characterized by:",
      options: [
        "Widening of arterial lumen",
        "Increased blood flow volume",
        "Narrowing of lumen due to fatty deposits",
        "Thinning of arterial walls"
      ],
      correct: "C"
    },
    {
      id: 26118,
      question: "Males are how many times more likely to suffer from coronary heart disease than females up to age 40?",
      options: [
        "Two times",
        "Three times",
        "Four times",
        "Five times"
      ],
      correct: "C"
    },
    {
      id: 26119,
      question: "After age 40, the prevalence of coronary heart disease:",
      options: [
        "Increases in males only",
        "Remains higher in males",
        "Is the same in females and males",
        "Increases in females only"
      ],
      correct: "C"
    },
    {
      id: 26120,
      question: "C-reactive protein (CRP) levels are used to determine:",
      options: [
        "Blood sugar levels",
        "Systemic inflammation",
        "Kidney function",
        "Liver enzymes"
      ],
      correct: "B"
    },
    {
      id: 26121,
      question: "Elevated CRP levels are key markers of:",
      options: [
        "Diabetes",
        "Atherosclerosis",
        "Kidney disease",
        "Liver dysfunction"
      ],
      correct: "B"
    },
    {
      id: 26122,
      question: "Angina pectoris is characterized by:",
      options: [
        "Sharp stabbing pain in back",
        "Burning, squeezing, or crushing tightness in chest",
        "Tingling in fingers",
        "Numbness in legs"
      ],
      correct: "B"
    },
    {
      id: 26123,
      question: "Stable angina attacks follow:",
      options: [
        "Sleep or rest periods",
        "Meal consumption",
        "Physical exertion or emotional excitement",
        "Random unpredictable events"
      ],
      correct: "C"
    },
    {
      id: 26124,
      question: "Unstable angina may occur:",
      options: [
        "Only during exercise",
        "At rest or during sleep",
        "Only after meals",
        "Only in morning"
      ],
      correct: "B"
    },
    {
      id: 26125,
      question: "The drug of choice for angina pectoris is:",
      options: [
        "Aspirin",
        "Morphine",
        "Nitroglycerin",
        "Digitalis"
      ],
      correct: "C"
    },
    {
      id: 26126,
      question: "Nitroglycerin works by:",
      options: [
        "Reducing heart rate",
        "Increasing blood flow by expanding arteries",
        "Decreasing blood pressure",
        "Thinning the blood"
      ],
      correct: "B"
    },
    {
      id: 26127,
      question: "An overdose of nitroglycerin can cause:",
      options: [
        "Nausea",
        "Dizziness",
        "Headache",
        "Chest pain"
      ],
      correct: "C"
    },
    {
      id: 26128,
      question: "A myocardial infarction is also known as:",
      options: [
        "Angina pectoris",
        "Heart attack",
        "Stroke",
        "Arrhythmia"
      ],
      correct: "B"
    },
    {
      id: 26129,
      question: "An infarct is:",
      options: [
        "Blood clot in artery",
        "Enlarged heart muscle",
        "Area of tissue that undergoes necrosis",
        "Widened blood vessel"
      ],
      correct: "C"
    },
    {
      id: 26130,
      question: "MI pain usually persists for:",
      options: [
        "5 minutes or less",
        "1 to 2 hours",
        "12 or more hours",
        "24 to 48 hours"
      ],
      correct: "C"
    },
    {
      id: 26131,
      question: "Sudden cardiovascular death most commonly occurs during the first:",
      options: [
        "6 to 12 hours after symptom onset",
        "12 to 18 hours after symptom onset",
        "24 to 48 hours after symptom onset",
        "48 to 72 hours after symptom onset"
      ],
      correct: "C"
    },
    {
      id: 26132,
      question: "Most sudden cardiovascular deaths are caused by:",
      options: [
        "Stroke",
        "Ventricular fibrillation",
        "Atrial fibrillation",
        "Heart block"
      ],
      correct: "B"
    },
    {
      id: 26133,
      question: "Biological death results when oxygen delivery to the brain is inadequate for:",
      options: [
        "1 to 2 minutes",
        "2 to 3 minutes",
        "4 to 6 minutes",
        "8 to 10 minutes"
      ],
      correct: "C"
    },
    {
      id: 26134,
      question: "Dental hygiene care should be postponed if MI occurred within the past:",
      options: [
        "7 days",
        "14 days",
        "30 days",
        "60 days"
      ],
      correct: "C"
    },
    {
      id: 26135,
      question: "Digitalis works by:",
      options: [
        "Thinning the blood",
        "Increasing contractility of heart",
        "Dilating blood vessels",
        "Reducing blood pressure"
      ],
      correct: "B"
    },
    {
      id: 26136,
      question: "The most commonly prescribed digitalis drug is:",
      options: [
        "Warfarin",
        "Heparin",
        "Digoxin",
        "Aspirin"
      ],
      correct: "C"
    },
    {
      id: 26137,
      question: "Early signs of digitalis toxicity include:",
      options: [
        "Chest pain and sweating",
        "Anorexia, nausea, and vomiting",
        "Shortness of breath and cough",
        "Swelling and weight gain"
      ],
      correct: "B"
    },
    {
      id: 26138,
      question: "Bradycardia is defined as a pulse rate:",
      options: [
        "Less than 50 BPM",
        "Less than 60 BPM",
        "Less than 70 BPM",
        "Less than 80 BPM"
      ],
      correct: "B"
    },
    {
      id: 26139,
      question: "Tachycardia is defined as a heart rate:",
      options: [
        "Greater than 80 BPM",
        "Greater than 90 BPM",
        "Greater than 100 BPM",
        "Greater than 110 BPM"
      ],
      correct: "C"
    },
    {
      id: 26140,
      question: "Atrial fibrillation is characterized by:",
      options: [
        "Slow, regular contractions",
        "Rapid, uneven contractions in upper chambers",
        "Complete cessation of heartbeat",
        "Irregular contractions in lower chambers only"
      ],
      correct: "B"
    },
    {
      id: 26141,
      question: "Atrial fibrillation may contribute to:",
      options: [
        "Diabetes development",
        "Kidney failure",
        "Formation of thrombosis leading to stroke",
        "Liver dysfunction"
      ],
      correct: "C"
    },
    {
      id: 26142,
      question: "If five or more PVCs are detected during a 60-second pulse examination:",
      options: [
        "No action needed",
        "Recheck in 10 minutes",
        "Medical consultation recommended",
        "Emergency services activated immediately"
      ],
      correct: "C"
    },
    {
      id: 26143,
      question: "Ventricular fibrillation is characterized by:",
      options: [
        "Slow, regular rhythm",
        "Rapid and disordered with no rhythm",
        "Mildly irregular pattern",
        "Normal rate with skipped beats"
      ],
      correct: "B"
    },
    {
      id: 26144,
      question: "Without immediate treatment, ventricular fibrillation results in death within:",
      options: [
        "1 minute",
        "2 minutes",
        "4 minutes",
        "10 minutes"
      ],
      correct: "C"
    },
    {
      id: 26145,
      question: "A cardiac pacemaker is used to:",
      options: [
        "Thin the blood",
        "Control or maintain heart rate",
        "Reduce blood pressure",
        "Increase oxygen supply"
      ],
      correct: "B"
    },
    {
      id: 26146,
      question: "Newer pacemakers are:",
      options: [
        "Unshielded and sensitive to interference",
        "Bipolar and shielded to protect against interference",
        "External devices only",
        "Temporary solutions only"
      ],
      correct: "B"
    },
    {
      id: 26147,
      question: "An ICD (implantable cardioverter defibrillator) is useful in preventing:",
      options: [
        "Hypertension",
        "Sudden death in patients with ventricular arrhythmias",
        "Stroke",
        "Kidney failure"
      ],
      correct: "B"
    },
    {
      id: 26148,
      question: "Pharmacologic cardioversion involves:",
      options: [
        "Electrical shock to heart",
        "Medication to reinstate regular heartbeat",
        "Surgical intervention",
        "Pacemaker implantation"
      ],
      correct: "B"
    },
    {
      id: 26149,
      question: "Electrical cardioversion involves:",
      options: [
        "Medication administration",
        "Sending electrical shock to heart",
        "Lifestyle modifications",
        "Physical therapy"
      ],
      correct: "B"
    },
    {
      id: 26150,
      question: "Congestive heart failure is characterized by:",
      options: [
        "Increased cardiac output",
        "Diminished cardiac output or circulatory congestion",
        "Enhanced blood flow",
        "Improved heart function"
      ],
      correct: "B"
    },
    {
      id: 26151,
      question: "Left-sided heart failure results in:",
      options: [
        "Peripheral edema only",
        "Increased fluid in lungs causing dyspnea",
        "Cold hands and feet",
        "No respiratory symptoms"
      ],
      correct: "B"
    },
    {
      id: 26152,
      question: "Right-sided heart failure is associated with:",
      options: [
        "Lung congestion only",
        "Systemic venous congestion and peripheral edema",
        "Increased cardiac output",
        "Enhanced breathing"
      ],
      correct: "B"
    },
    {
      id: 26153,
      question: "Patients with left-sided CHF should be positioned:",
      options: [
        "Flat supine",
        "Upright to support breathing",
        "Trendelenburg",
        "Prone"
      ],
      correct: "B"
    },
    {
      id: 26154,
      question: "A ventricular septal defect allows oxygenated blood to flow from:",
      options: [
        "Right ventricle to left ventricle",
        "Left ventricle to right ventricle",
        "Right atrium to left atrium",
        "Left atrium to right atrium"
      ],
      correct: "B"
    },
    {
      id: 26155,
      question: "An atrial septal defect is a shunt between:",
      options: [
        "The ventricles",
        "The left and right atria",
        "The aorta and pulmonary artery",
        "The vena cava and atrium"
      ],
      correct: "B"
    },
    {
      id: 26156,
      question: "Patent ductus arteriosus is most common in:",
      options: [
        "Full-term births only",
        "Premature births",
        "Elderly adults",
        "Middle-aged adults"
      ],
      correct: "B"
    },
    {
      id: 26157,
      question: "Tetralogy of Fallot is composed of how many congenital abnormalities?",
      options: [
        "Two",
        "Three",
        "Four",
        "Five"
      ],
      correct: "C"
    },
    {
      id: 26158,
      question: "According to American Heart Association, prophylactic antibiotics are required for:",
      options: [
        "All heart murmurs",
        "Residual defects following repair of congenital heart defects",
        "All congenital heart defects",
        "Family history of heart disease"
      ],
      correct: "B"
    },
    {
      id: 26159,
      question: "Prophylactic antibiotics are required during the first how many months after surgery to correct congenital defects?",
      options: [
        "3 months",
        "6 months",
        "9 months",
        "12 months"
      ],
      correct: "B"
    },
    {
      id: 26160,
      question: "Mitral valve prolapse is characterized by:",
      options: [
        "Forward bulging of valve",
        "Backward flopping of mitral valve into left atrium",
        "Complete valve closure",
        "Valve stenosis only"
      ],
      correct: "B"
    },
    {
      id: 26161,
      question: "MVP is also known as:",
      options: [
        "\"Silent valve syndrome\"",
        "\"Floppy mitral valve syndrome\"",
        "\"Rigid valve disorder\"",
        "\"Stenotic valve disease\""
      ],
      correct: "B"
    },
    {
      id: 26162,
      question: "Valvular malfunction can occur by:",
      options: [
        "Stenosis only",
        "Regurgitation only",
        "Stenosis or regurgitation",
        "Neither stenosis nor regurgitation"
      ],
      correct: "C"
    },
    {
      id: 26163,
      question: "Stenosis refers to:",
      options: [
        "Complete valve closure",
        "Incomplete opening of valve",
        "Backward blood flow",
        "Valve enlargement"
      ],
      correct: "B"
    },
    {
      id: 26164,
      question: "Regurgitation refers to:",
      options: [
        "Complete valve closure",
        "Forward blood flow only",
        "Backflow of blood through valve",
        "Normal valve function"
      ],
      correct: "C"
    },
    {
      id: 26165,
      question: "Echocardiography uses what to detect heart abnormalities?",
      options: [
        "X-rays",
        "Ultrasonic waves",
        "Magnetic fields",
        "Electrical currents"
      ],
      correct: "B"
    },
    {
      id: 26166,
      question: "Patients with prosthetic heart valves require:",
      options: [
        "No special precautions",
        "Prophylactic antibiotics before dental care",
        "Only regular dental care",
        "No dental treatment"
      ],
      correct: "B"
    },
    {
      id: 26167,
      question: "Normal prothrombin time varies between:",
      options: [
        "5 and 8 seconds",
        "8 and 11 seconds",
        "11 and 14 seconds",
        "14 and 17 seconds"
      ],
      correct: "C"
    },
    {
      id: 26168,
      question: "Optimal prothrombin time for dental hygiene therapy in persons taking anticoagulants should be less than:",
      options: [
        "15 seconds",
        "20 seconds",
        "25 seconds",
        "30 seconds"
      ],
      correct: "B"
    },
    {
      id: 26169,
      question: "When INR value is used, the normal range is:",
      options: [
        "Less than 1.5",
        "1.5 to 2.0",
        "2.5 to 3.0",
        "Greater than 3.5"
      ],
      correct: "A"
    },
    {
      id: 26170,
      question: "Routine dental care can be performed when INR is:",
      options: [
        "1 to 1.5",
        "2 to 3",
        "3.5 to 4",
        "Greater than 4"
      ],
      correct: "B"
    },
    {
      id: 26171,
      question: "Rheumatic fever may develop within how many weeks after streptococcal infection?",
      options: [
        "1 week",
        "2 to 3 weeks",
        "4 to 5 weeks",
        "6 to 8 weeks"
      ],
      correct: "B"
    },
    {
      id: 26172,
      question: "Carditis is:",
      options: [
        "Inflammation of cardiac muscle",
        "Heart valve replacement",
        "Blood clot in heart",
        "Irregular heartbeat"
      ],
      correct: "A"
    },
    {
      id: 26173,
      question: "According to American Heart Association Guidelines, prophylactic antibiotics prior to dental care for RHD patients are:",
      options: [
        "Always required",
        "Required for all procedures",
        "Not required",
        "Only for surgical procedures"
      ],
      correct: "C"
    },
    {
      id: 26174,
      question: "Infective endocarditis is an infection of:",
      options: [
        "Lung tissue only",
        "Endocardium, heart valves, or cardiac prosthesis",
        "Peripheral blood vessels",
        "Brain tissue"
      ],
      correct: "B"
    },
    {
      id: 26175,
      question: "The most prevalent organism causing IE is:",
      options: [
        "Staphylococcus aureus",
        "Alpha-hemolytic streptococci",
        "Streptococcus viridans",
        "Staphylococcus epidermidis"
      ],
      correct: "B"
    },
    {
      id: 26176,
      question: "ABE (acute bacterial endocarditis) is characterized by:",
      options: [
        "Slow-moving infection",
        "Severe infection with rapid course",
        "Mild symptoms",
        "Chronic low-grade fever"
      ],
      correct: "B"
    },
    {
      id: 26177,
      question: "SBE (subacute bacterial endocarditis) is characterized by:",
      options: [
        "Rapid onset with high fever",
        "Slow-moving infection with nonspecific features",
        "Severe acute symptoms",
        "No symptoms"
      ],
      correct: "B"
    },
    {
      id: 26178,
      question: "Patients at highest risk for IE include those with:",
      options: [
        "Family history of heart disease",
        "Previous history of endocarditis",
        "High cholesterol",
        "Diabetes"
      ],
      correct: "B"
    },
    {
      id: 26179,
      question: "Prophylactic antibiotics should be taken how long before dental procedures?",
      options: [
        "30 minutes",
        "1 hour",
        "2 hours",
        "3 hours"
      ],
      correct: "B"
    },
    {
      id: 26180,
      question: "The interval between antibiotic coverage should be:",
      options: [
        "3 to 5 days",
        "5 to 7 days",
        "9 to 14 days",
        "14 to 21 days"
      ],
      correct: "C"
    },
    {
      id: 26181,
      question: "Angioplasty is also known as:",
      options: [
        "Coronary artery bypass",
        "Percutaneous coronary intervention",
        "Valve replacement",
        "Heart transplantation"
      ],
      correct: "B"
    },
    {
      id: 26182,
      question: "Angioplasty involves:",
      options: [
        "Open-heart surgery",
        "Catheter with balloon to flatten fatty deposits",
        "Complete artery replacement",
        "Valve repair"
      ],
      correct: "B"
    },
    {
      id: 26183,
      question: "A coronary stent is:",
      options: [
        "Temporary device",
        "Meshlike metal device to open narrow arteries",
        "Medication",
        "Surgical technique"
      ],
      correct: "B"
    },
    {
      id: 26184,
      question: "Coronary bypass surgery involves:",
      options: [
        "Valve replacement",
        "Grafting vein onto coronary artery",
        "Stent placement",
        "Balloon angioplasty"
      ],
      correct: "B"
    },
    {
      id: 26185,
      question: "Patients with artificial cardiac valves are at high risk for:",
      options: [
        "Diabetes",
        "Infections and IE",
        "Kidney disease",
        "Liver disease"
      ],
      correct: "B"
    },
    {
      id: 26186,
      question: "A major concern of heart transplant patients is:",
      options: [
        "Hypertension only",
        "Infection and transplant rejection",
        "Weight gain",
        "Diabetes"
      ],
      correct: "B"
    },
    {
      id: 26187,
      question: "Immunosuppressant medication commonly used after heart transplant is:",
      options: [
        "Aspirin",
        "Warfarin",
        "Cyclosporine",
        "Digoxin"
      ],
      correct: "C"
    },
    {
      id: 26188,
      question: "Most medications for hypertension cause:",
      options: [
        "Excessive salivation",
        "Xerostomia",
        "Gingival bleeding",
        "Tooth sensitivity"
      ],
      correct: "B"
    },
    {
      id: 26189,
      question: "Calcium channel blockers may cause:",
      options: [
        "Increased salivation",
        "Drug-influenced gingival enlargement",
        "Tooth whitening",
        "Enamel strengthening"
      ],
      correct: "B"
    },
    {
      id: 26190,
      question: "Patients on anticoagulants have:",
      options: [
        "Decreased bleeding time",
        "Prolonged bleeding time",
        "Normal bleeding time",
        "No bleeding tendency"
      ],
      correct: "B"
    },
    {
      id: 26191,
      question: "Dual antiplatelet therapy (DAPT) involves:",
      options: [
        "One antiplatelet drug only",
        "Aspirin combined with another antiplatelet drug",
        "Two blood pressure medications",
        "Antibiotic combination"
      ],
      correct: "B"
    },
    {
      id: 26192,
      question: "Hypertension is three times more common in:",
      options: [
        "Normal-weight persons",
        "Underweight persons",
        "Obese persons",
        "Athletic persons"
      ],
      correct: "C"
    },
    {
      id: 26193,
      question: "There is a higher incidence of hypertension among:",
      options: [
        "Asians than Whites",
        "Hispanics than Whites",
        "African Americans than American Whites",
        "Whites than all other groups"
      ],
      correct: "C"
    },
    {
      id: 26194,
      question: "Vasopressors such as epinephrine work by:",
      options: [
        "Dilating blood vessels",
        "Constricting blood vessels",
        "Thinning the blood",
        "Slowing heart rate"
      ],
      correct: "B"
    },
    {
      id: 26195,
      question: "In hypertensive individuals, vasopressors increase risk of:",
      options: [
        "Diabetes",
        "Cerebrovascular accident, MI, or CHF",
        "Kidney stones",
        "Arthritis"
      ],
      correct: "B"
    },
    {
      id: 26196,
      question: "The four main types of CVD include all EXCEPT:",
      options: [
        "Coronary heart disease",
        "Peripheral arterial disease",
        "Diabetes mellitus",
        "Strokes and TIAs"
      ],
      correct: "C"
    },
    {
      id: 26197,
      question: "Patients with SARS-CoV-2 are at increased risk for:",
      options: [
        "Only respiratory disorders",
        "Comprehensive assortment of cardiovascular disorders",
        "Only neurological disorders",
        "Only kidney disease"
      ],
      correct: "B"
    },
    {
      id: 26198,
      question: "Research suggests that periodontal disease may increase cardiovascular risk through:",
      options: [
        "Direct mechanical damage",
        "Systemic inflammatory or immune response",
        "Genetic mutation",
        "Vitamin deficiency"
      ],
      correct: "B"
    },
    {
      id: 26199,
      question: "The current position of AHA and ADA on periodontal disease and heart health is:",
      options: [
        "No association exists",
        "Association exists but causal relationship needs more research",
        "Direct causal relationship proven",
        "Only genetic link exists"
      ],
      correct: "B"
    }
  ],
  "2. Diabetes and Oral Health": [
    {
      id: 26200,
      question: "Approximately what percentage of the US population has diabetes?",
      options: [
        "8.3%",
        "11.3%",
        "14.3%",
        "17.3%"
      ],
      correct: "B"
    },
    {
      id: 26201,
      question: "Of individuals with diabetes, approximately how many are unaware of their condition?",
      options: [
        "More than 8.5 million",
        "More than 6.5 million",
        "More than 10.5 million",
        "More than 12.5 million"
      ],
      correct: "A"
    },
    {
      id: 26202,
      question: "Current estimates project that at least what proportion of people will develop diabetes in their lifetime?",
      options: [
        "One in five",
        "One in four",
        "One in three",
        "One in two"
      ],
      correct: "C"
    },
    {
      id: 26203,
      question: "Approximately what percentage of the US adult population has diagnosed prediabetes?",
      options: [
        "28%",
        "33%",
        "38%",
        "43%"
      ],
      correct: "C"
    },
    {
      id: 26204,
      question: "Interventions to prevent type 2 diabetes include increasing physical activity to how many minutes per week?",
      options: [
        "100 minutes",
        "120 minutes",
        "150 minutes",
        "180 minutes"
      ],
      correct: "C"
    },
    {
      id: 26205,
      question: "The target weight reduction for preventing type 2 diabetes is:",
      options: [
        "5%",
        "7%",
        "10%",
        "12%"
      ],
      correct: "B"
    },
    {
      id: 26206,
      question: "Type 1 diabetes involves about what percentage of the adult diabetic population?",
      options: [
        "3%",
        "5%",
        "8%",
        "10%"
      ],
      correct: "B"
    },
    {
      id: 26207,
      question: "If one identical twin develops type 1 diabetes, the other twin will develop the disease in approximately what percentage of cases?",
      options: [
        "30%",
        "40%",
        "50%",
        "60%"
      ],
      correct: "C"
    },
    {
      id: 26208,
      question: "Type 2 diabetes constitutes approximately what percentage of the diabetic population?",
      options: [
        "75% to 80%",
        "80% to 85%",
        "85% to 90%",
        "90% to 95%"
      ],
      correct: "D"
    },
    {
      id: 26209,
      question: "If one identical twin develops type 2 diabetes, what is the chance the other twin will develop it?",
      options: [
        "75%",
        "85%",
        "95%",
        "100%"
      ],
      correct: "D"
    },
    {
      id: 26210,
      question: "It is estimated that people have type 2 diabetes for how many years before clinical diagnosis?",
      options: [
        "5 years",
        "10 years",
        "15 years",
        "20 years"
      ],
      correct: "B"
    },
    {
      id: 26211,
      question: "Gestational diabetes mellitus (GDM) occurs in what percentage of pregnancies in the United States?",
      options: [
        "5.8%",
        "6.8%",
        "7.8%",
        "8.8%"
      ],
      correct: "C"
    },
    {
      id: 26212,
      question: "Approximately what percentage of females with a history of GDM will develop type 2 diabetes?",
      options: [
        "30%",
        "40%",
        "50%",
        "60%"
      ],
      correct: "C"
    },
    {
      id: 26213,
      question: "When blood glucose level rises to more than what level do kidney tubules become incapable of resorption?",
      options: [
        "100 mg/dL",
        "125 mg/dL",
        "150 mg/dL",
        "175 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26214,
      question: "Diabetic ketoacidosis (DKA) may follow hyperglycemia when blood glucose levels rise to more than:",
      options: [
        "300 mg/dL",
        "350 mg/dL",
        "400 mg/dL",
        "450 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26215,
      question: "An A1c level between what range indicates prediabetes?",
      options: [
        "5.0% and 5.9%",
        "5.4% and 6.1%",
        "5.7% and 6.4%",
        "6.0% and 6.7%"
      ],
      correct: "C"
    },
    {
      id: 26216,
      question: "An A1c level of what percentage or greater indicates diabetes?",
      options: [
        "6.0%",
        "6.2%",
        "6.5%",
        "6.8%"
      ],
      correct: "C"
    },
    {
      id: 26217,
      question: "Patients with diabetes have what percentage increase in the incidence of periodontal disease compared to people without diabetes?",
      options: [
        "18%",
        "21%",
        "24%",
        "27%"
      ],
      correct: "C"
    },
    {
      id: 26218,
      question: "For patients with periodontitis, the risk of developing diabetes is elevated by what percentage?",
      options: [
        "20%",
        "23%",
        "26%",
        "29%"
      ],
      correct: "C"
    },
    {
      id: 26219,
      question: "Hemoglobin A is made during what life span of a red blood cell?",
      options: [
        "90 days",
        "105 days",
        "120 days",
        "135 days"
      ],
      correct: "C"
    },
    {
      id: 26220,
      question: "For people with type 2 diabetes who are overweight or obese, what percentage of weight loss is associated with benefits for glycemic control?",
      options: [
        "3%",
        "5%",
        "7%",
        "10%"
      ],
      correct: "B"
    },
    {
      id: 26221,
      question: "With type 1 diabetes, carbohydrates should comprise what percentage of total calories?",
      options: [
        "45% to 50%",
        "50% to 55%",
        "55% to 60%",
        "60% to 65%"
      ],
      correct: "C"
    },
    {
      id: 26222,
      question: "With type 1 diabetes, protein should comprise what percentage of total calories?",
      options: [
        "8% to 15%",
        "10% to 18%",
        "12% to 20%",
        "15% to 23%"
      ],
      correct: "C"
    },
    {
      id: 26223,
      question: "More than how many different insulins are sold in the United States?",
      options: [
        "15",
        "20",
        "25",
        "30"
      ],
      correct: "B"
    },
    {
      id: 26224,
      question: "Approximately what percentage of people with diabetes use insulin only to control hyperglycemia?",
      options: [
        "10%",
        "15%",
        "20%",
        "25%"
      ],
      correct: "B"
    },
    {
      id: 26225,
      question: "What percentage of people with diabetes use oral medications only?",
      options: [
        "45%",
        "48%",
        "52%",
        "56%"
      ],
      correct: "C"
    },
    {
      id: 26226,
      question: "What percentage of people with diabetes use a combination of insulin and oral medications?",
      options: [
        "10%",
        "12%",
        "14%",
        "16%"
      ],
      correct: "C"
    },
    {
      id: 26227,
      question: "The A1c target for adults with diabetes is:",
      options: [
        "Less than 6.0%",
        "Less than 6.5%",
        "Less than 7.0%",
        "Less than 7.5%"
      ],
      correct: "C"
    },
    {
      id: 26228,
      question: "The pre-meal glucose target for adults with diabetes is:",
      options: [
        "70 to 120 mg/dL",
        "80 to 130 mg/dL",
        "90 to 140 mg/dL",
        "100 to 150 mg/dL"
      ],
      correct: "B"
    },
    {
      id: 26229,
      question: "The peak postmeal glucose target for adults with diabetes is:",
      options: [
        "Less than 160 mg/dL",
        "Less than 170 mg/dL",
        "Less than 180 mg/dL",
        "Less than 190 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26230,
      question: "The target blood glucose concentration range for nonpregnant adults with diabetes is:",
      options: [
        "70 to 120 mg/dL",
        "80 to 130 mg/dL",
        "90 to 140 mg/dL",
        "100 to 150 mg/dL"
      ],
      correct: "B"
    },
    {
      id: 26231,
      question: "Only about what percentage of people with type 2 diabetes attain an A1c level of less than 7%?",
      options: [
        "40%",
        "45%",
        "50%",
        "55%"
      ],
      correct: "C"
    },
    {
      id: 26232,
      question: "Rapid-acting insulin has an onset of action of:",
      options: [
        "10 minutes",
        "15 minutes",
        "20 minutes",
        "25 minutes"
      ],
      correct: "B"
    },
    {
      id: 26233,
      question: "Rapid-acting insulin has a peak effect of:",
      options: [
        "1-2 hours",
        "2-3 hours",
        "3-4 hours",
        "4-5 hours"
      ],
      correct: "A"
    },
    {
      id: 26234,
      question: "Regular or short-acting insulin has an onset of action of:",
      options: [
        "15 minutes",
        "20 minutes",
        "30 minutes",
        "45 minutes"
      ],
      correct: "C"
    },
    {
      id: 26235,
      question: "Regular or short-acting insulin has a peak effect of:",
      options: [
        "1-2 hours",
        "2-3 hours",
        "3-4 hours",
        "4-5 hours"
      ],
      correct: "B"
    },
    {
      id: 26236,
      question: "Intermediate-acting insulin has an onset of action of:",
      options: [
        "1-2 hours",
        "2-4 hours",
        "4-6 hours",
        "6-8 hours"
      ],
      correct: "B"
    },
    {
      id: 26237,
      question: "Intermediate-acting insulin has a peak effect of:",
      options: [
        "2-8 hours",
        "4-12 hours",
        "6-14 hours",
        "8-16 hours"
      ],
      correct: "B"
    },
    {
      id: 26238,
      question: "Intermediate-acting insulin has a duration of:",
      options: [
        "8-14 hours",
        "10-16 hours",
        "12-18 hours",
        "14-20 hours"
      ],
      correct: "C"
    },
    {
      id: 26239,
      question: "Long-acting insulin has a duration of up to:",
      options: [
        "18 hours",
        "20 hours",
        "24 hours",
        "28 hours"
      ],
      correct: "C"
    },
    {
      id: 26240,
      question: "Ultralong-acting insulin has a duration of:",
      options: [
        "30 or more hours",
        "33 or more hours",
        "36 or more hours",
        "40 or more hours"
      ],
      correct: "C"
    },
    {
      id: 26241,
      question: "Blood glucose levels less than what level indicate hypoglycemia?",
      options: [
        "60 mg/dL",
        "65 mg/dL",
        "70 mg/dL",
        "75 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26242,
      question: "When blood glucose is 70 to 79 mg/dL, monitoring should occur at least how many times during the dental hygiene appointment?",
      options: [
        "Once",
        "Twice",
        "Three times",
        "Four times"
      ],
      correct: "A"
    },
    {
      id: 26243,
      question: "Blood glucose levels of 80 to what level are considered normal?",
      options: [
        "139 mg/dL",
        "144 mg/dL",
        "149 mg/dL",
        "154 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26244,
      question: "Blood glucose levels greater than what level indicate tendency toward hyperglycemia?",
      options: [
        "180 mg/dL",
        "190 mg/dL",
        "200 mg/dL",
        "210 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26245,
      question: "Periodontal debridement is postponed for people with blood glucose levels less than what level?",
      options: [
        "60 mg/dL",
        "65 mg/dL",
        "70 mg/dL",
        "75 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26246,
      question: "Periodontal debridement is postponed for people with blood glucose levels greater than what level?",
      options: [
        "180 mg/dL",
        "190 mg/dL",
        "200 mg/dL",
        "210 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26247,
      question: "The short-term risk for infections in persons with diabetes increases with blood glucose levels of:",
      options: [
        "180 to 210 mg/dL",
        "190 to 220 mg/dL",
        "200 to 230 mg/dL",
        "210 to 240 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26248,
      question: "For children and adolescents with diabetes, annual oral exams should start at what age?",
      options: [
        "4 years",
        "5 years",
        "6 years",
        "7 years"
      ],
      correct: "C"
    },
    {
      id: 26249,
      question: "Regular (short-acting) insulin peaks within how many hours after injection?",
      options: [
        "1 to 2 hours",
        "2 to 3 hours",
        "3 to 4 hours",
        "4 to 5 hours"
      ],
      correct: "B"
    },
    {
      id: 26250,
      question: "Morning appointments are best scheduled how many hours after breakfast?",
      options: [
        "One hour",
        "Two hours",
        "Three hours",
        "Four hours"
      ],
      correct: "B"
    },
    {
      id: 26251,
      question: "Hypoglycemia results from a blood glucose concentration of less than:",
      options: [
        "60 mg/dL",
        "65 mg/dL",
        "70 mg/dL",
        "75 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26252,
      question: "Each year, severe hypoglycemia episodes affect approximately what percentage of diabetic individuals?",
      options: [
        "15%",
        "20%",
        "25%",
        "30%"
      ],
      correct: "B"
    },
    {
      id: 26253,
      question: "How many grams of glucose are generally adequate to treat mild hypoglycemia?",
      options: [
        "5 to 10 g",
        "10 to 20 g",
        "20 to 30 g",
        "30 to 40 g"
      ],
      correct: "B"
    },
    {
      id: 26254,
      question: "An 8-ounce glass of 2% fat milk contains approximately how many grams of glucose?",
      options: [
        "8 to 12 g",
        "10 to 20 g",
        "15 to 25 g",
        "20 to 30 g"
      ],
      correct: "B"
    },
    {
      id: 26255,
      question: "A 4-ounce glass of orange juice contains approximately how many grams of glucose?",
      options: [
        "8 to 12 g",
        "10 to 20 g",
        "15 to 25 g",
        "20 to 30 g"
      ],
      correct: "B"
    },
    {
      id: 26256,
      question: "How many Life Savers candies contain approximately the right amount of glucose to treat hypoglycemia?",
      options: [
        "4",
        "6",
        "8",
        "10"
      ],
      correct: "C"
    },
    {
      id: 26257,
      question: "For unconscious hypoglycemic patients without IV access, what dose of glucagon should be administered intramuscularly?",
      options: [
        "0.25 mg to 0.75 mg",
        "0.5 mg to 1.0 mg",
        "0.75 mg to 1.25 mg",
        "1.0 mg to 1.5 mg"
      ],
      correct: "B"
    },
    {
      id: 26258,
      question: "After glucagon administration, the patient should regain consciousness in:",
      options: [
        "10 to 15 minutes",
        "15 to 20 minutes",
        "20 to 25 minutes",
        "25 to 30 minutes"
      ],
      correct: "B"
    },
    {
      id: 26259,
      question: "Conscious hypoglycemic patients should be treated with how many grams of simple carbohydrates?",
      options: [
        "10 g",
        "12 g",
        "15 g",
        "18 g"
      ],
      correct: "C"
    },
    {
      id: 26260,
      question: "After treating hypoglycemia, the finger-stick glucose test should be repeated in how many minutes?",
      options: [
        "10 minutes",
        "15 minutes",
        "20 minutes",
        "25 minutes"
      ],
      correct: "B"
    },
    {
      id: 26261,
      question: "How many ounces of regular fruit juice should be given to treat hypoglycemia?",
      options: [
        "2 ounces",
        "3 ounces",
        "4 ounces",
        "5 ounces"
      ],
      correct: "C"
    },
    {
      id: 26262,
      question: "How many glucose tablets should be given to treat hypoglycemia?",
      options: [
        "1 to 2",
        "2 to 3",
        "3 to 4",
        "4 to 5"
      ],
      correct: "C"
    },
    {
      id: 26263,
      question: "Diabetic deaths caused by hyperglycemic ketoacidotic coma currently represent what percentage of adults with type 1 diabetes?",
      options: [
        "0.5%",
        "1%",
        "1.5%",
        "2%"
      ],
      correct: "B"
    },
    {
      id: 26264,
      question: "Infection is present in more than what percentage of all persons with DKA coma?",
      options: [
        "40%",
        "45%",
        "50%",
        "55%"
      ],
      correct: "C"
    },
    {
      id: 26265,
      question: "For testing diabetes in asymptomatic adults, testing should begin at what age?",
      options: [
        "30 years",
        "35 years",
        "40 years",
        "45 years"
      ],
      correct: "B"
    },
    {
      id: 26266,
      question: "If diabetes testing results are normal, testing should be repeated at what interval?",
      options: [
        "2-year intervals",
        "3-year intervals",
        "4-year intervals",
        "5-year intervals"
      ],
      correct: "B"
    },
    {
      id: 26267,
      question: "Adults who are overweight should be tested if they have a body mass index of:",
      options: [
        "≥23 kg/m2",
        "≥24 kg/m2",
        "≥25 kg/m2",
        "≥26 kg/m2"
      ],
      correct: "C"
    },
    {
      id: 26268,
      question: "Adults are considered hypertensive if blood pressure is:",
      options: [
        "≥120/70 mm Hg",
        "≥130/80 mm Hg",
        "≥140/90 mm Hg",
        "≥150/100 mm Hg"
      ],
      correct: "B"
    },
    {
      id: 26269,
      question: "High-density lipoprotein cholesterol level indicating diabetes risk is less than:",
      options: [
        "30 mg/dL",
        "35 mg/dL",
        "40 mg/dL",
        "45 mg/dL"
      ],
      correct: "B"
    },
    {
      id: 26270,
      question: "Triglyceride level indicating diabetes risk is greater than:",
      options: [
        "200 mg/dL",
        "225 mg/dL",
        "250 mg/dL",
        "275 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26271,
      question: "For children, diabetes testing should be initiated at what age or onset of puberty?",
      options: [
        "8 years",
        "9 years",
        "10 years",
        "11 years"
      ],
      correct: "C"
    },
    {
      id: 26272,
      question: "For children at risk, diabetes testing frequency should be:",
      options: [
        "Every 2 years",
        "Every 3 years",
        "Every 4 years",
        "Every 5 years"
      ],
      correct: "B"
    },
    {
      id: 26273,
      question: "Children are considered overweight or obese with a body mass index at or above what percentile?",
      options: [
        "75th percentile",
        "80th percentile",
        "85th percentile",
        "90th percentile"
      ],
      correct: "C"
    },
    {
      id: 26274,
      question: "Estimated fasting blood glucose level indicating referral to physician is:",
      options: [
        "≥116 mg/mL",
        "≥121 mg/mL",
        "≥126 mg/mL",
        "≥131 mg/mL"
      ],
      correct: "C"
    },
    {
      id: 26275,
      question: "2-hour post meal blood glucose level indicating referral to physician is:",
      options: [
        "≥180 mg/mL",
        "≥190 mg/mL",
        "≥200 mg/mL",
        "≥210 mg/mL"
      ],
      correct: "C"
    },
    {
      id: 26276,
      question: "A random blood glucose test of what level or greater at any time with symptoms diagnoses diabetes?",
      options: [
        "≥180 mg/dL",
        "≥190 mg/dL",
        "≥200 mg/dL",
        "≥210 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26277,
      question: "Fasting plasma glucose of what level or greater indicates diabetes?",
      options: [
        "116 mg/dL",
        "121 mg/dL",
        "126 mg/dL",
        "131 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26278,
      question: "Oral glucose tolerance test result of what level or greater indicates diabetes?",
      options: [
        "180 mg/dL",
        "190 mg/dL",
        "200 mg/dL",
        "210 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26279,
      question: "Fasting plasma glucose result between 100 and what level indicates prediabetes?",
      options: [
        "120 mg/dL",
        "125 mg/dL",
        "130 mg/dL",
        "135 mg/dL"
      ],
      correct: "B"
    },
    {
      id: 26280,
      question: "Oral glucose tolerance test result between 140 and what level indicates prediabetes?",
      options: [
        "189 mg/dL",
        "194 mg/dL",
        "199 mg/dL",
        "204 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26281,
      question: "For frequent self-monitoring of blood glucose, patients should monitor at least how many times per day?",
      options: [
        "6 times",
        "7 times",
        "8 times",
        "9 times"
      ],
      correct: "C"
    },
    {
      id: 26282,
      question: "If glycemic control is good, A1c should be tested how many times a year?",
      options: [
        "Once a year",
        "Twice a year",
        "Three times a year",
        "Four times a year"
      ],
      correct: "B"
    },
    {
      id: 26283,
      question: "If treatment or control has changed, A1c should be tested how many times a year?",
      options: [
        "Two times a year",
        "Three times a year",
        "Four times a year",
        "Five times a year"
      ],
      correct: "C"
    },
    {
      id: 26284,
      question: "If not eating normally, adequate fluid intake should be:",
      options: [
        "1 to 2 L/day",
        "2 to 3 L/day",
        "3 to 4 L/day",
        "4 to 5 L/day"
      ],
      correct: "B"
    },
    {
      id: 26285,
      question: "Patients should contact physician if two preceding blood tests show glucose level greater than:",
      options: [
        "180 mg/dL",
        "190 mg/dL",
        "200 mg/dL",
        "210 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26286,
      question: "Patients should test for urine ketones if blood glucose level is greater than:",
      options: [
        "250 mg/dL",
        "275 mg/dL",
        "300 mg/dL",
        "325 mg/dL"
      ],
      correct: "C"
    },
    {
      id: 26287,
      question: "If blood glucose level is greater than 300 mg/dL with positive ketones for more than how many hours should urgent medical advice be sought?",
      options: [
        "12 hours",
        "18 hours",
        "24 hours",
        "30 hours"
      ],
      correct: "C"
    },
    {
      id: 26288,
      question: "Persons with type 1 diabetes who are more than twice as likely to develop periodontitis were studied in:",
      options: [
        "Meta-analysis",
        "Randomized controlled trial",
        "Systematic review",
        "Case-control study"
      ],
      correct: "C"
    },
    {
      id: 26289,
      question: "Diabetes is a risk factor that may modify the periodontitis grade based on:",
      options: [
        "Fasting glucose levels",
        "HbA1c level",
        "Oral glucose tolerance test",
        "Random blood glucose"
      ],
      correct: "B"
    },
    {
      id: 26290,
      question: "Patients with periodontitis and diabetes with HbA1c less than 7% would be given what grade score at minimum?",
      options: [
        "Grade A",
        "Grade B",
        "Grade C",
        "Grade D"
      ],
      correct: "B"
    },
    {
      id: 26291,
      question: "An HbA1c level of 7% or greater may shift the grade to:",
      options: [
        "Grade A",
        "Grade B",
        "Grade C",
        "Grade D"
      ],
      correct: "C"
    },
    {
      id: 26292,
      question: "Metformin is contraindicated for people with:",
      options: [
        "High blood pressure",
        "High cholesterol",
        "Reduced kidney function",
        "Liver disease"
      ],
      correct: "C"
    },
    {
      id: 26293,
      question: "Which medication is the preferred initial pharmacologic agent for type 2 diabetes?",
      options: [
        "Sulfonylureas",
        "Metformin",
        "Meglitinides",
        "Thiazolidinedione"
      ],
      correct: "B"
    },
    {
      id: 26294,
      question: "Adults with diabetes who drink alcohol should do so with a maximum of how many drinks per day for females?",
      options: [
        "None",
        "One drink",
        "Two drinks",
        "Three drinks"
      ],
      correct: "B"
    },
    {
      id: 26295,
      question: "Adults with diabetes who drink alcohol should do so with a maximum of how many drinks per day for males?",
      options: [
        "One drink",
        "Two drinks",
        "Three drinks",
        "Four drinks"
      ],
      correct: "B"
    },
    {
      id: 26296,
      question: "The incidence of lichen planus in patients with diabetes can be as high as:",
      options: [
        "20%",
        "25%",
        "30%",
        "35%"
      ],
      correct: "C"
    },
    {
      id: 26297,
      question: "Post-meal glucose measurements should be made how many hours after the beginning of the meal?",
      options: [
        "30 minutes to 1 hour",
        "1 to 2 hours",
        "2 to 3 hours",
        "3 to 4 hours"
      ],
      correct: "B"
    },
    {
      id: 26298,
      question: "What is the sixth most common complication of diabetes?",
      options: [
        "Retinopathy",
        "Nephropathy",
        "Periodontal disease",
        "Neuropathy"
      ],
      correct: "C"
    },
    {
      id: 26299,
      question: "Which type of diabetes is preventable?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "Other specific types"
      ],
      correct: "B"
    },
    {
      id: 26300,
      question: "Which type of diabetes is characterized by high blood glucose levels caused by total lack of insulin?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "Prediabetes"
      ],
      correct: "A"
    },
    {
      id: 26301,
      question: "Which type of diabetes results from lack of insulin or body\'s inability to use insulin efficiently?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "Prediabetes"
      ],
      correct: "B"
    },
    {
      id: 26302,
      question: "Which form of diabetes commonly presents during childhood and adolescence?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "Prediabetes"
      ],
      correct: "A"
    },
    {
      id: 26303,
      question: "People with which type of diabetes are rarely obese?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "All types"
      ],
      correct: "A"
    },
    {
      id: 26304,
      question: "In which type of diabetes is the role of genetics stronger?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "Equal in all types"
      ],
      correct: "A"
    },
    {
      id: 26305,
      question: "Which type of diabetes is predominantly genetically inherited?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "Prediabetes"
      ],
      correct: "B"
    },
    {
      id: 26306,
      question: "Which type of diabetes seldom has ketoacidosis unless associated with infection?",
      options: [
        "Type 1 diabetes",
        "Type 2 diabetes",
        "Gestational diabetes",
        "All types equally"
      ],
      correct: "B"
    },
    {
      id: 26307,
      question: "What is prediabetes also called?",
      options: [
        "Impaired glucose homeostasis",
        "Impaired glucose tolerance",
        "Glucose resistance",
        "Pre-hyperglycemia"
      ],
      correct: "B"
    },
    {
      id: 26308,
      question: "What is another term for prediabetes?",
      options: [
        "Borderline diabetes",
        "Impaired fasting glucose",
        "Glucose intolerance",
        "Insulin resistance"
      ],
      correct: "B"
    },
    {
      id: 26309,
      question: "What is the condition called when blood glucose levels are higher than normal but below diagnostic levels?",
      options: [
        "Hyperglycemia",
        "Pre-diabetes",
        "Glucose intolerance",
        "Insulin resistance"
      ],
      correct: "B"
    },
    {
      id: 26310,
      question: "What is DKA an abbreviation for?",
      options: [
        "Diabetic kidney acidosis",
        "Diabetic ketone accumulation",
        "Diabetic ketoacidosis",
        "Diabetic kidney acidemia"
      ],
      correct: "C"
    },
    {
      id: 26311,
      question: "What is the medical term for high levels of blood glucose?",
      options: [
        "Hyperglycemia",
        "Hypoglycemia",
        "Glucosuria",
        "Ketonemia"
      ],
      correct: "A"
    },
    {
      id: 26312,
      question: "What is the medical term for glucose in the urine?",
      options: [
        "Glycosuria",
        "Ketonuria",
        "Proteinuria",
        "Hematuria"
      ],
      correct: "A"
    },
    {
      id: 26313,
      question: "What is the medical term for increased volume of urine?",
      options: [
        "Polydipsia",
        "Polyuria",
        "Polyphagia",
        "Polyneuropathy"
      ],
      correct: "B"
    },
    {
      id: 26314,
      question: "What is the medical term for excessive thirst?",
      options: [
        "Polydipsia",
        "Polyuria",
        "Polyphagia",
        "Polyneuropathy"
      ],
      correct: "A"
    },
    {
      id: 26315,
      question: "What is the medical term for excessive ingestion of food?",
      options: [
        "Polydipsia",
        "Polyuria",
        "Polyphagia",
        "Polyneuropathy"
      ],
      correct: "C"
    },
    {
      id: 26316,
      question: "What is the medical term for ketones in the urine?",
      options: [
        "Glucosuria",
        "Ketonuria",
        "Proteinuria",
        "Hematuria"
      ],
      correct: "B"
    },
    {
      id: 26317,
      question: "What is the medical term for ketones circulating in the blood?",
      options: [
        "Ketonemia",
        "Ketoacidosis",
        "Ketonuria",
        "Hyperketonemia"
      ],
      correct: "A"
    },
    {
      id: 26318,
      question: "What is the medical term for burning mouth?",
      options: [
        "Glossitis",
        "Stomatitis",
        "Glossodynia",
        "Cheilosis"
      ],
      correct: "C"
    },
    {
      id: 26319,
      question: "What is the condition called when the body\'s immune system attacks insulin-producing beta cells?",
      options: [
        "Autoimmune reaction",
        "Beta-cell destruction",
        "Pancreatic failure",
        "Islet cell disease"
      ],
      correct: "A"
    },
    {
      id: 26320,
      question: "What hormone stimulates the entry of glucose into the cell?",
      options: [
        "Glucagon",
        "Insulin",
        "Cortisol",
        "Epinephrine"
      ],
      correct: "B"
    },
    {
      id: 26321,
      question: "What type of hormone is insulin?",
      options: [
        "Catabolic hormone",
        "Anabolic hormone",
        "Metabolic hormone",
        "Regulatory hormone"
      ],
      correct: "B"
    },
    {
      id: 26322,
      question: "What is the catabolism of fatty acids called?",
      options: [
        "Lipogenesis",
        "Gluconeogenesis",
        "Lipolysis",
        "Glycolysis"
      ],
      correct: "C"
    },
    {
      id: 26323,
      question: "Which human leukocyte antigens are related to type 1 diabetes?",
      options: [
        "DR1, DR2",
        "DR3, DR4",
        "DR5, DR6",
        "DR7, DR8"
      ],
      correct: "B"
    },
    {
      id: 26324,
      question: "Which cells in the pancreas produce insulin?",
      options: [
        "Alpha cells",
        "Beta cells",
        "Delta cells",
        "Gamma cells"
      ],
      correct: "B"
    },
    {
      id: 26325,
      question: "What is the life span of a red blood cell?",
      options: [
        "90 days",
        "105 days",
        "120 days",
        "135 days"
      ],
      correct: "C"
    },
    {
      id: 26326,
      question: "What test is used to monitor overall glycemic control over 2 to 3 months?",
      options: [
        "Fasting plasma glucose",
        "Random blood glucose",
        "Hemoglobin A1c test",
        "Oral glucose tolerance test"
      ],
      correct: "C"
    },
    {
      id: 26327,
      question: "What is the preferred test for prediabetes?",
      options: [
        "Fasting plasma glucose",
        "Random blood glucose",
        "A1c test",
        "Oral glucose tolerance test"
      ],
      correct: "C"
    },
    {
      id: 26328,
      question: "What is the most important aspect of diabetes control?",
      options: [
        "Diet management",
        "Exercise",
        "Self-monitoring of blood glucose",
        "Medication compliance"
      ],
      correct: "C"
    },
    {
      id: 26329,
      question: "What remains the hallmark of diabetes therapy?",
      options: [
        "Insulin therapy",
        "Diet",
        "Exercise",
        "Medication"
      ],
      correct: "B"
    },
    {
      id: 26330,
      question: "What is essential for diabetes control?",
      options: [
        "Diet",
        "Medication",
        "Physical activity",
        "Self-monitoring"
      ],
      correct: "C"
    },
    {
      id: 26331,
      question: "What is the most common precipitating factor for severe ketoacidosis?",
      options: [
        "Stress",
        "Infection",
        "Poor medication compliance",
        "Dietary indiscretion"
      ],
      correct: "B"
    },
    {
      id: 26332,
      question: "What is the most common metabolic emergency in persons with type 1 diabetes?",
      options: [
        "Hyperglycemia",
        "Hypoglycemia",
        "Ketoacidosis",
        "Diabetic coma"
      ],
      correct: "B"
    },
    {
      id: 26333,
      question: "What is the cardinal sign of diabetes that means frequent urination?",
      options: [
        "Polydipsia",
        "Polyuria",
        "Polyphagia",
        "Weight loss"
      ],
      correct: "B"
    },
    {
      id: 26334,
      question: "What is the cardinal sign of diabetes that means excessive thirst?",
      options: [
        "Polydipsia",
        "Polyuria",
        "Polyphagia",
        "Weight loss"
      ],
      correct: "A"
    },
    {
      id: 26335,
      question: "What is the cardinal sign of diabetes that means excessive hunger?",
      options: [
        "Polydipsia",
        "Polyuria",
        "Polyphagia",
        "Weight loss"
      ],
      correct: "C"
    },
    {
      id: 26336,
      question: "Which complication predominantly affects type 1 diabetes patients?",
      options: [
        "Atherosclerosis",
        "Kidney and eye diseases",
        "Peripheral neuropathy",
        "Cardiovascular disease"
      ],
      correct: "B"
    },
    {
      id: 26337,
      question: "Which complication predominantly affects type 2 diabetes patients?",
      options: [
        "Retinopathy",
        "Nephropathy",
        "Atherosclerosis",
        "Neuropathy"
      ],
      correct: "C"
    },
    {
      id: 26338,
      question: "Which complication occurs with both type 1 and type 2 diabetes?",
      options: [
        "Retinopathy",
        "Nephropathy",
        "Neuropathy",
        "Atherosclerosis"
      ],
      correct: "C"
    }
  ],
  "3. Cancer and Oral Care": [
    {
      id: 26300,
      question: "What percentage of new cancer cases in the United States occur in people who are 55 years and older?",
      options: [
        "72%",
        "87%",
        "65%",
        "93%"
      ],
      correct: "B"
    },
    {
      id: 26301,
      question: "Which of the following represents the estimated number of new cancer cases annually in the United States?",
      options: [
        "1.2 million new cases",
        "2.5 million new cases",
        "More than 1.9 million new cases",
        "850,000 new cases"
      ],
      correct: "C"
    },
    {
      id: 26302,
      question: "What percentage of new cancer cases could be reduced by health behavior changes including discontinuing tobacco, good nutrition, and increased physical activity?",
      options: [
        "42%",
        "28%",
        "55%",
        "37%"
      ],
      correct: "A"
    },
    {
      id: 26303,
      question: "Which virus has been identified as the primary causative agent for oropharyngeal and cervical cancers?",
      options: [
        "Hepatitis B virus",
        "Epstein-Barr virus",
        "Human papillomavirus (HPV)",
        "Cytomegalovirus"
      ],
      correct: "C"
    },
    {
      id: 26304,
      question: "What percentage of oral malignancies are squamous cell carcinomas?",
      options: [
        "7 out of 10",
        "8 out of 10",
        "9 out of 10",
        "6 out of 10"
      ],
      correct: "C"
    },
    {
      id: 26305,
      question: "What is the median age of a person with newly diagnosed oral cancer?",
      options: [
        "55 years",
        "62 years",
        "68 years",
        "58 years"
      ],
      correct: "B"
    },
    {
      id: 26306,
      question: "Cigarette smokers have approximately how many times the chance of developing squamous cell carcinoma compared to people who have never smoked?",
      options: [
        "5 times",
        "15 times",
        "10 times",
        "7 times"
      ],
      correct: "C"
    },
    {
      id: 26307,
      question: "What is the 5-year survival rate for patients with small, localized oral squamous cell cancer lesions?",
      options: [
        "83%",
        "67%",
        "75%",
        "91%"
      ],
      correct: "A"
    },
    {
      id: 26308,
      question: "What percentage of cervical cancers are caused by HPV infections?",
      options: [
        "Nearly all cervical cancers",
        "Approximately 75%",
        "About 60%",
        "Around 85%"
      ],
      correct: "A"
    },
    {
      id: 26309,
      question: "Between what years did HPV-related oropharyngeal cancers increase from 16% to 72%?",
      options: [
        "1990-1995 to 2005-2010",
        "1984-1989 to 2000-2004",
        "1980-1985 to 1995-2000",
        "1988-1993 to 2003-2007"
      ],
      correct: "B"
    },
    {
      id: 26310,
      question: "What percentage of oropharyngeal cancers are caused by HPV-16 infections?",
      options: [
        "72% to 80%",
        "85% to 96%",
        "65% to 75%",
        "90% to 98%"
      ],
      correct: "B"
    },
    {
      id: 26311,
      question: "At what age does the CDC recommend routine HPV vaccination?",
      options: [
        "13 or 14 years",
        "9 or 10 years",
        "11 or 12 years",
        "15 or 16 years"
      ],
      correct: "C"
    },
    {
      id: 26312,
      question: "What are the most common sites for oral-cavity squamous cell carcinomas?",
      options: [
        "Hard palate and buccal mucosa",
        "Lateral borders and ventral surfaces of tongue and floor of mouth",
        "Soft palate and uvula",
        "Gingiva and alveolar ridge"
      ],
      correct: "B"
    },
    {
      id: 26313,
      question: "What type of surgical procedure uses extreme cold to remove cancerous tumors?",
      options: [
        "Laser surgery",
        "Photodynamic therapy",
        "Cryosurgery",
        "Hyperthermia"
      ],
      correct: "C"
    },
    {
      id: 26314,
      question: "What condition results from chemotherapy-induced suppression of red blood cells, white blood cells, and platelets?",
      options: [
        "Thrombocytopenia",
        "Neutropenia",
        "Myelosuppression",
        "Pancytopenia"
      ],
      correct: "C"
    },
    {
      id: 26315,
      question: "What percentage of patients undergoing chemotherapy develop oral mucositis?",
      options: [
        "40%",
        "60%",
        "25%",
        "80%"
      ],
      correct: "A"
    },
    {
      id: 26316,
      question: "What percentage of patients undergoing oral radiation therapy develop oral mucositis?",
      options: [
        "85%",
        "75%",
        "100%",
        "90%"
      ],
      correct: "C"
    },
    {
      id: 26317,
      question: "What percentage of patients undergoing stem cell transplant therapy develop oral mucositis?",
      options: [
        "100%",
        "80%",
        "60%",
        "95%"
      ],
      correct: "B"
    },
    {
      id: 26318,
      question: "Into how many stages can the oral mucositis process be divided?",
      options: [
        "Three stages",
        "Four stages",
        "Five stages",
        "Six stages"
      ],
      correct: "C"
    },
    {
      id: 26319,
      question: "What is the recommended baking soda and water rinse formula for mucositis management?",
      options: [
        "1 tsp baking soda, 1/2 tsp salt, 16 oz water",
        "2 tsp baking soda, 1 tsp salt, 32 oz water",
        "1/2 tsp baking soda, 1/4 tsp salt, 8 oz water",
        "1 tsp baking soda, 1/4 tsp salt, 24 oz water"
      ],
      correct: "A"
    },
    {
      id: 26320,
      question: "How often should patients with mucositis rinse with sodium bicarbonate mouth rinses?",
      options: [
        "Every 6 to 8 hours",
        "Once daily",
        "Every 4 to 6 hours",
        "Twice daily"
      ],
      correct: "C"
    },
    {
      id: 26321,
      question: "What is the most common fungal organism implicated in cancer-related oral infections?",
      options: [
        "Aspergillus",
        "Candida albicans",
        "Cryptococcus",
        "Histoplasma"
      ],
      correct: "B"
    },
    {
      id: 26322,
      question: "When does salivary gland dysfunction typically begin during radiation therapy?",
      options: [
        "After 2 weeks of treatment",
        "Within the first week of treatment",
        "After 1 month of treatment",
        "At the end of treatment"
      ],
      correct: "B"
    },
    {
      id: 26323,
      question: "What is the term for difficulty chewing or swallowing food?",
      options: [
        "Dysphonia",
        "Dysphagia",
        "Dyspnea",
        "Dysgeusia"
      ],
      correct: "B"
    },
    {
      id: 26324,
      question: "What type of nerve damage can occur with chemotherapeutic agents derived from plant alkaloids?",
      options: [
        "Peripheral neuropathy",
        "Autonomic dysfunction",
        "Neurotoxicity",
        "Demyelination"
      ],
      correct: "C"
    },
    {
      id: 26325,
      question: "At what platelet count level may patients experience oral hemorrhaging during invasive dental procedures?",
      options: [
        "Less than 50,000/mm³",
        "Less than 100,000/mm³",
        "Less than 75,000/mm³",
        "Less than 25,000/mm³"
      ],
      correct: "C"
    },
    {
      id: 26326,
      question: "What class of drugs inhibits the ability of osteoclasts to resorb bone?",
      options: [
        "Corticosteroids",
        "Bisphosphonates",
        "Immunosuppressants",
        "Antimetabolites"
      ],
      correct: "B"
    },
    {
      id: 26327,
      question: "How long can the half-life of bisphosphonates last in the body?",
      options: [
        "5 years or more",
        "2 to 3 years",
        "10 or more years",
        "7 to 8 years"
      ],
      correct: "C"
    },
    {
      id: 26328,
      question: "What percentage of cancer patients receiving intravenously administered bisphosphonates develop MRONJ?",
      options: [
        "Less than 10%",
        "Less than 5%",
        "Less than 15%",
        "Less than 20%"
      ],
      correct: "B"
    },
    {
      id: 26329,
      question: "Which bone appears more susceptible to osteoradionecrosis than the other?",
      options: [
        "Maxilla",
        "Mandible",
        "Zygomatic bone",
        "Palatine bone"
      ],
      correct: "B"
    },
    {
      id: 26330,
      question: "What is the definition of osteoradionecrosis (ORN)?",
      options: [
        "Irradiated bone that becomes infected within 1 month",
        "Bone fracture following radiation",
        "Irradiated bone that becomes devitalized, exposed, and doesn\'t heal for at least 2 months",
        "Temporary bone inflammation from radiation"
      ],
      correct: "C"
    },
    {
      id: 26331,
      question: "Within what timeframe does trismus usually occur after radiation therapy?",
      options: [
        "Within 6 months",
        "Within 1 year",
        "Within 3 months",
        "Immediately after treatment"
      ],
      correct: "C"
    },
    {
      id: 26332,
      question: "How many times per day should jaw exercises be performed to prevent trismus?",
      options: [
        "Once a day",
        "Twice a day",
        "Three times a day",
        "Four times a day"
      ],
      correct: "C"
    },
    {
      id: 26333,
      question: "How many times should the mouth be opened and closed during each trismus prevention exercise session?",
      options: [
        "10 times",
        "20 times",
        "30 times",
        "15 times"
      ],
      correct: "B"
    },
    {
      id: 26334,
      question: "What is the minimum time oral surgical procedures should be performed before periods of immunosuppression?",
      options: [
        "14 days",
        "21 days",
        "7 days",
        "10 days"
      ],
      correct: "C"
    },
    {
      id: 26335,
      question: "What is the recommended timeframe for oral surgical procedures before the initiation of radiation therapy?",
      options: [
        "7 to 10 days",
        "21 to 28 days",
        "14 to 21 days",
        "10 to 14 days"
      ],
      correct: "C"
    },
    {
      id: 26336,
      question: "What percentage neutral-pH sodium fluoride gel should be used in custom fluoride trays?",
      options: [
        "0.5%",
        "1.1%",
        "2.0%",
        "1.5%"
      ],
      correct: "B"
    },
    {
      id: 26337,
      question: "For how many minutes should fluoride gel be applied in custom trays?",
      options: [
        "3 to 5 minutes",
        "10 to 15 minutes",
        "5 to 10 minutes",
        "2 to 3 minutes"
      ],
      correct: "C"
    },
    {
      id: 26338,
      question: "How long should patients avoid eating or drinking after fluoride gel application?",
      options: [
        "15 minutes",
        "45 minutes",
        "30 minutes",
        "60 minutes"
      ],
      correct: "C"
    },
    {
      id: 26339,
      question: "At what absolute neutrophil count should dental hygiene procedures be scheduled?",
      options: [
        ">500/mm³",
        ">2000/mm³",
        ">1000/mm³",
        ">1500/mm³"
      ],
      correct: "C"
    },
    {
      id: 26340,
      question: "What platelet count should patients have before dental hygiene procedures can be performed?",
      options: [
        ">75,000/mm³",
        ">100,000/mm³",
        ">50,000/mm³",
        ">25,000/mm³"
      ],
      correct: "C"
    },
    {
      id: 26341,
      question: "How long can patients remain susceptible to infections after being released from a transplant unit?",
      options: [
        "Several weeks",
        "Several days",
        "One year",
        "Several months"
      ],
      correct: "D"
    },
    {
      id: 26342,
      question: "Within what timeframe can graft-versus-host disease occur after stem cell transplantation?",
      options: [
        "Within a few months",
        "Within a few days",
        "Within a few weeks",
        "Within the first year"
      ],
      correct: "C"
    },
    {
      id: 26343,
      question: "How many different professionals could potentially make up the interprofessional collaborative practice team for a cancer patient?",
      options: [
        "More than 40",
        "More than 80",
        "More than 60",
        "More than 50"
      ],
      correct: "C"
    },
    {
      id: 26344,
      question: "What is the estimated number of new cases of oral cavity and pharyngeal cancer in the United States in 2022?",
      options: [
        "Approximately 45,000",
        "Approximately 62,000",
        "Approximately 54,000",
        "Approximately 38,000"
      ],
      correct: "C"
    },
    {
      id: 26345,
      question: "How many estimated males will be diagnosed with oral cavity and pharyngeal cancer in 2022?",
      options: [
        "38,700",
        "42,500",
        "33,200",
        "45,800"
      ],
      correct: "A"
    },
    {
      id: 26346,
      question: "How many estimated females will be diagnosed with oral cavity and pharyngeal cancer in 2022?",
      options: [
        "18,500",
        "15,300",
        "12,800",
        "20,100"
      ],
      correct: "B"
    },
    {
      id: 26347,
      question: "What is the overall 5-year relative survival rate for oral and pharyngeal cancer in Whites?",
      options: [
        "75%",
        "62%",
        "69%",
        "58%"
      ],
      correct: "C"
    },
    {
      id: 26348,
      question: "What is the overall 5-year relative survival rate for oral and pharyngeal cancer in African Americans?",
      options: [
        "51%",
        "45%",
        "58%",
        "63%"
      ],
      correct: "A"
    },
    {
      id: 26349,
      question: "What is the 5-year survival rate for patients whose oral cancer has metastasized to distant parts of the body?",
      options: [
        "40%",
        "15%",
        "28%",
        "35%"
      ],
      correct: "C"
    },
    {
      id: 26350,
      question: "How many estimated cancer deaths annually are caused by cigarette smoking?",
      options: [
        "150,200 deaths",
        "130,180 deaths",
        "110,500 deaths",
        "145,000 deaths"
      ],
      correct: "B"
    },
    {
      id: 26351,
      question: "What is the total estimated number of cancer deaths annually in the United States?",
      options: [
        "575,300 deaths",
        "650,200 deaths",
        "609,360 deaths",
        "590,100 deaths"
      ],
      correct: "C"
    },
    {
      id: 26352,
      question: "Approximately how many cancer survivors are estimated to be in the United States?",
      options: [
        "15.2 million",
        "18.5 million",
        "12.8 million",
        "21.3 million"
      ],
      correct: "B"
    },
    {
      id: 26353,
      question: "What percentage drop in cancer deaths has occurred, attributed primarily to reduction in smoking and improvements in early detection?",
      options: [
        "25%",
        "40%",
        "32%",
        "28%"
      ],
      correct: "C"
    },
    {
      id: 26354,
      question: "By approximately what percentage has the incidence rate of oral cavity and pharyngeal cancer increased per year?",
      options: [
        "2%",
        "0.5%",
        "1%",
        "1.5%"
      ],
      correct: "C"
    },
    {
      id: 26355,
      question: "How many HPV subtypes have been identified?",
      options: [
        "More than 150",
        "More than 200",
        "More than 100",
        "More than 250"
      ],
      correct: "B"
    },
    {
      id: 26356,
      question: "Which HPV subtypes are considered carcinogens and pose high risk for cancerous lesions?",
      options: [
        "HPV 11 and 13",
        "HPV 6 and 11",
        "HPV 16 and 18",
        "HPV 31 and 33"
      ],
      correct: "C"
    },
    {
      id: 26357,
      question: "How many HPV types does the Gardasil 9 vaccine protect against?",
      options: [
        "5 HPV types",
        "7 HPV types",
        "9 HPV types",
        "4 HPV types"
      ],
      correct: "C"
    },
    {
      id: 26358,
      question: "Up to what age does the Advisory Committee on Immunization Practices recommend HPV vaccination for inadequately vaccinated individuals?",
      options: [
        "21 years",
        "30 years",
        "26 years",
        "25 years"
      ],
      correct: "C"
    },
    {
      id: 26359,
      question: "What is the recommended interval for continued dental hygiene care after cancer therapy until acute side effects resolve?",
      options: [
        "2 to 3 months",
        "4 to 6 months",
        "1 to 2 months",
        "6 to 12 months"
      ],
      correct: "A"
    },
    {
      id: 26360,
      question: "What should be used instead of commercial mouthwashes with alcohol during cancer therapy?",
      options: [
        "Diluted hydrogen peroxide",
        "Listerine diluted with water",
        "Bland rinses such as 0.9% normal saline",
        "Chlorhexidine only"
      ],
      correct: "C"
    },
    {
      id: 26361,
      question: "What type of toothbrush bristles should be used during cancer therapy?",
      options: [
        "Medium bristles",
        "Hard bristles",
        "Extra soft or super soft bristles",
        "Standard soft bristles"
      ],
      correct: "C"
    },
    {
      id: 26362,
      question: "What can be used as an alternative dentifrice during cancer therapy?",
      options: [
        "Regular toothpaste diluted",
        "Baking soda and water paste",
        "Salt water only",
        "Fluoride gel"
      ],
      correct: "B"
    },
    {
      id: 26363,
      question: "What should patients avoid if toothbrushing becomes impossible due to painful tissues?",
      options: [
        "All oral hygiene",
        "Using mouthwash",
        "Glycerin swabs",
        "Drinking water"
      ],
      correct: "C"
    },
    {
      id: 26364,
      question: "What can be used to cleanse teeth when toothbrushing is not possible?",
      options: [
        "Cotton swabs",
        "Sponge toothbrushes only",
        "Gauze moistened in warm water",
        "Paper towels"
      ],
      correct: "C"
    },
    {
      id: 26365,
      question: "What is the recommended formulation for sodium bicarbonate rinse for mucositis?",
      options: [
        "1/2 tsp baking soda, 1/4 tsp salt, 16 oz water",
        "1/4 tsp baking soda, 1/4 tsp salt, 32 oz water",
        "1 tsp baking soda, 1/2 tsp salt, 32 oz water",
        "2 tsp baking soda, 1 tsp salt, 16 oz water"
      ],
      correct: "B"
    },
    {
      id: 26366,
      question: "What type of anesthetic agents may anesthetize the soft palate and epiglottis, potentially causing aspiration?",
      options: [
        "Injectable anesthetics",
        "Systemic analgesics",
        "Topical anesthetic agents",
        "Narcotic medications"
      ],
      correct: "C"
    },
    {
      id: 26367,
      question: "What should be done if dentures or partials cause trauma or pain during cancer therapy?",
      options: [
        "Continue wearing them",
        "Adjust them at home",
        "Remove the appliance and seek dental care",
        "Wear them only at night"
      ],
      correct: "C"
    },
    {
      id: 26368,
      question: "When should the fabrication of new dental prostheses be scheduled after head and neck radiation therapy?",
      options: [
        "Immediately after treatment",
        "One month after treatment",
        "Several months after treatment when acute side effects resolve",
        "During radiation therapy"
      ],
      correct: "C"
    },
    {
      id: 26369,
      question: "What lip moisturizer should NOT be used alone according to the recommendations?",
      options: [
        "Lip balm",
        "Pure petrolatum",
        "Moisturizing cream",
        "Lanolin-based products"
      ],
      correct: "B"
    },
    {
      id: 26370,
      question: "How should saliva substitutes be evaluated by patients?",
      options: [
        "They are universally effective",
        "They should be used continuously",
        "Patients may find them unacceptable in taste and too expensive",
        "They work better than water"
      ],
      correct: "C"
    },
    {
      id: 26371,
      question: "What effect may chlorhexidine gluconate 0.12% have on teeth?",
      options: [
        "Permanent whitening",
        "Enamel erosion",
        "Staining that is removable with dental prophylaxis",
        "Increased sensitivity"
      ],
      correct: "C"
    },
    {
      id: 26372,
      question: "For how long should chlorhexidine gluconate 0.12% be used as a mouth rinse?",
      options: [
        "15 seconds",
        "60 seconds",
        "30 seconds",
        "45 seconds"
      ],
      correct: "C"
    },
    {
      id: 26373,
      question: "What dietary changes might cancer patients make that can lead to increased plaque formation?",
      options: [
        "Eating more raw vegetables",
        "Shifting toward softer, processed foods",
        "Consuming more protein",
        "Increasing fiber intake"
      ],
      correct: "B"
    },
    {
      id: 26374,
      question: "What type of radiation therapy involves ribbons or capsules containing a radiation source placed near the tumor?",
      options: [
        "External-beam radiation therapy",
        "Proton therapy",
        "Internal radiation therapy or brachytherapy",
        "Intensity-modulated radiation therapy"
      ],
      correct: "C"
    },
    {
      id: 26375,
      question: "What is the primary cause of rampant caries after radiation therapy?",
      options: [
        "Poor oral hygiene",
        "Changes in quality and quantity of saliva",
        "Increased sugar consumption",
        "Bacterial overgrowth"
      ],
      correct: "B"
    },
    {
      id: 26376,
      question: "When does enamel demineralization or rapid decay usually begin after radiation therapy?",
      options: [
        "Within the first month",
        "After 2 years",
        "Within the first year",
        "After 6 months"
      ],
      correct: "C"
    },
    {
      id: 26377,
      question: "What should custom fluoride trays be made from?",
      options: [
        "Hard acrylic material",
        "Soft vinyl material",
        "Rigid plastic",
        "Metal framework"
      ],
      correct: "B"
    },
    {
      id: 26378,
      question: "How should custom fluoride tray edges be prepared?",
      options: [
        "Sharp and precise",
        "Thick and bulky",
        "Smooth and nonirritating",
        "Rough for better retention"
      ],
      correct: "C"
    },
    {
      id: 26379,
      question: "Where should custom fluoride trays extend on the teeth?",
      options: [
        "Only to the incisal edges",
        "To the middle of the crown",
        "Slightly beyond the cervical line",
        "Just to the gingival margin"
      ],
      correct: "C"
    },
    {
      id: 26380,
      question: "What should patients do after fluoride gel application in trays?",
      options: [
        "Rinse immediately",
        "Eat soft foods",
        "Not rinse, eat, or drink for 30 minutes",
        "Drink water only"
      ],
      correct: "C"
    },
    {
      id: 26381,
      question: "What alternative can be used if severe mucositis prevents fluoride application with trays?",
      options: [
        "No fluoride at all",
        "Nonalcoholic and bland fluoride rinses",
        "Prescription fluoride pills",
        "Fluoride toothpaste only"
      ],
      correct: "B"
    },
    {
      id: 26382,
      question: "What might be necessary if dental decay occurs despite daily fluoride applications?",
      options: [
        "Tooth extraction",
        "2-week chlorhexidine regimen and in-office fluoride varnish",
        "Antibiotics",
        "Increased brushing frequency"
      ],
      correct: "B"
    },
    {
      id: 26383,
      question: "What additional treatment may be necessary along with daily fluoride gel application for some patients?",
      options: [
        "Prescription mouthwash",
        "Daily remineralizing gel application",
        "Antibiotic rinse",
        "Desensitizing paste"
      ],
      correct: "B"
    },
    {
      id: 26384,
      question: "What method can help manage trismus after radiation therapy?",
      options: [
        "Pain medication only",
        "Placing tongue blades between teeth and gradually increasing the number",
        "Avoiding all jaw movement",
        "Surgery only"
      ],
      correct: "B"
    },
    {
      id: 26385,
      question: "What is required for providing competent dental hygiene care for cancer patients?",
      options: [
        "Working independently",
        "Establishing a relationship with the interprofessional oncology team",
        "Focusing only on oral hygiene",
        "Limiting communication with other providers"
      ],
      correct: "B"
    },
    {
      id: 26386,
      question: "What type of cancer treatment approach is based on genetic assessment of the patient\'s disease?",
      options: [
        "Standard chemotherapy",
        "Precision medicine or personalized medicine",
        "Radiation therapy",
        "Combination therapy"
      ],
      correct: "B"
    },
    {
      id: 26387,
      question: "What have researchers discovered about cancerous tumors regarding precision medicine?",
      options: [
        "They all respond the same to treatment",
        "They contain genetic changes that signal cells to grow and spread",
        "They cannot be genetically analyzed",
        "They have identical mutations"
      ],
      correct: "B"
    },
    {
      id: 26388,
      question: "What is the goal of precision medicine in cancer treatment?",
      options: [
        "To use the same treatment for all patients",
        "To identify tumor genetic deviations and use targeted therapy",
        "To increase radiation doses",
        "To combine multiple chemotherapy drugs"
      ],
      correct: "B"
    },
    {
      id: 26389,
      question: "What immunologic reaction can occur where donor white blood cells react against host tissue antigens?",
      options: [
        "Transplant rejection",
        "Allergic response",
        "Graft-versus-host disease",
        "Immune reconstitution"
      ],
      correct: "C"
    },
    {
      id: 26390,
      question: "What viral infection is common after stem cell transplantation?",
      options: [
        "Influenza virus",
        "Herpes simplex virus",
        "Rhinovirus",
        "Adenovirus"
      ],
      correct: "B"
    },
    {
      id: 26391,
      question: "What type of therapy boosts the natural ability of T cells to attach to cancer cells?",
      options: [
        "Hormone therapy",
        "Chemotherapy",
        "Adaptive cell transfer",
        "Radiation therapy"
      ],
      correct: "C"
    },
    {
      id: 26392,
      question: "What is used in some immunotherapy to boost the body\'s immune response to cancer?",
      options: [
        "Antibodies only",
        "Cytokines",
        "Steroids",
        "Vitamins"
      ],
      correct: "B"
    },
    {
      id: 26393,
      question: "What do targeted therapy drugs interfere with?",
      options: [
        "All cellular division",
        "Cellular proteins that support tumor growth and metastasis",
        "Only healthy cells",
        "Immune system function"
      ],
      correct: "B"
    },
    {
      id: 26394,
      question: "Why might targeted therapy be used with chemotherapy and radiation?",
      options: [
        "To reduce treatment time",
        "Cancer cells can become resistant with targeted therapy alone",
        "It\'s less expensive",
        "It has no side effects"
      ],
      correct: "B"
    },
    {
      id: 26395,
      question: "What type of cancers is hormone therapy used to treat?",
      options: [
        "All cancer types",
        "Tumors that depend on hormones, such as breast or prostate cancer",
        "Only brain cancers",
        "Skin cancers only"
      ],
      correct: "B"
    },
    {
      id: 26396,
      question: "What effect does hormone therapy have on hormone-dependent tumors?",
      options: [
        "Makes them grow faster",
        "Has no effect",
        "Slows or stops their growth",
        "Causes immediate cell death"
      ],
      correct: "C"
    },
    {
      id: 26397,
      question: "What is another name for stem cell transplantation?",
      options: [
        "Plasma transfusion",
        "Bone marrow transplant (BMT)",
        "White blood cell infusion",
        "Platelet transfer"
      ],
      correct: "B"
    },
    {
      id: 26398,
      question: "What does stem cell transplantation restore after chemotherapy or radiation?",
      options: [
        "Liver function",
        "Blood-forming stem cells",
        "Kidney function",
        "Lung capacity"
      ],
      correct: "B"
    },
    {
      id: 26399,
      question: "What types of cancers are commonly treated with stem cell transplantation?",
      options: [
        "Only solid tumors",
        "Hematologic diseases like leukemia and lymphoma",
        "Skin cancers only",
        "Gastrointestinal cancers"
      ],
      correct: "B"
    },
    {
      id: 26400,
      question: "What may occur within a few weeks of stem cell transplantation as a complication?",
      options: [
        "Complete recovery",
        "Graft-versus-host disease",
        "Tumor regrowth",
        "Organ failure"
      ],
      correct: "B"
    },
    {
      id: 26401,
      question: "What oral complication is associated with graft-versus-host disease?",
      options: [
        "Excessive salivation",
        "Oral mucositis and salivary gland dysfunction",
        "Tooth overgrowth",
        "Gingival hyperplasia"
      ],
      correct: "B"
    },
    {
      id: 26402,
      question: "What type of therapy uses extreme heat as an experimental cancer treatment?",
      options: [
        "Cryosurgery",
        "Photodynamic therapy",
        "Hyperthermia",
        "Laser therapy"
      ],
      correct: "C"
    },
    {
      id: 26403,
      question: "What does photodynamic therapy use to treat cancer?",
      options: [
        "Radiation only",
        "Drugs to sensitize cells to a specific type of light",
        "Heat application",
        "Chemical burns"
      ],
      correct: "B"
    },
    {
      id: 26404,
      question: "What can radiation therapy result in regarding bone?",
      options: [
        "Increased bone density",
        "Osteoradionecrosis",
        "Accelerated healing",
        "No bone changes"
      ],
      correct: "B"
    },
    {
      id: 26405,
      question: "What should be avoided throughout a patient\'s lifetime after radiation therapy to the jaw?",
      options: [
        "Dental cleanings",
        "All surgical insult to irradiated bone",
        "Fluoride treatments",
        "Orthodontic treatment"
      ],
      correct: "B"
    },
    {
      id: 26406,
      question: "What treatment might be considered for osteoradionecrosis management?",
      options: [
        "Antibiotics only",
        "Hyperbaric oxygen therapy and surgical management",
        "Increased fluoride use",
        "Pain medication only"
      ],
      correct: "B"
    },
    {
      id: 26407,
      question: "What is the key to survival for oral squamous cell cancer?",
      options: [
        "Aggressive chemotherapy",
        "Multiple surgeries",
        "Early detection",
        "Radiation therapy"
      ],
      correct: "C"
    },
    {
      id: 26408,
      question: "What should people do if they have one of the seven common signs of cancer for more than 2 weeks?",
      options: [
        "Wait another month",
        "Self-medicate",
        "See a doctor promptly",
        "Ignore it if painless"
      ],
      correct: "C"
    },
    {
      id: 26409,
      question: "What is NOT typically a symptom during early stages of cancer?",
      options: [
        "Unusual bleeding",
        "Pain",
        "Lumps",
        "Changes in bowel habits"
      ],
      correct: "B"
    },
    {
      id: 26410,
      question: "What type of cancers include the back third or base of the tongue?",
      options: [
        "Oral cavity cancers",
        "Oropharyngeal cancers",
        "Pharyngeal cancers only",
        "Laryngeal cancers"
      ],
      correct: "B"
    },
    {
      id: 26411,
      question: "What area do oral cavity cancers include?",
      options: [
        "Back of throat only",
        "Anterior part of mouth including lips, tongue, gingiva",
        "Tonsil area",
        "Esophagus"
      ],
      correct: "B"
    }
  ],
  "4. HIV and Oral Health": [
    {
      id: 26400,
      question: "When was HIV first reported by the US Centers for Disease Control and Prevention?",
      options: [
        "June and July 1981",
        "January and February 1980",
        "March and April 1982",
        "December 1979"
      ],
      correct: "A"
    },
    {
      id: 26401,
      question: "What percentage of HIV-infected patients will have at least one HIV-related oral manifestation during their disease course?",
      options: [
        "More than 70%",
        "More than 80%",
        "More than 90%",
        "More than 60%"
      ],
      correct: "C"
    },
    {
      id: 26402,
      question: "In what year did AIDS mortality first show a significant decrease?",
      options: [
        "1994",
        "1998",
        "1996",
        "2000"
      ],
      correct: "C"
    },
    {
      id: 26403,
      question: "What does U=U stand for in the context of HIV?",
      options: [
        "Undetectable = Untransmissible",
        "Universal = Uniform",
        "Uncontrolled = Unmanageable",
        "Urgent = Unresolved"
      ],
      correct: "A"
    },
    {
      id: 26404,
      question: "How many stages are in the HIV life cycle?",
      options: [
        "Six stages",
        "Seven stages",
        "Eight stages",
        "Nine stages"
      ],
      correct: "C"
    },
    {
      id: 26405,
      question: "Which type of white blood cell does HIV primarily infect?",
      options: [
        "B lymphocytes",
        "Natural killer cells",
        "CD4+ T lymphocytes",
        "Neutrophils"
      ],
      correct: "C"
    },
    {
      id: 26406,
      question: "What enzyme does HIV use to convert viral RNA into DNA?",
      options: [
        "DNA polymerase",
        "Reverse transcriptase",
        "RNA polymerase",
        "DNA ligase"
      ],
      correct: "B"
    },
    {
      id: 26407,
      question: "How many days after exposure does acute HIV infection syndrome occur?",
      options: [
        "3 to 30 days",
        "10 to 45 days",
        "6 to 56 days",
        "15 to 60 days"
      ],
      correct: "C"
    },
    {
      id: 26408,
      question: "What percentage of CD4+ T lymphocytes are lost per year on average during the asymptomatic period of HIV infection?",
      options: [
        "5%",
        "15%",
        "10%",
        "20%"
      ],
      correct: "C"
    },
    {
      id: 26409,
      question: "What is the estimated number of Americans living with diagnosed or undiagnosed HIV infection?",
      options: [
        "900,000",
        "1.5 million",
        "1.2 million",
        "2 million"
      ],
      correct: "C"
    },
    {
      id: 26410,
      question: "What percentage of Americans living with HIV are diagnosed according to the CDC?",
      options: [
        "75%",
        "92%",
        "87%",
        "80%"
      ],
      correct: "C"
    },
    {
      id: 26411,
      question: "Approximately how many new HIV infections occurred in the United States in 2019?",
      options: [
        "45,200",
        "36,940",
        "28,500",
        "52,800"
      ],
      correct: "B"
    },
    {
      id: 26412,
      question: "What percentage of people with HIV are African Americans?",
      options: [
        "30%",
        "35%",
        "40%",
        "45%"
      ],
      correct: "C"
    },
    {
      id: 26413,
      question: "What percentage of the US population do African Americans represent?",
      options: [
        "10%",
        "13%",
        "16%",
        "19%"
      ],
      correct: "B"
    },
    {
      id: 26414,
      question: "The incidence of HIV infections among Black females is how many times that of White females?",
      options: [
        "8 times",
        "11 times",
        "14 times",
        "5 times"
      ],
      correct: "B"
    },
    {
      id: 26415,
      question: "What percentage of all PWH are over the age of 50?",
      options: [
        "35%",
        "60%",
        "50%",
        "45%"
      ],
      correct: "C"
    },
    {
      id: 26416,
      question: "What age range does the CDC recommend for at least one-time HIV testing?",
      options: [
        "13 to 64",
        "18 to 65",
        "15 to 60",
        "21 to 70"
      ],
      correct: "A"
    },
    {
      id: 26417,
      question: "What percentage of Americans living with HIV are unaware of their infection?",
      options: [
        "18%",
        "14%",
        "22%",
        "10%"
      ],
      correct: "B"
    },
    {
      id: 26418,
      question: "Approximately what percentage of all Americans living with HIV were controlling the virus through antiviral treatment in 2019?",
      options: [
        "75%",
        "80%",
        "66%",
        "55%"
      ],
      correct: "C"
    },
    {
      id: 26419,
      question: "What is the estimated risk of acquiring HIV infection through an occupational exposure?",
      options: [
        "0.50%",
        "0.23%",
        "0.15%",
        "0.35%"
      ],
      correct: "B"
    },
    {
      id: 26420,
      question: "What is the risk of HIV transmission through exposure via the eye, nose, or mouth?",
      options: [
        "0.1%",
        "0.3%",
        "0.05%",
        "0.2%"
      ],
      correct: "A"
    },
    {
      id: 26421,
      question: "Within how many hours should postexposure ART ideally be initiated?",
      options: [
        "6 hours",
        "12 hours",
        "2 hours",
        "24 hours"
      ],
      correct: "C"
    },
    {
      id: 26422,
      question: "Within what maximum timeframe must postexposure ART be started to be effective?",
      options: [
        "48 hours",
        "96 hours",
        "72 hours",
        "120 hours"
      ],
      correct: "C"
    },
    {
      id: 26423,
      question: "For how many days should postexposure prophylaxis be taken?",
      options: [
        "21 days",
        "14 days",
        "28 days",
        "35 days"
      ],
      correct: "C"
    },
    {
      id: 26424,
      question: "By what percentage does PrEP reduce the risk of HIV transmission when properly adhered to?",
      options: [
        "Over 85%",
        "Over 92%",
        "Over 78%",
        "Over 95%"
      ],
      correct: "B"
    },
    {
      id: 26425,
      question: "What is the most commonly seen oral manifestation in PWH?",
      options: [
        "Hairy leukoplakia",
        "Oral candidiasis",
        "Kaposi sarcoma",
        "Herpes simplex"
      ],
      correct: "B"
    },
    {
      id: 26426,
      question: "Which virus is associated with hairy leukoplakia?",
      options: [
        "Cytomegalovirus",
        "Human papillomavirus",
        "Epstein-Barr virus",
        "Varicella-zoster virus"
      ],
      correct: "C"
    },
    {
      id: 26427,
      question: "Where does hairy leukoplakia typically present?",
      options: [
        "Hard palate",
        "Buccal mucosa",
        "Lateral border of the tongue",
        "Floor of mouth"
      ],
      correct: "C"
    },
    {
      id: 26428,
      question: "What type of tissue does pseudomembranous candidiasis appear as?",
      options: [
        "Red, bleeding patches",
        "Soft, yellow-white, curd-like plaques",
        "Purple nodules",
        "White corrugated lesions"
      ],
      correct: "B"
    },
    {
      id: 26429,
      question: "What organism causes pseudomembranous candidiasis?",
      options: [
        "Streptococcus mutans",
        "Staphylococcus aureus",
        "Candida albicans",
        "Aspergillus niger"
      ],
      correct: "C"
    },
    {
      id: 26430,
      question: "Where does erythematous candidiasis most commonly appear?",
      options: [
        "Tongue or buccal/palatal mucosa",
        "Gingiva only",
        "Floor of mouth",
        "Lips only"
      ],
      correct: "A"
    },
    {
      id: 26431,
      question: "What characterizes angular cheilitis?",
      options: [
        "White plaques on lips",
        "Redness, cracks, crusting at lip commissures",
        "Purple nodules on lips",
        "Bleeding ulcers on lips"
      ],
      correct: "B"
    },
    {
      id: 26432,
      question: "What is the characteristic pain description for necrotizing ulcerative periodontitis?",
      options: [
        "Sharp, stabbing pain",
        "Mild, throbbing pain",
        "Severe, deep jaw pain",
        "Burning, superficial pain"
      ],
      correct: "C"
    },
    {
      id: 26433,
      question: "Which HPV type is overwhelmingly associated with oropharyngeal cancer?",
      options: [
        "HPV11",
        "HPV6",
        "HPV16",
        "HPV18"
      ],
      correct: "C"
    },
    {
      id: 26434,
      question: "On what type of tissue does herpes simplex virus typically appear?",
      options: [
        "Nonkeratinized tissue only",
        "Any oral tissue",
        "Keratinized tissue or vermilion border",
        "Soft palate only"
      ],
      correct: "C"
    },
    {
      id: 26435,
      question: "How long do HSV lesions typically heal within?",
      options: [
        "3 to 4 weeks",
        "5 to 7 days",
        "1 to 2 weeks",
        "2 to 3 days"
      ],
      correct: "C"
    },
    {
      id: 26436,
      question: "What appearance characterizes Kaposi sarcoma lesions?",
      options: [
        "White corrugated patches",
        "Flat, red, or purple to dark purple macules",
        "Yellow-white plaques",
        "Clear vesicles"
      ],
      correct: "B"
    },
    {
      id: 26437,
      question: "Which virus is most notably associated with Kaposi sarcoma?",
      options: [
        "Human herpesvirus-8",
        "Epstein-Barr virus",
        "Cytomegalovirus",
        "Human papillomavirus"
      ],
      correct: "A"
    },
    {
      id: 26438,
      question: "What percentage of all oral cancers does squamous cell carcinoma account for in the general population?",
      options: [
        "75%",
        "85%",
        "90%",
        "95%"
      ],
      correct: "C"
    },
    {
      id: 26439,
      question: "On what type of tissue do aphthous ulcers occur?",
      options: [
        "Keratinized tissue only",
        "Nonkeratinized tissue",
        "Hard palate only",
        "Attached gingiva"
      ],
      correct: "B"
    },
    {
      id: 26440,
      question: "What appearance characterizes aphthous ulcers?",
      options: [
        "White corrugated surface",
        "Purple nodules",
        "Halo of inflammation with gray or yellow cover",
        "Red, bleeding patches"
      ],
      correct: "C"
    },
    {
      id: 26441,
      question: "What is the first class of drugs approved by the FDA to treat HIV?",
      options: [
        "Protease inhibitors",
        "Integrase inhibitors",
        "Reverse transcriptase inhibitors",
        "Fusion inhibitors"
      ],
      correct: "C"
    },
    {
      id: 26442,
      question: "When were protease inhibitors first introduced?",
      options: [
        "1992",
        "1995",
        "1998",
        "2000"
      ],
      correct: "B"
    },
    {
      id: 26443,
      question: "When was the first integrase inhibitor approved?",
      options: [
        "2005",
        "2009",
        "2012",
        "2007"
      ],
      correct: "B"
    },
    {
      id: 26444,
      question: "What is the fusion inhibitor approved in 2003?",
      options: [
        "Maraviroc",
        "Raltegravir",
        "Enfuvirtide",
        "Fostemsavir"
      ],
      correct: "C"
    },
    {
      id: 26445,
      question: "When was the CCR5 antagonist maraviroc approved?",
      options: [
        "2003",
        "2007",
        "2009",
        "2005"
      ],
      correct: "B"
    },
    {
      id: 26446,
      question: "What is the name of the long-acting injectable HIV treatment approved by the FDA?",
      options: [
        "Stribild",
        "Cabenuva",
        "Truvada",
        "Atripla"
      ],
      correct: "B"
    },
    {
      id: 26447,
      question: "What medication was used in the seminal HPTN 076 clinical trial to reduce vertical transmission?",
      options: [
        "Tenofovir",
        "Emtricitabine",
        "Zidovudine",
        "Lamivudine"
      ],
      correct: "C"
    },
    {
      id: 26448,
      question: "What is zidovudine also known as?",
      options: [
        "3TC",
        "AZT",
        "d4T",
        "ddI"
      ],
      correct: "B"
    },
    {
      id: 26449,
      question: "What does cART stand for?",
      options: [
        "Comprehensive antiretroviral therapy",
        "Complete AIDS recovery treatment",
        "Combination active antiretroviral therapy",
        "Combined antiviral resistance therapy"
      ],
      correct: "C"
    },
    {
      id: 26450,
      question: "What is the current simplified term for HIV multidrug regimens?",
      options: [
        "cART",
        "ART",
        "HAART",
        "MART"
      ],
      correct: "B"
    },
    {
      id: 26451,
      question: "What is Stribild an example of?",
      options: [
        "A single-drug therapy",
        "A twice-daily regimen",
        "A once-daily combination pill",
        "An injectable therapy"
      ],
      correct: "C"
    },
    {
      id: 26452,
      question: "Which component of Stribild is an integrase inhibitor?",
      options: [
        "Tenofovir",
        "Cobicistat",
        "Elvitegravir",
        "Emtricitabine"
      ],
      correct: "C"
    },
    {
      id: 26453,
      question: "What is cobicistat\'s role in Stribild?",
      options: [
        "Integrase inhibitor",
        "NRTI",
        "Boosting agent",
        "Protease inhibitor"
      ],
      correct: "C"
    },
    {
      id: 26454,
      question: "What percentage of reduction in new HIV infections could be expected if all people with HIV received care and treatment?",
      options: [
        "75%",
        "80%",
        "90%",
        "95%"
      ],
      correct: "C"
    },
    {
      id: 26455,
      question: "How many closely related viruses make up HIV?",
      options: [
        "One virus",
        "Two viruses",
        "Three viruses",
        "Four viruses"
      ],
      correct: "B"
    },
    {
      id: 26456,
      question: "Which HIV virus is more common worldwide?",
      options: [
        "HIV-2",
        "Both are equally common",
        "HIV-1",
        "Neither is common"
      ],
      correct: "C"
    },
    {
      id: 26457,
      question: "Where is HIV-2 primarily found?",
      options: [
        "United States",
        "West Africa",
        "Eastern Europe",
        "South America"
      ],
      correct: "B"
    },
    {
      id: 26458,
      question: "How many subtypes or clades does HIV-1 have?",
      options: [
        "At least five",
        "At least seven",
        "At least nine",
        "At least twelve"
      ],
      correct: "C"
    },
    {
      id: 26459,
      question: "What does the HIV virion core contain?",
      options: [
        "DNA",
        "Proteins only",
        "RNA",
        "Lipids only"
      ],
      correct: "C"
    },
    {
      id: 26460,
      question: "What coating encapsulates the HIV core?",
      options: [
        "Protein coating",
        "Carbohydrate coating",
        "Lipid coating",
        "Nucleic acid coating"
      ],
      correct: "C"
    },
    {
      id: 26461,
      question: "What is the primary source of HIV infection among men who have sex with men?",
      options: [
        "Injection drug use",
        "Blood products",
        "Sexual contact",
        "Vertical transmission"
      ],
      correct: "C"
    },
    {
      id: 26462,
      question: "What is the primary route of infection for injection drug users?",
      options: [
        "Sexual contact",
        "Sharing blood-contaminated needles",
        "Blood transfusions",
        "Vertical transmission"
      ],
      correct: "B"
    },
    {
      id: 26463,
      question: "How can HIV-positive mothers transmit the virus to their fetuses?",
      options: [
        "During pregnancy only",
        "During pregnancy, at birth, or when breastfeeding",
        "At birth only",
        "When breastfeeding only"
      ],
      correct: "B"
    },
    {
      id: 26464,
      question: "What is the initial spike in viral levels in the bloodstream called?",
      options: [
        "Secondary viremia",
        "Chronic viremia",
        "Primary viremia",
        "Latent viremia"
      ],
      correct: "C"
    },
    {
      id: 26465,
      question: "What is HIV seroconversion?",
      options: [
        "Loss of antibodies",
        "Viral mutation",
        "Acquisition of HIV-specific antibodies in blood serum",
        "Decrease in viral load"
      ],
      correct: "C"
    },
    {
      id: 26466,
      question: "What percentage of PWH does African Americans represent?",
      options: [
        "25%",
        "40%",
        "29%",
        "35%"
      ],
      correct: "B"
    },
    {
      id: 26467,
      question: "What percentage of PWH were White?",
      options: [
        "35%",
        "29%",
        "25%",
        "20%"
      ],
      correct: "B"
    },
    {
      id: 26468,
      question: "What percentage of PWH were Hispanic/Latino?",
      options: [
        "25%",
        "30%",
        "20%",
        "35%"
      ],
      correct: "A"
    },
    {
      id: 26469,
      question: "In what year was the AIDS Cascade introduced?",
      options: [
        "2009",
        "2011",
        "2013",
        "2015"
      ],
      correct: "B"
    },
    {
      id: 26470,
      question: "What is another name for the AIDS Cascade?",
      options: [
        "HIV Treatment Pathway",
        "HIV Care Continuum",
        "AIDS Management System",
        "HIV Recovery Model"
      ],
      correct: "B"
    },
    {
      id: 26471,
      question: "How many documented transmissions of HIV have occurred in dental healthcare workers since 1999?",
      options: [
        "None",
        "Five",
        "Ten",
        "Two"
      ],
      correct: "A"
    },
    {
      id: 26472,
      question: "What is the estimated number of people living with HIV globally in 2020?",
      options: [
        "30.5 million",
        "37.7 million",
        "42.3 million",
        "25.8 million"
      ],
      correct: "B"
    },
    {
      id: 26473,
      question: "How many children are estimated to be living with HIV globally?",
      options: [
        "1.2 million",
        "2.5 million",
        "1.7 million",
        "900,000"
      ],
      correct: "C"
    },
    {
      id: 26474,
      question: "Where do the majority of affected individuals with HIV live globally?",
      options: [
        "North America",
        "Eastern and Southern Africa",
        "Western Europe",
        "South America"
      ],
      correct: "B"
    },
    {
      id: 26475,
      question: "What is the first stage of the HIV life cycle?",
      options: [
        "Fusion",
        "Integration",
        "Binding",
        "Reverse transcription"
      ],
      correct: "C"
    },
    {
      id: 26476,
      question: "What is the second stage of the HIV life cycle?",
      options: [
        "Binding",
        "Fusion",
        "Reverse transcription",
        "Integration"
      ],
      correct: "B"
    },
    {
      id: 26477,
      question: "What is the third stage of the HIV life cycle?",
      options: [
        "Integration",
        "Replication",
        "Reverse transcription",
        "Assembly"
      ],
      correct: "C"
    },
    {
      id: 26478,
      question: "What is the fourth stage of the HIV life cycle?",
      options: [
        "Replication",
        "Integration",
        "Assembly",
        "Budding"
      ],
      correct: "B"
    },
    {
      id: 26479,
      question: "What is the fifth stage of the HIV life cycle?",
      options: [
        "Assembly",
        "Budding",
        "Replication",
        "Maturation"
      ],
      correct: "C"
    },
    {
      id: 26480,
      question: "What is the sixth stage of the HIV life cycle?",
      options: [
        "Budding",
        "Assembly",
        "Maturation",
        "Release"
      ],
      correct: "B"
    },
    {
      id: 26481,
      question: "What is the seventh stage of the HIV life cycle?",
      options: [
        "Maturation",
        "Release",
        "Budding",
        "Integration"
      ],
      correct: "C"
    },
    {
      id: 26482,
      question: "What is the eighth stage of the HIV life cycle?",
      options: [
        "Release",
        "Budding",
        "Assembly",
        "Maturation"
      ],
      correct: "D"
    },
    {
      id: 26483,
      question: "What does CD4+ T lymphocytes lack?",
      options: [
        "Receptor sites",
        "Cytotoxicity",
        "Cell membrane",
        "Nucleus"
      ],
      correct: "B"
    },
    {
      id: 26484,
      question: "What role do CD4+ T lymphocytes play?",
      options: [
        "Direct killing of infected cells",
        "Antibody production",
        "Activating cytotoxic T lymphocytes",
        "Phagocytosis"
      ],
      correct: "C"
    },
    {
      id: 26485,
      question: "What type of virus is HIV classified as?",
      options: [
        "DNA virus",
        "Retrovirus",
        "Bacteriophage",
        "Oncovirus"
      ],
      correct: "B"
    },
    {
      id: 26486,
      question: "What happens when HIV integrates into the host cell\'s genome?",
      options: [
        "The cell immediately dies",
        "The cell becomes immune",
        "HIV hijacks the host cell",
        "The virus is destroyed"
      ],
      correct: "C"
    },
    {
      id: 26487,
      question: "What is the result of HIV virion circulation?",
      options: [
        "Immune system strengthening",
        "Infection of other immune cells",
        "Viral elimination",
        "Antibody production"
      ],
      correct: "B"
    },
    {
      id: 26488,
      question: "What causes the characteristic immunodeficiency in HIV?",
      options: [
        "Direct organ damage",
        "Suppression of immune response",
        "Autoimmune reaction",
        "Bacterial infection"
      ],
      correct: "B"
    },
    {
      id: 26489,
      question: "What happens if HIV infection is left untreated?",
      options: [
        "Spontaneous recovery",
        "Gradually diminishing immune response",
        "Immune system strengthening",
        "No change in health"
      ],
      correct: "B"
    },
    {
      id: 26490,
      question: "What does a weakened immune response make the host susceptible to?",
      options: [
        "Allergies only",
        "Opportunistic infections and malignancies",
        "Autoimmune diseases",
        "Metabolic disorders"
      ],
      correct: "B"
    },
    {
      id: 26491,
      question: "What is the definition of AIDS-defining illnesses?",
      options: [
        "Any infection in PWH",
        "Diseases that classify HIV as stage 3 or AIDS",
        "Common colds in PWH",
        "Routine viral infections"
      ],
      correct: "B"
    },
    {
      id: 26492,
      question: "What is the CDC categorization of HIV/AIDS based on?",
      options: [
        "Viral load only",
        "CD4+ count and presence of certain OIs",
        "Age of patient",
        "Duration of infection"
      ],
      correct: "B"
    },
    {
      id: 26493,
      question: "What CD4+ count defines stage 1 HIV infection for those 6 years and older?",
      options: [
        "≥300 cells/μL",
        "≥400 cells/μL",
        "≥500 cells/μL",
        "≥600 cells/μL"
      ],
      correct: "C"
    },
    {
      id: 26494,
      question: "What CD4+ count defines stage 3 HIV infection for those 6 years and older?",
      options: [
        "<100 cells/μL",
        "<300 cells/μL",
        "<200 cells/μL",
        "<150 cells/μL"
      ],
      correct: "C"
    },
    {
      id: 26495,
      question: "What CD4+ count defines stage 2 HIV infection for those 6 years and older?",
      options: [
        "100-399 cells/μL",
        "200-499 cells/μL",
        "300-599 cells/μL",
        "150-449 cells/μL"
      ],
      correct: "B"
    },
    {
      id: 26496,
      question: "What is the first step in the HIV Care Continuum?",
      options: [
        "Linkage to care",
        "Testing and diagnosis",
        "Viral suppression",
        "Treatment adherence"
      ],
      correct: "B"
    },
    {
      id: 26497,
      question: "What is the second step in the HIV Care Continuum?",
      options: [
        "Viral suppression",
        "Testing and diagnosis",
        "Connect with medical care and begin ART",
        "Retention in care"
      ],
      correct: "C"
    },
    {
      id: 26498,
      question: "What is the third step in the HIV Care Continuum?",
      options: [
        "Viral suppression",
        "Retention in care and adherence to treatment",
        "Testing and diagnosis",
        "Medical consultation"
      ],
      correct: "B"
    },
    {
      id: 26499,
      question: "What is the final stage of the HIV Care Continuum?",
      options: [
        "Treatment completion",
        "Retention in care",
        "Viral suppression",
        "Diagnosis confirmation"
      ],
      correct: "C"
    },
    {
      id: 26500,
      question: "What role can oral healthcare teams play in the HIV Care Continuum?",
      options: [
        "Prescribing ART only",
        "Improving screening, testing, linkage, and retention",
        "Providing surgical care only",
        "Managing only oral lesions"
      ],
      correct: "B"
    },
    {
      id: 26501,
      question: "What should dental hygienists do when conducting patient interviews with PWH?",
      options: [
        "Avoid sensitive questions",
        "Review health and pharmacologic history",
        "Focus only on dental history",
        "Skip medical history"
      ],
      correct: "B"
    },
    {
      id: 26502,
      question: "What must be reaffirmed during patient assessment?",
      options: [
        "Insurance coverage",
        "Professional confidentiality",
        "Appointment scheduling",
        "Payment terms"
      ],
      correct: "B"
    },
    {
      id: 26503,
      question: "What does PrEP stand for?",
      options: [
        "Post-exposure prophylaxis",
        "Pre-exposure prophylaxis",
        "Preventive exposure protocol",
        "Primary exposure prevention"
      ],
      correct: "B"
    },
    {
      id: 26504,
      question: "When did the CDC publish clinical practice guidelines for PrEP?",
      options: [
        "2018",
        "2019",
        "2021",
        "2020"
      ],
      correct: "C"
    },
    {
      id: 26505,
      question: "What should oral health professionals understand about individuals on PrEP?",
      options: [
        "They are HIV positive",
        "They are HIV negative with high exposure potential",
        "They need no dental care",
        "They cannot receive dental treatment"
      ],
      correct: "B"
    },
    {
      id: 26506,
      question: "What may PWH present with as a side effect of medications?",
      options: [
        "Gingival hyperplasia",
        "Xerostomia",
        "Enamel hypoplasia",
        "Tooth discoloration"
      ],
      correct: "B"
    },
    {
      id: 26507,
      question: "What should be done when clients present with signs and symptoms of HIV-associated conditions?",
      options: [
        "Ignore them",
        "Refer to dentist or physician",
        "Treat immediately without consultation",
        "Dismiss the patient"
      ],
      correct: "B"
    },
    {
      id: 26508,
      question: "What is the most common manifestation seen in PWH?",
      options: [
        "Hairy leukoplakia",
        "Kaposi sarcoma",
        "Oral candidiasis",
        "Necrotizing periodontitis"
      ],
      correct: "C"
    },
    {
      id: 26509,
      question: "Can candidiasis be found in patients other than PWH?",
      options: [
        "No, only in PWH",
        "Yes, in various patient populations",
        "Only in cancer patients",
        "Only in diabetics"
      ],
      correct: "B"
    },
    {
      id: 26510,
      question: "What patients besides PWH commonly have candidiasis?",
      options: [
        "Only healthy individuals",
        "Steroid inhaler users, chemotherapy patients, diabetics",
        "Athletes only",
        "Children only"
      ],
      correct: "B"
    },
    {
      id: 26511,
      question: "What happens when pseudomembranous candidiasis plaques are wiped away?",
      options: [
        "Nothing happens",
        "They regenerate immediately",
        "Leave red, tender, bleeding patches",
        "Leave white scars"
      ],
      correct: "C"
    },
    {
      id: 26512,
      question: "What is the common complaint with erythematous candidiasis?",
      options: [
        "Severe pain at rest",
        "Burning when eating salty, spicy foods or acidic beverages",
        "No symptoms",
        "Excessive salivation"
      ],
      correct: "B"
    },
    {
      id: 26513,
      question: "Must appliances be treated along with candidiasis when associated with acrylic appliances?",
      options: [
        "No, only treat the infection",
        "Yes, appliances must be treated",
        "Sometimes, depending on severity",
        "Never treat appliances"
      ],
      correct: "B"
    },
    {
      id: 26514,
      question: "What characterizes the pain associated with NUP?",
      options: [
        "Mild discomfort",
        "No pain",
        "Severe, deep jaw pain",
        "Sharp, intermittent pain"
      ],
      correct: "C"
    },
    {
      id: 26515,
      question: "What are the characteristics of NUP?",
      options: [
        "Minimal symptoms",
        "Severe pain, fetid odor, bleeding, loose teeth",
        "Painless swelling",
        "White patches only"
      ],
      correct: "B"
    },
    {
      id: 26516,
      question: "Is NUP isolated to PWH only?",
      options: [
        "Yes, only PWH get NUP",
        "No, associated with severe immune suppression generally",
        "Only in diabetics",
        "Only in cancer patients"
      ],
      correct: "B"
    },
    {
      id: 26517,
      question: "Can oral warts caused by HPV be singular or multifocal?",
      options: [
        "Only singular",
        "Only multifocal",
        "Singular or multifocal",
        "Neither"
      ],
      correct: "C"
    },
    {
      id: 26518,
      question: "When may an increase in oral warts occur in PWH?",
      options: [
        "Before treatment",
        "During antiretroviral therapy",
        "After stopping treatment",
        "Never"
      ],
      correct: "B"
    },
    {
      id: 26519,
      question: "Is recurrence common after HPV treatment?",
      options: [
        "Never recurs",
        "Rarely recurs",
        "Recurrence is common",
        "Unknown"
      ],
      correct: "C"
    },
    {
      id: 26520,
      question: "Where are most HPV-related head and neck cancers located?",
      options: [
        "Anterior oral cavity",
        "Posterior oropharynx in tonsillar and posterior tongue",
        "Lips only",
        "Hard palate"
      ],
      correct: "B"
    },
    {
      id: 26521,
      question: "Is oral cavity cancer rarely or commonly related to HPV etiology?",
      options: [
        "Commonly related",
        "Rarely related",
        "Always related",
        "Never related"
      ],
      correct: "B"
    },
    {
      id: 26522,
      question: "What is hairy leukoplakia associated with?",
      options: [
        "Human papillomavirus",
        "Cytomegalovirus",
        "Epstein-Barr virus",
        "Herpes simplex virus"
      ],
      correct: "C"
    },
    {
      id: 26523,
      question: "Can hairy leukoplakia be wiped off?",
      options: [
        "Yes, easily wiped off",
        "No, cannot be wiped off",
        "Sometimes",
        "Only with force"
      ],
      correct: "B"
    },
    {
      id: 26524,
      question: "Is hairy leukoplakia usually painful?",
      options: [
        "Always painful",
        "Usually painless",
        "Moderately painful",
        "Severely painful"
      ],
      correct: "B"
    },
    {
      id: 26525,
      question: "Does hairy leukoplakia require treatment?",
      options: [
        "Always requires treatment",
        "Usually does not require treatment",
        "Sometimes requires treatment",
        "Immediately requires surgery"
      ],
      correct: "B"
    },
    {
      id: 26526,
      question: "Is biopsy confirmation indicated for Kaposi sarcoma?",
      options: [
        "Never needed",
        "Rarely needed",
        "Biopsy confirmation is indicated",
        "Only for large lesions"
      ],
      correct: "C"
    },
    {
      id: 26527,
      question: "Is Kaposi sarcoma more or less frequently seen since the advent of ART?",
      options: [
        "More frequently seen",
        "Frequency unchanged",
        "Less frequently seen",
        "Never seen anymore"
      ],
      correct: "C"
    },
    {
      id: 26528,
      question: "Is Kaposi sarcoma still the most common oral cancer in individuals with untreated HIV?",
      options: [
        "No, never was",
        "No, not anymore",
        "Yes, still the most common",
        "Only in women"
      ],
      correct: "C"
    },
    {
      id: 26529,
      question: "Should the dental hygiene care plan be driven by HIV serostatus?",
      options: [
        "Yes, always",
        "Sometimes",
        "No, should not be driven by serostatus",
        "Only for severe cases"
      ],
      correct: "C"
    },
    {
      id: 26530,
      question: "What should the care plan be based on?",
      options: [
        "HIV status only",
        "Patient\'s insurance",
        "Identified conditions rather than serostatus",
        "Age only"
      ],
      correct: "C"
    },
    {
      id: 26531,
      question: "Do PWH present with oral needs similar to HIV-negative population?",
      options: [
        "No, completely different",
        "Generally similar",
        "Never similar",
        "Sometimes similar"
      ],
      correct: "B"
    },
    {
      id: 26532,
      question: "Is it ethical to withhold procedures based solely on HIV status?",
      options: [
        "Yes, always ethical",
        "Sometimes ethical",
        "Unethical and discriminatory",
        "Depends on procedure"
      ],
      correct: "C"
    },
    {
      id: 26533,
      question: "How should PWH with xerostomia be treated?",
      options: [
        "Differently than other patients",
        "Same manner as other patients",
        "No treatment available",
        "Only with medication"
      ],
      correct: "B"
    },
    {
      id: 26534,
      question: "What are treatment options for xerostomia?",
      options: [
        "Surgery only",
        "Drinking more water, avoiding caffeine/tobacco/alcohol, saliva stimulants",
        "Antibiotics only",
        "No treatment exists"
      ],
      correct: "B"
    },
    {
      id: 26535,
      question: "What medications are commonly used for mild to moderate candida infections?",
      options: [
        "Antibiotics",
        "Antivirals",
        "Nystatin or clotrimazole",
        "Steroids"
      ],
      correct: "C"
    },
    {
      id: 26536,
      question: "What may be required for severe candida infections?",
      options: [
        "No treatment",
        "Topical treatment only",
        "Systemic antifungal medications like fluconazole",
        "Surgery"
      ],
      correct: "C"
    },
    {
      id: 26537,
      question: "Should elective dental treatment be postponed for patients with active HSV lesions?",
      options: [
        "No, treat immediately",
        "Never postpone",
        "Yes, postpone until healed",
        "Sometimes"
      ],
      correct: "C"
    },
    {
      id: 26538,
      question: "How is HSV treated?",
      options: [
        "Antibiotics",
        "Antifungal therapy",
        "Antiviral therapy",
        "No treatment"
      ],
      correct: "C"
    },
    {
      id: 26539,
      question: "What is used to treat aphthous ulcers?",
      options: [
        "Antibiotics only",
        "Topical analgesics, antimicrobials, corticosteroids",
        "Surgery only",
        "No treatment"
      ],
      correct: "B"
    },
    {
      id: 26540,
      question: "What is necessary for neoplastic lesions like Kaposi sarcoma?",
      options: [
        "No action needed",
        "Biopsy, consultation, and referral",
        "Immediate surgery",
        "Wait and observe"
      ],
      correct: "B"
    },
    {
      id: 26541,
      question: "How are oral KS lesions treated?",
      options: [
        "Topical creams",
        "Oral antibiotics",
        "Systemic chemotherapy",
        "No treatment"
      ],
      correct: "C"
    },
    {
      id: 26542,
      question: "Is periodontal care essential for patients with KS lesions?",
      options: [
        "No, avoid all care",
        "Yes, essential",
        "Only after chemotherapy",
        "Never provide care"
      ],
      correct: "B"
    },
    {
      id: 26543,
      question: "Can tumor reduction be achieved with nonsurgical periodontal therapy?",
      options: [
        "Never possible",
        "Sometimes possible",
        "Always possible",
        "Only with surgery"
      ],
      correct: "B"
    },
    {
      id: 26544,
      question: "Is the use of powered instruments prohibited during periodontal debridement?",
      options: [
        "Yes, always prohibited",
        "No, not prohibited",
        "Only for PWH",
        "Only for severe cases"
      ],
      correct: "B"
    },
    {
      id: 26545,
      question: "Are aerosols a mode of HIV transmission?",
      options: [
        "Yes, primary mode",
        "No, not a mode of transmission",
        "Sometimes",
        "Unknown"
      ],
      correct: "B"
    },
    {
      id: 26546,
      question: "What is the most appropriate initial treatment for NUP?",
      options: [
        "Surgery only",
        "Observation only",
        "Systemic antibiotics, debridement, nutritional counseling, pain management",
        "Topical treatment only"
      ],
      correct: "C"
    },
    {
      id: 26547,
      question: "Is NUP a marker of severe immune deterioration?",
      options: [
        "No",
        "Sometimes",
        "Yes",
        "Unknown"
      ],
      correct: "C"
    },
    {
      id: 26548,
      question: "Should NUP involve medical/dental collaboration?",
      options: [
        "Never needed",
        "Rarely needed",
        "Yes, should involve collaboration",
        "Only in severe cases"
      ],
      correct: "C"
    },
    {
      id: 26549,
      question: "May periodontal surgery be required for NUP?",
      options: [
        "Never required",
        "Always required",
        "May be required",
        "Only as first treatment"
      ],
      correct: "C"
    },
    {
      id: 26550,
      question: "What local irrigation is recommended for NUP?",
      options: [
        "Saline only",
        "0.12% chlorhexidine gluconate",
        "Hydrogen peroxide",
        "Alcohol-based rinse"
      ],
      correct: "B"
    },
    {
      id: 26551,
      question: "How frequently should persons being treated for NUP be monitored?",
      options: [
        "Annually",
        "Every 6 months",
        "Frequent monitoring required",
        "No monitoring needed"
      ],
      correct: "C"
    },
    {
      id: 26552,
      question: "What is recommended for chemical oral biofilm control in NUP?",
      options: [
        "No rinses",
        "Twice-daily 0.12% chlorhexidine rinses",
        "Once-weekly rinses",
        "Alcohol-based rinses"
      ],
      correct: "B"
    },
    {
      id: 26553,
      question: "What are possible side effects of chlorhexidine?",
      options: [
        "No side effects",
        "Tooth whitening",
        "Staining, discoloration, calculus, altered taste",
        "Gingival hyperplasia"
      ],
      correct: "C"
    },
    {
      id: 26554,
      question: "What antibiotic is often prescribed to control oral anaerobic pathogens in NUP?",
      options: [
        "Amoxicillin",
        "Penicillin",
        "Metronidazole",
        "Tetracycline"
      ],
      correct: "C"
    },
    {
      id: 26555,
      question: "When should reevaluation occur after initial therapy?",
      options: [
        "In 2 weeks",
        "In 6 weeks",
        "In about 4 weeks",
        "In 8 weeks"
      ],
      correct: "C"
    },
    {
      id: 26556,
      question: "Why is 4-week reevaluation timing important?",
      options: [
        "Arbitrary timing",
        "Insurance requirements",
        "Allows healing of connective tissue for accurate probing",
        "Patient scheduling"
      ],
      correct: "C"
    },
    {
      id: 26557,
      question: "Should recall intervals for PWH differ from HIV-negative patients?",
      options: [
        "Yes, always different",
        "Yes, longer intervals",
        "No, follow same guidelines",
        "Yes, shorter intervals"
      ],
      correct: "C"
    }
  ],
  "5. Autoimmune Diseases": [
    {
      id: 26500,
      question: "What is the unique ability of the human immune system to recognize the difference between \"self\" and \"foreign\" antigens called?",
      options: [
        "Immunologic tolerance",
        "Autoimmune response",
        "Antigen presentation",
        "Cellular immunity"
      ],
      correct: "A"
    },
    {
      id: 26501,
      question: "What process occurs when activated T cells and antibodies begin to attack an individual\'s own tissues?",
      options: [
        "Inflammation",
        "Immunosuppression",
        "Autoimmunity",
        "Hypersensitivity"
      ],
      correct: "C"
    },
    {
      id: 26502,
      question: "What are the two primary factors necessary for the development of autoimmunity?",
      options: [
        "Age and gender",
        "Genetic predisposition and environmental triggers",
        "Diet and exercise",
        "Stress and trauma only"
      ],
      correct: "B"
    },
    {
      id: 26503,
      question: "What are the most important genes that predispose to autoimmune disease?",
      options: [
        "Immunoglobulin genes",
        "Major histocompatibility complex (MHC) genes",
        "Cytokine receptor genes",
        "T cell receptor genes"
      ],
      correct: "B"
    },
    {
      id: 26504,
      question: "What do MHC genes encode?",
      options: [
        "Antibodies",
        "Immunoglobulins",
        "Cytokines",
        "B lymphocytes"
      ],
      correct: "C"
    },
    {
      id: 26505,
      question: "What frequently triggers the activation of autoantibodies?",
      options: [
        "Dietary changes",
        "Exercise",
        "Infection, fever, or severe trauma",
        "Stress only"
      ],
      correct: "C"
    },
    {
      id: 26506,
      question: "What is often preceded by infection in many autoimmune diseases?",
      options: [
        "Remission",
        "Recovery",
        "Manifestation of disease",
        "Cure"
      ],
      correct: "C"
    },
    {
      id: 26507,
      question: "What virus correlates with systemic lupus erythematosus flares in winter?",
      options: [
        "Coxsackievirus",
        "Epstein-Barr virus",
        "Cytomegalovirus",
        "Herpes simplex virus"
      ],
      correct: "B"
    },
    {
      id: 26508,
      question: "What infection precedes type 1 diabetes mellitus onset in late summer?",
      options: [
        "Epstein-Barr virus",
        "Influenza virus",
        "Coxsackievirus",
        "Adenovirus"
      ],
      correct: "C"
    },
    {
      id: 26509,
      question: "What environmental factors contribute to autoimmunity besides infections?",
      options: [
        "High protein diet",
        "Low levels of vitamin D, UV radiation exposure, melatonin fluctuations",
        "Excessive exercise",
        "High carbohydrate intake"
      ],
      correct: "B"
    },
    {
      id: 26510,
      question: "In how many ways does tissue destruction generally occur in autoimmune diseases?",
      options: [
        "One way",
        "Three ways",
        "Two ways",
        "Four ways"
      ],
      correct: "C"
    },
    {
      id: 26511,
      question: "Where do bound antibodies deposit in autoimmune diseases?",
      options: [
        "In blood vessels only",
        "In tissues expressing self-antigens",
        "In lymph nodes",
        "In bone marrow"
      ],
      correct: "B"
    },
    {
      id: 26512,
      question: "Where do immune complexes deposit causing systemic involvement?",
      options: [
        "In tissues only",
        "In organs only",
        "In blood vessels",
        "In lymphatic system"
      ],
      correct: "C"
    },
    {
      id: 26513,
      question: "What does immune complex deposition in blood vessels manifest as?",
      options: [
        "Anemia",
        "Vasculitis, joint and kidney damage",
        "Liver damage",
        "Lung disease"
      ],
      correct: "B"
    },
    {
      id: 26514,
      question: "In myasthenia gravis, what receptors are inhibited by autoantibodies?",
      options: [
        "Insulin receptors",
        "Dopamine receptors",
        "Acetylcholine receptors",
        "Serotonin receptors"
      ],
      correct: "C"
    },
    {
      id: 26515,
      question: "What fails in myasthenia gravis causing paralysis?",
      options: [
        "Cardiac transmission",
        "Neuromuscular transmission",
        "Nerve conduction",
        "Synaptic transmission"
      ],
      correct: "B"
    },
    {
      id: 26516,
      question: "In hyperthyroidism, what do antibodies stimulate directly?",
      options: [
        "Parathyroid cells",
        "Adrenal cells",
        "Thyroid cells",
        "Pituitary cells"
      ],
      correct: "C"
    },
    {
      id: 26517,
      question: "What do patients with autoimmune diseases often exhibit presenting with more than one autoimmune disease?",
      options: [
        "Single disorders",
        "Cluster disorders",
        "Isolated conditions",
        "Independent diseases"
      ],
      correct: "B"
    },
    {
      id: 26518,
      question: "What type of organ involvement do patients with autoimmune diseases usually experience?",
      options: [
        "Single organ",
        "No organ involvement",
        "Multisystem organ involvement",
        "Limited involvement"
      ],
      correct: "C"
    },
    {
      id: 26519,
      question: "What are common nondescript signs and symptoms of autoimmune diseases?",
      options: [
        "Fever and chills only",
        "Rash only",
        "Fatigue, joint pain, muscle aches, sleep disorders, anemia",
        "Headache only"
      ],
      correct: "C"
    },
    {
      id: 26520,
      question: "What psychiatric difficulties do some patients with autoimmune diseases experience?",
      options: [
        "Schizophrenia",
        "Depression and frustration",
        "Bipolar disorder",
        "Anxiety only"
      ],
      correct: "B"
    },
    {
      id: 26521,
      question: "How many different types of autoimmune diseases exist?",
      options: [
        "Over 50",
        "Over 75",
        "Over 100",
        "Over 150"
      ],
      correct: "C"
    },
    {
      id: 26522,
      question: "Approximately how many people are affected by autoimmune diseases?",
      options: [
        "More than 30 million",
        "More than 40 million",
        "More than 50 million",
        "More than 60 million"
      ],
      correct: "C"
    },
    {
      id: 26523,
      question: "What is primary adrenal insufficiency known as?",
      options: [
        "Cushing disease",
        "Addison disease",
        "Conn syndrome",
        "Graves disease"
      ],
      correct: "B"
    },
    {
      id: 26524,
      question: "What is the most common cause of secondary adrenal insufficiency?",
      options: [
        "Infection",
        "Cancer",
        "Chronic use of steroids",
        "Trauma"
      ],
      correct: "C"
    },
    {
      id: 26525,
      question: "What characterizes cicatricial pemphigoid?",
      options: [
        "Healing without scarring",
        "Healing of lesions with scarring",
        "No healing",
        "Rapid healing"
      ],
      correct: "B"
    },
    {
      id: 26526,
      question: "What tissues does cicatricial pemphigoid affect?",
      options: [
        "Skin only",
        "Oral mucosa only",
        "Oral and genital mucosa, conjunctiva, skin",
        "Eyes only"
      ],
      correct: "C"
    },
    {
      id: 26527,
      question: "What is fibromyalgia characterized by?",
      options: [
        "Bone pain only",
        "Widespread musculoskeletal pain and fatigue",
        "Joint swelling only",
        "Muscle weakness only"
      ],
      correct: "B"
    },
    {
      id: 26528,
      question: "What autoimmune conditions have frequent comorbidity with fibromyalgia?",
      options: [
        "Diabetes only",
        "Hypertension only",
        "Rheumatoid arthritis, SLE, hypothyroidism",
        "Heart disease only"
      ],
      correct: "C"
    },
    {
      id: 26529,
      question: "What is another name for hyperthyroidism?",
      options: [
        "Myxedema",
        "Thyrotoxicosis",
        "Hypothyroidism",
        "Goiter"
      ],
      correct: "B"
    },
    {
      id: 26530,
      question: "What hormones are in excess in hyperthyroidism?",
      options: [
        "TSH only",
        "Cortisol and aldosterone",
        "Thyroxine (T4) and triiodothyronine (T3)",
        "Parathyroid hormone"
      ],
      correct: "C"
    },
    {
      id: 26531,
      question: "What is the most common autoimmune disease affecting the nervous system?",
      options: [
        "Myasthenia gravis",
        "Multiple sclerosis",
        "Guillain-Barré syndrome",
        "Parkinson disease"
      ],
      correct: "B"
    },
    {
      id: 26532,
      question: "What characterizes multiple sclerosis?",
      options: [
        "Muscle degeneration",
        "Demyelination of nerves in CNS",
        "Bone loss",
        "Joint inflammation"
      ],
      correct: "B"
    },
    {
      id: 26533,
      question: "What does myasthenia gravis represent?",
      options: [
        "Increase in acetylcholine receptors",
        "Decrease in acetylcholine receptors",
        "Increase in dopamine",
        "Decrease in serotonin"
      ],
      correct: "B"
    },
    {
      id: 26534,
      question: "What muscles does myasthenia gravis affect?",
      options: [
        "Cardiac muscles",
        "Smooth muscles",
        "Skeletal muscles",
        "All muscle types"
      ],
      correct: "C"
    },
    {
      id: 26535,
      question: "What characterizes pemphigus vulgaris?",
      options: [
        "Mild skin irritation",
        "Bullae that rupture and form painful ulcers",
        "Dry skin patches",
        "Itchy rash"
      ],
      correct: "B"
    },
    {
      id: 26536,
      question: "What causes pernicious anemia?",
      options: [
        "Iron deficiency",
        "Folate deficiency",
        "Failure to produce intrinsic factor and lack of vitamin B12",
        "Blood loss"
      ],
      correct: "C"
    },
    {
      id: 26537,
      question: "What percentage of psoriasis is associated with arthritis?",
      options: [
        "Approximately 5%",
        "Approximately 10%",
        "Approximately 15%",
        "Approximately 20%"
      ],
      correct: "C"
    },
    {
      id: 26538,
      question: "What characterizes rheumatoid arthritis?",
      options: [
        "Acute inflammation only",
        "Chronic inflammatory condition attacking joints",
        "Bone infection",
        "Muscle degeneration"
      ],
      correct: "B"
    },
    {
      id: 26539,
      question: "What is scleroderma better known as?",
      options: [
        "Systemic sclerosis",
        "Lupus",
        "Dermatomyositis",
        "Polymyositis"
      ],
      correct: "A"
    },
    {
      id: 26540,
      question: "What is the triad of Sjögren syndrome?",
      options: [
        "Fever, rash, arthritis",
        "Keratoconjunctivitis sicca, xerostomia, connective tissue disorder",
        "Pain, swelling, stiffness",
        "Fatigue, weight loss, anemia"
      ],
      correct: "B"
    },
    {
      id: 26541,
      question: "What characterizes systemic lupus erythematosus?",
      options: [
        "Single organ damage",
        "Injury from immune complexes and antibody binding",
        "Bacterial infection",
        "Viral infection"
      ],
      correct: "B"
    },
    {
      id: 26542,
      question: "What pattern does systemic lupus erythematosus follow?",
      options: [
        "Continuous progression",
        "Periods of remissions and exacerbations",
        "Steady decline",
        "Rapid resolution"
      ],
      correct: "B"
    },
    {
      id: 26543,
      question: "What is the first-line pharmacologic treatment for autoimmune diseases?",
      options: [
        "Immunosuppressants",
        "Antibiotics",
        "Antiinflammatory medications",
        "Antiviral medications"
      ],
      correct: "C"
    },
    {
      id: 26544,
      question: "What are the goals of medication therapy for autoimmune diseases?",
      options: [
        "Cure the disease",
        "Reduced pain, improved function, slowed progression, limited destruction",
        "Immediate symptom relief",
        "Prevention only"
      ],
      correct: "B"
    },
    {
      id: 26545,
      question: "What do NSAIDs block the synthesis of?",
      options: [
        "Leukotrienes",
        "Histamines",
        "Prostaglandins",
        "Cytokines"
      ],
      correct: "C"
    },
    {
      id: 26546,
      question: "What enzyme do NSAIDs inhibit?",
      options: [
        "Lipoxygenase",
        "Cyclooxygenase",
        "Phospholipase",
        "Acetylcholinesterase"
      ],
      correct: "B"
    },
    {
      id: 26547,
      question: "How are NSAIDs categorized?",
      options: [
        "By potency only",
        "As salicylates or nonsalicylates",
        "By duration of action",
        "By route of administration"
      ],
      correct: "B"
    },
    {
      id: 26548,
      question: "What is acetaminophen\'s limitation in treating autoimmune diseases?",
      options: [
        "Too expensive",
        "No antiinflammatory activity",
        "Too toxic",
        "Short duration"
      ],
      correct: "B"
    },
    {
      id: 26549,
      question: "What do DMARDs do?",
      options: [
        "Cure arthritis",
        "Slow joint disease course and prevent destruction",
        "Provide immediate relief",
        "Reduce fever only"
      ],
      correct: "B"
    },
    {
      id: 26550,
      question: "How long may patients need to take DMARDs before seeing an effect?",
      options: [
        "Up to 2 weeks",
        "Up to 4 weeks",
        "Up to 4 months",
        "Up to 6 months"
      ],
      correct: "C"
    },
    {
      id: 26551,
      question: "What is methotrexate used for?",
      options: [
        "Mild arthritis only",
        "Severe rheumatoid arthritis or psoriatic arthritis",
        "Osteoarthritis only",
        "Gout only"
      ],
      correct: "B"
    },
    {
      id: 26552,
      question: "How quickly does methotrexate provide relief after initiating treatment?",
      options: [
        "Within 2 weeks",
        "Within 4 weeks",
        "Within 6 weeks",
        "Within 8 weeks"
      ],
      correct: "C"
    },
    {
      id: 26553,
      question: "What are interleukin-1β and tumor necrosis factor-α?",
      options: [
        "Anti-inflammatory cytokines",
        "Proinflammatory cytokines",
        "Antibodies",
        "Hormones"
      ],
      correct: "B"
    },
    {
      id: 26554,
      question: "What do anticytokine therapies block?",
      options: [
        "Pain receptors",
        "Nerve transmission",
        "Unwanted inflammatory effects",
        "Blood flow"
      ],
      correct: "C"
    },
    {
      id: 26555,
      question: "Examples of anticytokine therapies include which of the following?",
      options: [
        "Aspirin and ibuprofen",
        "Etanercept, infliximab, adalimumab, anakinra",
        "Penicillin and amoxicillin",
        "Prednisone and cortisone"
      ],
      correct: "B"
    },
    {
      id: 26556,
      question: "What are JAK inhibitors?",
      options: [
        "Antibiotics",
        "Antivirals",
        "Targeted small molecule treatment therapies",
        "Pain relievers"
      ],
      correct: "C"
    },
    {
      id: 26557,
      question: "What do JAK inhibitors suppress?",
      options: [
        "Pain pathways",
        "Intracellular signaling mediated by cytokines",
        "Nerve conduction",
        "Muscle contraction"
      ],
      correct: "B"
    },
    {
      id: 26558,
      question: "What are current JAK inhibitors approved for use?",
      options: [
        "Aspirin and ibuprofen",
        "Methotrexate and gold",
        "Tofacitinib, baricitinib, upadacitinib, peficitinib, filgotinib",
        "Prednisone and dexamethasone"
      ],
      correct: "C"
    },
    {
      id: 26559,
      question: "What does penicillamine depress?",
      options: [
        "Blood pressure",
        "Circulating IgM rheumatoid factor and T-cell activity",
        "Heart rate",
        "Respiratory rate"
      ],
      correct: "B"
    },
    {
      id: 26560,
      question: "What do antimalarial agents impair?",
      options: [
        "Kidney function",
        "Liver function",
        "Complement-dependent antigen-antibody reactions",
        "Cardiac function"
      ],
      correct: "C"
    },
    {
      id: 26561,
      question: "What antimalarial agents are used for rheumatoid arthritis?",
      options: [
        "Penicillin and tetracycline",
        "Chloroquine and hydroxychloroquine",
        "Aspirin and ibuprofen",
        "Methotrexate and gold"
      ],
      correct: "B"
    },
    {
      id: 26562,
      question: "What do gold compounds inhibit?",
      options: [
        "Nerve transmission",
        "Mononuclear phagocyte maturation and function",
        "Blood clotting",
        "Bone formation"
      ],
      correct: "B"
    },
    {
      id: 26563,
      question: "What are azathioprine and cyclophosphamide?",
      options: [
        "Antibiotics",
        "Antivirals",
        "Immunosuppressive drugs",
        "Pain relievers"
      ],
      correct: "C"
    },
    {
      id: 26564,
      question: "What does cyclosporine inhibit?",
      options: [
        "Insulin production",
        "Production of interleukin-2 by helper T cells",
        "Blood clotting",
        "Bone resorption"
      ],
      correct: "B"
    },
    {
      id: 26565,
      question: "What adverse effects are salicylates, NSAIDs, and COX-2 inhibitors associated with?",
      options: [
        "Hypertension",
        "Adverse bleeding events",
        "Diabetes",
        "Kidney stones"
      ],
      correct: "B"
    },
    {
      id: 26566,
      question: "What common dermatologic problems occur with DMARDs?",
      options: [
        "Excessive hair growth",
        "Skin lesions, rashes, hair loss",
        "Nail thickening",
        "Skin tightening"
      ],
      correct: "B"
    },
    {
      id: 26567,
      question: "What may appear on oral mucosa with DMARD use?",
      options: [
        "White patches",
        "Red lesions",
        "Bluish-black pigmentation",
        "Yellow spots"
      ],
      correct: "C"
    },
    {
      id: 26568,
      question: "What may immunosuppressive drugs cause orally?",
      options: [
        "Tooth mobility",
        "Gingival enlargement",
        "Tooth discoloration",
        "Enamel hypoplasia"
      ],
      correct: "B"
    },
    {
      id: 26569,
      question: "Because DMARDs alter immune response, what do patients become susceptible to?",
      options: [
        "Allergies",
        "Infections",
        "Autoimmune diseases",
        "Cancer only"
      ],
      correct: "B"
    },
    {
      id: 26570,
      question: "What infections may patients experience reactivation of with DMARD use?",
      options: [
        "Common cold",
        "Hepatitis, tuberculosis, herpetic infections",
        "Urinary tract infections",
        "Skin infections"
      ],
      correct: "B"
    },
    {
      id: 26571,
      question: "What are corticosteroids used for in autoimmune diseases?",
      options: [
        "Cure the disease",
        "Antiinflammatory effects and immune suppression",
        "Pain relief only",
        "Fever reduction only"
      ],
      correct: "B"
    },
    {
      id: 26572,
      question: "What are adverse reactions to corticosteroids proportional to?",
      options: [
        "Patient age",
        "Dose, frequency, time of administration, duration",
        "Body weight",
        "Gender"
      ],
      correct: "B"
    },
    {
      id: 26573,
      question: "What is the most common oral side effect of chronic corticosteroid therapy?",
      options: [
        "Tooth decay",
        "Gingival bleeding",
        "Candidiasis",
        "Xerostomia"
      ],
      correct: "C"
    },
    {
      id: 26574,
      question: "Why does candidiasis occur with corticosteroid therapy?",
      options: [
        "Immune suppression",
        "Related to xerostomic effect",
        "Poor oral hygiene",
        "Dietary changes"
      ],
      correct: "B"
    },
    {
      id: 26575,
      question: "What may patients on chronic corticosteroids exhibit after dental hygiene therapy?",
      options: [
        "Excessive bleeding",
        "Poor wound healing",
        "Allergic reactions",
        "Tooth sensitivity"
      ],
      correct: "B"
    },
    {
      id: 26576,
      question: "What axis controls regulation of cortisol secretion?",
      options: [
        "Renin-angiotensin-aldosterone axis",
        "Growth hormone axis",
        "Hypothalamic-pituitary-adrenal axis",
        "Thyroid-pituitary axis"
      ],
      correct: "C"
    },
    {
      id: 26577,
      question: "What causes immediate increase of ACTH secretion?",
      options: [
        "Sleep",
        "Food intake",
        "Virtually any stress",
        "Exercise only"
      ],
      correct: "C"
    },
    {
      id: 26578,
      question: "What is one of the greatest stressors producing ACTH secretion?",
      options: [
        "Anxiety",
        "Surgery",
        "Fever",
        "Pain"
      ],
      correct: "B"
    },
    {
      id: 26579,
      question: "What does chronic corticosteroid use suppress?",
      options: [
        "Appetite",
        "Body\'s own cortisol production and release",
        "Thyroid function",
        "Kidney function"
      ],
      correct: "B"
    },
    {
      id: 26580,
      question: "What is secondary adrenal insufficiency also known as?",
      options: [
        "Primary insufficiency",
        "Medication-induced adrenal insufficiency",
        "Acute insufficiency",
        "Chronic insufficiency"
      ],
      correct: "B"
    },
    {
      id: 26581,
      question: "What is the patient at risk for without adequate stress response?",
      options: [
        "Hypertension",
        "Hyperglycemia",
        "Decreased cardiac output, hypoglycemia, circulatory shock",
        "Respiratory failure"
      ],
      correct: "C"
    },
    {
      id: 26582,
      question: "What is one method used to minimize adrenal suppression?",
      options: [
        "Daily high doses",
        "Administer hydrocortisone on alternating days",
        "Continuous low doses",
        "Weekly injections"
      ],
      correct: "B"
    },
    {
      id: 26583,
      question: "Do most patients require steroid supplementation for routine dental hygiene procedures?",
      options: [
        "Yes, always",
        "Yes, sometimes",
        "No, most do not",
        "Only for prophylaxis"
      ],
      correct: "C"
    },
    {
      id: 26584,
      question: "What helps eliminate the need for supplementation during procedures?",
      options: [
        "Antibiotics",
        "Local anesthesia and conscious sedation",
        "General anesthesia",
        "Muscle relaxants"
      ],
      correct: "B"
    },
    {
      id: 26585,
      question: "What type of condition is adrenal crisis?",
      options: [
        "Common occurrence",
        "Rare, life-threatening condition",
        "Mild complication",
        "Expected side effect"
      ],
      correct: "B"
    },
    {
      id: 26586,
      question: "What does adrenal crisis commonly occur with?",
      options: [
        "Primary adrenal insufficiency",
        "Does not commonly occur with secondary insufficiency",
        "Tertiary insufficiency",
        "All types equally"
      ],
      correct: "B"
    },
    {
      id: 26587,
      question: "How many factors contribute to risk of adrenal crisis during oral surgery?",
      options: [
        "Two factors",
        "Three factors",
        "Four factors",
        "Five factors"
      ],
      correct: "C"
    },
    {
      id: 26588,
      question: "What does adrenal crisis lead to if untreated?",
      options: [
        "Recovery",
        "Circulatory collapse and death",
        "Mild symptoms",
        "Temporary illness"
      ],
      correct: "B"
    },
    {
      id: 26589,
      question: "What does treatment of adrenal crisis require?",
      options: [
        "Oral medications",
        "Outpatient care",
        "Hospitalization and IV interventions",
        "Observation only"
      ],
      correct: "C"
    },
    {
      id: 26590,
      question: "What interventions are needed for adrenal crisis?",
      options: [
        "Oral fluids only",
        "IV hydrocortisone, glucose, fluids, electrolyte replacement",
        "Antibiotics only",
        "Pain medication only"
      ],
      correct: "B"
    },
    {
      id: 26591,
      question: "When should patients be scheduled for dental procedures in stress reduction protocol?",
      options: [
        "Afternoon",
        "Evening",
        "First thing in the morning",
        "Anytime"
      ],
      correct: "C"
    },
    {
      id: 26592,
      question: "Why schedule patients first thing in the morning?",
      options: [
        "Office is less busy",
        "Cortisol levels are highest",
        "Patient is more rested",
        "Less traffic"
      ],
      correct: "B"
    },
    {
      id: 26593,
      question: "What should be monitored before, during, and after procedures?",
      options: [
        "Blood glucose only",
        "Temperature only",
        "Vital signs",
        "Weight"
      ],
      correct: "C"
    },
    {
      id: 26594,
      question: "What blood pressure reading indicates hypotension requiring action?",
      options: [
        "Below 120/80",
        "Below 110/70",
        "Below 100/60",
        "Below 90/50"
      ],
      correct: "C"
    },
    {
      id: 26595,
      question: "How should a patient with hypotension be positioned?",
      options: [
        "Flat",
        "Sitting upright",
        "Feet elevated above head",
        "On their side"
      ],
      correct: "C"
    },
    {
      id: 26596,
      question: "How much hydrocortisone is administered by IV during adrenal crisis?",
      options: [
        "50 mg",
        "75 mg",
        "100 mg",
        "150 mg"
      ],
      correct: "C"
    },
    {
      id: 26597,
      question: "What is of utmost importance during assessment phase?",
      options: [
        "Checking insurance",
        "Thorough health, oral, pharmacologic history",
        "Scheduling next appointment",
        "Taking radiographs"
      ],
      correct: "B"
    },
    {
      id: 26598,
      question: "What must the clinician determine during assessment?",
      options: [
        "Insurance coverage",
        "If medical care supersedes oral care and patient safety",
        "Appointment length only",
        "Payment method"
      ],
      correct: "B"
    },
    {
      id: 26599,
      question: "When may oral care have to be deferred?",
      options: [
        "Never",
        "Always",
        "Until additional medical evaluation/treatment",
        "For convenience"
      ],
      correct: "C"
    },
    {
      id: 26600,
      question: "What can the dental hygienist use to assist with identification of autoimmune characteristics?",
      options: [
        "Blood test",
        "Risk assessment tool",
        "X-rays",
        "Questionnaire only"
      ],
      correct: "B"
    },
    {
      id: 26601,
      question: "When should the risk assessment tool be completed?",
      options: [
        "Before health history",
        "During treatment",
        "After reviewing health history",
        "At checkout"
      ],
      correct: "C"
    },
    {
      id: 26602,
      question: "What can be defined as a multidimensional concept demonstrating comfort in managing daily activities?",
      options: [
        "Quality of care",
        "Oral health-related quality of life (OHRQL)",
        "Patient satisfaction",
        "Treatment outcomes"
      ],
      correct: "B"
    },
    {
      id: 26603,
      question: "What scales can measure OHRQL?",
      options: [
        "Pain scales only",
        "Modified OHIP and MHISS",
        "Anxiety scales",
        "Depression scales"
      ],
      correct: "B"
    },
    {
      id: 26604,
      question: "What is used to identify key diagnoses in dental hygiene?",
      options: [
        "Laboratory tests",
        "X-rays only",
        "Objective and subjective assessment findings",
        "Medical records only"
      ],
      correct: "C"
    },
    {
      id: 26605,
      question: "What should dental hygiene students determine based on diagnoses?",
      options: [
        "Treatment cost",
        "Needs improved through interventions and needed referrals",
        "Appointment length",
        "Payment plans"
      ],
      correct: "B"
    },
    {
      id: 26606,
      question: "What may be necessary to accommodate patients with joint pain and stiffness?",
      options: [
        "Longer appointments",
        "Shorter appointments",
        "Multiple appointments per day",
        "No appointments"
      ],
      correct: "B"
    },
    {
      id: 26607,
      question: "What should be discussed in advance for patient comfort?",
      options: [
        "Payment options",
        "Insurance coverage",
        "Assistive and supportive devices",
        "Parking availability"
      ],
      correct: "C"
    },
    {
      id: 26608,
      question: "What is helpful to determine safe coordination of care?",
      options: [
        "Patient preference",
        "Consultation with patient\'s physician",
        "Internet research",
        "Patient\'s family input"
      ],
      correct: "B"
    },
    {
      id: 26609,
      question: "What should be consulted for antibiotic premedication decisions in RA patients with joint replacement?",
      options: [
        "ADA guidelines",
        "AAOS Appropriate Use Criteria",
        "CDC recommendations",
        "WHO guidelines"
      ],
      correct: "B"
    },
    {
      id: 26610,
      question: "What percentage of MS patients have oral manifestations?",
      options: [
        "2% to 3%",
        "5% to 7%",
        "10% to 15%",
        "20% to 25%"
      ],
      correct: "A"
    },
    {
      id: 26611,
      question: "When should patients with multiple sclerosis be scheduled for treatment?",
      options: [
        "During active disease",
        "During periods of remission",
        "Anytime",
        "Never"
      ],
      correct: "B"
    },
    {
      id: 26612,
      question: "What may be needed for MS patients during treatment?",
      options: [
        "General anesthesia",
        "Steroid supplementation",
        "Antibiotic prophylaxis",
        "Blood transfusion"
      ],
      correct: "B"
    },
    {
      id: 26613,
      question: "What should be avoided in patients with uncontrolled hyperthyroidism?",
      options: [
        "All anesthesia",
        "Local anesthesia with epinephrine",
        "Fluoride treatment",
        "Dental prophylaxis"
      ],
      correct: "B"
    },
    {
      id: 26614,
      question: "What must the clinician review for potential medical emergency?",
      options: [
        "Insurance coverage",
        "Patient\'s condition and medications",
        "Appointment schedule",
        "Treatment costs"
      ],
      correct: "B"
    },
    {
      id: 26615,
      question: "What does implementation include?",
      options: [
        "Scheduling only",
        "Administration of interventions to minimize infections and restore health",
        "Billing procedures",
        "Record keeping only"
      ],
      correct: "B"
    },
    {
      id: 26616,
      question: "When are referrals to specialists warranted?",
      options: [
        "Never",
        "Always",
        "When lesions not responding or more definitive treatment needed",
        "For convenience"
      ],
      correct: "C"
    },
    {
      id: 26617,
      question: "What must patient education include?",
      options: [
        "Cost information",
        "Disease pathophysiology, oral effects, treatments",
        "Insurance details",
        "Office policies"
      ],
      correct: "B"
    },
    {
      id: 26618,
      question: "What percentage of SLE patients have oral lesions?",
      options: [
        "1% to 5%",
        "5% to 25%",
        "30% to 40%",
        "50% to 60%"
      ],
      correct: "B"
    },
    {
      id: 26619,
      question: "Where do SLE oral lesions commonly appear?",
      options: [
        "Tongue only",
        "Palate, buccal mucosa, gingiva",
        "Lips only",
        "Floor of mouth only"
      ],
      correct: "B"
    },
    {
      id: 26620,
      question: "What do oral lesions in SLE may appear as?",
      options: [
        "Always ulcerated",
        "Lichenoid, nonspecific, or granulomatous",
        "Only red patches",
        "Only white patches"
      ],
      correct: "B"
    },
    {
      id: 26621,
      question: "What percentage of RA cases have TMJ involvement?",
      options: [
        "50%",
        "60%",
        "75%",
        "90%"
      ],
      correct: "C"
    },
    {
      id: 26622,
      question: "What is recommended for regular assessment of TMJ in RA patients?",
      options: [
        "CT scans",
        "MRI",
        "Panoramic radiographs",
        "Blood tests"
      ],
      correct: "C"
    },
    {
      id: 26623,
      question: "What is observed radiographically in scleroderma?",
      options: [
        "Normal findings",
        "Widened periodontal ligament spaces",
        "Tooth resorption",
        "Bone spurs"
      ],
      correct: "B"
    },
    {
      id: 26624,
      question: "What oral finding is characteristic of scleroderma?",
      options: [
        "Macrostomia",
        "Microstomia",
        "Normal opening",
        "Excessive opening"
      ],
      correct: "B"
    },
    {
      id: 26625,
      question: "What salivary glands are especially enlarged in Sjögren syndrome?",
      options: [
        "Submandibular glands",
        "Sublingual glands",
        "Parotids",
        "Minor salivary glands"
      ],
      correct: "C"
    },
    {
      id: 26626,
      question: "What is the most common location of caries in Sjögren syndrome?",
      options: [
        "Occlusal surfaces",
        "Interproximal surfaces",
        "Cervical surfaces",
        "Incisal edges"
      ],
      correct: "C"
    },
    {
      id: 26627,
      question: "What form of candidiasis is often seen in Sjögren syndrome?",
      options: [
        "Pseudomembranous",
        "Hyperplastic",
        "Erythematous",
        "Angular cheilitis"
      ],
      correct: "C"
    },
    {
      id: 26628,
      question: "What tongue appearance is seen in Sjögren syndrome?",
      options: [
        "Normal appearance",
        "Fissured tongue with atrophy of papillae",
        "Geographic tongue",
        "Hairy tongue"
      ],
      correct: "B"
    },
    {
      id: 26629,
      question: "On what maintenance interval should patients with autoimmune disease be placed?",
      options: [
        "6-month intervals",
        "Annual intervals",
        "2- to 3-month intervals",
        "Monthly intervals"
      ],
      correct: "C"
    },
    {
      id: 26630,
      question: "Why is an evaluation appointment important after initial therapy?",
      options: [
        "For billing purposes",
        "To assess host response and determine if additional treatment needed",
        "For scheduling convenience",
        "To meet quotas"
      ],
      correct: "B"
    },
    {
      id: 26631,
      question: "What should be reassessed at subsequent appointments?",
      options: [
        "Insurance only",
        "Overall health and oral health",
        "Payment history",
        "Appointment history"
      ],
      correct: "B"
    },
    {
      id: 26632,
      question: "What is the final step in the dental hygiene process of care?",
      options: [
        "Billing",
        "Scheduling",
        "Documentation",
        "Dismissal"
      ],
      correct: "C"
    },
    {
      id: 26633,
      question: "What should be documented regarding goals?",
      options: [
        "Only if met",
        "Extent to which goals were met and influencing factors",
        "Brief notes only",
        "Nothing specific"
      ],
      correct: "B"
    },
    {
      id: 26634,
      question: "What must be shared with dentist and physician of record?",
      options: [
        "Billing information",
        "Appointment times",
        "Adverse reactions or emergency situations",
        "Patient complaints only"
      ],
      correct: "C"
    },
    {
      id: 26635,
      question: "What complications are associated with chronic steroid use?",
      options: [
        "Weight loss only",
        "Insomnia, peptic ulceration, osteoporosis, cataracts, glaucoma",
        "Hair growth",
        "Improved wound healing"
      ],
      correct: "B"
    },
    {
      id: 26636,
      question: "What other complications occur with chronic steroid use?",
      options: [
        "Increased energy",
        "Growth suppression, delayed wound healing, psychosis, weight gain",
        "Improved immune function",
        "Enhanced healing"
      ],
      correct: "B"
    },
    {
      id: 26637,
      question: "What appears as superficial \"ragged\" erosions in pemphigus vulgaris?",
      options: [
        "Intact vesicles",
        "Ulcerations with haphazard distribution",
        "Red patches only",
        "White lesions"
      ],
      correct: "B"
    },
    {
      id: 26638,
      question: "What are the most common areas for pemphigus vulgaris lesions?",
      options: [
        "Gingiva only",
        "Tongue only",
        "Palate, labial mucosa, buccal mucosa, ventral tongue, gingiva",
        "Floor of mouth only"
      ],
      correct: "C"
    },
    {
      id: 26639,
      question: "What tongue appearance is seen in pernicious anemia?",
      options: [
        "Normal appearance",
        "Painful, red, burning tongue with atrophy of papillae",
        "Geographic tongue",
        "Fissured tongue"
      ],
      correct: "B"
    },
    {
      id: 26640,
      question: "What oral manifestations are rare in psoriasis?",
      options: [
        "Lesions are common",
        "Lesions always present",
        "Oral manifestations are rare",
        "Lesions are severe"
      ],
      correct: "C"
    },
    {
      id: 26641,
      question: "What may occur with psoriasis when oral lesions are present?",
      options: [
        "Only ulcers",
        "Only white patches",
        "Geographic tongue",
        "Tooth mobility"
      ],
      correct: "C"
    },
    {
      id: 26642,
      question: "What percentage of cicatricial pemphigoid lesions heal with scarring?",
      options: [
        "None",
        "Some",
        "Characterized by healing with scarring",
        "All heal without scars"
      ],
      correct: "C"
    },
    {
      id: 26643,
      question: "What difficulty may occur in myasthenia gravis?",
      options: [
        "Excessive salivation",
        "Chewing and swallowing difficulty",
        "Excessive muscle tone",
        "Hyperactivity"
      ],
      correct: "B"
    },
    {
      id: 26644,
      question: "What voice alteration occurs in myasthenia gravis?",
      options: [
        "Loud voice",
        "Altered voice with nasal tone",
        "Deep voice",
        "High-pitched voice"
      ],
      correct: "B"
    },
    {
      id: 26645,
      question: "What may patients with myasthenia gravis have difficulty wearing?",
      options: [
        "Glasses",
        "Dentures",
        "Hearing aids",
        "Watches"
      ],
      correct: "B"
    },
    {
      id: 26646,
      question: "What should be used during appointments for myasthenia gravis patients?",
      options: [
        "General anesthesia",
        "No special equipment",
        "Rubber dam, evacuation, mouth props",
        "Only hand instruments"
      ],
      correct: "C"
    },
    {
      id: 26647,
      question: "What sedation may be considered for myasthenia gravis patients?",
      options: [
        "IV sedation",
        "General anesthesia",
        "Nitrous oxide-oxygen sedation",
        "Oral sedation"
      ],
      correct: "C"
    },
    {
      id: 26648,
      question: "What should be consulted before prescribing to myasthenia gravis patients?",
      options: [
        "Nothing special",
        "Consult before antibiotics and muscle relaxants",
        "Any medication",
        "Only narcotics"
      ],
      correct: "B"
    },
    {
      id: 26649,
      question: "What should be monitored throughout appointments for myasthenia gravis?",
      options: [
        "Blood pressure only",
        "Heart rate only",
        "Ease of breathing",
        "Temperature"
      ],
      correct: "C"
    },
    {
      id: 26650,
      question: "What appears as localized scleroderma on the face?",
      options: [
        "Red patches",
        "Scarlike appearance (coup de sabre)",
        "Swelling",
        "Bruising"
      ],
      correct: "B"
    },
    {
      id: 26651,
      question: "What finger position is characteristic of systemic sclerosis?",
      options: [
        "Extended fingers",
        "Normal position",
        "Clawlike finger position",
        "Flexed position"
      ],
      correct: "C"
    },
    {
      id: 26652,
      question: "What jaw position may develop late in scleroderma?",
      options: [
        "Normal occlusion",
        "Anterior open bite",
        "Deep bite",
        "Crossbite"
      ],
      correct: "B"
    },
    {
      id: 26653,
      question: "What tongue characteristic appears in scleroderma?",
      options: [
        "Normal mobility",
        "Firm, hypomobile tongue",
        "Enlarged tongue",
        "Atrophied tongue"
      ],
      correct: "B"
    },
    {
      id: 26654,
      question: "What exercises should be recommended for scleroderma patients?",
      options: [
        "Aerobic exercise",
        "Weight lifting",
        "Isometric exercises for facial muscles and mouth opening",
        "Running"
      ],
      correct: "C"
    },
    {
      id: 26655,
      question: "What rash is seen in systemic lupus erythematosus?",
      options: [
        "Butterfly rash",
        "Malar rash",
        "Discoid rash",
        "Petechial rash"
      ],
      correct: "B"
    },
    {
      id: 26656,
      question: "What thyroid condition is shown as goiter in Graves disease?",
      options: [
        "Hypothyroidism",
        "Hyperthyroidism",
        "Thyroiditis",
        "Thyroid cancer"
      ],
      correct: "B"
    },
    {
      id: 26657,
      question: "What eye condition is seen in Graves disease?",
      options: [
        "Cataracts",
        "Glaucoma",
        "Exophthalmos",
        "Ptosis"
      ],
      correct: "C"
    },
    {
      id: 26658,
      question: "What product category is indicated for caries risk reduction?",
      options: [
        "Antibiotics",
        "Fluorides and remineralization therapies",
        "Pain relievers",
        "Sedatives"
      ],
      correct: "B"
    },
    {
      id: 26659,
      question: "What is indicated for salivary hypofunction and xerostomia?",
      options: [
        "Antibiotics",
        "Pain relievers",
        "Salivary stimulants and substitutes",
        "Anti-inflammatory drugs"
      ],
      correct: "C"
    },
    {
      id: 26660,
      question: "What product category helps with biofilm removal and oral cleansing?",
      options: [
        "Fluorides only",
        "Antibiotics",
        "Mechanical devices",
        "Pain relievers"
      ],
      correct: "C"
    },
    {
      id: 26661,
      question: "What antimicrobial agents are indicated for oral disease risk reduction?",
      options: [
        "Antibiotics only",
        "Antivirals only",
        "Chlorhexidine, essential oils, cetylpyridinium chloride",
        "Antifungals only"
      ],
      correct: "C"
    },
    {
      id: 26662,
      question: "What OTC products provide topical pain control?",
      options: [
        "Aspirin only",
        "Ibuprofen",
        "Benzocaine, lidocaine, tetracaine ointments",
        "Acetaminophen"
      ],
      correct: "C"
    },
    {
      id: 26663,
      question: "What prescription products provide topical pain control?",
      options: [
        "Antibiotics",
        "2% viscous lidocaine, sucralfate suspension, amlexanox paste",
        "Antifungals",
        "Antivirals"
      ],
      correct: "B"
    }
  ],
  "6. Organ Transplant and Kidney Disease": [
    {
      id: 26600,
      question: "What does solid organ transplant refer to?",
      options: [
        "Surgical placement of viable functioning organ into appropriate patient",
        "Temporary organ support system",
        "Artificial organ implantation",
        "Partial organ replacement"
      ],
      correct: "A"
    },
    {
      id: 26601,
      question: "Which patients are the most affected potential end-stage organ disease candidates?",
      options: [
        "Those waiting for heart",
        "Those waiting for liver",
        "Those waiting for kidney",
        "Those waiting for lung"
      ],
      correct: "C"
    },
    {
      id: 26602,
      question: "What is UNOS?",
      options: [
        "Universal National Organ System",
        "United Network for Organ Sharing",
        "Unified National Organ Services",
        "United Network of Organ Surgeons"
      ],
      correct: "B"
    },
    {
      id: 26603,
      question: "What does OPTN stand for?",
      options: [
        "Organ Processing and Treatment Network",
        "Organ Procurement and Transplantation Network",
        "Organ Placement and Transfer Network",
        "Organ Prevention and Testing Network"
      ],
      correct: "B"
    },
    {
      id: 26604,
      question: "What does UNOS maintain?",
      options: [
        "State organ databases",
        "Regional transplant centers",
        "Nation\'s only Organ Procurement and Transplantation Network",
        "International organ registry"
      ],
      correct: "C"
    },
    {
      id: 26605,
      question: "How long does the average renal patient wait for a deceased donor kidney?",
      options: [
        "At least 6 months",
        "At least 1 year",
        "At least 2 years",
        "At least 3 years"
      ],
      correct: "C"
    },
    {
      id: 26606,
      question: "What is the expected waiting time for recipients receiving a direct donation from a living donor?",
      options: [
        "6 months",
        "1 year",
        "Virtually no waiting time",
        "3 months"
      ],
      correct: "C"
    },
    {
      id: 26607,
      question: "How long should patients avoid dental treatment after organ or stem cell transplants except for emergencies?",
      options: [
        "Up to 3 months",
        "Up to 6 months",
        "Up to 9 months",
        "Up to 12 months"
      ],
      correct: "B"
    },
    {
      id: 26608,
      question: "Within what timeframe does the graft typically stabilize after transplant?",
      options: [
        "1 to 2 months",
        "2 to 4 months",
        "3 to 6 months",
        "6 to 12 months"
      ],
      correct: "C"
    },
    {
      id: 26609,
      question: "What is a breakthrough drug in solid organ transplantation?",
      options: [
        "Tacrolimus",
        "Azathioprine",
        "Cyclosporine",
        "Sirolimus"
      ],
      correct: "C"
    },
    {
      id: 26610,
      question: "What risk does cyclosporine increase?",
      options: [
        "Hepatotoxicity",
        "Nephrotoxicity",
        "Cardiotoxicity",
        "Neurotoxicity"
      ],
      correct: "B"
    },
    {
      id: 26611,
      question: "What trio of immunosuppression medications are most transplant recipients treated with?",
      options: [
        "Cyclosporine, azathioprine, tacrolimus",
        "Prednisone, azathioprine, tacrolimus",
        "Cyclosporine, prednisone, mycophenolate mofetil",
        "Tacrolimus, prednisone, sirolimus"
      ],
      correct: "C"
    },
    {
      id: 26612,
      question: "What is gingival enlargement also known as?",
      options: [
        "Gingival hyperplasia",
        "Gingival overgrowth",
        "Gingival hypertrophy",
        "Gingival proliferation"
      ],
      correct: "B"
    },
    {
      id: 26613,
      question: "What may gingival enlargement be exacerbated by?",
      options: [
        "Diet",
        "Medications only",
        "Poor oral hygiene",
        "Stress"
      ],
      correct: "C"
    },
    {
      id: 26614,
      question: "What immunosuppressive medication has been associated with drug-influenced gingival enlargement?",
      options: [
        "Cyclosporine",
        "Azathioprine",
        "Tacrolimus",
        "Mycophenolate mofetil"
      ],
      correct: "C"
    },
    {
      id: 26615,
      question: "What continued-care interval is recommended to reduce gingival enlargement risk?",
      options: [
        "2- to 3-month intervals",
        "3- to 4-month intervals",
        "4- to 6-month intervals",
        "6-month intervals"
      ],
      correct: "B"
    },
    {
      id: 26616,
      question: "When is immunosuppressive therapy at its most aggressive level?",
      options: [
        "6 months after transplant",
        "1 year after transplant",
        "Immediately after transplant surgery",
        "During pre-transplant phase"
      ],
      correct: "C"
    },
    {
      id: 26617,
      question: "What can immunosuppressive therapy mask?",
      options: [
        "Pain",
        "Infection",
        "Inflammation",
        "Bleeding"
      ],
      correct: "C"
    },
    {
      id: 26618,
      question: "What do the majority of medical providers recommend for transplant patients?",
      options: [
        "No antibiotic prophylaxis",
        "Antibiotic prophylaxis for invasive dental procedures",
        "Antibiotic prophylaxis only for surgery",
        "Antibiotic prophylaxis quarterly"
      ],
      correct: "B"
    },
    {
      id: 26619,
      question: "What period after transplantation represents significant risk for immunocompromised patients?",
      options: [
        "3-month period",
        "4-month period",
        "6-month period",
        "12-month period"
      ],
      correct: "C"
    },
    {
      id: 26620,
      question: "What do patients taking immunosuppressive therapy often experience in the oral cavity?",
      options: [
        "Tooth sensitivity",
        "Candidiasis or recurrence of herpetic infections",
        "Tooth discoloration",
        "Enamel hypoplasia"
      ],
      correct: "B"
    },
    {
      id: 26621,
      question: "What increased incidence do organ transplant recipients have?",
      options: [
        "Tooth decay",
        "Periodontal disease",
        "Squamous and basal cell carcinomas",
        "Oral ulcers"
      ],
      correct: "C"
    },
    {
      id: 26622,
      question: "Which transplant recipients are at particular risk for oropharyngeal cancer?",
      options: [
        "Kidney transplant recipients",
        "Heart transplant recipients",
        "Liver transplant recipients with tobacco/alcohol history",
        "Lung transplant recipients"
      ],
      correct: "C"
    },
    {
      id: 26623,
      question: "How many solid organ transplant adult candidates were wait-listed with UNOS in 2021?",
      options: [
        "Nearly 87,000",
        "Nearly 97,000",
        "Nearly 107,000",
        "Nearly 117,000"
      ],
      correct: "C"
    },
    {
      id: 26624,
      question: "How many transplants were performed in 2021?",
      options: [
        "31,355",
        "36,355",
        "41,355",
        "46,355"
      ],
      correct: "C"
    },
    {
      id: 26625,
      question: "How many kidney transplants alone were performed in 2021?",
      options: [
        "19,670",
        "21,670",
        "24,670",
        "27,670"
      ],
      correct: "C"
    },
    {
      id: 26626,
      question: "What is the window for deceased kidneys before transplantation?",
      options: [
        "24-hour window",
        "36-hour window",
        "48-hour window",
        "72-hour window"
      ],
      correct: "C"
    },
    {
      id: 26627,
      question: "What does K/DOQI stand for?",
      options: [
        "Kidney Disease Outcomes Quality Initiative",
        "Kidney Dialysis Outcomes Quality Initiative",
        "Kidney Disease Overall Quality Initiative",
        "Kidney Diagnosis Outcomes Quality Initiative"
      ],
      correct: "A"
    },
    {
      id: 26628,
      question: "What does KDIGO stand for?",
      options: [
        "Kidney Disease International Guidelines Organization",
        "Kidney Dialysis Improving Global Outcomes",
        "Kidney Disease: Improving Global Outcomes",
        "Kidney Donors International Global Organization"
      ],
      correct: "C"
    },
    {
      id: 26629,
      question: "How many essential bodily functions do kidneys perform?",
      options: [
        "Two functions",
        "Three functions",
        "Four functions",
        "Five functions"
      ],
      correct: "B"
    },
    {
      id: 26630,
      question: "What three essential functions do kidneys perform?",
      options: [
        "Filtration, digestion, circulation",
        "Excretion, regulation, synthesis of hormones",
        "Absorption, secretion, metabolism",
        "Filtration, absorption, excretion"
      ],
      correct: "B"
    },
    {
      id: 26631,
      question: "What is the functional part of the kidney?",
      options: [
        "Glomerulus",
        "Tubule",
        "Nephron",
        "Collecting duct"
      ],
      correct: "C"
    },
    {
      id: 26632,
      question: "What often develops when kidney function declines?",
      options: [
        "Diabetes and obesity",
        "Hypertension and anemia",
        "Hypotension and polycythemia",
        "Bradycardia and edema"
      ],
      correct: "B"
    },
    {
      id: 26633,
      question: "What is the most accurate means of measuring renal function?",
      options: [
        "Creatinine clearance",
        "Blood urea nitrogen",
        "Glomerular filtration rate (GFR)",
        "Serum creatinine"
      ],
      correct: "C"
    },
    {
      id: 26634,
      question: "What does GFR stand for?",
      options: [
        "General filtration rate",
        "Glomerular filtration rate",
        "Glomerular function rate",
        "General function rate"
      ],
      correct: "B"
    },
    {
      id: 26635,
      question: "How many stages of CKD are defined by the National Kidney Foundation?",
      options: [
        "Three stages",
        "Four stages",
        "Five stages",
        "Six stages"
      ],
      correct: "C"
    },
    {
      id: 26636,
      question: "What is the GFR for Stage 1 CKD?",
      options: [
        "GFR ≥60",
        "GFR ≥70",
        "GFR ≥80",
        "GFR ≥90"
      ],
      correct: "D"
    },
    {
      id: 26637,
      question: "What is the GFR for Stage 2 CKD?",
      options: [
        "50 to 79",
        "60 to 89",
        "70 to 99",
        "40 to 69"
      ],
      correct: "B"
    },
    {
      id: 26638,
      question: "What is the GFR for Stage 3 CKD?",
      options: [
        "20 to 49",
        "25 to 54",
        "30 to 59",
        "35 to 64"
      ],
      correct: "C"
    },
    {
      id: 26639,
      question: "What is the GFR for Stage 4 CKD?",
      options: [
        "10 to 24",
        "12 to 26",
        "15 to 29",
        "18 to 32"
      ],
      correct: "C"
    },
    {
      id: 26640,
      question: "What is the GFR for Stage 5 CKD or kidney failure?",
      options: [
        "<10",
        "<12",
        "<15",
        "<18"
      ],
      correct: "C"
    },
    {
      id: 26641,
      question: "What defines CKD according to kidney damage or GFR?",
      options: [
        "GFR <50",
        "GFR <55",
        "GFR <60",
        "GFR <65"
      ],
      correct: "C"
    },
    {
      id: 26642,
      question: "What preventive medications delay or avoid end-stage renal disease?",
      options: [
        "Beta-blockers and calcium channel blockers",
        "ACE inhibitors and ARBs",
        "Diuretics and vasodilators",
        "Alpha-blockers and nitrates"
      ],
      correct: "B"
    },
    {
      id: 26643,
      question: "How many million American adults have CKD according to NKF estimates?",
      options: [
        "27 million",
        "32 million",
        "37 million",
        "42 million"
      ],
      correct: "C"
    },
    {
      id: 26644,
      question: "What percentage of American adults have CKD?",
      options: [
        "10%",
        "12%",
        "15%",
        "18%"
      ],
      correct: "C"
    },
    {
      id: 26645,
      question: "What percentage of people with kidney damage or mildly reduced function are unaware of having CKD?",
      options: [
        "70%",
        "80%",
        "90%",
        "95%"
      ],
      correct: "C"
    },
    {
      id: 26646,
      question: "Which population has CKD more commonly according to estimates?",
      options: [
        "Males",
        "Females",
        "Children",
        "Elderly only"
      ],
      correct: "B"
    },
    {
      id: 26647,
      question: "What systemic factors increase risk of developing CKD?",
      options: [
        "Obesity only",
        "Age only",
        "Diabetes mellitus, high blood pressure, or both",
        "Family history only"
      ],
      correct: "C"
    },
    {
      id: 26648,
      question: "What is anemia?",
      options: [
        "Increase in red blood cells",
        "Reduction in mass of circulating red blood cells",
        "Increase in white blood cells",
        "Reduction in platelets"
      ],
      correct: "B"
    },
    {
      id: 26649,
      question: "What hormone do healthy kidneys produce that stimulates bone marrow?",
      options: [
        "Insulin",
        "Glucagon",
        "Erythropoietin (EPO)",
        "Cortisol"
      ],
      correct: "C"
    },
    {
      id: 26650,
      question: "What percentage of renal function indicates end-stage renal failure where anemia is present?",
      options: [
        "Less than 5%",
        "Less than 10%",
        "Less than 15%",
        "Less than 20%"
      ],
      correct: "B"
    },
    {
      id: 26651,
      question: "What are oral manifestations of anemia?",
      options: [
        "Tooth decay only",
        "Gingival bleeding only",
        "Pallor of oral mucosa, glossitis, aphthous ulcers, candidiasis",
        "Tooth mobility only"
      ],
      correct: "C"
    },
    {
      id: 26652,
      question: "When are persons with kidney disease considered anemic according to K/DOQI?",
      options: [
        "Hemoglobin <10 g/dL or hematocrit <30%",
        "Hemoglobin <11 g/dL or hematocrit <33%",
        "Hemoglobin <12 g/dL or hematocrit <36%",
        "Hemoglobin <13 g/dL or hematocrit <39%"
      ],
      correct: "B"
    },
    {
      id: 26653,
      question: "What is mineral and bone disorder formerly referred to as?",
      options: [
        "Primary hyperparathyroidism",
        "Osteoporosis",
        "Secondary hyperparathyroidism",
        "Osteomalacia"
      ],
      correct: "C"
    },
    {
      id: 26654,
      question: "What do kidneys lose ability to excrete as renal disease progresses?",
      options: [
        "Calcium",
        "Phosphorus",
        "Sodium",
        "Potassium"
      ],
      correct: "B"
    },
    {
      id: 26655,
      question: "What vitamin do kidneys produce that is necessary in bone metabolism?",
      options: [
        "Vitamin A",
        "Vitamin C",
        "Vitamin D",
        "Vitamin E"
      ],
      correct: "C"
    },
    {
      id: 26656,
      question: "What are medications known as that reduce absorption of phosphorus?",
      options: [
        "Calcium binders",
        "Phosphorus binders",
        "Potassium binders",
        "Sodium binders"
      ],
      correct: "B"
    },
    {
      id: 26657,
      question: "What radiographic finding is part of the triad in mineral and bone disorders?",
      options: [
        "Increased bone density",
        "Loss of lamina dura",
        "Widened PDL space",
        "Root resorption"
      ],
      correct: "B"
    },
    {
      id: 26658,
      question: "What appearance does demineralized bone assume in mineral and bone disorders?",
      options: [
        "Cotton wool appearance",
        "Ground glass appearance",
        "Soap bubble appearance",
        "Sunburst appearance"
      ],
      correct: "B"
    },
    {
      id: 26659,
      question: "What are expansile radiolucent osseous lesions also called?",
      options: [
        "Osteomas",
        "Cysts",
        "Central giant cell granulomas or brown tumors",
        "Fibromas"
      ],
      correct: "C"
    },
    {
      id: 26660,
      question: "What does a renal diet typically restrict?",
      options: [
        "Protein only",
        "Carbohydrates only",
        "Fluid and sodium intake",
        "Fat only"
      ],
      correct: "C"
    },
    {
      id: 26661,
      question: "What does a renal diet limit?",
      options: [
        "Calcium and magnesium",
        "Dietary phosphorus and potassium",
        "Carbohydrates and fats",
        "Proteins and vitamins"
      ],
      correct: "B"
    },
    {
      id: 26662,
      question: "Who should the dental hygienist collaborate with when counseling patients on dental products?",
      options: [
        "Physician",
        "Pharmacist",
        "Patient\'s renal dietitian",
        "Nurse"
      ],
      correct: "C"
    },
    {
      id: 26663,
      question: "What is an excellent indicator of protein intake?",
      options: [
        "Hemoglobin",
        "Albumin",
        "Creatinine",
        "BUN"
      ],
      correct: "B"
    },
    {
      id: 26664,
      question: "What condition produces when nitrogenous materials accumulate in the body?",
      options: [
        "Azotemia",
        "Hyperkalemia",
        "Uremia",
        "Acidosis"
      ],
      correct: "C"
    },
    {
      id: 26665,
      question: "What percentage of adults with CKD/ESRD suffer from xerostomia?",
      options: [
        "Nearly 30%",
        "Nearly 40%",
        "Nearly 50%",
        "Nearly 60%"
      ],
      correct: "C"
    },
    {
      id: 26666,
      question: "What causes xerostomia in dialysis patients?",
      options: [
        "Age only",
        "Restriction in fluid intake and drug therapy effects",
        "Diet only",
        "Genetics only"
      ],
      correct: "B"
    },
    {
      id: 26667,
      question: "What can provide gustatory stimulation for dry mouth?",
      options: [
        "Water",
        "Sugar-free candies",
        "Ice chips",
        "Mouth rinses"
      ],
      correct: "B"
    },
    {
      id: 26668,
      question: "What provides mechanical stimulation for dry mouth?",
      options: [
        "Medications",
        "Food",
        "Power toothbrush, xylitol gum or lozenges",
        "Saliva substitutes"
      ],
      correct: "C"
    },
    {
      id: 26669,
      question: "What pharmacologic stimulation drugs require prescription?",
      options: [
        "Fluoride and xylitol",
        "Pilocarpine HCl or cevimeline HCl",
        "Chlorhexidine",
        "Antibiotics"
      ],
      correct: "B"
    },
    {
      id: 26670,
      question: "What relationship exists between periodontal disease and renal insufficiency?",
      options: [
        "Strong relationship",
        "No relationship",
        "Moderate relationship",
        "Inverse relationship"
      ],
      correct: "C"
    },
    {
      id: 26671,
      question: "In which patients does risk for periodontal disease appear significantly increased?",
      options: [
        "Early stage CKD",
        "Mild kidney disease",
        "Severe renal disease or hemodialysis patients",
        "Post-transplant patients"
      ],
      correct: "C"
    },
    {
      id: 26672,
      question: "What may contribute to accelerated bone loss in presence of periodontal disease?",
      options: [
        "Primary hyperthyroidism",
        "Hypothyroidism",
        "Secondary hyperparathyroidism",
        "Hypoparathyroidism"
      ],
      correct: "C"
    },
    {
      id: 26673,
      question: "What continued-care interval is recommended for transplant patients?",
      options: [
        "6-month intervals",
        "2- to 3-month intervals",
        "3- to 4-month intervals",
        "12-month intervals"
      ],
      correct: "C"
    },
    {
      id: 26674,
      question: "Who coordinates all required preoperative appointments for transplant candidates?",
      options: [
        "Nephrologist",
        "Transplant surgeon",
        "Pretransplant coordinator",
        "Primary care physician"
      ],
      correct: "C"
    },
    {
      id: 26675,
      question: "What is the pretransplant coordinator usually?",
      options: [
        "Physician or surgeon",
        "Registered nurse or physician\'s assistant",
        "Social worker",
        "Pharmacist"
      ],
      correct: "B"
    },
    {
      id: 26676,
      question: "What should not be done in hemodialysis?",
      options: [
        "Perform oral hygiene",
        "Take blood pressure in dialysis access arm",
        "Schedule appointments",
        "Provide patient education"
      ],
      correct: "B"
    },
    {
      id: 26677,
      question: "Why should blood pressure not be taken in dialysis access arm?",
      options: [
        "Inaccurate readings",
        "Patient discomfort",
        "Could cause access to become occluded or infected",
        "No reason"
      ],
      correct: "C"
    },
    {
      id: 26678,
      question: "When should invasive dental treatment be avoided for hemodialysis patients?",
      options: [
        "Day before dialysis",
        "Same day as dialysis treatment",
        "Day after dialysis",
        "Week of dialysis"
      ],
      correct: "B"
    },
    {
      id: 26679,
      question: "Why avoid treatment same day as dialysis?",
      options: [
        "Patient fatigue",
        "Coagulation complications from heparin use",
        "Scheduling conflicts",
        "Patient preference"
      ],
      correct: "B"
    },
    {
      id: 26680,
      question: "What does hemodialysis tend to exacerbate?",
      options: [
        "Hypertension",
        "Anemia",
        "Bleeding tendencies",
        "Nausea"
      ],
      correct: "C"
    },
    {
      id: 26681,
      question: "Why does hemodialysis exacerbate bleeding?",
      options: [
        "Medication interactions",
        "Physical destruction of platelets",
        "Lowered blood pressure",
        "Dehydration"
      ],
      correct: "B"
    },
    {
      id: 26682,
      question: "What laboratory tests should be reviewed when high risk of bleeding expected?",
      options: [
        "CBC and BMP",
        "Liver function tests",
        "Partial thromboplastin time and platelet count",
        "Blood glucose"
      ],
      correct: "C"
    },
    {
      id: 26683,
      question: "What does peritoneal dialysis use to filter blood?",
      options: [
        "Artificial kidney",
        "Dialysis machine",
        "Person\'s own peritoneal lining",
        "External filter"
      ],
      correct: "C"
    },
    {
      id: 26684,
      question: "Where does surgeon place catheter for peritoneal dialysis?",
      options: [
        "Chest",
        "Arm",
        "Abdomen",
        "Leg"
      ],
      correct: "C"
    },
    {
      id: 26685,
      question: "What does dialysate solution for peritoneal dialysis contain?",
      options: [
        "Saline only",
        "Glucose only",
        "Dextrose, salt, and other minerals dissolved in water",
        "Protein solutions"
      ],
      correct: "C"
    },
    {
      id: 26686,
      question: "What are the two primary forms of peritoneal dialysis?",
      options: [
        "CAPD and CCPD",
        "CAPD and HD",
        "CCPD and HD",
        "IPD and CAPD"
      ],
      correct: "A"
    },
    {
      id: 26687,
      question: "What does CAPD stand for?",
      options: [
        "Continuous Ambulatory Peritoneal Dialysis",
        "Continual Ambulatory Peritoneal Dialysis",
        "Chronic Ambulatory Peritoneal Dialysis",
        "Complete Ambulatory Peritoneal Dialysis"
      ],
      correct: "B"
    },
    {
      id: 26688,
      question: "What does CCPD stand for?",
      options: [
        "Continuous Cyclic-Assisted Peritoneal Dialysis",
        "Chronic Cyclic-Assisted Peritoneal Dialysis",
        "Complete Cyclic-Assisted Peritoneal Dialysis",
        "Continual Cyclic-Assisted Peritoneal Dialysis"
      ],
      correct: "A"
    },
    {
      id: 26689,
      question: "How is dialysate delivered in CAPD?",
      options: [
        "By machine",
        "Intravenously",
        "Manually to abdominal catheter",
        "Through vascular access"
      ],
      correct: "C"
    },
    {
      id: 26690,
      question: "When is solution removed and replaced in CAPD?",
      options: [
        "Once daily",
        "During prescribed intervals throughout day",
        "Once weekly",
        "Twice daily"
      ],
      correct: "B"
    },
    {
      id: 26691,
      question: "When is solution removed and replaced in CCPD?",
      options: [
        "During day",
        "Morning only",
        "During evening/night while patient sleeps",
        "Afternoon"
      ],
      correct: "C"
    },
    {
      id: 26692,
      question: "What does CCPD require that CAPD does not?",
      options: [
        "Sterile technique",
        "Catheter placement",
        "Electricity to operate machine",
        "Medical supervision"
      ],
      correct: "C"
    },
    {
      id: 26693,
      question: "What is dialysis access for hemodialysis patient?",
      options: [
        "Temporary access",
        "Patient\'s lifeline",
        "Optional equipment",
        "Backup system"
      ],
      correct: "B"
    },
    {
      id: 26694,
      question: "How many times per week do hemodialysis patients typically receive treatment?",
      options: [
        "Once per week",
        "Twice per week",
        "Three times per week",
        "Daily"
      ],
      correct: "C"
    },
    {
      id: 26695,
      question: "What creates the dialysis access?",
      options: [
        "Nephrologist",
        "Interventional radiologist",
        "Vascular surgeon",
        "Transplant surgeon"
      ],
      correct: "C"
    },
    {
      id: 26696,
      question: "Where is dialysis access usually created?",
      options: [
        "Upper arm",
        "Forearm",
        "Leg",
        "Chest"
      ],
      correct: "B"
    },
    {
      id: 26697,
      question: "What is inserted into vascular access during each dialysis session?",
      options: [
        "Small IV catheter",
        "Large intravenous cannula",
        "Needle only",
        "Tube"
      ],
      correct: "B"
    },
    {
      id: 26698,
      question: "What filters blood during hemodialysis?",
      options: [
        "Kidney",
        "Liver",
        "Dialyzer or artificial kidney",
        "Membrane"
      ],
      correct: "C"
    },
    {
      id: 26699,
      question: "What is the most prevalent cause of mortality in hemodialysis and PD populations?",
      options: [
        "Infections",
        "Malnutrition",
        "Cardiovascular complications",
        "Bleeding"
      ],
      correct: "C"
    },
    {
      id: 26700,
      question: "What are secondary medical conditions?",
      options: [
        "Primary disease symptoms",
        "Complications from original disease",
        "Not part of original etiology but developed because of disease",
        "Genetic conditions"
      ],
      correct: "C"
    },
    {
      id: 26701,
      question: "What can patients with ESRD from hypertension develop?",
      options: [
        "Secondary hypotension",
        "Secondary diabetes",
        "Secondary obesity",
        "Secondary asthma"
      ],
      correct: "B"
    },
    {
      id: 26702,
      question: "What serious conditions need management in dialysis patients besides hypertension and diabetes?",
      options: [
        "Obesity and cancer",
        "Anemia, hyperparathyroidism, malnutrition",
        "Asthma and allergies",
        "Depression and anxiety"
      ],
      correct: "B"
    },
    {
      id: 26703,
      question: "What plays important role in clinical outcomes regardless of CKD stage?",
      options: [
        "Diet",
        "Exercise",
        "Inflammation",
        "Genetics"
      ],
      correct: "C"
    },
    {
      id: 26704,
      question: "What oral manifestation results from anemia?",
      options: [
        "Xerostomia",
        "Gingival bleeding",
        "Pallor of oral mucosa",
        "Tooth mobility"
      ],
      correct: "C"
    },
    {
      id: 26705,
      question: "What is an early sign of folate or vitamin B12 deficiency?",
      options: [
        "Xerostomia",
        "Glossitis",
        "Candidiasis",
        "Bleeding"
      ],
      correct: "B"
    },
    {
      id: 26706,
      question: "What are common systemic complications of anemia?",
      options: [
        "Hypertension and diabetes",
        "Fatigue and increased infection risk",
        "Weight gain and edema",
        "Headache and dizziness"
      ],
      correct: "B"
    },
    {
      id: 26707,
      question: "What may anemia contribute to?",
      options: [
        "Renal complications",
        "Hepatic complications",
        "Cardiovascular complications",
        "Respiratory complications"
      ],
      correct: "C"
    },
    {
      id: 26708,
      question: "What treatment for anemia may include genetically engineered hormone?",
      options: [
        "Insulin",
        "EPO hormone",
        "Growth hormone",
        "Thyroid hormone"
      ],
      correct: "B"
    },
    {
      id: 26709,
      question: "What supplements may be used for anemia treatment?",
      options: [
        "Calcium and vitamin D",
        "Iron and folate supplements",
        "Vitamin C and zinc",
        "Magnesium and potassium"
      ],
      correct: "B"
    },
    {
      id: 26710,
      question: "What may be detected on panoramic radiographs in mineral and bone disorders?",
      options: [
        "Tooth decay",
        "Periapical lesions",
        "Calcifications in carotid arteries",
        "TMJ problems"
      ],
      correct: "C"
    },
    {
      id: 26711,
      question: "What may periapical radiographs show in mineral and bone disorders?",
      options: [
        "Root caries",
        "Periodontal disease",
        "Narrowing or obliteration of pulp chamber",
        "Tooth fractures"
      ],
      correct: "C"
    },
    {
      id: 26712,
      question: "What appearance may oral mucosa have in CKD patients?",
      options: [
        "Red appearance",
        "Pale appearance from anemia",
        "Yellow appearance",
        "Purple appearance"
      ],
      correct: "B"
    },
    {
      id: 26713,
      question: "What causes xerostomia in CKD patients?",
      options: [
        "Age only",
        "Reduction in salivary flow",
        "Diet only",
        "Medications only"
      ],
      correct: "B"
    },
    {
      id: 26714,
      question: "What results from xerostomia?",
      options: [
        "Improved oral health",
        "Dry mouth, caries, gingival disease, infections",
        "Better taste sensation",
        "Increased appetite"
      ],
      correct: "B"
    },
    {
      id: 26715,
      question: "What pigmentation may result from decreased renal filtration?",
      options: [
        "White pigmentation",
        "Blue pigmentation",
        "Red-orange pigmentation",
        "Yellow pigmentation"
      ],
      correct: "C"
    },
    {
      id: 26716,
      question: "What is dysgeusia?",
      options: [
        "Difficulty swallowing",
        "Altered or metallic taste sensation",
        "Loss of smell",
        "Dry mouth"
      ],
      correct: "B"
    },
    {
      id: 26717,
      question: "What characteristic odor may saliva exhibit in CKD?",
      options: [
        "Sweet odor",
        "Fruity odor",
        "Ammonia-like odor",
        "No odor"
      ],
      correct: "C"
    },
    {
      id: 26718,
      question: "What infections are more frequent in CKD patients?",
      options: [
        "Bacterial only",
        "Viral only",
        "Fungal infections like candidiasis",
        "Parasitic"
      ],
      correct: "C"
    },
    {
      id: 26719,
      question: "What causes bleeding tendencies in oral tissues of CKD patients?",
      options: [
        "Poor oral hygiene",
        "Thrombocytopenia, infection, medications, anticoagulants",
        "Diet",
        "Age"
      ],
      correct: "B"
    },
    {
      id: 26720,
      question: "Where may petechiae and ecchymoses be observed?",
      options: [
        "Teeth only",
        "Gingiva only",
        "Oral mucosa, soft palate, tongue borders, gingiva",
        "Hard palate only"
      ],
      correct: "C"
    },
    {
      id: 26721,
      question: "What dentition abnormalities occur in children with CKD?",
      options: [
        "Tooth decay only",
        "Enamel hypoplasia, discoloration, altered eruption",
        "Tooth mobility only",
        "Gingival recession"
      ],
      correct: "B"
    },
    {
      id: 26722,
      question: "What may appear narrowed on radiographs in children with CKD?",
      options: [
        "PDL space",
        "Bone density",
        "Dental pulps",
        "Tooth roots"
      ],
      correct: "C"
    },
    {
      id: 26723,
      question: "What is dental erosion associated with in CKD?",
      options: [
        "Acidic foods",
        "Tooth grinding",
        "Regurgitation and vomiting from uremia",
        "Poor oral hygiene"
      ],
      correct: "C"
    },
    {
      id: 26724,
      question: "Are systemic fluoride supplements indicated in chronic renal insufficiency?",
      options: [
        "Yes, always indicated",
        "No, contraindicated",
        "Sometimes indicated",
        "Only for children"
      ],
      correct: "B"
    },
    {
      id: 26725,
      question: "What are the two forms of uremic stomatitis?",
      options: [
        "Mild and severe",
        "Acute and chronic",
        "Erythemopultaceous and ulcerative",
        "Primary and secondary"
      ],
      correct: "C"
    },
    {
      id: 26726,
      question: "What features does erythemopultaceous uremic stomatitis have?",
      options: [
        "White patches only",
        "Dry, erythematous burning mucosa with gray exudates",
        "Ulcers only",
        "Bleeding only"
      ],
      correct: "B"
    },
    {
      id: 26727,
      question: "What characterizes ulcerative uremic stomatitis?",
      options: [
        "Red patches",
        "White lesions",
        "Mucosal ulcerations",
        "Bleeding gums"
      ],
      correct: "C"
    },
    {
      id: 26728,
      question: "What are white patches or uremic frost?",
      options: [
        "Tooth deposits",
        "Crystallized urea deposits on skin or oral mucosa",
        "Fungal infection",
        "Bacterial plaque"
      ],
      correct: "B"
    },
    {
      id: 26729,
      question: "When is uremic frost observed?",
      options: [
        "Mild uremia",
        "Moderate uremia",
        "Severe uremia",
        "Early CKD"
      ],
      correct: "C"
    },
    {
      id: 26730,
      question: "What osseous changes may appear in maxilla and mandible?",
      options: [
        "Increased density",
        "Loss of lamina dura, demineralized bone, radiolucent lesions",
        "Bone growth",
        "No changes"
      ],
      correct: "B"
    },
    {
      id: 26731,
      question: "What may periodontal inflammation be in CKD patients?",
      options: [
        "Less severe than normal",
        "Same as normal",
        "More severe than normal biofilm-induced gingivitis",
        "Non-existent"
      ],
      correct: "C"
    },
    {
      id: 26732,
      question: "What may result from poor oral hygiene in CKD?",
      options: [
        "Tooth whitening",
        "Periodontal attachment loss",
        "Enamel strengthening",
        "Reduced calculus"
      ],
      correct: "B"
    },
    {
      id: 26733,
      question: "How can prevention of periodontal infections be achieved?",
      options: [
        "Medications only",
        "Reducing biofilm through optimal hygiene and antimicrobials",
        "Diet changes only",
        "Supplements only"
      ],
      correct: "B"
    },
    {
      id: 26734,
      question: "What may increase calculus formation?",
      options: [
        "Good oral hygiene",
        "Uremic status and duration of renal disease",
        "Regular dental visits",
        "Fluoride use"
      ],
      correct: "B"
    }
  ],
  "7. Respiratory Diseases": [
    {
      id: 26700,
      question: "What is asthma characterized by?",
      options: [
        "Decreased responsiveness of bronchial airways",
        "Increased responsiveness of bronchial airways to stimuli",
        "Permanent lung tissue damage",
        "Irreversible airway obstruction"
      ],
      correct: "B"
    },
    {
      id: 26701,
      question: "How is asthma severity classified?",
      options: [
        "Acute or chronic only",
        "Mild or severe only",
        "Intermittent or persistent (mild, moderate, or severe)",
        "Primary or secondary only"
      ],
      correct: "C"
    },
    {
      id: 26702,
      question: "What can precipitate an asthma attack?",
      options: [
        "Adequate rest and hydration",
        "Normal room temperature",
        "Pollen, ragweed, molds, foods, latex, dust mites",
        "Balanced diet and exercise"
      ],
      correct: "C"
    },
    {
      id: 26703,
      question: "What produces asthmatic symptoms?",
      options: [
        "Bronchial dilation and decreased secretions",
        "Narrowing of bronchi from inflammation and muscle contraction",
        "Increased lung capacity",
        "Enhanced oxygen exchange"
      ],
      correct: "B"
    },
    {
      id: 26704,
      question: "What are clinical manifestations of asthma?",
      options: [
        "Bradycardia and hypotension",
        "Increased appetite and weight gain",
        "Wheezing, dyspnea, coughing, chest tightness",
        "Fever and night sweats"
      ],
      correct: "C"
    },
    {
      id: 26705,
      question: "What is status asthmaticus?",
      options: [
        "Mild asthma easily controlled",
        "Asthma in remission phase",
        "Severe attack not responding to bronchodilators",
        "Early stage of asthma"
      ],
      correct: "C"
    },
    {
      id: 26706,
      question: "What respiratory rate indicates an acute asthmatic attack?",
      options: [
        "Less than 12 rpm",
        "12 to 20 rpm",
        "20 to 30 rpm",
        "More than 30 rpm"
      ],
      correct: "D"
    },
    {
      id: 26707,
      question: "What pulse rate indicates an acute asthmatic attack?",
      options: [
        "Less than 60 bpm",
        "60 to 100 bpm",
        "More than 120 bpm",
        "100 to 120 bpm"
      ],
      correct: "C"
    },
    {
      id: 26708,
      question: "What should dental hygienists assess in asthma patients?",
      options: [
        "Only current medications",
        "Frequency, onset, type of attacks, and precipitating factors",
        "Only family history",
        "Only previous hospitalizations"
      ],
      correct: "B"
    },
    {
      id: 26709,
      question: "When should medical consultation be sought for asthma patients?",
      options: [
        "For all patients with asthma",
        "Only for patients with severe attacks",
        "For persistent severe asthma or poorly controlled symptoms",
        "Never necessary"
      ],
      correct: "C"
    },
    {
      id: 26710,
      question: "What systemic corticosteroid is commonly used for chronic asthma?",
      options: [
        "Insulin",
        "Prednisone",
        "Metformin",
        "Warfarin"
      ],
      correct: "B"
    },
    {
      id: 26711,
      question: "What should asthma patients bring to every dental appointment?",
      options: [
        "Emergency contact information only",
        "Medical records",
        "Medical inhalers prescribed by physician",
        "List of allergies only"
      ],
      correct: "C"
    },
    {
      id: 26712,
      question: "What side effects do asthma medications cause?",
      options: [
        "Increased salivation and appetite",
        "Hyperactivity and insomnia",
        "Xerostomia and unpleasant taste",
        "Weight gain and edema"
      ],
      correct: "C"
    },
    {
      id: 26713,
      question: "Why are asthma patients prone to dental caries?",
      options: [
        "Poor oral hygiene only",
        "Xerostomia and increased sucrose intake",
        "Genetic factors only",
        "Lack of fluoride exposure"
      ],
      correct: "B"
    },
    {
      id: 26714,
      question: "What adverse reaction do inhaled synthetic corticosteroids cause?",
      options: [
        "Hypertension and tachycardia",
        "Nausea and vomiting",
        "Oral candidiasis, unpleasant taste, xerostomia",
        "Diarrhea and cramping"
      ],
      correct: "C"
    },
    {
      id: 26715,
      question: "What do short-acting inhaled beta2-adrenergic agonists temporarily do?",
      options: [
        "Constrict bronchial tubes",
        "Dilate or relax bronchial tube muscles",
        "Increase mucus production",
        "Decrease oxygen absorption"
      ],
      correct: "B"
    },
    {
      id: 26716,
      question: "What adverse reactions are associated with beta2-adrenergic agonists?",
      options: [
        "Drowsiness and bradycardia",
        "Weight gain and edema",
        "Nervousness, xerostomia, throat irritation",
        "Hypotension and dizziness"
      ],
      correct: "C"
    },
    {
      id: 26717,
      question: "What drugs should asthma patients avoid?",
      options: [
        "Vitamins and minerals",
        "Antibiotics",
        "Aspirin-containing medications, NSAIDs, barbiturates, narcotics",
        "Antacids and antihistamines"
      ],
      correct: "C"
    },
    {
      id: 26718,
      question: "Why should some asthma patients avoid epinephrine in local anesthetics?",
      options: [
        "It causes allergic reactions",
        "Sensitivity to sulfite preservatives present",
        "It decreases anesthetic effectiveness",
        "It causes excessive bleeding"
      ],
      correct: "B"
    },
    {
      id: 26719,
      question: "What correlation has been observed in children with asthma?",
      options: [
        "Lower dental caries rate",
        "Enhanced jaw development",
        "Higher palatal vaults, overjets, posterior crossbite",
        "Smaller tooth size"
      ],
      correct: "C"
    },
    {
      id: 26720,
      question: "What can trigger decreased lung function during dental procedures?",
      options: [
        "Proper positioning only",
        "Use of fluoride",
        "Anxiety, supine positioning, enamel dust, aerosols",
        "Adequate lighting"
      ],
      correct: "C"
    },
    {
      id: 26721,
      question: "What is the first step in managing acute asthma?",
      options: [
        "Call emergency services immediately",
        "Recognize symptoms",
        "Administer parenteral drugs",
        "Position patient supine"
      ],
      correct: "B"
    },
    {
      id: 26722,
      question: "What position should be used for an asthma patient during an attack?",
      options: [
        "Completely supine",
        "Trendelenburg position",
        "Sitting upright",
        "Left lateral position"
      ],
      correct: "C"
    },
    {
      id: 26723,
      question: "What is COPD as defined by Global Initiative?",
      options: [
        "Reversible lung condition",
        "Disease with persistent respiratory symptoms and airflow limitation",
        "Acute respiratory infection",
        "Genetic disorder only"
      ],
      correct: "B"
    },
    {
      id: 26724,
      question: "What is COPD often directly related to?",
      options: [
        "Genetic factors only",
        "Environmental allergies",
        "Tobacco smoking",
        "Dietary deficiencies"
      ],
      correct: "C"
    },
    {
      id: 26725,
      question: "What are the primary causes of COPD historically?",
      options: [
        "Pneumonia and tuberculosis",
        "Asthma and allergies",
        "Chronic bronchitis and emphysema",
        "Lung cancer and fibrosis"
      ],
      correct: "C"
    },
    {
      id: 26726,
      question: "What does emphysema describe?",
      options: [
        "Lung infection",
        "Overinflation and destruction of alveoli",
        "Bronchial constriction",
        "Pleural effusion"
      ],
      correct: "B"
    },
    {
      id: 26727,
      question: "What is chronic bronchitis associated with?",
      options: [
        "Dry cough for 1 month",
        "Occasional cough",
        "Mucus-producing cough for 3 months/year for 2+ years",
        "Cough only at night"
      ],
      correct: "C"
    },
    {
      id: 26728,
      question: "How many stages can COPD be classified into with spirometry?",
      options: [
        "Two stages",
        "Three stages",
        "Four stages",
        "Five stages"
      ],
      correct: "C"
    },
    {
      id: 26729,
      question: "What is the major risk factor for COPD?",
      options: [
        "Poor diet",
        "Lack of exercise",
        "Cigarette smoking",
        "Stress"
      ],
      correct: "C"
    },
    {
      id: 26730,
      question: "What is alpha-1 antitrypsin deficiency?",
      options: [
        "Common cause of COPD",
        "Genetic predisposition for emphysema",
        "Viral infection",
        "Environmental toxin exposure"
      ],
      correct: "B"
    },
    {
      id: 26731,
      question: "In how many emphysema cases does alpha-1 occur?",
      options: [
        "1 in every 10 cases",
        "1 in every 25 cases",
        "1 in every 50 cases",
        "1 in every 100 cases"
      ],
      correct: "C"
    },
    {
      id: 26732,
      question: "What does alpha-1 antitrypsin protect lungs from?",
      options: [
        "Bacterial invasion",
        "The enzyme elastase",
        "Viral infections",
        "Allergens"
      ],
      correct: "B"
    },
    {
      id: 26733,
      question: "What term describes individuals with bluish skin and breathing distress?",
      options: [
        "Pink puffer",
        "Blue bloater",
        "Gray gasper",
        "Red wheezer"
      ],
      correct: "B"
    },
    {
      id: 26734,
      question: "What physical finding is seen in advanced emphysema cases?",
      options: [
        "Weight gain",
        "Decreased chest size",
        "Weight loss and barrel-chest appearance",
        "Increased muscle mass"
      ],
      correct: "C"
    },
    {
      id: 26735,
      question: "How many components does COPD management include?",
      options: [
        "Two components",
        "Three components",
        "Four components",
        "Five components"
      ],
      correct: "C"
    },
    {
      id: 26736,
      question: "What is foundational in COPD management?",
      options: [
        "Medication only",
        "Surgery",
        "Self-management and smoking cessation",
        "Oxygen therapy alone"
      ],
      correct: "C"
    },
    {
      id: 26737,
      question: "Can medications cure COPD?",
      options: [
        "Yes, with proper dosing",
        "No, but they improve airflow and relieve symptoms",
        "Yes, if started early",
        "Only in mild cases"
      ],
      correct: "B"
    },
    {
      id: 26738,
      question: "What are beta2-agonists particularly effective at?",
      options: [
        "Curing the disease",
        "Preventing all symptoms",
        "Relaxing bronchial tubes and improving mucus clearance",
        "Eliminating need for other medications"
      ],
      correct: "C"
    },
    {
      id: 26739,
      question: "What may be added for insufficient symptom relief in COPD?",
      options: [
        "Vitamins only",
        "Dietary supplements",
        "Methylxanthine as add-on therapy",
        "Herbal remedies"
      ],
      correct: "C"
    },
    {
      id: 26740,
      question: "What chair position should be used for COPD patients?",
      options: [
        "Completely supine",
        "Trendelenburg",
        "Semi-supine or upright",
        "Right lateral"
      ],
      correct: "C"
    },
    {
      id: 26741,
      question: "Why plan short appointments for COPD patients?",
      options: [
        "To save time",
        "Decrease stress if patient cannot tolerate long periods",
        "For scheduling convenience",
        "To reduce costs"
      ],
      correct: "B"
    },
    {
      id: 26742,
      question: "What should be assessed before treating COPD patients?",
      options: [
        "Insurance coverage only",
        "Transportation needs",
        "Severity, frequency of symptoms, conditions that exacerbate",
        "Family support only"
      ],
      correct: "C"
    },
    {
      id: 26743,
      question: "What should be avoided with COPD patients if possible?",
      options: [
        "Fluoride treatments",
        "Dental dams",
        "All dental procedures",
        "Local anesthesia"
      ],
      correct: "B"
    },
    {
      id: 26744,
      question: "Why avoid dental dams with COPD patients?",
      options: [
        "Patient discomfort",
        "May further obstruct ventilation",
        "Causes allergic reactions",
        "Interferes with medications"
      ],
      correct: "B"
    },
    {
      id: 26745,
      question: "What should be avoided with emphysema patients?",
      options: [
        "All anesthesia",
        "Fluoride",
        "Nitrous oxide-oxygen inhalation sedation",
        "Routine cleanings"
      ],
      correct: "C"
    },
    {
      id: 26746,
      question: "What causes tuberculosis?",
      options: [
        "Viral infection",
        "Mycobacterium tuberculosis bacterium",
        "Fungal infection",
        "Parasitic infection"
      ],
      correct: "B"
    },
    {
      id: 26747,
      question: "How is TB transmitted?",
      options: [
        "Through water",
        "Through food",
        "Airborne transmission",
        "Through direct skin contact"
      ],
      correct: "C"
    },
    {
      id: 26748,
      question: "What is the Mantoux tuberculin skin test commonly called?",
      options: [
        "TB test or skin test",
        "TST or PPD",
        "Mantoux or MT",
        "Tuberculin or TT"
      ],
      correct: "B"
    },
    {
      id: 26749,
      question: "What do persons with latent tuberculosis infection have?",
      options: [
        "Active disease and are infectious",
        "No clinical evidence and are not infectious",
        "Severe symptoms",
        "Contagious condition"
      ],
      correct: "B"
    },
    {
      id: 26750,
      question: "What is the most common obvious symptom of active TB?",
      options: [
        "Fever",
        "Weight gain",
        "Chronic cough",
        "Chest pain"
      ],
      correct: "C"
    },
    {
      id: 26751,
      question: "What treatment is used for latent TB?",
      options: [
        "No treatment needed",
        "Surgery",
        "Isoniazid or rifampin for 4 to 9 months",
        "Antibiotics for 1 week"
      ],
      correct: "C"
    },
    {
      id: 26752,
      question: "How long was active TB treated in the past?",
      options: [
        "1 to 3 months",
        "6 to 12 months",
        "At least 18 months",
        "24 to 36 months"
      ],
      correct: "C"
    },
    {
      id: 26753,
      question: "What is multi drug-resistant TB often caused by?",
      options: [
        "Genetic factors",
        "Environmental exposure",
        "Low patient compliance or inadequate treatment",
        "Viral mutation"
      ],
      correct: "C"
    },
    {
      id: 26754,
      question: "What is \"directly observed therapy\" for TB?",
      options: [
        "Patient self-monitoring",
        "Observing patients take each medication dose",
        "Video monitoring",
        "Weekly check-ins"
      ],
      correct: "B"
    },
    {
      id: 26755,
      question: "What vaccine is offered for TB in high-risk populations?",
      options: [
        "TB vaccine",
        "Tuberculosis immunization",
        "Bacille Calmette-Guérin (BCG)",
        "Mycobacterium vaccine"
      ],
      correct: "C"
    },
    {
      id: 26756,
      question: "Where should patients with active TB be treated for dental care?",
      options: [
        "Regular dental office",
        "Home setting",
        "Hospital setting under strict infection control",
        "Mobile dental clinic"
      ],
      correct: "C"
    },
    {
      id: 26757,
      question: "What is pneumonia?",
      options: [
        "Lung cancer",
        "Inflammation of gas-exchanging units of lungs",
        "Chronic cough",
        "Allergic reaction"
      ],
      correct: "B"
    },
    {
      id: 26758,
      question: "What are the two broad categories of pneumonia?",
      options: [
        "Viral and bacterial",
        "Acute and chronic",
        "Community-acquired and nosocomial",
        "Primary and secondary"
      ],
      correct: "C"
    },
    {
      id: 26759,
      question: "What percentage of CAP cases are caused by bacterial infections?",
      options: [
        "Over 30%",
        "Over 40%",
        "Over 50%",
        "Over 60%"
      ],
      correct: "C"
    },
    {
      id: 26760,
      question: "What is the most common organism causing CAP?",
      options: [
        "Haemophilus influenzae",
        "Streptococcus pneumoniae",
        "Pseudomonas aeruginosa",
        "MRSA"
      ],
      correct: "B"
    },
    {
      id: 26761,
      question: "What are common risk factors for CAP?",
      options: [
        "Young age only",
        "Good health",
        "COPD, alcohol abuse, cystic fibrosis, HIV/AIDS",
        "Adequate nutrition"
      ],
      correct: "C"
    },
    {
      id: 26762,
      question: "What are the three subcategories of nosocomial pneumonia?",
      options: [
        "Mild, moderate, severe",
        "HAP, VAP, HCAP",
        "Type 1, 2, 3",
        "Primary, secondary, tertiary"
      ],
      correct: "B"
    },
    {
      id: 26763,
      question: "What does HCAP stand for?",
      options: [
        "Hospital-acquired care pneumonia",
        "Healthcare-associated pneumonia",
        "High-alert care pneumonia",
        "Hospital-administered care pneumonia"
      ],
      correct: "B"
    },
    {
      id: 26764,
      question: "Who is aspiration pneumonia most often associated with?",
      options: [
        "Children",
        "Young adults",
        "Elderly, particularly frail individuals",
        "Athletes"
      ],
      correct: "C"
    },
    {
      id: 26765,
      question: "What is dysphagia?",
      options: [
        "Difficulty breathing",
        "Difficulty swallowing",
        "Difficulty speaking",
        "Difficulty walking"
      ],
      correct: "B"
    },
    {
      id: 26766,
      question: "When is VAP diagnosed?",
      options: [
        "Immediately upon admission",
        "Within 24 hours of intubation",
        "After 48 hours of mechanical ventilation",
        "After 7 days of hospitalization"
      ],
      correct: "C"
    },
    {
      id: 26767,
      question: "What are risk factors for VAP?",
      options: [
        "Short hospital stay only",
        "Young age only",
        "Long ventilation, advanced age, depressed consciousness",
        "Adequate nutrition only"
      ],
      correct: "C"
    },
    {
      id: 26768,
      question: "What is thought to develop on the endotracheal tube?",
      options: [
        "Scar tissue",
        "Blood clots",
        "Biofilm",
        "Calculus deposits"
      ],
      correct: "C"
    },
    {
      id: 26769,
      question: "What makes oral hygiene challenging for intubated patients?",
      options: [
        "Patient cooperation",
        "Presence of endotracheal tube, gastric tubes, bite blocks",
        "Time constraints",
        "Cost factors"
      ],
      correct: "B"
    },
    {
      id: 26770,
      question: "What have oral swabs been shown to be compared to toothbrushing?",
      options: [
        "More effective",
        "Equally effective",
        "Less effective in removing oral pathogens",
        "Preferred method"
      ],
      correct: "C"
    },
    {
      id: 26771,
      question: "What can serve as reservoirs for respiratory infection?",
      options: [
        "The stomach",
        "The esophagus",
        "The teeth and periodontium",
        "The nasal passages"
      ],
      correct: "C"
    },
    {
      id: 26772,
      question: "How often should dentures be removed and cleaned for pneumonia prevention?",
      options: [
        "Weekly",
        "Monthly",
        "Daily",
        "Every other day"
      ],
      correct: "C"
    },
    {
      id: 26773,
      question: "How often should teeth be brushed for ventilated patients?",
      options: [
        "Once a day",
        "Twice a day",
        "Three times a day",
        "After every meal"
      ],
      correct: "B"
    },
    {
      id: 26774,
      question: "How often should foam swabs with chlorhexidine be used for ventilated patients?",
      options: [
        "Once a day",
        "Every 8 hours",
        "Every 2 to 4 hours",
        "Weekly"
      ],
      correct: "C"
    },
    {
      id: 26775,
      question: "At what angle should the ventilated patient\'s head be elevated?",
      options: [
        "10° to 20°",
        "20° to 30°",
        "30° to 45°",
        "45° to 60°"
      ],
      correct: "C"
    },
    {
      id: 26776,
      question: "What is PACS sometimes referred to as?",
      options: [
        "Post-COVID disorder",
        "Long COVID",
        "Extended COVID",
        "Chronic COVID"
      ],
      correct: "B"
    },
    {
      id: 26777,
      question: "What are common PACS symptoms?",
      options: [
        "Rash and fever",
        "Nausea and vomiting",
        "Fatigue, brain fog, headache, dyspnea",
        "Weight gain and edema"
      ],
      correct: "C"
    },
    {
      id: 26778,
      question: "What refers to a range of breathing abnormalities from snoring to sleep apnea?",
      options: [
        "Respiratory distress syndrome",
        "Pulmonary disorders",
        "Sleep-related breathing disorders",
        "Nocturnal respiratory failure"
      ],
      correct: "C"
    },
    {
      id: 26779,
      question: "What does OSA involve?",
      options: [
        "Complete lung collapse",
        "Partial or complete upper airway collapse during sleep",
        "Chronic cough",
        "Permanent airway damage"
      ],
      correct: "B"
    },
    {
      id: 26780,
      question: "What characterizes OSA?",
      options: [
        "Silent sleep",
        "Shallow breathing only",
        "Loud snoring and breathing cessation periods",
        "Rapid breathing"
      ],
      correct: "C"
    },
    {
      id: 26781,
      question: "What is apnea during sleep most often caused by?",
      options: [
        "Genetic factors",
        "Medications",
        "Excess weight and obesity",
        "Environmental allergies"
      ],
      correct: "C"
    },
    {
      id: 26782,
      question: "What is the major causative factor of OSA in children?",
      options: [
        "Obesity",
        "Enlarged tonsils",
        "Allergies",
        "Asthma"
      ],
      correct: "B"
    },
    {
      id: 26783,
      question: "What device is commonly used to treat OSA?",
      options: [
        "Oxygen tank",
        "Nebulizer",
        "CPAP or BiPAP device",
        "Inhaler"
      ],
      correct: "C"
    },
    {
      id: 26784,
      question: "What does CPAP stand for?",
      options: [
        "Chronic positive airway pressure",
        "Continuous positive airway pressure",
        "Complete positive airway pressure",
        "Controlled positive airway pressure"
      ],
      correct: "B"
    },
    {
      id: 26785,
      question: "What does the CPAP device consist of?",
      options: [
        "Oxygen cylinder only",
        "Nasal cannula",
        "Mask covering nose and mouth connected to ventilating machine",
        "Oral appliance"
      ],
      correct: "C"
    },
    {
      id: 26786,
      question: "What oral manifestation is associated with OSA?",
      options: [
        "Decreased tooth decay",
        "Enlarged tongue with scalloped borders",
        "Smaller oral cavity",
        "Enhanced salivation"
      ],
      correct: "B"
    },
    {
      id: 26787,
      question: "What may result from bruxism in OSA patients?",
      options: [
        "Whiter teeth",
        "Stronger enamel",
        "Attrition, exposed dentin, abfraction, tooth fracture",
        "Improved bite"
      ],
      correct: "C"
    },
    {
      id: 26788,
      question: "Why does acid erosion occur in OSA patients?",
      options: [
        "Poor diet",
        "Inadequate brushing",
        "Acid reflux when attempting to breathe during OSA events",
        "Excessive fluoride"
      ],
      correct: "C"
    },
    {
      id: 26789,
      question: "What extraoral feature is associated with OSA?",
      options: [
        "Prognathic mandible",
        "Retrognathic mandible",
        "Normal jaw position",
        "Enlarged maxilla"
      ],
      correct: "B"
    },
    {
      id: 26790,
      question: "What malocclusion often accompanies retrognathic mandible in OSA?",
      options: [
        "Class I",
        "Class II",
        "Class III",
        "No malocclusion"
      ],
      correct: "B"
    },
    {
      id: 26791,
      question: "What gingival tissues may indicate mouth breathing in OSA?",
      options: [
        "Pale and firm",
        "Normal pink",
        "Red and edematous, particularly in anterior teeth",
        "White and keratinized"
      ],
      correct: "C"
    }
  ],
  "8. Substance Use Disorders": [
    {
      id: 26800,
      question: "What is substance misuse?",
      options: [
        "Pattern of self-administered drugs leading to addiction",
        "Prescription medication use",
        "Occasional alcohol consumption",
        "Medical marijuana use"
      ],
      correct: "A"
    },
    {
      id: 26801,
      question: "What is substance use disorder (SUD)?",
      options: [
        "Single use of illicit drugs",
        "Repeated misuse of drugs or alcohol",
        "Prescription medication use",
        "Social drinking behavior"
      ],
      correct: "B"
    },
    {
      id: 26802,
      question: "How many people aged 18 or older had an SUD in 2020?",
      options: [
        "Approximately 30.3 million",
        "Approximately 35.3 million",
        "Approximately 40.3 million",
        "Approximately 45.3 million"
      ],
      correct: "C"
    },
    {
      id: 26803,
      question: "What percentage of individuals with SUD also experience mental illness?",
      options: [
        "About 25%",
        "About 50%",
        "About 75%",
        "About 90%"
      ],
      correct: "B"
    },
    {
      id: 26804,
      question: "What is a co-occurring disorder?",
      options: [
        "Two mental illnesses present",
        "Coexistence of SUD and mental health disorder",
        "Multiple substance addictions",
        "Dual diagnosis of physical diseases"
      ],
      correct: "B"
    },
    {
      id: 26805,
      question: "What does AMI stand for?",
      options: [
        "Acute mental illness",
        "Any mental illness",
        "Advanced mental illness",
        "Acquired mental illness"
      ],
      correct: "B"
    },
    {
      id: 26806,
      question: "What is serious mental illness (SMI)?",
      options: [
        "Mental disorder in children",
        "Temporary behavioral disorder",
        "Mental disorder causing serious functional impairment",
        "Mild depression or anxiety"
      ],
      correct: "C"
    },
    {
      id: 26807,
      question: "What percentage of the population over 18 has SMI?",
      options: [
        "2%",
        "5%",
        "10%",
        "15%"
      ],
      correct: "B"
    },
    {
      id: 26808,
      question: "What does SMI include?",
      options: [
        "All anxiety disorders",
        "Schizophrenia, severe major depression, severe bipolar",
        "Mild depression only",
        "ADHD only"
      ],
      correct: "B"
    },
    {
      id: 26809,
      question: "In 2020, how many drivers involved in serious crashes tested positive for drugs?",
      options: [
        "About one-third",
        "About half",
        "Almost two-thirds",
        "Almost all"
      ],
      correct: "C"
    },
    {
      id: 26810,
      question: "In 2020, how many people aged 16+ drove under influence of alcohol?",
      options: [
        "10.5 million",
        "15.5 million",
        "20.5 million",
        "25.5 million"
      ],
      correct: "C"
    },
    {
      id: 26811,
      question: "What percentage of drug-related ED visits involved alcohol in 2021?",
      options: [
        "29.33%",
        "34.33%",
        "39.33%",
        "44.33%"
      ],
      correct: "C"
    },
    {
      id: 26812,
      question: "What is addiction?",
      options: [
        "Single episode of drug use",
        "Prolonged repeated misuse causing physical/emotional harm",
        "Occasional substance use",
        "Medical treatment with opioids"
      ],
      correct: "B"
    },
    {
      id: 26813,
      question: "What can prolonged substance misuse produce in the brain?",
      options: [
        "Temporary changes only",
        "No significant changes",
        "Changes leading to SUD",
        "Enhanced cognitive function"
      ],
      correct: "C"
    },
    {
      id: 26814,
      question: "What places IV drug users at higher risk?",
      options: [
        "Dental caries",
        "Respiratory infections",
        "HIV infection and hepatitis B, C, D",
        "Skin conditions only"
      ],
      correct: "C"
    },
    {
      id: 26815,
      question: "What may long-term alcohol use result in?",
      options: [
        "Enhanced liver function",
        "Liver, heart, kidney, pancreas damage",
        "Improved cardiovascular health",
        "Better cognitive function"
      ],
      correct: "B"
    },
    {
      id: 26816,
      question: "What is FASD?",
      options: [
        "Fetal alcohol spectrum disorders",
        "Fatal alcohol syndrome disorder",
        "Functional alcohol screening device",
        "Family alcohol support department"
      ],
      correct: "A"
    },
    {
      id: 26817,
      question: "What is psychological dependence?",
      options: [
        "Physical withdrawal symptoms",
        "Cognitive and emotional aspects of addiction",
        "Medical complications only",
        "Genetic predisposition"
      ],
      correct: "B"
    },
    {
      id: 26818,
      question: "What is physiological dependence?",
      options: [
        "Emotional need for substance",
        "Biologic alteration in user\'s brain",
        "Social pressure to use",
        "Environmental factors"
      ],
      correct: "B"
    },
    {
      id: 26819,
      question: "What are symptoms of drug withdrawal?",
      options: [
        "Increased energy and focus",
        "Improved mood and sleep",
        "Vomiting, diarrhea, rapid pulse, anxiety, convulsions",
        "Enhanced appetite and weight gain"
      ],
      correct: "C"
    },
    {
      id: 26820,
      question: "What is drug tolerance?",
      options: [
        "Accepting others\' drug use",
        "Decreasing doses needed over time",
        "Increasingly larger dose needed for same effect",
        "No change in dosage requirements"
      ],
      correct: "C"
    },
    {
      id: 26821,
      question: "What is relapse?",
      options: [
        "Complete recovery from addiction",
        "Return to heavy substance use",
        "Reduction in substance use",
        "Initial drug experimentation"
      ],
      correct: "B"
    },
    {
      id: 26822,
      question: "What is alcohol use disorder (AUD)?",
      options: [
        "Social drinking behavior",
        "Occasional alcohol consumption",
        "Impaired ability to stop alcohol use despite consequences",
        "Medical use of alcohol"
      ],
      correct: "C"
    },
    {
      id: 26823,
      question: "How many Americans had AUD according to recent data?",
      options: [
        "Approximately 19.9 million",
        "Approximately 24.9 million",
        "Approximately 29.9 million",
        "Approximately 34.9 million"
      ],
      correct: "C"
    },
    {
      id: 26824,
      question: "How many people in the US die annually from alcohol-related causes?",
      options: [
        "Almost 50,000",
        "Almost 75,000",
        "Almost 100,000",
        "Almost 125,000"
      ],
      correct: "C"
    },
    {
      id: 26825,
      question: "What cancers are associated with alcohol consumption?",
      options: [
        "Lung cancer only",
        "Skin cancer only",
        "Oral cavity, pharynx, larynx, esophagus, colon, liver, breast",
        "Bone cancer only"
      ],
      correct: "C"
    },
    {
      id: 26826,
      question: "How many times greater is risk of head/neck cancers in heavy drinkers?",
      options: [
        "Two times",
        "Three times",
        "Five times",
        "Ten times"
      ],
      correct: "C"
    },
    {
      id: 26827,
      question: "What are illicit drugs?",
      options: [
        "Prescription medications",
        "Over-the-counter drugs",
        "Drugs illegal to manufacture, use, or sell",
        "Herbal supplements"
      ],
      correct: "C"
    },
    {
      id: 26828,
      question: "What are commonly misused OTC drugs?",
      options: [
        "Aspirin and ibuprofen",
        "Dextromethorphan and pseudoephedrine",
        "Antacids and laxatives",
        "Vitamins and minerals"
      ],
      correct: "B"
    },
    {
      id: 26829,
      question: "What does CSA stand for?",
      options: [
        "Controlled Substances Act",
        "Central Substance Agency",
        "Clinical Screening Assessment",
        "Chronic Substance Addiction"
      ],
      correct: "A"
    },
    {
      id: 26830,
      question: "How many drug schedules exist under the CSA?",
      options: [
        "Three categories",
        "Four categories",
        "Five categories",
        "Six categories"
      ],
      correct: "C"
    },
    {
      id: 26831,
      question: "What are Schedule I drugs?",
      options: [
        "Low abuse potential",
        "High abuse potential",
        "No abuse potential",
        "Moderate abuse potential"
      ],
      correct: "B"
    },
    {
      id: 26832,
      question: "What is an example of a Schedule I drug?",
      options: [
        "Aspirin",
        "Codeine",
        "Heroin",
        "Tramadol"
      ],
      correct: "C"
    },
    {
      id: 26833,
      question: "What are club drugs?",
      options: [
        "Prescription medications",
        "Psychoactive drugs used at nightclubs/raves",
        "Legal supplements",
        "Medical treatments"
      ],
      correct: "B"
    },
    {
      id: 26834,
      question: "What are considered predatory or date rape drugs?",
      options: [
        "Marijuana and cocaine",
        "Alcohol and nicotine",
        "Rohypnol, GHB, and ketamine",
        "Caffeine and sugar"
      ],
      correct: "C"
    },
    {
      id: 26835,
      question: "After tobacco and alcohol, what is the most commonly used addictive drug?",
      options: [
        "Cocaine",
        "Heroin",
        "Marijuana",
        "Methamphetamine"
      ],
      correct: "C"
    },
    {
      id: 26836,
      question: "How many people used marijuana at least once in past year?",
      options: [
        "Over 28 million",
        "Over 38 million",
        "Over 48 million",
        "Over 58 million"
      ],
      correct: "C"
    },
    {
      id: 26837,
      question: "What percentage of marijuana users develop marijuana use disorder?",
      options: [
        "1 in 10",
        "2 in 10",
        "3 in 10",
        "5 in 10"
      ],
      correct: "C"
    },
    {
      id: 26838,
      question: "Who is especially susceptible to adverse effects of marijuana?",
      options: [
        "Adults over 50",
        "Infants, children, teens with developing brains",
        "Elderly population",
        "Middle-aged adults"
      ],
      correct: "B"
    },
    {
      id: 26839,
      question: "What is synthetic marijuana also known as?",
      options: [
        "Hash and grass",
        "Spice or K2",
        "Weed and pot",
        "Mary Jane and chronic"
      ],
      correct: "B"
    },
    {
      id: 26840,
      question: "What are opioid analgesic pain relievers now?",
      options: [
        "Rarely prescribed medications",
        "Moderately prescribed medications",
        "Most prescribed class of medications",
        "Banned medications"
      ],
      correct: "C"
    },
    {
      id: 26841,
      question: "How many opioid prescriptions were written in 2020?",
      options: [
        "Almost 92 million",
        "Almost 117 million",
        "Almost 142 million",
        "Almost 167 million"
      ],
      correct: "C"
    },
    {
      id: 26842,
      question: "What illicit synthetic opioid is often combined with heroin?",
      options: [
        "Codeine",
        "Fentanyl",
        "Tramadol",
        "Hydrocodone"
      ],
      correct: "B"
    },
    {
      id: 26843,
      question: "How quickly does a drug reach the CNS after entering the body?",
      options: [
        "Within 5 to 10 seconds",
        "Within 10 to 15 seconds",
        "Within 20 to 30 seconds",
        "Within 30 to 60 seconds"
      ],
      correct: "B"
    },
    {
      id: 26844,
      question: "What are neurotransmitters?",
      options: [
        "Hormones in bloodstream",
        "Chemicals allowing neurons to communicate",
        "Blood cells",
        "Enzymes in brain"
      ],
      correct: "B"
    },
    {
      id: 26845,
      question: "What does CNS depressant increase activity of?",
      options: [
        "Dopamine",
        "Serotonin",
        "GABA",
        "Epinephrine"
      ],
      correct: "C"
    },
    {
      id: 26846,
      question: "Where does heroin attach in the brain?",
      options: [
        "Visual cortex",
        "Motor cortex",
        "Emotional center",
        "Language center"
      ],
      correct: "C"
    },
    {
      id: 26847,
      question: "What do CNS stimulants force release of?",
      options: [
        "Only serotonin",
        "Only dopamine",
        "Epinephrine and dopamine",
        "GABA and melatonin"
      ],
      correct: "C"
    },
    {
      id: 26848,
      question: "What are endorphins released by?",
      options: [
        "Liver and kidneys",
        "Hypothalamus and pituitary glands",
        "Heart and lungs",
        "Stomach and intestines"
      ],
      correct: "B"
    },
    {
      id: 26849,
      question: "What does \"endorphins\" mean?",
      options: [
        "External morphine",
        "Endogenous morphine",
        "Enhanced morphine",
        "Engineered morphine"
      ],
      correct: "B"
    },
    {
      id: 26850,
      question: "What genes may contribute to addiction?",
      options: [
        "Genes affecting height",
        "Genes interfering with serotonin metabolism",
        "Genes determining eye color",
        "Genes controlling blood type"
      ],
      correct: "B"
    },
    {
      id: 26851,
      question: "What is the greatest environmental influence on SUDs?",
      options: [
        "School performance",
        "Peer pressure only",
        "Family dynamics",
        "Media exposure only"
      ],
      correct: "C"
    },
    {
      id: 26852,
      question: "How did COVID-19 impact adults with SUDs?",
      options: [
        "Decreased substance use",
        "No change in use",
        "Exacerbated use of alcohol/drugs",
        "Complete cessation"
      ],
      correct: "C"
    },
    {
      id: 26853,
      question: "What percentage of adults reported anxiety/depression during pandemic?",
      options: [
        "About 1 in 10",
        "About 2 in 10",
        "About 3 in 10",
        "About 4 in 10"
      ],
      correct: "D"
    },
    {
      id: 26854,
      question: "When is treatment most effective for substance abuse?",
      options: [
        "Only when voluntary",
        "When motivated or court-appointed",
        "Never effective",
        "Only with family pressure"
      ],
      correct: "B"
    },
    {
      id: 26855,
      question: "How long should patients remain in treatment for significant improvement?",
      options: [
        "End of 1 month",
        "End of 2 months",
        "End of 3 months",
        "End of 6 months"
      ],
      correct: "C"
    },
    {
      id: 26856,
      question: "What are three objectives of pharmacological treatment?",
      options: [
        "Cure addiction, prevent use, eliminate cravings",
        "Management of withdrawal, attenuate cravings, prevent relapse",
        "Reduce tolerance, increase use, manage symptoms",
        "Enhance effects, prolong use, maintain dependency"
      ],
      correct: "B"
    },
    {
      id: 26857,
      question: "What does acamprosate do for alcohol treatment?",
      options: [
        "Blocks metabolism of alcohol",
        "Eliminates all alcohol effects",
        "Decreases cravings and urges",
        "Increases alcohol tolerance"
      ],
      correct: "C"
    },
    {
      id: 26858,
      question: "What does disulfiram (Antabuse) do?",
      options: [
        "Increases alcohol tolerance",
        "Blocks alcohol metabolism",
        "Enhances alcohol effects",
        "Reduces withdrawal symptoms"
      ],
      correct: "B"
    },
    {
      id: 26859,
      question: "What does naltrexone do for alcohol?",
      options: [
        "Increases cravings",
        "Blocks euphoric effects",
        "Decreases or eliminates cravings",
        "Enhances intoxication"
      ],
      correct: "C"
    },
    {
      id: 26860,
      question: "What does buprenorphine do?",
      options: [
        "Increases opioid effects",
        "Suppresses and reduces opioid cravings",
        "Enhances euphoria",
        "Blocks all medications"
      ],
      correct: "B"
    },
    {
      id: 26861,
      question: "What does methadone do?",
      options: [
        "Increases opioid cravings",
        "Enhances opioid effects",
        "Reduces cravings, withdrawal, blocks opioid effects",
        "Has no therapeutic effect"
      ],
      correct: "C"
    },
    {
      id: 26862,
      question: "What does naloxone do?",
      options: [
        "Enhances opioid effects",
        "Increases overdose risk",
        "Prevents opioid overdose, reverses toxic effects",
        "Prolongs intoxication"
      ],
      correct: "C"
    },
    {
      id: 26863,
      question: "What percentage of patients with SUD are identified by healthcare providers?",
      options: [
        "About 5%",
        "About 10%",
        "About 20%",
        "About 30%"
      ],
      correct: "B"
    },
    {
      id: 26864,
      question: "What should dental hygienists look for in health history?",
      options: [
        "Only current medications",
        "Substances used and routes of administration",
        "Only alcohol use",
        "Only prescription drugs"
      ],
      correct: "B"
    },
    {
      id: 26865,
      question: "How should observations of substance abuse be recorded?",
      options: [
        "With personal opinions",
        "With judgmental statements",
        "Using objective terminology",
        "With assumptions"
      ],
      correct: "C"
    },
    {
      id: 26866,
      question: "What question indicates possible abuse if answered \"yes\"?",
      options: [
        "Do you drink socially?",
        "Have you felt need to cut down?",
        "Do you exercise regularly?",
        "Do you eat healthy meals?"
      ],
      correct: "B"
    },
    {
      id: 26867,
      question: "What may long sleeves in hot weather indicate?",
      options: [
        "Fashion choice only",
        "Covering needle marks",
        "Medical condition",
        "Cultural preference"
      ],
      correct: "B"
    },
    {
      id: 26868,
      question: "What may needle marks in antecubital fossae indicate?",
      options: [
        "Medical testing only",
        "Vaccination sites",
        "Illicit drug use",
        "Blood donation"
      ],
      correct: "C"
    },
    {
      id: 26869,
      question: "What causes \"meth mouth\"?",
      options: [
        "Poor diet only",
        "Lack of fluoride",
        "Methadone abuse causing rampant caries",
        "Normal aging"
      ],
      correct: "C"
    },
    {
      id: 26870,
      question: "What oral manifestation is associated with cocaine use?",
      options: [
        "Enhanced enamel",
        "Increased saliva",
        "Severe bruxism",
        "Reduced caries"
      ],
      correct: "C"
    },
    {
      id: 26871,
      question: "What may xerostomia result from?",
      options: [
        "Adequate hydration",
        "Antidepressant medications",
        "Healthy lifestyle",
        "Proper nutrition"
      ],
      correct: "B"
    },
    {
      id: 26872,
      question: "What should be avoided when treating cocaine users?",
      options: [
        "All anesthetics",
        "Fluoride treatments",
        "Anesthetics with epinephrine",
        "Prophylaxis"
      ],
      correct: "C"
    },
    {
      id: 26873,
      question: "How long after cocaine use should treatment be deferred?",
      options: [
        "1 to 6 hours",
        "6 to 24 hours",
        "24 to 48 hours",
        "48 to 72 hours"
      ],
      correct: "B"
    },
    {
      id: 26874,
      question: "What is recommended for postoperative pain in SUD patients?",
      options: [
        "Opioids only",
        "No pain control",
        "NSAIDs like ibuprofen",
        "High-dose narcotics"
      ],
      correct: "C"
    },
    {
      id: 26875,
      question: "What combination is as effective as some opioids for pain?",
      options: [
        "Aspirin and caffeine",
        "Ibuprofen and acetaminophen",
        "Codeine and aspirin",
        "Hydrocodone and ibuprofen"
      ],
      correct: "B"
    },
    {
      id: 26876,
      question: "How long should appointments be for patients with SUDs?",
      options: [
        "60 minutes",
        "45 minutes",
        "20 minutes",
        "90 minutes"
      ],
      correct: "C"
    },
    {
      id: 26877,
      question: "What should be checked before aggressive periodontal therapy?",
      options: [
        "Insurance coverage",
        "No immunosuppression, kidney/liver damage",
        "Appointment availability",
        "Family support"
      ],
      correct: "B"
    },
    {
      id: 26878,
      question: "What recall interval is indicated after extensive periodontal therapy?",
      options: [
        "6 months",
        "4 months",
        "3 months",
        "12 months"
      ],
      correct: "C"
    },
    {
      id: 26879,
      question: "What should be recommended for alcoholics?",
      options: [
        "Alcohol-containing rinses",
        "No fluoride products",
        "Alcohol-free fluoride and antimicrobial rinses",
        "Sugar-containing products"
      ],
      correct: "C"
    },
    {
      id: 26880,
      question: "Why are dental professionals at risk for chemical dependence?",
      options: [
        "Low stress levels",
        "Poor education",
        "Easy access to abused drugs",
        "Genetic immunity"
      ],
      correct: "C"
    },
    {
      id: 26881,
      question: "What characterizes healthcare professional education?",
      options: [
        "Relaxed schedule",
        "Minimal competition",
        "Overworked, competitive, self-sacrificing",
        "Adequate sleep"
      ],
      correct: "C"
    },
    {
      id: 26882,
      question: "What happens when prescription pads should be kept?",
      options: [
        "On reception desk",
        "Out of sight and inaccessible",
        "In patient areas",
        "In waiting room"
      ],
      correct: "B"
    },
    {
      id: 26883,
      question: "What support is available for dental professionals with addiction?",
      options: [
        "No support available",
        "Only court intervention",
        "State dental association programs",
        "Public shaming"
      ],
      correct: "C"
    },
    {
      id: 26884,
      question: "What are Caduceus meetings modeled on?",
      options: [
        "Medical conferences",
        "Alcoholics Anonymous principles",
        "Business seminars",
        "Educational lectures"
      ],
      correct: "B"
    }
  ],
  "9. Eating Disorders": [
    {
      id: 26900,
      question: "What role does the dental hygienist serve for patients with eating disorders?",
      options: [
        "Medical therapist",
        "Patient advocate",
        "Nutritional counselor",
        "Primary psychiatrist"
      ],
      correct: "B"
    },
    {
      id: 26901,
      question: "What are eating disorders categorized as?",
      options: [
        "Physical health disorders",
        "Nutritional deficiencies",
        "Mental health disorders",
        "Behavioral preferences"
      ],
      correct: "C"
    },
    {
      id: 26902,
      question: "What two eating disorders are the focus of this chapter?",
      options: [
        "Binge eating and night eating",
        "Anorexia nervosa and bulimia nervosa",
        "Avoidant eating and restrictive eating",
        "Compulsive eating and food addiction"
      ],
      correct: "B"
    },
    {
      id: 26903,
      question: "What does anorexia literally mean?",
      options: [
        "Fear of food",
        "Excessive hunger",
        "Loss of appetite",
        "Food avoidance"
      ],
      correct: "C"
    },
    {
      id: 26904,
      question: "How does a patient with anorexia nervosa respond to hunger?",
      options: [
        "Expresses it openly",
        "Eats small portions",
        "Suppresses and denies sensation",
        "Seeks medical help"
      ],
      correct: "C"
    },
    {
      id: 26905,
      question: "How many diagnostic criteria exist for anorexia nervosa?",
      options: [
        "Two criteria",
        "Three criteria",
        "Four criteria",
        "Five criteria"
      ],
      correct: "B"
    },
    {
      id: 26906,
      question: "What are the two specified types of anorexia nervosa?",
      options: [
        "Mild and severe",
        "Acute and chronic",
        "Restricting type or binge eating and purging type",
        "Primary and secondary"
      ],
      correct: "C"
    },
    {
      id: 26907,
      question: "What involves restriction relative to nutritional needs in anorexia nervosa?",
      options: [
        "Occasional fasting",
        "Eating resulting in significantly low body weight",
        "Moderate calorie reduction",
        "Balanced diet reduction"
      ],
      correct: "B"
    },
    {
      id: 26908,
      question: "What characterizes the intense fear in anorexia nervosa?",
      options: [
        "Fear of illness",
        "Fear of being fat or gaining weight",
        "Fear of social judgment",
        "Fear of medical treatment"
      ],
      correct: "B"
    },
    {
      id: 26909,
      question: "What is lacking in anorexia nervosa regarding health challenges?",
      options: [
        "Medical insurance",
        "Family support",
        "Recognition of health challenges related to restrictions",
        "Access to healthcare"
      ],
      correct: "C"
    },
    {
      id: 26910,
      question: "What determines severity in anorexia nervosa diagnosis?",
      options: [
        "Age of patient",
        "Duration of illness",
        "Body mass index (BMI)",
        "Family history"
      ],
      correct: "C"
    },
    {
      id: 26911,
      question: "How do patients with restricting type achieve weight loss?",
      options: [
        "Medication only",
        "Surgery",
        "Dieting, fasting, or excessive exercise",
        "Balanced nutrition"
      ],
      correct: "C"
    },
    {
      id: 26912,
      question: "When is anorexia nervosa most commonly seen?",
      options: [
        "Early childhood",
        "Middle age",
        "Adolescence and young adulthood",
        "Late adulthood"
      ],
      correct: "C"
    },
    {
      id: 26913,
      question: "What is the crude mortality rate of anorexia nervosa per decade?",
      options: [
        "2%",
        "5%",
        "10%",
        "15%"
      ],
      correct: "B"
    },
    {
      id: 26914,
      question: "Which gender has higher prevalence of anorexia nervosa?",
      options: [
        "Males",
        "Females",
        "Equal distribution",
        "Varies by region"
      ],
      correct: "B"
    },
    {
      id: 26915,
      question: "What does bulimia literally mean?",
      options: [
        "Food refusal",
        "Ox hunger",
        "No appetite",
        "Food aversion"
      ],
      correct: "B"
    },
    {
      id: 26916,
      question: "How many diagnostic criteria exist for bulimia nervosa?",
      options: [
        "Three criteria",
        "Four criteria",
        "Five criteria",
        "Six criteria"
      ],
      correct: "C"
    },
    {
      id: 26917,
      question: "What characterizes bulimia nervosa?",
      options: [
        "Complete food avoidance",
        "Repeated binge eating",
        "Constant hunger",
        "Moderate eating"
      ],
      correct: "B"
    },
    {
      id: 26918,
      question: "What are the two specific types of bulimia nervosa?",
      options: [
        "Mild and severe",
        "Bingeing/purging type and restricting type",
        "Acute and chronic",
        "Primary and secondary"
      ],
      correct: "B"
    },
    {
      id: 26919,
      question: "How often must bingeing and purging occur for bulimia nervosa diagnosis?",
      options: [
        "Daily for 1 month",
        "Twice weekly for 2 months",
        "Once a week for minimum of 3 months",
        "Several times monthly for 6 months"
      ],
      correct: "C"
    },
    {
      id: 26920,
      question: "Which eating disorder is more common?",
      options: [
        "Anorexia nervosa",
        "Bulimia nervosa",
        "Binge eating disorder",
        "Night eating syndrome"
      ],
      correct: "B"
    },
    {
      id: 26921,
      question: "When does bulimia nervosa onset generally occur?",
      options: [
        "Early childhood",
        "Middle age",
        "Late teenage years and young adulthood",
        "Senior years"
      ],
      correct: "C"
    },
    {
      id: 26922,
      question: "What is the crude mortality rate of bulimia nervosa per decade?",
      options: [
        "1%",
        "2%",
        "5%",
        "10%"
      ],
      correct: "B"
    },
    {
      id: 26923,
      question: "What can bulimia nervosa be characterized by in its course?",
      options: [
        "Always chronic",
        "Always cured quickly",
        "Chronic or intermittent with periods of remission",
        "Never remits"
      ],
      correct: "C"
    },
    {
      id: 26924,
      question: "What body weight can persons with bulimia nervosa maintain?",
      options: [
        "Always underweight",
        "Normal range for body type",
        "Always overweight",
        "Constantly fluctuating"
      ],
      correct: "B"
    },
    {
      id: 26925,
      question: "What gastrointestinal problem is associated with bulimia nervosa?",
      options: [
        "Appendicitis",
        "Gastroesophageal reflux disease",
        "Diverticulitis",
        "Hernia"
      ],
      correct: "B"
    },
    {
      id: 26926,
      question: "What rare but life-threatening complications can occur in bulimia nervosa?",
      options: [
        "Heart attack only",
        "Stroke only",
        "Esophageal tears or gastric ruptures",
        "Kidney failure only"
      ],
      correct: "C"
    },
    {
      id: 26927,
      question: "What may prompt a person with bulimia nervosa to seek professional help?",
      options: [
        "Weight gain",
        "Family pressure only",
        "Tooth sensitivity from perimylolysis",
        "Social embarrassment only"
      ],
      correct: "C"
    },
    {
      id: 26928,
      question: "What controls food in anorexia nervosa according to patients?",
      options: [
        "Brings chaos",
        "Brings feelings of competence and control",
        "Reduces anxiety",
        "Improves relationships"
      ],
      correct: "B"
    },
    {
      id: 26929,
      question: "What reinforces behavior in bulimia nervosa?",
      options: [
        "Family approval",
        "Social acceptance",
        "Achievement and maintenance of lower weight",
        "Medical recommendations"
      ],
      correct: "C"
    },
    {
      id: 26930,
      question: "What underlying feelings exist in bulimia nervosa beneath the facade?",
      options: [
        "Confidence and peace",
        "Anxiety, guilt, and dysphoria",
        "Happiness and contentment",
        "Indifference and calm"
      ],
      correct: "B"
    },
    {
      id: 26931,
      question: "What hormonal effect occurs in anorexia nervosa among females?",
      options: [
        "Increased estrogen",
        "Prolonged decrease in estrogen",
        "Increased progesterone",
        "Normal hormone levels"
      ],
      correct: "B"
    },
    {
      id: 26932,
      question: "What may decreased estrogen contribute to in anorexia nervosa?",
      options: [
        "Increased energy",
        "Better bone health",
        "Amenorrhea and decreased bone density",
        "Improved metabolism"
      ],
      correct: "C"
    },
    {
      id: 26933,
      question: "What cardiovascular effects occur in anorexia nervosa?",
      options: [
        "Increased heart rate and blood pressure",
        "Low pulse rates, decreased blood pressure",
        "Normal vital signs",
        "Irregular but elevated pulse"
      ],
      correct: "B"
    },
    {
      id: 26934,
      question: "What dangerous complications result from binge-purge cycle?",
      options: [
        "Weight gain",
        "Increased energy",
        "Dehydration and electrolyte imbalance",
        "Improved digestion"
      ],
      correct: "C"
    },
    {
      id: 26935,
      question: "What does ipecac syrup contain that is dangerous?",
      options: [
        "Sodium",
        "Potassium",
        "Emetine",
        "Calcium"
      ],
      correct: "C"
    },
    {
      id: 26936,
      question: "What can chronic ipecac ingestion lead to?",
      options: [
        "Improved health",
        "Weight stabilization",
        "Fatal myocardial dysfunction",
        "Better digestion"
      ],
      correct: "C"
    },
    {
      id: 26937,
      question: "What is lanugo?",
      options: [
        "Weight loss",
        "Muscle wasting",
        "Fine, downy hair on face and upper body",
        "Skin rash"
      ],
      correct: "C"
    },
    {
      id: 26938,
      question: "Where is lanugo usually found?",
      options: [
        "Scalp only",
        "Arms only",
        "Lower half of face and upper body",
        "Legs only"
      ],
      correct: "C"
    },
    {
      id: 26939,
      question: "What may patients with anorexia nervosa report about hair?",
      options: [
        "Increased growth",
        "Improved texture",
        "Hair falling out",
        "Thicker hair"
      ],
      correct: "C"
    },
    {
      id: 26940,
      question: "What clothing behavior may indicate hypothermia sensitivity?",
      options: [
        "Wearing minimal clothing",
        "Normal seasonal clothing",
        "Wearing inappropriately warm clothing",
        "Refusing to wear jackets"
      ],
      correct: "C"
    },
    {
      id: 26941,
      question: "What may calloused knuckles indicate?",
      options: [
        "Manual labor",
        "Sports injury",
        "Fingers used to induce vomiting",
        "Arthritis"
      ],
      correct: "C"
    },
    {
      id: 26942,
      question: "What can cause calloused knuckles in purging?",
      options: [
        "Washing hands frequently",
        "Repetitive friction from teeth during digital stimulation",
        "Cold weather exposure",
        "Writing excessively"
      ],
      correct: "B"
    },
    {
      id: 26943,
      question: "What objects besides fingers may be used to induce vomiting?",
      options: [
        "Towels",
        "Cotton swabs",
        "Spoons",
        "Brushes"
      ],
      correct: "C"
    },
    {
      id: 26944,
      question: "What extraoral finding is observed with eating disorders?",
      options: [
        "Facial swelling",
        "Parotid enlargement",
        "Jaw dislocation",
        "Facial paralysis"
      ],
      correct: "B"
    },
    {
      id: 26945,
      question: "What is the nature of parotid enlargement in eating disorders?",
      options: [
        "Inflammatory",
        "Infectious",
        "Noninflammatory",
        "Cancerous"
      ],
      correct: "C"
    },
    {
      id: 26946,
      question: "When does parotid enlargement subside?",
      options: [
        "With medication",
        "With surgery",
        "With abstinence from self-induced vomiting",
        "Never subsides"
      ],
      correct: "C"
    },
    {
      id: 26947,
      question: "What has been reported by patients regarding taste?",
      options: [
        "Enhanced taste",
        "Diminished taste acuity",
        "No change",
        "Sweet preference only"
      ],
      correct: "B"
    },
    {
      id: 26948,
      question: "What causes diminished taste acuity?",
      options: [
        "Age only",
        "Genetics only",
        "Malnutrition or hormonal abnormalities",
        "Environmental factors only"
      ],
      correct: "C"
    },
    {
      id: 26949,
      question: "What oral condition may occur if patient is dehydrated?",
      options: [
        "Increased saliva",
        "Xerostomia (dry mouth)",
        "Tongue swelling",
        "Increased taste"
      ],
      correct: "B"
    },
    {
      id: 26950,
      question: "What causes xerostomia in eating disorder patients?",
      options: [
        "Adequate hydration",
        "Normal salivary flow",
        "Vomiting, diuretic/laxative abuse, antidepressants",
        "Healthy eating habits"
      ],
      correct: "C"
    },
    {
      id: 26951,
      question: "What commissure lesions may resemble?",
      options: [
        "Cold sores",
        "Canker sores",
        "Angular cheilitis",
        "Oral cancer"
      ],
      correct: "C"
    },
    {
      id: 26952,
      question: "What hormone produced in stomach signals hunger?",
      options: [
        "Insulin",
        "Leptin",
        "Ghrelin",
        "Cortisol"
      ],
      correct: "C"
    },
    {
      id: 26953,
      question: "Where is ghrelin found besides the stomach?",
      options: [
        "Blood only",
        "Liver",
        "Saliva",
        "Brain tissue"
      ],
      correct: "C"
    },
    {
      id: 26954,
      question: "What is the most common dental finding in oral purging?",
      options: [
        "Tooth decay",
        "Gum disease",
        "Perimylolysis or enamel erosion",
        "Tooth discoloration"
      ],
      correct: "C"
    },
    {
      id: 26955,
      question: "What initially causes enamel erosion in purging?",
      options: [
        "Poor brushing",
        "Gastric acids",
        "Bacteria",
        "Sugar consumption"
      ],
      correct: "B"
    },
    {
      id: 26956,
      question: "Which teeth are initially involved in perimylolysis?",
      options: [
        "Mandibular anterior teeth",
        "Maxillary anterior teeth",
        "Mandibular molars",
        "Maxillary molars"
      ],
      correct: "B"
    },
    {
      id: 26957,
      question: "What appearance may be present on cusps of posterior teeth?",
      options: [
        "Sharp points",
        "Flattened surfaces",
        "Cupping appearance",
        "No changes"
      ],
      correct: "C"
    },
    {
      id: 26958,
      question: "What weakens tooth structure from lingual and incisal enamel loss?",
      options: [
        "Mandibular molars",
        "Maxillary molars",
        "Anterior teeth",
        "All teeth equally"
      ],
      correct: "C"
    },
    {
      id: 26959,
      question: "What may form from vertical height loss of anterior teeth?",
      options: [
        "Crossbite",
        "Overbite",
        "Open bite",
        "Underbite"
      ],
      correct: "C"
    },
    {
      id: 26960,
      question: "What appearance do teeth exhibit with extensive enamel loss?",
      options: [
        "Opaque appearance",
        "Yellowish appearance",
        "Translucent appearance",
        "White appearance"
      ],
      correct: "C"
    },
    {
      id: 26961,
      question: "What appearance do amalgam restorations have with enamel loss around them?",
      options: [
        "Sunken appearance",
        "Flat appearance",
        "Raised-island appearance",
        "Normal appearance"
      ],
      correct: "C"
    },
    {
      id: 26962,
      question: "What may perimylolysis eventually result in?",
      options: [
        "Stronger teeth",
        "Whiter teeth",
        "Dentinal exposure and sensitivity",
        "Improved enamel"
      ],
      correct: "C"
    },
    {
      id: 26963,
      question: "What is often the chief reason patients seek dental care?",
      options: [
        "Routine cleaning",
        "Cosmetic whitening",
        "Tooth sensitivity",
        "Orthodontic treatment"
      ],
      correct: "C"
    },
    {
      id: 26964,
      question: "What may predispose patients to increased caries rate?",
      options: [
        "Excessive fluoride",
        "Decreased salivary flow and dietary patterns",
        "Too much brushing",
        "Genetic immunity"
      ],
      correct: "B"
    },
    {
      id: 26965,
      question: "What factors contribute to periodontal disease risk?",
      options: [
        "Excessive oral hygiene",
        "Too much fluoride",
        "Malnutrition and medications causing xerostomia",
        "Genetic protection"
      ],
      correct: "C"
    },
    {
      id: 26966,
      question: "What may depression combined with eating disorder result in?",
      options: [
        "Enhanced oral hygiene",
        "Improved self-care",
        "Apathy toward oral hygiene habits",
        "Increased dental visits"
      ],
      correct: "C"
    },
    {
      id: 26967,
      question: "What intraoral trauma may be evident?",
      options: [
        "Tongue piercing",
        "Orthodontic injuries",
        "Ulcerations or hematomas on palates",
        "Normal tissues"
      ],
      correct: "C"
    },
    {
      id: 26968,
      question: "At what prevention level does dental hygienist involvement typically occur?",
      options: [
        "Primary prevention only",
        "No prevention",
        "Secondary and tertiary prevention",
        "Quaternary prevention"
      ],
      correct: "C"
    },
    {
      id: 26969,
      question: "What framework was developed for clinician communication about eating disorders?",
      options: [
        "Assess, Treat, Evaluate",
        "Evaluate, Assess, Treat",
        "Treat, Assess, Evaluate",
        "Diagnose, Treat, Follow-up"
      ],
      correct: "B"
    },
    {
      id: 26970,
      question: "What is the Evaluate, Assess, Treat framework based on?",
      options: [
        "Cognitive therapy",
        "Behavioral modification",
        "Motivational interviewing",
        "Psychoanalysis"
      ],
      correct: "C"
    },
    {
      id: 26971,
      question: "What validated questionnaire can be used for screening eating disorders?",
      options: [
        "CAGE questionnaire",
        "PHQ-9 questionnaire",
        "SCOFF questionnaire",
        "GAD-7 questionnaire"
      ],
      correct: "C"
    },
    {
      id: 26972,
      question: "How many points on SCOFF indicate likely anorexia nervosa?",
      options: [
        "1 point",
        "2 points",
        "3 points",
        "4 points"
      ],
      correct: "B"
    },
    {
      id: 26973,
      question: "What should dental hygienists use for baseline comparison?",
      options: [
        "Patient statements only",
        "Family reports only",
        "Photographs, erosion indices, study models",
        "Memory only"
      ],
      correct: "C"
    },
    {
      id: 26974,
      question: "What are the three phases of dental hygiene care planning?",
      options: [
        "Assessment, treatment, evaluation",
        "Referral, team roles, oral health management",
        "Diagnosis, planning, implementation",
        "Screening, testing, treatment"
      ],
      correct: "B"
    },
    {
      id: 26975,
      question: "What is the primary role of oral healthcare team initially?",
      options: [
        "Provide all treatment",
        "Prescribe medications",
        "Refer patient to eating disorder specialists",
        "Monitor weight only"
      ],
      correct: "C"
    },
    {
      id: 26976,
      question: "What must be established for successful referral?",
      options: [
        "Financial incentives",
        "Family pressure",
        "Caring and nonjudgmental environment based on trust",
        "Strict rules"
      ],
      correct: "C"
    },
    {
      id: 26977,
      question: "What should dental hygiene goals be based on?",
      options: [
        "Dentist preferences only",
        "Insurance coverage",
        "Dental hygiene diagnoses",
        "Time constraints"
      ],
      correct: "C"
    },
    {
      id: 26978,
      question: "What characteristic should dental hygiene goals have?",
      options: [
        "Vague and flexible",
        "Specific and measurable outcomes",
        "General suggestions",
        "Unrealistic expectations"
      ],
      correct: "B"
    },
    {
      id: 26979,
      question: "What is recommended for patients with perimylolysis?",
      options: [
        "Aggressive brushing",
        "Acidic rinses",
        "Professional fluoride varnish and home fluoride",
        "No fluoride use"
      ],
      correct: "C"
    },
    {
      id: 26980,
      question: "How long should patients wait after purging before toothbrushing?",
      options: [
        "10 to 20 minutes",
        "20 to 30 minutes",
        "30 to 40 minutes",
        "60 minutes"
      ],
      correct: "C"
    },
    {
      id: 26981,
      question: "What type of prophylaxis should be avoided?",
      options: [
        "Gentle prophylaxis",
        "No prophylaxis at all",
        "Abrasive prophylaxis",
        "Ultrasonic prophylaxis"
      ],
      correct: "C"
    },
    {
      id: 26982,
      question: "What solution should patients rinse with after purging?",
      options: [
        "Acidic mouthwash",
        "Alcohol-based rinse",
        "pH-neutralizing solution",
        "Plain water only"
      ],
      correct: "C"
    },
    {
      id: 26983,
      question: "What example of neutralizing solution is given?",
      options: [
        "Hydrogen peroxide",
        "Lemon juice",
        "Sodium bicarbonate in water",
        "Vinegar solution"
      ],
      correct: "C"
    },
    {
      id: 26984,
      question: "What type of toothbrush should be used?",
      options: [
        "Hard bristles",
        "Medium bristles",
        "Soft bristles with gentle touch",
        "Electric only"
      ],
      correct: "C"
    },
    {
      id: 26985,
      question: "What fluoride product must have low pH level?",
      options: [
        "All fluoride products",
        "Only prescription fluoride",
        "Fluoride product for normal pH reestablishment",
        "No fluoride needed"
      ],
      correct: "C"
    },
    {
      id: 26986,
      question: "What may be used for home fluoride application?",
      options: [
        "Disposable trays",
        "No tray needed",
        "Fabricated mouthguard",
        "Paper trays"
      ],
      correct: "C"
    },
    {
      id: 26987,
      question: "What should be considered during periodontal debridement?",
      options: [
        "Maximum force",
        "Aggressive techniques",
        "Appropriate pain management techniques",
        "No anesthesia"
      ],
      correct: "C"
    },
    {
      id: 26988,
      question: "Why avoid polishing if no extrinsic stains present?",
      options: [
        "Time constraints",
        "Cost savings",
        "Dental hypersensitivity and damaged tooth structure",
        "Patient preference only"
      ],
      correct: "C"
    },
    {
      id: 26989,
      question: "What are the two parts of evaluation?",
      options: [
        "Objective and financial",
        "Objective and subjective",
        "Subjective and administrative",
        "Clinical and laboratory"
      ],
      correct: "B"
    },
    {
      id: 26990,
      question: "What does objective evaluation compare?",
      options: [
        "Patient opinions only",
        "Insurance coverage",
        "Baseline findings with subsequent appointments",
        "Family observations"
      ],
      correct: "C"
    },
    {
      id: 26991,
      question: "What does subjective evaluation provide?",
      options: [
        "Laboratory results",
        "Insurance information",
        "Patient\'s personal evaluation",
        "Family input only"
      ],
      correct: "C"
    },
    {
      id: 26992,
      question: "What is common during eating disorder recovery?",
      options: [
        "Immediate cure",
        "No setbacks",
        "Relapse during recovery phase",
        "Perfect compliance"
      ],
      correct: "C"
    },
    {
      id: 26993,
      question: "What psychotherapy may be used for eating disorders?",
      options: [
        "Electroconvulsive therapy only",
        "Medication only",
        "Cognitive behavioral therapy",
        "No therapy needed"
      ],
      correct: "C"
    },
    {
      id: 26994,
      question: "What is nutritional treatment aimed at?",
      options: [
        "Continued weight loss",
        "Maintaining low weight",
        "Weight restoration and balanced dietary lifestyle",
        "Eliminating all carbohydrates"
      ],
      correct: "C"
    },
    {
      id: 26995,
      question: "Why does brain function improve with weight restoration?",
      options: [
        "Psychological effects",
        "Starved brain doesn\'t function optimally",
        "Social pressure",
        "Medication effects"
      ],
      correct: "B"
    },
    {
      id: 26996,
      question: "When is physical activity reintroduced in anorexia nervosa recovery?",
      options: [
        "Immediately",
        "During early treatment",
        "After healthy weight achieved",
        "Never reintroduced"
      ],
      correct: "C"
    }
  ]
,

  // Case Study Questions
  "1. Cardiovascular Disease and Oral Health (Case Study)": [
    {
      id: 30000,
      question: "A 52-year-old male patient presents for a routine dental hygiene appointment. During the health history review, he reports no previous cardiovascular problems. His blood pressure reading is 146/92 mm Hg. After waiting 10 minutes, a second reading shows 144/90 mm Hg. The patient mentions smoking one pack of cigarettes daily and has not seen his physician in 3 years due to his busy lifestyle. What is the MOST appropriate action for the dental hygienist?",
      options: [
        "Continue with full dental hygiene treatment and monitor blood pressure throughout the appointment",
        "Limit the appointment to assessment and planning, then refer the patient to his physician",
        "Administer nitrous oxide-oxygen analgesia to reduce stress before proceeding with treatment",
        "Provide treatment using local anesthetic without vasoconstrictor to avoid elevating blood pressure",
      ],
      correct: "B"
    },
    {
      id: 30001,
      question: "A 45-year-old female patient with a history of stable angina arrives for periodontal maintenance. She reports that her chest pain occurs only with physical exertion and is promptly relieved with nitroglycerin. Her last angina episode was 3 weeks ago after climbing stairs. She has her nitroglycerin prescription with her. Which appointment modification is MOST important for this patient?",
      options: [
        "Schedule afternoon appointments to ensure the patient is well-rested from the previous night",
        "Place nitroglycerin within reach of the dental hygienist before beginning any procedures",
        "Administer prophylactic nitroglycerin sublingually 5 minutes before starting treatment",
        "Limit appointments to 15 minutes to prevent fatigue and avoid triggering an angina attack",
      ],
      correct: "B"
    },
    {
      id: 30002,
      question: "A 68-year-old patient reports having a myocardial infarction 6 weeks ago. He states he has recovered well with no complications and has been walking daily. His medications include aspirin, a beta-blocker, and a statin. He is scheduled for scaling and root planing today. What is the BEST course of action?",
      options: [
        "Postpone treatment until 6 months post-MI to ensure complete cardiac healing and stability",
        "Proceed with treatment as planned since he is more than 30 days post-MI with no complications",
        "Consult with his cardiologist before any treatment due to his recent cardiac event history",
        "Provide only supragingival scaling today and reschedule subgingival instrumentation for next month",
      ],
      correct: "B"
    },
    {
      id: 30003,
      question: "A 55-year-old patient with hypertensive cardiovascular disease controlled with medication presents for treatment. Her blood pressure today is 128/82 mm Hg. The treatment plan includes scaling and root planing in the mandibular right quadrant. Which local anesthetic consideration is MOST appropriate?",
      options: [
        "Use mepivacaine 3% without vasoconstrictor to completely avoid any blood pressure elevation",
        "Use lidocaine with 1:50,000 epinephrine as the concentration is safe for hypertensive patients",
        "Avoid all local anesthetics and rely solely on nitrous oxide-oxygen analgesia for pain control",
        "Use lidocaine with 1:100,000 epinephrine with careful aspiration and minimal vasoconstrictor amount",
      ],
      correct: "D"
    },
    {
      id: 30004,
      question: "During a routine examination, the dental hygienist records a patient's pulse as 54 beats per minute. The patient is a 28-year-old marathon runner who exercises daily. He reports no cardiac symptoms and feels healthy. How should the dental hygienist interpret this finding?",
      options: [
        "This represents pathologic bradycardia requiring immediate emergency medical services activation",
        "This is likely physiologic bradycardia normal for a physically fit athlete and requires no intervention",
        "This pulse rate indicates potential acute myocardial infarction and treatment should stop immediately",
        "This finding suggests cardiac pacemaker malfunction and the patient needs urgent cardiologist consultation",
      ],
      correct: "B"
    },
    {
      id: 30005,
      question: "A 72-year-old patient with atrial fibrillation takes warfarin (Coumadin) daily. She is scheduled for scaling and root planing. Her most recent INR value from yesterday is 2.8, and her physician confirms this is within her therapeutic range. What is the MOST appropriate treatment approach?",
      options: [
        "Postpone all treatment until INR decreases to below 2.0 for safe periodontal instrumentation",
        "Request physician consultation to temporarily discontinue warfarin 3 days before the appointment",
        "Proceed with scaling and root planing one quadrant at a time, managing bleeding with local measures",
        "Limit treatment to coronal polishing only and avoid all subgingival instrumentation indefinitely",
      ],
      correct: "C"
    },
    {
      id: 30006,
      question: "A 50-year-old patient presents with a health history indicating mitral valve prolapse. She reports occasional heart palpitations and takes a beta-blocker for symptom management. She has not had any valve repair or replacement surgery. According to current American Heart Association guidelines, what prophylactic antibiotic protocol is indicated?",
      options: [
        "Amoxicillin 2g orally 1 hour before procedures that manipulate gingival tissue or periapical regions",
        "Clindamycin 600mg orally 1 hour before any dental appointment regardless of procedure type",
        "No prophylactic antibiotics are required as MVP alone is not high-risk for infective endocarditis",
        "Azithromycin 500mg orally 1 hour before appointments but only for scaling and root planing procedures",
      ],
      correct: "C"
    },
    {
      id: 30007,
      question: "A patient with congestive heart failure arrives for a dental hygiene appointment. She reports sleeping with three pillows at night due to difficulty breathing when lying flat. Her ankles show visible edema. Which chair position is MOST appropriate during treatment?",
      options: [
        "Completely supine position to facilitate optimal access for instrumentation in all areas",
        "Semi-supine position at 45 degrees to balance patient comfort with clinician ergonomics",
        "Upright position to decrease fluid collection in the lungs and facilitate easier breathing",
        "Trendelenburg position with feet elevated to improve venous return and cardiac output",
      ],
      correct: "C"
    },
    {
      id: 30008,
      question: "A 35-year-old patient reports having a ventricular septal defect that was surgically repaired 18 months ago with complete closure. She has no residual defects and has been cleared by her cardiologist. She is scheduled for routine prophylaxis. What prophylactic antibiotic regimen is indicated?",
      options: [
        "Standard amoxicillin 2g protocol since all congenital heart defects require lifelong prophylaxis",
        "No prophylactic antibiotics needed as the defect is completely repaired with no residual issues",
        "Clindamycin 600mg for this appointment only, then no prophylaxis needed for future appointments",
        "Prophylactic antibiotics only for the first 6 months post-surgery, so prophylaxis is required today",
      ],
      correct: "B"
    },
    {
      id: 30009,
      question: "A 58-year-old patient has a pacemaker implanted 5 years ago for third-degree heart block. She reports it is a newer bipolar, shielded model. She needs ultrasonic scaling for calculus removal. What is the MOST appropriate action regarding ultrasonic instrumentation?",
      options: [
        "Avoid all ultrasonic instruments and use only hand instrumentation to prevent pacemaker interference",
        "Use piezoelectric ultrasonic instruments only, as they are safer than magnetostrictive types for pacemakers",
        "Consult with her cardiologist to verify the pacemaker model's shielding before using any powered devices",
        "Place a lead apron over the pacemaker site and proceed with ultrasonic instrumentation as planned",
      ],
      correct: "C"
    },
    {
      id: 30010,
      question: "During treatment, a patient with a history of angina suddenly complains of chest pain radiating to the left arm. The pain started 2 minutes ago and has not subsided. The patient appears anxious and is perspiring. What is the immediate priority action?",
      options: [
        "Continue treatment while monitoring vital signs to determine if the pain worsens or improves",
        "Stop treatment immediately, place patient upright, administer nitroglycerin sublingually, and give oxygen",
        "Lower the chair to supine position, elevate the patient's legs, and begin cardiopulmonary resuscitation",
        "Dismiss the patient with instructions to rest and take nitroglycerin at home if pain continues",
      ],
      correct: "B"
    },
    {
      id: 30011,
      question: "A 63-year-old patient with coronary heart disease takes aspirin 81mg daily and clopidogrel (Plavix) 75mg daily following stent placement 4 months ago. He requires extensive periodontal debridement. This dual antiplatelet therapy indicates what treatment consideration?",
      options: [
        "Discontinue both medications 7 days before treatment to minimize bleeding complications during scaling",
        "Replace aspirin with vitamin K supplements for 3 days before and after periodontal procedures",
        "Proceed with treatment using meticulous technique, local hemostatic measures, and shorter appointments",
        "Postpone all periodontal treatment until dual antiplatelet therapy is discontinued by the cardiologist",
      ],
      correct: "C"
    },
    {
      id: 30012,
      question: "A patient's health history reveals rheumatic heart disease diagnosed 15 years ago following streptococcal pharyngitis. She has mild mitral valve damage but no history of infective endocarditis. She needs scaling and root planing. What prophylactic antibiotic protocol is recommended?",
      options: [
        "Amoxicillin 2g orally 1 hour before treatment since rheumatic heart disease always requires prophylaxis",
        "No prophylactic antibiotics required as rheumatic heart disease alone is not high-risk for IE",
        "Clindamycin 600mg orally 1 hour before treatment due to the valvular damage from rheumatic fever",
        "Azithromycin 500mg orally 1 hour before treatment but only for this appointment, then reassess",
      ],
      correct: "B"
    },
    {
      id: 30013,
      question: "A 70-year-old patient had a heart transplant 2 years ago. He takes cyclosporine (immunosuppressant) and is on long-term preventive antibiotic therapy. During examination, the dental hygienist notes gingival enlargement. Which factor MOST likely contributes to the gingival condition?",
      options: [
        "Poor oral hygiene practices due to decreased manual dexterity from advanced age",
        "Cyclosporine medication causing drug-influenced gingival enlargement as a side effect",
        "Chronic periodontitis exacerbated by immunosuppression leading to tissue inflammation",
        "Inadequate dental hygiene care frequency resulting in biofilm accumulation and gingival response",
      ],
      correct: "B"
    },
    {
      id: 30014,
      question: "A 48-year-old patient reports taking amlodipine (calcium channel blocker) for hypertension. She complains of dry mouth and altered taste sensation. Clinical examination reveals gingival enlargement, particularly in the anterior regions. What oral manifestations are associated with this medication?",
      options: [
        "Xerostomia, taste alterations, and potential for drug-influenced gingival enlargement",
        "Increased salivation, oral candidiasis, and angular cheilitis affecting commissures",
        "Burning tongue sensation, geographic tongue, and aphthous ulceration patterns",
        "Teeth mobility, alveolar bone loss, and rapid periodontal attachment loss progression",
      ],
      correct: "A"
    },
    {
      id: 30015,
      question: "A patient with a history of patent ductus arteriosus underwent catheter-based closure 8 weeks ago. The procedure was successful with complete closure. She presents for routine dental hygiene care. What antibiotic prophylaxis is indicated?",
      options: [
        "Standard amoxicillin prophylaxis for 6 months post-procedure, then no further prophylaxis needed",
        "Prophylaxis required for all future dental appointments due to the congenital heart defect history",
        "No prophylaxis currently needed since she is beyond 6 months from complete defect repair",
        "Prophylaxis needed today only since the repair was recent, then consult cardiologist for future appointments",
      ],
      correct: "A"
    },
    {
      id: 30016,
      question: "During periodontal charting, the dental hygienist notes five premature ventricular contractions (PVCs) within one minute while taking the patient's pulse. The patient is 65 years old with known coronary artery disease. What action is MOST appropriate?",
      options: [
        "Document the finding in the patient record and continue with planned treatment today",
        "Recommend medical consultation given the frequency of PVCs and cardiovascular disease history",
        "Immediately activate emergency medical services as this indicates imminent myocardial infarction",
        "Administer oxygen at 6 liters per minute and monitor vital signs every 5 minutes during treatment",
      ],
      correct: "B"
    },
    {
      id: 30017,
      question: "A 56-year-old patient with Type 2 diabetes and obesity presents for initial periodontal therapy. His blood pressure is 138/88 mm Hg. He smokes half a pack of cigarettes daily and leads a sedentary lifestyle. Periodontal examination reveals generalized moderate periodontitis. Which statement BEST describes the relationship between his conditions?",
      options: [
        "Periodontal disease and cardiovascular disease share common risk factors but no direct causal relationship is established",
        "Treating periodontal disease will directly prevent cardiovascular disease development in this patient",
        "Diabetes causes both periodontal disease and cardiovascular disease through identical pathogenic mechanisms",
        "Periodontal disease bacteria directly migrate to cardiac tissue causing atherosclerotic plaque formation",
      ],
      correct: "A"
    },
    {
      id: 30018,
      question: "A patient with tetralogy of Fallot had complete surgical repair 10 years ago with no residual defects. She requires scaling and root planing in all quadrants. What prophylactic antibiotic protocol is appropriate?",
      options: [
        "Amoxicillin 2g one hour before each quadrant appointment due to cyanotic congenital heart disease history",
        "No prophylactic antibiotics needed since surgical repair was complete with no residual defects",
        "Clindamycin 600mg before first quadrant only, then no prophylaxis needed for subsequent quadrants",
        "Prophylaxis required only if appointments are scheduled less than 14 days apart between quadrants",
      ],
      correct: "B"
    },
    {
      id: 30019,
      question: "A 44-year-old patient takes lisinopril (ACE inhibitor) for hypertension. She reports a persistent dry cough and mentions that her mouth feels dry. Intraoral examination reveals multiple areas of erythema on the buccal mucosa. What oral condition is MOST associated with ACE inhibitor medications?",
      options: [
        "Xerostomia, taste impairment, and oral ulceration as documented medication side effects",
        "Oral candidiasis, angular cheilitis, and denture stomatitis from immunosuppression",
        "Melanotic pigmentation, gingival hyperplasia, and tooth intrinsic staining",
        "Median rhomboid glossitis, fissured tongue, and bilateral commissure lesions",
      ],
      correct: "A"
    },
    {
      id: 30020,
      question: "A patient presents with atrial septal defect detected as an adult. She reports easy fatigue and shortness of breath after mild exertion. She is scheduled for surgical repair next month. She needs a prophylaxis appointment today. What treatment approach is indicated?",
      options: [
        "Provide full prophylaxis today without antibiotic prophylaxis since the defect is currently unrepaired",
        "Postpone all dental treatment until after surgical repair and 6-month healing period completion",
        "Provide treatment with antibiotic prophylaxis as unrepaired congenital defects require prophylaxis",
        "Limit treatment to examination and oral hygiene instruction only, avoiding tissue manipulation completely",
      ],
      correct: "C"
    },
    {
      id: 30021,
      question: "A 59-year-old patient had coronary artery bypass surgery 8 months ago. Recovery was uncomplicated. He takes aspirin, atorvastatin, and metoprolol. He has good oral hygiene and requires routine maintenance. What treatment modifications are necessary?",
      options: [
        "Prophylactic antibiotics before all dental procedures for 1 year following bypass surgery",
        "Avoid epinephrine-containing local anesthetics permanently due to coronary bypass history",
        "No specific modifications needed beyond consideration of aspirin's effect on bleeding time",
        "Consult with cardiologist before every appointment to verify clearance for dental treatment",
      ],
      correct: "C"
    },
    {
      id: 30022,
      question: "During scaling procedures on a patient taking calcium channel blockers, the dental hygienist observes prolonged bleeding from the gingival tissues. The patient's gingival tissues appear enlarged and inflamed despite adequate biofilm control. What explains this clinical presentation?",
      options: [
        "Undiagnosed bleeding disorder requiring immediate hematologic consultation and laboratory testing",
        "Drug-influenced gingival enlargement from calcium channel blockers increases bleeding during instrumentation",
        "Acute necrotizing ulcerative gingivitis developing secondary to stress and immunocompromise",
        "Aggressive periodontitis with rapid attachment loss causing friable tissues and spontaneous bleeding",
      ],
      correct: "B"
    },
    {
      id: 30023,
      question: "A 51-year-old patient reports unstable angina with chest pain occurring at rest and during sleep. Episodes last 15-20 minutes. Pain is not consistently relieved with nitroglycerin. He presents for a scheduled hygiene appointment. What is the MOST appropriate action?",
      options: [
        "Proceed with treatment using stress reduction protocols and have nitroglycerin readily available",
        "Provide treatment in shorter appointments with frequent breaks to minimize physical exertion",
        "Postpone all treatment and refer for immediate medical evaluation due to unstable angina",
        "Administer prophylactic nitroglycerin before treatment and monitor vital signs every 10 minutes",
      ],
      correct: "C"
    },
    {
      id: 30024,
      question: "A patient with an implantable cardioverter defibrillator (ICD) for ventricular tachycardia needs periodontal maintenance. She states the device is a newer model with dual pacemaker function. What is the appropriate approach to ultrasonic instrumentation?",
      options: [
        "Ultrasonic instruments pose no risk to modern ICDs and can be used without restrictions",
        "Place a lead apron over the ICD and proceed with magnetostrictive ultrasonic scaling",
        "Consult with her cardiologist regarding device specifications before using powered instruments",
        "Use only piezoelectric ultrasonic devices as magnetostrictive types will interfere with ICDs",
      ],
      correct: "C"
    },
    {
      id: 30025,
      question: "A 67-year-old patient with left-sided congestive heart failure presents for treatment. She reports sleeping upright in a chair and has a productive cough. Her ankles show no edema. Which finding is MOST consistent with left-sided heart failure?",
      options: [
        "Peripheral edema in ankles and feet from systemic venous congestion throughout body",
        "Difficulty breathing in supine position from increased fluid and blood in lungs",
        "Cold hands and feet from inadequate blood return to the right side of the heart",
        "Jugular vein distention from elevated right atrial pressure and systemic backup",
      ],
      correct: "B"
    },
    {
      id: 30026,
      question: "A patient taking digitalis (Lanoxin) for congestive heart failure reports feeling nauseated during the appointment. The dental hygienist is preparing to take a full-mouth series of radiographs. What modification should be made?",
      options: [
        "Proceed with radiographs but allow frequent breaks if nausea worsens during the procedure",
        "Administer antiemetic medication before continuing with any planned radiographic procedures",
        "Postpone radiographs and procedures that may cause gagging due to digitalis side effects",
        "Complete radiographs quickly to minimize appointment time and reduce patient discomfort",
      ],
      correct: "C"
    },
    {
      id: 30027,
      question: "A 40-year-old patient with a history of intravenous drug use reports having had bacterial endocarditis 3 years ago. The infection was successfully treated. She has residual damage to the mitral valve. She requires scaling and root planing. What prophylactic antibiotic protocol is indicated?",
      options: [
        "Amoxicillin 2g orally 1 hour before treatment due to previous endocarditis history",
        "Clindamycin 600mg orally 1 hour before treatment for patients with previous IE",
        "No prophylaxis required unless she has a prosthetic valve or unrepaired cyanotic defect",
        "Double-dose amoxicillin 4g given the high-risk history of previous infective endocarditis",
      ],
      correct: "A"
    },
    {
      id: 30028,
      question: "A patient presents with peripheral arterial disease and reports cold hands and feet. She has right-sided heart failure. Blood pressure is 118/76 mm Hg. What finding is associated with right-sided heart failure?",
      options: [
        "Pulmonary edema from inadequate blood flow from lungs to left atrium",
        "Dyspnea on exertion from fluid accumulation in alveolar spaces",
        "Peripheral edema in extremities from systemic venous congestion",
        "Orthopnea requiring multiple pillows for sleeping due to lung fluid",
      ],
      correct: "C"
    },
    {
      id: 30029,
      question: "A 73-year-old patient with atrial fibrillation takes rivaroxaban (Xarelto), a direct oral anticoagulant. She requires extraction of a mobile tooth with advanced bone loss. What is the appropriate management approach?",
      options: [
        "Discontinue rivaroxaban 7 days before extraction to allow adequate time for drug clearance",
        "Consult with her physician regarding anticoagulation management for this invasive procedure",
        "Proceed with extraction and manage bleeding with local hemostatic measures only",
        "Switch to warfarin temporarily as INR monitoring allows better control during extraction healing",
      ],
      correct: "B"
    },
    {
      id: 30030,
      question: "During a medical history review, a patient reports having ventricular fibrillation that required automated external defibrillator use and CPR 6 months ago. She now has an ICD and takes antiarrhythmic medication. What best describes ventricular fibrillation?",
      options: [
        "A slow, regular heart rhythm originating from the sinoatrial node with delayed conduction",
        "A rapid, irregular, disordered ventricular rhythm that is life-threatening without immediate intervention",
        "An irregular atrial rhythm with variable ventricular response causing decreased cardiac output",
        "A complete blockage of impulses from the atria to ventricles resulting in independent beating",
      ],
      correct: "B"
    },
    {
      id: 30031,
      question: "A patient with coronary heart disease mentions that periodontal disease increases cardiovascular disease risk. She asks if treating her periodontitis will prevent heart disease. What is the MOST accurate response?",
      options: [
        "Yes, treating periodontitis will directly prevent cardiovascular disease development in all patients",
        "No, periodontal and cardiovascular diseases share no relationship and are completely independent conditions",
        "Periodontal disease is a modifiable risk factor, and good oral health may reduce systemic inflammation",
        "Only severe periodontitis affects cardiovascular health; mild to moderate disease has no impact",
      ],
      correct: "C"
    },
    {
      id: 30032,
      question: "A 62-year-old patient reports chest pain that began 30 minutes ago during his dental hygiene appointment. The pain is crushing, radiates to his jaw and left arm, and has not subsided. He appears diaphoretic and nauseated. Nitroglycerin was administered with no relief. What is the MOST likely emergency situation?",
      options: [
        "Stable angina pectoris that will resolve with rest and additional nitroglycerin administration",
        "Anxiety-induced chest pain from dental care stress requiring reassurance and breathing exercises",
        "Acute myocardial infarction requiring immediate emergency medical services activation",
        "Gastroesophageal reflux disease causing substernal discomfort mimicking cardiac pain",
      ],
      correct: "C"
    },
    {
      id: 30033,
      question: "A patient with hypertension controlled on medication has a blood pressure reading of 132/84 mm Hg today. Treatment planned includes scaling and root planing of the maxillary right quadrant using local anesthetic. Which statement regarding local anesthetic use is correct?",
      options: [
        "All vasoconstrictors are absolutely contraindicated in any patient with hypertension history",
        "Vasoconstrictors can be used judiciously in minimal amounts with controlled hypertension",
        "Only prilocaine with felypressin is safe for hypertensive patients requiring local anesthesia",
        "Mepivacaine 3% without vasoconstrictor must be used exclusively in all cardiac patients",
      ],
      correct: "B"
    },
    {
      id: 30034,
      question: "A 55-year-old patient had mechanical aortic valve replacement 1 year ago. She takes warfarin with a therapeutic INR of 2.5. She requires comprehensive periodontal therapy including scaling and root planing in all quadrants. What prophylactic protocol is indicated?",
      options: [
        "Amoxicillin 2g one hour before each appointment due to prosthetic heart valve",
        "No prophylaxis needed as valve replacement was more than 6 months ago",
        "Clindamycin 600mg before first appointment only, then no further prophylaxis needed",
        "Consult cardiologist to determine if prophylaxis frequency can be reduced with good oral health",
      ],
      correct: "A"
    },
    {
      id: 30035,
      question: "A patient with controlled congestive heart failure on diuretic therapy complains of severe dry mouth. Clinical examination reveals multiple root caries and candidiasis on the palate. What preventive recommendations are MOST appropriate?",
      options: [
        "Discontinue the diuretic medication temporarily and substitute with alternative heart failure medication",
        "Prescribe antifungal medication only and schedule follow-up in 6 months for routine care",
        "Recommend fluoride therapy, saliva substitutes, reduced sugar intake, and antifungal treatment",
        "Increase frequency of professional fluoride applications but avoid saliva substitutes that contain sugar",
      ],
      correct: "C"
    },
    {
      id: 30036,
      question: "A 47-year-old patient reports a family history of premature coronary heart disease. His father had a myocardial infarction at age 52. The patient smokes, is obese, and has uncontrolled hypertension. He has generalized moderate periodontitis. Which risk factors for cardiovascular disease are modifiable?",
      options: [
        "Age, gender, and race are the only modifiable risk factors in this patient's case",
        "Genetic predisposition and family history can be modified through gene therapy",
        "Tobacco use, obesity, hypertension, and periodontal disease can be modified",
        "Only tobacco use is modifiable; other factors are determined by genetics",
      ],
      correct: "C"
    },
    {
      id: 30037,
      question: "During treatment, a patient with a history of angina becomes anxious and begins to show signs of distress including muscular tension and perspiration. She has not yet complained of chest pain. What preventive action is MOST appropriate?",
      options: [
        "Continue treatment while closely monitoring for development of actual chest pain symptoms",
        "Stop treatment immediately, place patient upright, and administer nitroglycerin prophylactically",
        "Pause treatment, implement stress reduction strategies, and assess patient's comfort level",
        "Complete treatment quickly to minimize total appointment time and reduce overall stress",
      ],
      correct: "C"
    },
    {
      id: 30038,
      question: "A patient had an atrial septal defect repaired with a prosthetic patch 4 months ago. She presents for routine prophylaxis. Her cardiologist reports no residual defects at the repair site. What antibiotic prophylaxis is required?",
      options: [
        "Amoxicillin 2g one hour before treatment since repair involved prosthetic material within 6 months",
        "No prophylaxis needed since the repair was complete and successful without complications",
        "Clindamycin 600mg one hour before treatment for patients allergic to penicillin only",
        "Prophylaxis required today only; future appointments will not require antibiotic coverage",
      ],
      correct: "A"
    },
    {
      id: 30039,
      question: "A 69-year-old patient with coronary artery disease reports taking aspirin 81mg daily. His last dental hygiene appointment was 18 months ago. Clinical examination reveals heavy calculus and inflamed gingival tissues with bleeding on probing. What is the PRIMARY concern during scaling procedures?",
      options: [
        "Aspirin's antiplatelet effect may result in prolonged bleeding requiring careful management",
        "Patient cannot receive local anesthetic with vasoconstrictor due to coronary artery disease",
        "Prophylactic antibiotics are required before scaling due to cardiovascular disease history",
        "Treatment must be limited to one quadrant per year due to aspirin's effect on healing",
      ],
      correct: "A"
    },
    {
      id: 30040,
      question: "A patient taking spironolactone (Aldactone), a diuretic for hypertension, reports dry mouth and difficulty with denture retention. She has multiple areas of root caries. Which intervention addresses the medication side effect?",
      options: [
        "Recommend discontinuing medication and consulting physician for alternative hypertension treatment",
        "Suggest using saliva stimulants, fluoride therapy, and limiting sugar exposure between meals",
        "Prescribe antibiotic therapy to address the bacterial infection causing the root caries",
        "Apply dental sealants over all root surfaces to permanently protect against caries development",
      ],
      correct: "B"
    },
    {
      id: 30041,
      question: "A 58-year-old patient with a history of acute myocardial infarction 10 months ago reports compliance with cardiac rehabilitation. He exercises regularly and experiences no chest pain or shortness of breath. His medications include aspirin, beta-blocker, ACE inhibitor, and statin. What describes his functional capacity status?",
      options: [
        "Poor functional capacity requiring medical consultation before any dental treatment",
        "Fair functional capacity allowing limited dental treatment with extensive modifications",
        "Good functional capacity indicated by exercise tolerance and absence of ischemic symptoms",
        "Excellent functional capacity eliminating need to consider cardiovascular disease in treatment planning",
      ],
      correct: "C"
    },
    {
      id: 30042,
      question: "A patient with heart disease asks why the dental hygienist uses an antimicrobial mouth rinse before scaling procedures. She wants to know if this prevents heart problems. What is the BEST explanation?",
      options: [
        "Antimicrobial rinse eliminates all oral bacteria, completely preventing bacteremia during dental procedures",
        "Preprocedural rinsing reduces oral bacterial counts, potentially decreasing bacteremia severity during tissue manipulation",
        "Antimicrobial rinse replaces the need for prophylactic antibiotics in all cardiac patients",
        "Rinsing prevents infective endocarditis by killing bacteria that cause heart valve infections",
      ],
      correct: "B"
    },
    {
      id: 30043,
      question: "A 64-year-old patient reports having second-degree heart block. He has a permanent pacemaker implanted 3 years ago. He needs a comprehensive periodontal assessment including full-mouth probing. What characterizes second-degree heart block?",
      options: [
        "All impulses from atria are blocked at the AV node resulting in complete dissociation",
        "Impulses from the AV node are fully blocked in irregular patterns causing disordered rates",
        "Atrial and ventricular rates are normal with no electrical conduction abnormalities present",
        "Electrical impulses are conducted normally from SA node through Purkinje fibers without delay",
      ],
      correct: "B"
    },
    {
      id: 30044,
      question: "A patient with rheumatic heart disease from childhood rheumatic fever has mitral valve damage. She maintains excellent oral hygiene and has no periodontal disease. She requires routine prophylaxis. According to current guidelines, what prophylaxis protocol is appropriate?",
      options: [
        "Amoxicillin 2g one hour before treatment since all valvular damage requires antibiotic prophylaxis",
        "No antibiotic prophylaxis required as rheumatic heart disease is not high-risk for IE",
        "Clindamycin 600mg one hour before treatment for patients with penicillin allergy only",
        "Prophylaxis required only if patient has poor oral hygiene with active periodontal disease",
      ],
      correct: "B"
    },
    {
      id: 30045,
      question: "During an emergency, a patient with known cardiovascular disease loses consciousness. The automated external defibrillator (AED) is retrieved. The device analyzes the rhythm and advises \"shock advised.\" What does this indicate?",
      options: [
        "The patient has ventricular fibrillation or ventricular tachycardia requiring defibrillation",
        "The patient is experiencing bradycardia requiring immediate cardiac pacing intervention",
        "The device has malfunctioned and cardiopulmonary resuscitation should begin immediately",
        "The patient has normal sinus rhythm but elevated heart rate requiring medication",
      ],
      correct: "A"
    },
    {
      id: 30046,
      question: "A 52-year-old African American male presents for initial examination. He is sedentary, obese, and reports a high-stress job. His blood pressure is 142/90 mm Hg. He has no previous hypertension diagnosis. Which factor increases his cardiovascular disease risk?",
      options: [
        "Only his blood pressure reading indicates cardiovascular disease risk at this time",
        "Race, sedentary lifestyle, obesity, stress, and elevated blood pressure all contribute to risk",
        "African American race is the sole non-modifiable risk factor affecting his heart disease risk",
        "His age and gender are the primary risk factors; other findings are insignificant",
      ],
      correct: "B"
    },
    {
      id: 30047,
      question: "A patient with a history of coronary bypass surgery 2 years ago takes clopidogrel (Plavix) and aspirin. She requires extraction of a periodontally involved tooth with mobility. What is the appropriate approach?",
      options: [
        "Continue both antiplatelet medications and manage bleeding with local hemostatic measures",
        "Discontinue clopidogrel 7 days before extraction but continue aspirin therapy",
        "Consult with her cardiologist regarding antiplatelet management for the extraction procedure",
        "Discontinue both medications 10 days before extraction to prevent excessive bleeding complications",
      ],
      correct: "C"
    },
    {
      id: 30048,
      question: "A 45-year-old patient reports mitral valve prolapse without regurgitation. She has no history of infective endocarditis and takes no medications. She has moderate periodontitis requiring scaling and root planing. What prophylactic antibiotic protocol is indicated?",
      options: [
        "Standard amoxicillin 2g protocol since all mitral valve conditions require IE prophylaxis",
        "Clindamycin 600mg for patients allergic to penicillin or with GI intolerance to amoxicillin",
        "No prophylactic antibiotics required as MVP without complications is not high-risk for IE",
        "Azithromycin 500mg before first appointment, then no prophylaxis needed for subsequent appointments",
      ],
      correct: "C"
    },
    {
      id: 30049,
      question: "A patient with congestive heart failure taking furosemide (Lasix) complains of xerostomia. Examination reveals cervical root caries on several teeth and generalized mild gingivitis. What is the relationship between medication and oral findings?",
      options: [
        "Furosemide causes increased salivation leading to enamel erosion and caries development",
        "Diuretics like furosemide cause decreased salivary flow, increasing caries and periodontal disease risk",
        "Furosemide has no effect on salivary glands; findings are unrelated to medication use",
        "The medication causes gingival enlargement that traps biofilm leading to gingivitis and caries",
      ],
      correct: "B"
    },
    {
      id: 30050,
      question: "A 71-year-old patient had a cardiac stent placed 3 months ago. He takes aspirin and ticagrelor (Brilinta). This dual antiplatelet therapy will continue for 12 months per his cardiologist. What does this medication regimen indicate?",
      options: [
        "The patient must postpone all dental treatment until dual therapy is discontinued at 12 months",
        "Prophylactic antibiotics are required before dental procedures due to the cardiac stent placement",
        "Treatment can proceed with careful technique and local hemostatic measures for bleeding management",
        "All medications must be discontinued 14 days before any invasive dental hygiene procedures",
      ],
      correct: "C"
    },
    {
      id: 30051,
      question: "During scaling, a patient with cardiovascular disease suddenly complains of chest pain, becomes diaphoretic, and appears nauseated. Nitroglycerin is administered sublingually. After 5 minutes, pain persists with no relief. What action should be taken?",
      options: [
        "Administer a second dose of nitroglycerin and wait another 5 minutes for pain relief",
        "Activate emergency medical services immediately as this may indicate myocardial infarction",
        "Place patient in Trendelenburg position and begin chest compressions for cardiac arrest",
        "Continue monitoring and administer third nitroglycerin dose if pain persists 5 more minutes",
      ],
      correct: "B"
    },
    {
      id: 30052,
      question: "A patient with atherosclerosis asks what causes the condition. He wants to understand his disease better to make informed health decisions. What is the PRIMARY etiology of atherosclerosis?",
      options: [
        "Viral infection causing inflammation and damage to arterial walls leading to plaque formation",
        "Genetic mutation preventing normal lipid metabolism resulting in arterial lipid accumulation",
        "Fatty deposits containing lipids and cholesterol narrowing arterial lumens and reducing blood flow",
        "Autoimmune response attacking arterial endothelium creating scar tissue and stenosis",
      ],
      correct: "C"
    },
    {
      id: 30053,
      question: "A 66-year-old patient with controlled atrial fibrillation takes apixaban (Eliquis). Her physician confirms therapeutic dosing. She requires full-mouth scaling and root planing. What treatment approach is most appropriate?",
      options: [
        "Request temporary discontinuation of apixaban for 5 days before each quadrant appointment",
        "Proceed with quadrant-by-quadrant treatment managing bleeding with local measures as needed",
        "Postpone all subgingival instrumentation permanently due to bleeding risks with anticoagulation",
        "Replace apixaban with warfarin temporarily to allow INR monitoring during treatment period",
      ],
      correct: "B"
    },
    {
      id: 30054,
      question: "A patient reports using smokeless tobacco daily. He has no diagnosed cardiovascular disease but has several CVD risk factors including hypertension and obesity. How does tobacco use affect cardiovascular disease risk?",
      options: [
        "Smokeless tobacco has no effect on cardiovascular disease risk unlike cigarette smoking",
        "Only cigarette smoking increases cardiovascular disease risk; other tobacco forms are safe",
        "Both cigarette smoking and smokeless tobacco use increase risk of developing coronary heart disease",
        "Tobacco use affects only the lungs and oral cavity, not the cardiovascular system",
      ],
      correct: "C"
    },
    {
      id: 30055,
      question: "A 57-year-old patient had successful percutaneous coronary intervention (PCI) with angioplasty 6 months ago. He has no angina symptoms and exercises regularly. He requires periodontal maintenance. What treatment modifications are necessary?",
      options: [
        "Prophylactic antibiotics before all dental procedures for patients with history of PCI",
        "Avoid all epinephrine-containing anesthetics indefinitely following coronary interventions",
        "No specific modifications beyond monitoring for medication effects and current health status",
        "Limit treatment to supragingival scaling only to minimize stress on the cardiovascular system",
      ],
      correct: "C"
    },
    {
      id: 30056,
      question: "A patient with heart transplant 18 months ago takes cyclosporine immunosuppressant medication. Clinical examination reveals moderate gingival enlargement despite good oral hygiene. What oral condition is associated with cyclosporine?",
      options: [
        "Xerostomia leading to increased caries risk and compromised denture retention",
        "Drug-influenced gingival enlargement particularly in anterior regions despite good hygiene",
        "Oral candidiasis from immunosuppression causing white patches on mucosa",
        "Necrotizing ulcerative gingivitis from reduced immune response to periodontal pathogens",
      ],
      correct: "B"
    },
    {
      id: 30057,
      question: "A 75-year-old patient with tachycardia has a resting pulse of 118 beats per minute. She reports feeling anxious about dental treatment. Her health history includes coronary artery disease. What concern does persistent tachycardia present?",
      options: [
        "Tachycardia decreases cardiac workload and improves overall cardiovascular function",
        "Rapid heart rate increases oxygen demand potentially causing angina, heart failure, or MI",
        "Tachycardia has no clinical significance in patients with existing coronary artery disease",
        "Elevated pulse rate indicates improved cardiac output and better treatment tolerance",
      ],
      correct: "B"
    },
    {
      id: 30058,
      question: "A patient with prosthetic mitral valve takes warfarin with INR consistently at 2.7. She has excellent oral hygiene and no periodontal disease. She presents for routine prophylaxis today. What treatment protocol is required?",
      options: [
        "Amoxicillin 2g one hour before treatment due to prosthetic heart valve requiring prophylaxis",
        "No modifications needed as prophylaxis is only required for periodontal procedures",
        "Consult physician to temporarily reduce warfarin dose before performing prophylaxis",
        "Postpone treatment until INR decreases below 2.0 to minimize bleeding during scaling",
      ],
      correct: "A"
    },
    {
      id: 30059,
      question: "A 68-year-old patient complains of palpitations. While taking her pulse, the dental hygienist notes irregular beats with pauses. The patient has no diagnosed heart disease. What cardiac arrhythmia might this indicate?",
      options: [
        "Ventricular fibrillation requiring immediate defibrillation and emergency medical intervention",
        "Premature ventricular contractions (PVCs) causing pauses in otherwise normal heart rhythm",
        "Third-degree heart block with complete dissociation between atrial and ventricular contractions",
        "Stable angina pectoris manifesting as irregular pulse during episodes of chest pain",
      ],
      correct: "B"
    },
    {
      id: 30060,
      question: "A patient with hypertensive cardiovascular disease has blood pressure of 168/102 mm Hg despite medication. She reports taking her medication irregularly due to cost concerns. What is the appropriate action?",
      options: [
        "Proceed with treatment today but implement stress reduction protocols during procedures",
        "Provide only prophylaxis today; postpone periodontal procedures until next appointment",
        "Stop treatment after assessment and refer to physician for medical evaluation and control",
        "Continue with planned treatment but monitor blood pressure every 10 minutes throughout appointment",
      ],
      correct: "C"
    },
    {
      id: 30061,
      question: "A patient asks about the relationship between C-reactive protein (CRP) levels, periodontitis, and cardiovascular disease after reading about it online. What is the BEST explanation of this relationship?",
      options: [
        "Elevated CRP indicates systemic inflammation; periodontitis may contribute to increased CRP and CVD risk",
        "CRP is only elevated in cardiovascular disease and has no relationship to periodontal infections",
        "Periodontitis causes decreased CRP levels which then directly lead to atherosclerotic plaque formation",
        "CRP testing cannot detect inflammation from periodontal disease, only cardiovascular conditions",
      ],
      correct: "A"
    },
    {
      id: 30062,
      question: "A 54-year-old patient with angina pectoris scheduled for morning appointment arrives late due to traffic, appearing stressed and anxious. His nitroglycerin prescription expired 8 months ago. What should be done before proceeding with treatment?",
      options: [
        "Continue with planned treatment since he has fresh nitroglycerin at home available after appointment",
        "Ensure fresh nitroglycerin supply is available before beginning treatment due to medication expiration",
        "Proceed without nitroglycerin as the patient has no current chest pain or angina symptoms",
        "Administer prophylactic nitroglycerin from office emergency kit before starting any procedures",
      ],
      correct: "B"
    },
    {
      id: 30063,
      question: "A patient with congenital heart disease history had surgical repair of ventricular septal defect in childhood. She has a small residual defect at the repair site. She requires scaling and root planing. What prophylactic antibiotic protocol is indicated?",
      options: [
        "No antibiotics needed since childhood repairs more than 10 years old no longer require prophylaxis",
        "Amoxicillin 2g one hour before treatment due to residual defect at prosthetic repair site",
        "Clindamycin 600mg one hour before treatment only for this appointment, then reassess future needs",
        "Prophylaxis required only during first 6 months after surgical repair, now discontinued",
      ],
      correct: "B"
    },
    {
      id: 30064,
      question: "A 70-year-old patient takes digoxin for heart failure. He reports recent onset of facial pain, loss of appetite, and nausea. These symptoms began 2 weeks ago. What might these symptoms indicate?",
      options: [
        "Normal aging process unrelated to cardiac medication requiring no intervention",
        "Early signs of digitalis toxicity that should be reported to the patient's physician",
        "Typical side effects of digoxin therapy that resolve with continued medication use",
        "Unrelated dental infection requiring antibiotic therapy and immediate treatment",
      ],
      correct: "B"
    },
    {
      id: 30065,
      question: "A patient had percutaneous coronary intervention with coronary stent placement 2 months ago. Her cardiologist prescribed dual antiplatelet therapy. She requires periodontal maintenance with localized areas of calculus. How does stent placement affect dental hygiene care?",
      options: [
        "Prophylactic antibiotics are required for all dental procedures for 6 months after stent placement",
        "Treatment can proceed with consideration of antiplatelet therapy effects on bleeding time",
        "All dental treatment must be postponed until 12 months after stent placement for healing",
        "Local anesthetics with vasoconstrictors are contraindicated permanently after stent procedures",
      ],
      correct: "B"
    },
    {
      id: 30066,
      question: "A 63-year-old patient with coronary heart disease reports following a low-cholesterol, low-fat diet. She asks what dietary recommendations help both her heart disease and oral health. What nutritional counseling is appropriate?",
      options: [
        "High-sugar diet promotes good cardiovascular health but increases caries risk",
        "Low-fat diet benefits cardiovascular health; limit frequency of sugar exposure for oral health",
        "High-sodium diet improves heart function while reducing periodontal disease progression",
        "Cardiovascular and oral health dietary recommendations are completely contradictory",
      ],
      correct: "B"
    },
    {
      id: 30067,
      question: "A patient with history of bacterial endocarditis 5 years ago has a prosthetic aortic valve. She maintains excellent oral hygiene with no periodontal disease. She presents for 4-month preventive maintenance. What protocol is required?",
      options: [
        "Amoxicillin 2g one hour before appointment due to prosthetic valve and previous IE history",
        "No antibiotics needed at preventive maintenance appointments, only before invasive procedures",
        "Clindamycin 600mg one hour before appointment for patients with penicillin allergies only",
        "Prophylaxis frequency can be reduced to once yearly due to excellent oral hygiene status",
      ],
      correct: "A"
    },
    {
      id: 30068,
      question: "A 59-year-old patient had open-heart surgery for coronary artery bypass 14 months ago. He takes warfarin, aspirin, and atorvastatin. He requires comprehensive periodontal treatment. What consideration relates to warfarin therapy?",
      options: [
        "Warfarin must be discontinued 10 days before any dental treatment to prevent bleeding",
        "Consult with physician regarding prothrombin time or INR before performing invasive procedures",
        "Warfarin causes gingival enlargement requiring more frequent periodontal maintenance intervals",
        "Local anesthetics with epinephrine are contraindicated in all patients taking anticoagulants",
      ],
      correct: "B"
    },
    {
      id: 30069,
      question: "During examination, a patient reports having \"water pills\" for blood pressure. She has xerostomia and multiple cervical caries. She cannot remember the medication name. What class of medication is she likely taking?",
      options: [
        "Vasodilators that increase blood vessel size and facilitate blood flow through vessels",
        "Diuretics that promote renal excretion of water and sodium to reduce blood pressure",
        "Beta blockers that modify sympathetic nerve activity to decrease cardiac output",
        "Calcium channel blockers that reduce vascular resistance and lower blood pressure",
      ],
      correct: "B"
    },
    {
      id: 30070,
      question: "A patient with third-degree heart block has a permanent pacemaker. During the health history interview, she mentions the pacemaker was implanted in 1998 and has never been replaced. What precaution is necessary for this older pacemaker?",
      options: [
        "Modern dental equipment poses no risk to pacemakers regardless of age or shielding status",
        "Older pacemakers may lack adequate shielding requiring avoidance of electrical dental equipment",
        "Age of pacemaker is irrelevant; only the manufacturer determines equipment compatibility",
        "Pacemakers implanted before 2000 automatically require replacement before dental treatment",
      ],
      correct: "B"
    },
    {
      id: 30071,
      question: "A 77-year-old patient with hypertension and coronary artery disease reports feeling dizzy when standing up quickly. She takes multiple antihypertensive medications. What medication side effect might cause this symptom?",
      options: [
        "Xerostomia from diuretics causing dehydration and reduced blood volume",
        "Orthostatic hypotension from antihypertensive agents causing dizziness upon position change",
        "Gingival enlargement from calcium channel blockers affecting balance and coordination",
        "Increased salivation from ACE inhibitors creating difficulty swallowing and dizziness",
      ],
      correct: "B"
    },
    {
      id: 30072,
      question: "A patient with controlled hypertension asks if dental treatment will affect her blood pressure. She is concerned about potential complications. What is the BEST response regarding stress and blood pressure?",
      options: [
        "Dental treatment never affects blood pressure in patients with controlled hypertension",
        "Stress and anxiety during treatment may temporarily elevate blood pressure requiring monitoring",
        "Blood pressure always decreases during dental treatment due to relaxation in the dental chair",
        "Controlled hypertension eliminates need for blood pressure monitoring during dental appointments",
      ],
      correct: "B"
    },
    {
      id: 30073,
      question: "A 51-year-old patient has a bicuspid aortic valve with mild stenosis. He has no symptoms and is not on medication. He requires routine prophylaxis with minimal supragingival scaling. What antibiotic prophylaxis protocol is appropriate?",
      options: [
        "Amoxicillin 2g one hour before treatment since all valvular defects require prophylaxis",
        "No prophylaxis required as valvular stenosis without other risk factors is not high-risk for IE",
        "Clindamycin 600mg one hour before treatment for patients with valvular heart disease",
        "Prophylaxis required only if patient has poor oral hygiene or active periodontal disease",
      ],
      correct: "B"
    },
    {
      id: 30074,
      question: "A patient taking verapamil (calcium channel blocker) for hypertension presents for periodontal maintenance. Examination reveals localized gingival enlargement in the maxillary anterior region despite good oral hygiene. What management strategy is appropriate?",
      options: [
        "Discontinue verapamil and request physician prescribe alternative hypertension medication",
        "Refer for periodontal surgery to remove enlarged tissue and establish medication-free status",
        "Recommend meticulous oral hygiene, antimicrobial rinse, and frequent maintenance visits",
        "Inform patient that gingival enlargement will resolve spontaneously without intervention",
      ],
      correct: "C"
    },
    {
      id: 30075,
      question: "A 69-year-old patient with heart failure takes an angiotensin-receptor neprilysin inhibitor (ARNI). She complains of dry mouth affecting her quality of life. What oral manifestation is associated with ARNIs?",
      options: [
        "Excessive salivation causing difficulty speaking and swallowing during conversations",
        "Xerostomia increasing risk for dental caries and periodontal disease development",
        "Gingival enlargement particularly in anterior regions despite adequate biofilm control",
        "Oral ulcerations on buccal mucosa and tongue requiring topical corticosteroid treatment",
      ],
      correct: "B"
    },
    {
      id: 30076,
      question: "A patient with stable angina pectoris asks how many nitroglycerin tablets she can take if chest pain occurs during her appointment before calling for emergency help. What is the correct instruction?",
      options: [
        "Take up to five nitroglycerin tablets at 5-minute intervals before activating emergency services",
        "Take one nitroglycerin tablet; if pain persists after 5 minutes, activate emergency medical services",
        "Take three nitroglycerin tablets at 3-minute intervals before seeking emergency medical attention",
        "Take nitroglycerin tablets until bottle is empty since overdose is impossible with this medication",
      ],
      correct: "B"
    },
    {
      id: 30077,
      question: "A 65-year-old patient had mechanical mitral valve replacement. She takes warfarin with INR of 3.2 today. She requires extraction of a tooth with severe bone loss and mobility. What is the appropriate management?",
      options: [
        "Proceed with extraction today and manage bleeding with local hemostatic measures",
        "Discontinue warfarin for 7 days, perform extraction, then resume warfarin therapy",
        "Consult with her cardiologist and surgeon regarding anticoagulation management for extraction",
        "Postpone extraction permanently due to anticoagulation status and cardiovascular disease",
      ],
      correct: "C"
    },
    {
      id: 30078,
      question: "A patient with coronary artery disease reports that his physician prescribed aspirin 81mg daily. He asks why aspirin helps his heart condition. What is the mechanism of aspirin in cardiovascular disease?",
      options: [
        "Aspirin increases heart rate and contractility improving cardiac output and tissue perfusion",
        "Aspirin has antiplatelet effects decreasing blood clotting risk and improving blood flow",
        "Aspirin dilates coronary arteries increasing oxygen delivery to myocardial tissue",
        "Aspirin lowers cholesterol levels preventing atherosclerotic plaque formation in arteries",
      ],
      correct: "B"
    },
    {
      id: 30079,
      question: "A 72-year-old patient with atrial fibrillation has an irregular pulse of 88 beats per minute. She takes warfarin and reports no other cardiac symptoms. What concern does atrial fibrillation present?",
      options: [
        "Atrial fibrillation has no clinical consequences and requires no treatment modifications",
        "Irregular atrial contractions may contribute to thrombosis formation leading to stroke or TIAs",
        "Atrial fibrillation always progresses to ventricular fibrillation requiring immediate defibrillation",
        "Irregular pulse indicates need for immediate emergency medical services activation",
      ],
      correct: "B"
    }
  ],
  "2. Diabetes and Oral Health (Case Study)": [
    {
      id: 30100,
      question: "A 45-year-old male patient presents for a routine dental hygiene appointment. During the health history review, he reports frequent urination, excessive thirst, and unexplained weight loss over the past 2 months. He has no previous diabetes diagnosis. His blood pressure is 138/86 mm Hg and he appears fatigued. What is the MOST appropriate action for the dental hygienist?",
      options: [
        "Continue with planned dental hygiene treatment and monitor symptoms at future appointments",
        "Complete assessment only, then refer the patient to a physician for diabetes screening",
        "Provide full periodontal debridement today and recommend dietary modifications for weight gain",
        "Administer prophylaxis and schedule frequent recall appointments to monitor the symptoms",
      ],
      correct: "B"
    },
    {
      id: 30101,
      question: "A 32-year-old female patient was diagnosed with type 1 diabetes 15 years ago. She takes insulin via pump and reports her last A1c was 8.2%. She monitors blood glucose daily with average readings of 180 mg/dL. Periodontal examination reveals generalized 4-5 mm pocket depths with bleeding on probing. What explains the relationship between her conditions?",
      options: [
        "Type 1 diabetes has no relationship to periodontal disease since it is autoimmune in origin",
        "Hyperglycemia increases proinflammatory cytokines causing enhanced periodontal inflammation and bone loss",
        "Periodontal disease causes type 1 diabetes through bacterial invasion of pancreatic beta cells",
        "The insulin pump delivery system introduces oral bacteria into bloodstream causing periodontal infection",
      ],
      correct: "B"
    },
    {
      id: 30102,
      question: "A 58-year-old obese patient has type 2 diabetes managed with metformin 1000mg twice daily. His fasting blood glucose today is 145 mg/dL. He is scheduled for scaling and root planing of the mandibular right quadrant. What is the BEST course of action?",
      options: [
        "Postpone all treatment until blood glucose is below 100 mg/dL to ensure safety",
        "Proceed with planned scaling and root planing using stress reduction protocols",
        "Provide only supragingival scaling to avoid stimulating a hyperglycemic emergency",
        "Administer prophylactic antibiotics before proceeding with any periodontal instrumentation",
      ],
      correct: "B"
    },
    {
      id: 30103,
      question: "A pregnant patient at 26 weeks gestation presents for continued care. She reports being diagnosed with gestational diabetes 2 weeks ago. She has no previous diabetes history and manages the condition with diet modifications. What information should the dental hygienist provide?",
      options: [
        "Gestational diabetes always persists after delivery requiring lifelong insulin therapy",
        "Approximately 50% of women with gestational diabetes will develop type 2 diabetes later",
        "Gestational diabetes has no relationship to blood glucose control or insulin function",
        "The condition indicates pre-existing type 1 diabetes that was undiagnosed before pregnancy",
      ],
      correct: "B"
    },
    {
      id: 30104,
      question: "A 52-year-old patient with well-controlled type 2 diabetes (A1c 6.8%) presents for periodontal maintenance. His blood glucose reading today is 115 mg/dL. He takes metformin and exercises regularly. He has no active periodontal disease. What treatment approach is indicated?",
      options: [
        "Postpone all treatment until A1c decreases to 6.0% or lower for optimal safety",
        "Provide prophylactic antibiotics before any tissue manipulation due to diabetes history",
        "Proceed with routine periodontal maintenance without modifications due to good control",
        "Limit treatment to oral hygiene instruction only to avoid any infection risk",
      ],
      correct: "C"
    },
    {
      id: 30105,
      question: "During a health history update, a patient reports taking insulin glargine (Lantus) at bedtime and insulin lispro (Humalog) before meals. She is scheduled for a 10:00 AM appointment for scaling and root planing. What appointment timing consideration is MOST important?",
      options: [
        "Schedule appointments 2 hours after breakfast to avoid peak action time of rapid-acting insulin",
        "Schedule appointments before breakfast when insulin levels are highest for better control",
        "Schedule appointments immediately after lunch when blood glucose is most stable throughout the day",
        "Schedule appointments at 5:00 PM when long-acting insulin is at peak effectiveness",
      ],
      correct: "A"
    },
    {
      id: 30106,
      question: "A 67-year-old patient with type 2 diabetes for 20 years reports blurred vision, tingling in his feet, and frequent urination. His last A1c was 9.5%. Intraoral examination reveals xerostomia, multiple cervical caries, and gingival inflammation. What chronic diabetes complication does this presentation suggest?",
      options: [
        "Acute diabetic ketoacidosis requiring immediate emergency medical services activation",
        "Hypoglycemia from excessive oral medication causing neurologic symptoms",
        "Multiple chronic complications including retinopathy, neuropathy, and nephropathy",
        "Gestational diabetes with associated hormonal changes affecting multiple systems",
      ],
      correct: "C"
    },
    {
      id: 30107,
      question: "A patient with type 1 diabetes suddenly appears confused, sweaty, and shaky during scaling procedures. Her blood glucose reading is 62 mg/dL. She is conscious and able to swallow. What is the immediate priority action?",
      options: [
        "Administer 1 mg glucagon intramuscularly and activate emergency medical services immediately",
        "Give 15 grams of simple carbohydrates, wait 15 minutes, then recheck blood glucose",
        "Continue treatment while monitoring vital signs to determine if symptoms worsen",
        "Place patient supine with feet elevated and administer oxygen at 6 liters per minute",
      ],
      correct: "B"
    },
    {
      id: 30108,
      question: "A 40-year-old patient presents with a periodontal abscess and reports having type 2 diabetes. His blood glucose today is 245 mg/dL and he appears dehydrated. He has not seen his physician in 6 months. What is the MOST appropriate management?",
      options: [
        "Proceed with scaling and root planing to eliminate the infection source immediately",
        "Provide only pain management and refer to physician for diabetes evaluation before dental treatment",
        "Prescribe antibiotics and schedule periodontal surgery for next week after infection resolves",
        "Complete full mouth debridement today to control all periodontal infections at once",
      ],
      correct: "B"
    },
    {
      id: 30109,
      question: "A patient with prediabetes (A1c 6.0%) asks about preventing progression to type 2 diabetes. He is overweight with a sedentary lifestyle and family history of diabetes. What evidence-based intervention should be recommended?",
      options: [
        "Immediate insulin therapy to prevent beta cell destruction and preserve pancreatic function",
        "Increasing physical activity to 150 minutes per week and targeting 7% weight reduction",
        "Strict carbohydrate-free diet eliminating all sugars and starches from daily intake",
        "Annual monitoring only since prediabetes always progresses to diabetes regardless of intervention",
      ],
      correct: "B"
    },
    {
      id: 30110,
      question: "A 35-year-old patient with type 1 diabetes reports using an insulin pump for 3 years. She monitors blood glucose 6 times daily. Her A1c is 7.2%. She presents for routine prophylaxis with no active periodontal disease. What describes the insulin pump's mechanism?",
      options: [
        "Delivers programmed basal rate continuously with bolus doses for meals via subcutaneous catheter",
        "Provides single daily dose of long-acting insulin eliminating need for mealtime injections",
        "Administers insulin orally through dissolvable tablets released on a timed schedule",
        "Injects intermediate-acting insulin automatically every 6 hours based on glucose sensor readings",
      ],
      correct: "A"
    },
    {
      id: 30111,
      question: "A patient taking glyburide (sulfonylurea) for type 2 diabetes presents for continued care. She reports occasional episodes of shakiness and sweating between meals that resolve with eating. What medication side effect is she experiencing?",
      options: [
        "Hyperglycemia from inadequate medication dosage requiring increased sulfonylurea dose",
        "Hypoglycemia as sulfonylureas increase insulin secretion potentially causing low blood glucose",
        "Diabetic ketoacidosis from sulfonylurea-induced beta cell destruction in the pancreas",
        "Gestational diabetes triggered by oral hypoglycemic medication during reproductive years",
      ],
      correct: "B"
    },
    {
      id: 30112,
      question: "A 48-year-old patient with type 2 diabetes managed with metformin has generalized moderate periodontitis. His A1c is 8.5%. Scaling and root planing is planned for all quadrants. What effect might periodontal therapy have on his diabetes?",
      options: [
        "No effect as periodontal disease and diabetes are completely independent conditions",
        "Worsening glycemic control as periodontal treatment increases systemic inflammation temporarily",
        "Potential reduction in A1c levels through decreased systemic inflammation from periodontal therapy",
        "Immediate cure of type 2 diabetes once all periodontal inflammation is eliminated",
      ],
      correct: "C"
    },
    {
      id: 30113,
      question: "A 15-year-old patient was diagnosed with type 1 diabetes 6 months ago. His mother asks why he needs insulin injections while her father with type 2 diabetes takes pills. What is the BEST explanation?",
      options: [
        "Type 1 diabetes results from autoimmune destruction of beta cells causing total insulin deficiency",
        "Type 2 diabetes is more severe requiring stronger oral medications instead of insulin",
        "Type 1 diabetes responds to diet changes while type 2 requires lifelong insulin replacement",
        "Insulin injections are only temporary until the pancreas recovers beta cell function",
      ],
      correct: "A"
    },
    {
      id: 30114,
      question: "A patient with diabetes reports his physician prescribed sitagliptin (Januvia), a DPP-4 inhibitor. He asks how this medication works differently from his previous sulfonylurea. What is the mechanism of DPP-4 inhibitors?",
      options: [
        "Blocks resorption of glucose in the kidneys promoting urinary glucose excretion",
        "Decreases glucose production by liver and increases insulin sensitivity in tissues",
        "Reduces glucagon secretion and increases insulin secretion in response to meals",
        "Stimulates pancreatic beta cells to produce maximum insulin regardless of glucose levels",
      ],
      correct: "C"
    },
    {
      id: 30115,
      question: "During examination of a patient with poorly controlled diabetes (A1c 10.2%), the dental hygienist notes bilateral parotid gland swelling, xerostomia, and increased salivary viscosity. What explains these salivary gland changes?",
      options: [
        "Acute bacterial infection of parotid glands requiring immediate antibiotic therapy",
        "Increased fatty acid deposition and compensatory hypertrophy from decreased saliva production",
        "Autoimmune destruction of salivary tissue similar to Sjögren's syndrome presentation",
        "Viral infection causing mumps-like symptoms associated with hyperglycemia states",
      ],
      correct: "B"
    },
    {
      id: 30116,
      question: "A patient with type 2 diabetes takes metformin 1000mg twice daily. Her blood glucose today is 85 mg/dL. She ate breakfast 2 hours ago and feels fine. She is scheduled for scaling and root planing. What is the appropriate action?",
      options: [
        "Postpone treatment as blood glucose under 100 mg/dL indicates dangerous hypoglycemia",
        "Proceed with planned treatment as this represents normal blood glucose control",
        "Provide glucose immediately as metformin commonly causes severe hypoglycemic episodes",
        "Refer to physician for emergency evaluation of suspected hypoglycemic unawareness",
      ],
      correct: "B"
    },
    {
      id: 30117,
      question: "A 50-year-old obese patient with no diabetes diagnosis presents with periodontitis. Risk assessment reveals family history of type 2 diabetes, sedentary lifestyle, and hypertension (142/88 mm Hg). What screening approach is indicated?",
      options: [
        "No screening needed as the patient has no symptoms suggesting diabetes presence",
        "Administer diabetes risk test and consider chairside A1c testing or physician referral",
        "Wait until patient develops classic symptoms before suggesting any diabetes screening",
        "Prescribe oral hypoglycemic medication preventively to avoid diabetes development",
      ],
      correct: "B"
    },
    {
      id: 30118,
      question: "A patient with type 1 diabetes reports his last A1c was 7.0%. He asks what this value means for his diabetes control. What is the BEST explanation of A1c?",
      options: [
        "A1c measures current blood glucose and reflects control over the past 24 hours",
        "A1c reflects average blood glucose control over the past 2-3 months from hemoglobin glycation",
        "A1c indicates insulin resistance and is only meaningful for type 2 diabetes management",
        "A1c measures pancreatic beta cell function and predicts future diabetes complications",
      ],
      correct: "B"
    },
    {
      id: 30119,
      question: "A pregnant patient at 32 weeks with gestational diabetes controlled by diet presents for periodontal maintenance. Her fasting blood glucose today is 95 mg/dL. She has mild gingivitis. What statement about gestational diabetes is correct?",
      options: [
        "Gestational diabetes indicates pre-existing type 2 diabetes that was undiagnosed before pregnancy",
        "The condition results from normal anti-insulin effects of pregnancy hormones and glucose diversion to fetus",
        "Gestational diabetes always requires insulin therapy as oral medications are ineffective during pregnancy",
        "The condition has no relationship to glucose metabolism and resolves immediately after delivery",
      ],
      correct: "B"
    },
    {
      id: 30120,
      question: "A patient with type 2 diabetes asks why his dentist is concerned about his periodontal disease when he sees his physician regularly for diabetes management. What describes the two-way relationship?",
      options: [
        "Diabetes increases periodontitis risk by 24%; periodontitis increases diabetes risk by 26%",
        "Periodontal disease causes diabetes but diabetes has no effect on periodontal disease",
        "Both conditions share genetic factors but have no direct pathophysiologic relationship",
        "Diabetes prevents periodontal disease through altered immune response in gingival tissues",
      ],
      correct: "A"
    },
    {
      id: 30121,
      question: "A 72-year-old patient with type 2 diabetes reports taking canagliflozin (Invokana), an SGLT2 inhibitor. He asks about side effects to watch for with this medication. What potential side effect should be discussed?",
      options: [
        "Severe hypoglycemia requiring emergency glucagon administration and hospitalization",
        "Diabetic ketoacidosis from excessive insulin production by pancreatic beta cells",
        "Yeast and urinary tract infections from increased glucose in urinary system",
        "Weight gain and fluid retention leading to congestive heart failure development",
      ],
      correct: "C"
    },
    {
      id: 30122,
      question: "A patient with type 1 diabetes for 25 years presents for emergency care with a painful tooth. Examination reveals a periapical abscess. His blood glucose is 310 mg/dL and he reports feeling unwell. What is the MOST appropriate management?",
      options: [
        "Proceed with endodontic therapy immediately to eliminate infection source today",
        "Extract the tooth under local anesthesia to remove infection source quickly",
        "Prescribe antibiotics, provide palliative care, and refer to physician before definitive treatment",
        "Perform scaling and root planing of entire mouth to address all potential infection sources",
      ],
      correct: "C"
    },
    {
      id: 30123,
      question: "A patient with well-controlled type 2 diabetes (A1c 6.9%) has completed nonsurgical periodontal therapy. Reevaluation shows improved probing depths and reduced bleeding on probing. What explains the positive response to therapy?",
      options: [
        "Diabetes prevents normal healing so improvement indicates misdiagnosis of diabetes",
        "Well-controlled diabetes allows response to periodontal therapy similar to non-diabetic patients",
        "Type 2 diabetes enhances healing through increased growth factor production",
        "Oral hypoglycemic medications have antibiotic effects improving periodontal outcomes",
      ],
      correct: "B"
    },
    {
      id: 30124,
      question: "During health history review, a patient reports taking pramlintide (Symlin) before meals in addition to mealtime insulin for type 1 diabetes management. What is the function of pramlintide?",
      options: [
        "Increases insulin production by stimulating remaining functional pancreatic beta cells",
        "Blocks glucose reabsorption in kidneys promoting glucose excretion in urine",
        "Modulates gastric emptying as an analog of human amylin for glucose control",
        "Decreases hepatic glucose production and increases peripheral insulin sensitivity",
      ],
      correct: "C"
    },
    {
      id: 30125,
      question: "A 38-year-old patient with type 1 diabetes suddenly becomes unconscious during treatment. Blood glucose reading is 45 mg/dL. She cannot swallow. What is the appropriate emergency management?",
      options: [
        "Administer 15 grams oral glucose and wait 15 minutes for patient to regain consciousness",
        "Give 1 mg glucagon intramuscularly or subcutaneously and activate emergency medical services",
        "Place glucose gel under tongue and continue monitoring until consciousness returns",
        "Provide 4 ounces orange juice via straw positioned in unconscious patient's mouth",
      ],
      correct: "B"
    },
    {
      id: 30126,
      question: "A patient with type 2 diabetes asks about the relationship between periodontal disease grade and his diabetes control. His A1c is 7.8%. How does diabetes affect periodontitis grading?",
      options: [
        "Diabetes has no effect on periodontitis grading as grade is determined solely by bone loss",
        "HbA1c ≥7% may shift the periodontitis grade to Grade C indicating rapid rate of progression",
        "Any diabetes diagnosis automatically results in Grade A classification regardless of control",
        "Only type 1 diabetes affects grading; type 2 diabetes is not considered in staging or grading",
      ],
      correct: "B"
    },
    {
      id: 30127,
      question: "A patient with diabetes presents with burning sensation in her mouth, altered taste, and oral erythema. Examination reveals white patches that can be wiped off leaving red areas. What oral complication is present?",
      options: [
        "Oral lichen planus from autoimmune reaction associated with diabetes",
        "Aphthous ulceration from stress and immunosuppression in diabetic state",
        "Candidiasis (thrush) from fungal overgrowth related to hyperglycemia",
        "Median rhomboid glossitis from papillary atrophy on dorsal tongue surface",
      ],
      correct: "C"
    },
    {
      id: 30128,
      question: "A 55-year-old patient reports his physician diagnosed prediabetes (A1c 6.2%) last month. He is overweight and has a family history of type 2 diabetes. He asks about his prognosis. What information should be provided?",
      options: [
        "Prediabetes always progresses to type 2 diabetes within 5 years regardless of interventions",
        "Lifestyle interventions including exercise, weight loss, and diet can delay or prevent type 2 diabetes",
        "Prediabetes requires immediate insulin therapy to prevent irreversible beta cell destruction",
        "Prediabetes indicates type 1 diabetes development and requires autoantibody testing",
      ],
      correct: "B"
    },
    {
      id: 30129,
      question: "A patient with type 2 diabetes managed with metformin and diet presents for periodontal maintenance. Her blood glucose today is 205 mg/dL. She ate breakfast 1 hour ago and reports feeling fine. What is the MOST appropriate action?",
      options: [
        "Proceed cautiously with treatment while monitoring patient closely for hyperglycemic symptoms",
        "Postpone all dental hygiene treatment until blood glucose decreases below 200 mg/dL",
        "Administer insulin immediately to lower blood glucose before beginning treatment",
        "Continue with planned treatment as this represents normal postprandial blood glucose elevation",
      ],
      correct: "B"
    },
    {
      id: 30130,
      question: "A 28-year-old patient was diagnosed with type 1 diabetes 10 years ago. Genetic testing revealed specific human leukocyte antigens (HLA). She asks why genetic testing was performed. What is the relationship between HLA and type 1 diabetes?",
      options: [
        "HLA testing diagnoses type 2 diabetes by identifying insulin resistance genetic markers",
        "Certain HLA types influence immune activity against pancreatic islet cells in type 1 diabetes",
        "HLA determines insulin dosage requirements for optimal glycemic control in all diabetes types",
        "HLA testing predicts gestational diabetes risk in women planning pregnancy",
      ],
      correct: "B"
    },
    {
      id: 30131,
      question: "A patient with poorly controlled type 2 diabetes (A1c 9.8%) presents with acute periodontal abscess. His physician wants to delay dental treatment until glycemic control improves. Why is delaying treatment appropriate?",
      options: [
        "Periodontal treatment has no effect on diabetes so timing is irrelevant to outcomes",
        "Infection is the most common precipitating factor for ketoacidosis requiring infection control first",
        "Dental treatment always causes hypoglycemia in patients with any level of diabetes control",
        "Well-controlled diabetes is required to prevent dental caries but not periodontal disease",
      ],
      correct: "B"
    },
    {
      id: 30132,
      question: "During examination of a patient with diabetes, the dental hygienist notes multiple cervical caries, particularly on root surfaces. The patient reports dry mouth and difficulty with denture retention. What explains this caries pattern?",
      options: [
        "Xerostomia from diabetes medications reduces saliva flow; increased salivary glucose increases caries risk",
        "Hyperglycemia directly causes enamel demineralization independent of bacterial activity",
        "Diabetes medications contain high sugar content causing increased caries on root surfaces",
        "Insulin injections alter salivary pH making the oral environment more acidogenic",
      ],
      correct: "A"
    },
    {
      id: 30133,
      question: "A patient with type 1 diabetes is scheduled for scaling and root planing requiring local anesthesia. His diabetes is well-controlled (A1c 6.8%, blood glucose 110 mg/dL today). What local anesthetic consideration is appropriate?",
      options: [
        "Avoid all vasoconstrictors completely as epinephrine raises blood glucose in diabetic patients",
        "Use minimal vasoconstrictor at lowest effective concentration since epinephrine can raise glucose",
        "Use maximum vasoconstrictor dose to ensure profound anesthesia preventing stress hyperglycemia",
        "Vasoconstrictors have no effect on blood glucose so use standard doses per dental indication",
      ],
      correct: "B"
    },
    {
      id: 30134,
      question: "A 16-year-old patient was recently diagnosed with type 1 diabetes. His dentist recommends annual oral examinations for early signs of periodontal involvement. At what age should annual exams for periodontal screening begin?",
      options: [
        "Immediately at diabetes diagnosis regardless of patient age due to infection risk",
        "Starting at age 6 years for children and adolescents diagnosed with diabetes",
        "At age 18 when permanent dentition is complete and periodontitis can develop",
        "Only after patient develops symptoms of periodontal disease such as bleeding gums",
      ],
      correct: "B"
    },
    {
      id: 30135,
      question: "A patient with type 2 diabetes controlled with oral medications reports her physician added exenatide (Byetta) injections. She asks how this medication differs from insulin. What describes exenatide's mechanism?",
      options: [
        "Exenatide is synthetic insulin with longer duration of action for once-weekly dosing",
        "Exenatide is a GLP-1 receptor agonist that stimulates incretin effect increasing insulin response",
        "Exenatide blocks renal glucose reabsorption promoting urinary glucose excretion",
        "Exenatide is oral hypoglycemic agent in injectable form for improved absorption",
      ],
      correct: "B"
    },
    {
      id: 30136,
      question: "A patient with diabetes develops acute pulpitis. Examination reveals extensive caries and periapical radiolucency. The patient asks why the tooth problem developed so quickly. What diabetes-related factor contributes to pulpal complications?",
      options: [
        "Pulpal arteritis from microangiopathies causes unexplained odontalgia and percussion sensitivity",
        "Hyperglycemia directly infects pulp tissue with glucose-metabolizing bacteria",
        "Diabetes medications accumulate in dental pulp causing inflammatory response",
        "Insulin deficiency prevents dentin formation allowing rapid caries penetration to pulp",
      ],
      correct: "A"
    },
    {
      id: 30137,
      question: "A patient taking pioglitazone (Actos), a thiazolidinedione, for type 2 diabetes presents for continued care. He asks about his medication's mechanism of action. How do thiazolidinediones work?",
      options: [
        "Increase pancreatic insulin secretion by stimulating beta cell activity throughout the day",
        "Block intestinal carbohydrate digestion enzymes delaying glucose absorption after meals",
        "Make body tissues more sensitive to insulin action improving glucose uptake by cells",
        "Decrease glucose production by liver through inhibition of gluconeogenesis pathways",
      ],
      correct: "C"
    },
    {
      id: 30138,
      question: "A 65-year-old patient with type 2 diabetes for 15 years reports numbness in his feet and hands. He has difficulty feeling when his hands are cold or hot. His A1c is 8.9%. What chronic complication is indicated?",
      options: [
        "Acute hypoglycemia causing temporary neurologic symptoms that resolve with glucose",
        "Diabetic retinopathy affecting visual processing of sensory information",
        "Peripheral neuropathy from chronic hyperglycemia causing impaired sensation in extremities",
        "Nephropathy causing electrolyte imbalances affecting nerve conduction",
      ],
      correct: "C"
    },
    {
      id: 30139,
      question: "A patient with diabetes had extraction of tooth #19 two weeks ago. The socket has not healed and appears inflamed. His blood glucose readings average 220 mg/dL. What explains the delayed healing?",
      options: [
        "Hyperglycemia reduces phagocytic activity and causes abnormal collagen production",
        "Diabetes causes excessive healing with hyperplastic tissue formation in extraction sites",
        "Insulin therapy prevents normal clot formation leading to dry socket development",
        "Oral hypoglycemic medications are cytotoxic to oral tissues preventing healing",
      ],
      correct: "A"
    },
    {
      id: 30140,
      question: "A patient with well-controlled type 1 diabetes (A1c 6.9%) completed nonsurgical periodontal therapy 6 months ago. Reevaluation shows 2 mm probing depth reduction and decreased bleeding on probing. What explains this positive long-term response?",
      options: [
        "Type 1 diabetes always prevents positive periodontal treatment response regardless of control",
        "With good glycemic control, diabetic patients have similar long-term periodontal outcomes as non-diabetics",
        "Insulin therapy has direct antimicrobial effects that eliminate periodontal pathogens",
        "The 6-month timeframe is too short to evaluate periodontal response in diabetic patients",
      ],
      correct: "B"
    },
    {
      id: 30141,
      question: "A 42-year-old obese patient with type 2 diabetes asks about weight loss goals. His current BMI is 34 kg/m² and his A1c is 8.2%. He wants to improve his diabetes control. What weight loss goal is associated with benefits for glycemic control?",
      options: [
        "Any weight loss under 3% has no effect on glycemic control in type 2 diabetes",
        "Weight loss of 5% is associated with glycemic control benefits; 15% may have maximum effect",
        "Weight loss is not recommended for type 2 diabetes as it worsens insulin resistance",
        "Only weight loss exceeding 30% of body weight produces meaningful diabetes improvement",
      ],
      correct: "B"
    },
    {
      id: 30142,
      question: "A patient with type 2 diabetes reports taking acarbose (Precose) before meals. She asks why this medication is taken with food rather than at bedtime. What is the mechanism of alpha-glucosidase inhibitors?",
      options: [
        "Stimulate immediate insulin release from pancreas requiring glucose present from meal",
        "Inhibit enzymes in small intestine that digest carbohydrates thereby delaying glucose absorption",
        "Block glucose reabsorption in kidney tubules promoting excretion during postprandial period",
        "Increase insulin sensitivity in muscle tissue which is most responsive after eating",
      ],
      correct: "B"
    },
    {
      id: 30143,
      question: "A patient with diabetes presents with gingival bleeding during probing. She asks if her periodontal disease could be making her diabetes harder to control. What information should be provided?",
      options: [
        "Periodontal disease has no effect on diabetes control as the conditions are independent",
        "Severe periodontitis is associated with poor glycemic control and increased A1c levels",
        "Periodontal disease improves diabetes control by stimulating immune system activity",
        "Only dental caries affects diabetes; periodontal disease has no systemic effects",
      ],
      correct: "B"
    },
    {
      id: 30144,
      question: "A pregnant patient diagnosed with gestational diabetes at 28 weeks is now 6 weeks postpartum. She asks if she still has diabetes and needs continued monitoring. What information should be provided?",
      options: [
        "Gestational diabetes always resolves immediately after delivery with no further risk",
        "She should be reclassified as having diabetes, prediabetes, or normal glucose regulation",
        "Gestational diabetes converts to type 1 diabetes in all cases requiring insulin therapy",
        "No follow-up testing is needed as gestational diabetes cannot recur in future pregnancies",
      ],
      correct: "B"
    },
    {
      id: 30145,
      question: "A patient with type 1 diabetes reports her identical twin sister was recently diagnosed with type 1 diabetes. She asks about her other siblings' risk. What is the genetic risk for type 1 diabetes in identical twins?",
      options: [
        "If one identical twin develops type 1 diabetes, the other has approximately 50% chance of developing it",
        "Identical twins have 100% concordance rate meaning both will always develop type 1 diabetes",
        "Type 1 diabetes has no genetic component so twin status does not affect risk",
        "Only fraternal twins share genetic risk; identical twins have independent diabetes risk",
      ],
      correct: "A"
    },
    {
      id: 30146,
      question: "A 70-year-old patient with type 2 diabetes takes multiple medications including insulin. During treatment, he becomes confused and sweaty. His blood glucose is 55 mg/dL but he denies typical hypoglycemia symptoms. What condition is suggested?",
      options: [
        "Normal aging changes that do not require intervention or glucose administration",
        "Hypoglycemic unawareness from long-standing diabetes and autonomic neuropathy",
        "Hyperglycemia causing confusion despite low glucose meter reading indicating device error",
        "Diabetic ketoacidosis with neurologic symptoms requiring immediate hospitalization",
      ],
      correct: "B"
    },
    {
      id: 30147,
      question: "A patient with poorly controlled type 2 diabetes (A1c 10.5%) presents with bilateral parotid enlargement, multiple carious lesions, and candidiasis. She reports chronic dry mouth. What preventive interventions are indicated?",
      options: [
        "Discontinue all diabetes medications temporarily until oral conditions improve",
        "Prescribe antifungal therapy, fluoride treatments, antimicrobial rinse, and saliva substitutes",
        "Extract all carious teeth to eliminate infection sources before treating candidiasis",
        "Avoid all preventive treatments until diabetes is controlled to prevent complications",
      ],
      correct: "B"
    },
    {
      id: 30148,
      question: "A patient with type 1 diabetes asks why he needs to check his blood glucose 6-8 times daily when his physician checks A1c every 3 months. What explains the different purposes of these tests?",
      options: [
        "Blood glucose and A1c measure identical parameters so either test alone is sufficient",
        "Blood glucose examines current level affected by recent intake; A1c examines 2-3 month average control",
        "A1c is more accurate than blood glucose so daily monitoring is unnecessary",
        "Blood glucose predicts future complications; A1c only diagnoses diabetes initially",
      ],
      correct: "B"
    },
    {
      id: 30149,
      question: "A patient with type 2 diabetes managed with metformin has generalized moderate periodontitis. His physician asks if periodontal treatment might help his diabetes control. What evidence supports this inquiry?",
      options: [
        "Several meta-analyses confirm periodontal therapy can reduce A1c levels in patients with diabetes",
        "Periodontal treatment has no effect on diabetes control in any published research studies",
        "Periodontal therapy worsens glycemic control by increasing systemic inflammation long-term",
        "Only surgical periodontal treatment affects A1c; nonsurgical therapy has no metabolic effects",
      ],
      correct: "A"
    },
    {
      id: 30150,
      question: "A patient with type 1 diabetes reports using inhaled insulin (Afrezza) before meals. She asks about the onset and duration compared to her previous rapid-acting injectable insulin. What are the characteristics of inhaled insulin?",
      options: [
        "Onset 30 minutes, peak 2-3 hours, duration 6-8 hours similar to regular insulin",
        "Onset 12-15 minutes, peak 30 minutes, duration 3 hours faster than injectable rapid-acting",
        "Onset 2-4 hours, peak 4-12 hours, duration 12-18 hours similar to intermediate-acting",
        "Onset several hours, no peak, duration up to 24 hours similar to long-acting insulin",
      ],
      correct: "B"
    },
    {
      id: 30151,
      question: "During examination, a patient with diabetes mentions she has been experiencing frequent yeast infections and urinary tract infections since starting her new diabetes medication. What medication class is MOST likely responsible?",
      options: [
        "Sulfonylureas that increase insulin secretion from pancreatic beta cells",
        "SGLT2 inhibitors that block glucose reabsorption in the kidneys",
        "DPP-4 inhibitors that reduce glucagon secretion and increase insulin release",
        "Thiazolidinediones that increase insulin sensitivity in peripheral tissues",
      ],
      correct: "B"
    },
    {
      id: 30152,
      question: "A patient with type 2 diabetes controlled with lifestyle modifications alone (A1c 6.5%) has mild gingivitis. She asks about the frequency of dental visits. What maintenance interval is appropriate?",
      options: [
        "Annual visits only since diabetes is controlled and periodontal disease is not present",
        "Frequent maintenance visits (3-4 month intervals) to monitor oral health and diabetes relationship",
        "Every 5 years unless symptoms develop since well-controlled diabetes prevents oral disease",
        "Monthly visits indefinitely as diabetes always causes rapid periodontal disease progression",
      ],
      correct: "B"
    },
    {
      id: 30153,
      question: "A 45-year-old patient reports his physician diagnosed diabetes after finding an A1c of 6.8%. He has no symptoms and questions the diagnosis. What A1c value indicates diabetes?",
      options: [
        "A1c of 5.7% to 6.4% indicates diabetes requiring immediate treatment",
        "A1c of 6.5% or greater indicates diabetes; 5.7% to 6.4% indicates prediabetes",
        "Any A1c above 5.0% diagnoses diabetes in all patient populations",
        "A1c cannot diagnose diabetes; only fasting blood glucose is diagnostic",
      ],
      correct: "B"
    },
    {
      id: 30154,
      question: "A patient with gestational diabetes at 30 weeks gestation presents for periodontal maintenance. Her obstetrician confirmed she is managing the condition well with diet. Her blood glucose today is 102 mg/dL. What statement about treatment is correct?",
      options: [
        "All dental treatment must be postponed until after delivery due to gestational diabetes",
        "Dental hygiene care can proceed as her diabetes is controlled and she is in second trimester",
        "Prophylactic antibiotics are required for all dental procedures during gestational diabetes",
        "Only emergency dental care is permitted during pregnancy in patients with gestational diabetes",
      ],
      correct: "B"
    },
    {
      id: 30155,
      question: "A patient with type 2 diabetes develops signs of ketoacidosis including fruity breath, rapid deep breathing, and confusion. His blood glucose is 485 mg/dL. What is the MOST appropriate emergency action?",
      options: [
        "Administer 15 grams oral glucose and recheck blood glucose in 15 minutes",
        "Give 1 mg glucagon intramuscularly to rapidly lower blood glucose level",
        "Activate emergency medical services for hospital treatment of ketoacidosis",
        "Provide insulin injection from office emergency kit to normalize blood glucose",
      ],
      correct: "C"
    },
    {
      id: 30156,
      question: "A patient with diabetes asks about diet recommendations that benefit both diabetes control and oral health. What nutritional counseling is appropriate?",
      options: [
        "High-sugar diet improves diabetes control but increases caries risk creating conflicting goals",
        "Limit carbohydrates with added sugars/refined grains; eat whole grains, fruits, vegetables for both conditions",
        "High-sodium diet helps diabetes management but promotes periodontal disease progression",
        "Diabetes and oral health have completely contradictory dietary requirements preventing optimization",
      ],
      correct: "B"
    },
    {
      id: 30157,
      question: "A patient with type 1 diabetes reports frequently forgetting insulin doses. His A1c is 11.2% and he has multiple oral infections. He states he doesn't understand why his diabetes matters for dental treatment. What patient education is MOST important?",
      options: [
        "Diabetes only affects systemic health and has no relationship to oral disease development",
        "Hyperglycemia increases infection risk, impairs healing, and makes diabetes control more difficult",
        "Oral infections never affect diabetes control so dental treatment can be postponed indefinitely",
        "Insulin doses don't affect oral health so medication compliance is not relevant to dental care",
      ],
      correct: "B"
    },
    {
      id: 30158,
      question: "A patient taking insulin detemir (Levemir) asks why she also needs rapid-acting insulin at meals when she takes long-acting insulin daily. What explains the need for multiple insulin types?",
      options: [
        "Long-acting insulin provides basal coverage; rapid-acting insulin addresses mealtime glucose spikes",
        "Rapid-acting insulin is backup medication used only when long-acting insulin fails to work",
        "Using both types is unnecessary; patients only need one insulin type for diabetes control",
        "Long-acting insulin treats type 1 diabetes; rapid-acting insulin treats type 2 diabetes",
      ],
      correct: "A"
    },
    {
      id: 30159,
      question: "A 55-year-old patient with type 2 diabetes has sleep apnea and reports poor sleep quality. His A1c has increased from 7.2% to 8.5% over 6 months despite medication compliance. What relationship exists between sleep disorders and diabetes?",
      options: [
        "Sleep disorders have no relationship to diabetes development or glycemic control",
        "Sleep disturbances may impede meeting glycemic targets among people with diabetes",
        "Sleep apnea prevents diabetes development by altering metabolic hormone secretion",
        "Poor sleep improves insulin sensitivity making diabetes easier to control",
      ],
      correct: "B"
    },
    {
      id: 30160,
      question: "A patient with diabetes presents for scaling and root planing. His physician recommends administering preprocedural antimicrobial rinse before tissue manipulation. What is the rationale for preprocedural rinsing?",
      options: [
        "Antimicrobial rinse eliminates all oral bacteria completely preventing bacteremia during procedures",
        "Preprocedural rinsing reduces oral bacterial counts potentially decreasing bacteremia severity",
        "Antimicrobial rinse stimulates immune response preventing infection in diabetic patients",
        "Preprocedural rinsing has no effect on bacteremia and is not recommended for patients",
      ],
      correct: "B"
    },
    {
      id: 30161,
      question: "A 60-year-old patient with type 2 diabetes and chronic kidney disease is scheduled for periodontal debridement requiring local anesthesia. What consideration is important regarding kidney disease?",
      options: [
        "Kidney disease prevents local anesthetic metabolism requiring dose reduction for safety",
        "Medications excreted by kidneys may be retained causing toxicity in patients with kidney disease",
        "Chronic kidney disease eliminates need for local anesthesia due to uremic neuropathy",
        "Kidney disease requires prophylactic antibiotics before any dental hygiene procedures",
      ],
      correct: "B"
    },
    {
      id: 30162,
      question: "A patient with newly diagnosed prediabetes (A1c 6.0%, fasting glucose 108 mg/dL) asks if he needs medication to prevent diabetes progression. What pharmacologic intervention may be indicated?",
      options: [
        "Insulin therapy for all prediabetic patients to preserve pancreatic beta cell function",
        "Metformin for those with BMI >35 kg/m², age <60 years, or females with prior gestational diabetes",
        "Sulfonylureas for all patients with fasting glucose above 100 mg/dL regardless of age",
        "No medications are effective for preventing progression from prediabetes to type 2 diabetes",
      ],
      correct: "B"
    },
    {
      id: 30163,
      question: "A patient with type 1 diabetes mentions she had multiple severe hypoglycemic episodes last year requiring emergency treatment. She presents today for routine prophylaxis. What appointment modification is MOST important?",
      options: [
        "Proceed with routine care as hypoglycemic history does not affect current treatment planning",
        "Verify blood glucose before and monitor during appointment; have glucose readily available",
        "Postpone all dental care indefinitely until patient has no hypoglycemic episodes for 5 years",
        "Provide treatment only under general anesthesia in hospital setting due to emergency risk",
      ],
      correct: "B"
    },
    {
      id: 30164,
      question: "A patient with type 2 diabetes has periodontal disease. She asks if controlling her periodontal disease will help control her diabetes. What information is accurate?",
      options: [
        "Periodontal treatment has no effect on diabetes since the conditions are completely independent",
        "Severe periodontitis may be a risk factor in diabetes onset; treatment may improve glycemic control",
        "Periodontal disease cures diabetes once all inflammation is eliminated from oral tissues",
        "Only tooth extraction improves diabetes control; nonsurgical periodontal therapy has no effect",
      ],
      correct: "B"
    },
    {
      id: 30165,
      question: "A pregnant patient with gestational diabetes asks about her children's risk of developing diabetes. She has no previous diabetes history before this pregnancy. What information about offspring risk is accurate?",
      options: [
        "Children have no increased diabetes risk since gestational diabetes is not hereditary",
        "Children of mothers with gestational diabetes have increased risk for obesity and type 2 diabetes",
        "All children born to mothers with gestational diabetes will develop type 1 diabetes by age 10",
        "Only male children are at risk; female children have normal diabetes risk",
      ],
      correct: "B"
    },
    {
      id: 30166,
      question: "A patient with type 1 diabetes reports wearing a continuous glucose monitor (CGM). She asks how this differs from traditional finger-stick testing. What describes continuous glucose monitoring?",
      options: [
        "CGM measures glucose in interstitial fluid continuously; finger-stick tests blood glucose at specific times",
        "CGM and finger-stick testing measure identical parameters with no difference in monitoring",
        "CGM is less accurate than finger-stick testing and should never be used for treatment decisions",
        "CGM measures A1c levels continuously while finger-stick tests measure blood glucose only",
      ],
      correct: "A"
    },
    {
      id: 30167,
      question: "A 35-year-old patient with polycystic ovary syndrome (PCOS) presents for new patient examination. She has no diabetes diagnosis but is overweight with family history of type 2 diabetes. What diabetes screening approach is indicated?",
      options: [
        "No screening needed until patient reaches age 45 when routine screening begins for all adults",
        "Screen now as PCOS is a risk factor; test at younger age for adults with risk factors",
        "Wait until patient develops symptoms of hyperglycemia before any testing occurs",
        "PCOS has no relationship to diabetes risk so standard age-based screening applies",
      ],
      correct: "B"
    },
    {
      id: 30168,
      question: "A patient with type 2 diabetes controlled with diet and exercise alone (A1c 6.4%) presents for continued care. She has no periodontal disease. Her blood glucose today is 95 mg/dL. What describes her diabetes management classification?",
      options: [
        "Poorly controlled diabetes requiring immediate physician referral and treatment modifications",
        "Well-controlled diabetes allowing safe dental hygiene care without modifications",
        "Uncontrolled diabetes necessitating postponement of all dental care indefinitely",
        "Gestational diabetes requiring special pregnancy-related treatment protocols",
      ],
      correct: "B"
    },
    {
      id: 30169,
      question: "A patient with diabetes asks why his dentist documented that he has \"diabetes, a modifiable risk factor\" in his periodontal diagnosis. What explains diabetes as a modifiable periodontal risk factor?",
      options: [
        "Diabetes cannot be modified so it should never be listed as a risk factor",
        "Diabetes status and control can be modified affecting periodontal disease grade and progression",
        "Only smoking and oral hygiene are modifiable; diabetes is always a non-modifiable risk",
        "Modifiable means diabetes can be cured through periodontal treatment eliminating the risk",
      ],
      correct: "B"
    },
    {
      id: 30170,
      question: "A patient taking bromocriptine (Cycloset), a dopamine-2 agonist, for type 2 diabetes asks about this medication's purpose. What is the mechanism of dopamine-2 agonists?",
      options: [
        "Stimulates maximum insulin secretion from pancreatic beta cells throughout the day",
        "Blocks renal glucose reabsorption promoting urinary glucose excretion",
        "Helps decrease blood glucose after meals through dopamine receptor modulation",
        "Increases peripheral insulin sensitivity allowing better glucose uptake by tissues",
      ],
      correct: "C"
    },
    {
      id: 30171,
      question: "A patient with type 1 diabetes had dental extraction 3 weeks ago. He reports the site is not healing well. Examination reveals delayed healing with inflammation. His recent blood glucose readings average 195 mg/dL. What explains the delayed healing?",
      options: [
        "Type 1 diabetes always prevents healing regardless of blood glucose control levels",
        "Hyperglycemia causes degenerative vascular changes decreasing blood flow to healing tissues",
        "Insulin therapy prevents normal clot formation in all extraction sites",
        "Dental extractions are contraindicated in type 1 diabetes due to healing impossibility",
      ],
      correct: "B"
    },
    {
      id: 30172,
      question: "A 14-year-old patient was diagnosed with type 1 diabetes 2 years ago. His mother asks about oral care recommendations specific to adolescents with diabetes. What guidance is appropriate?",
      options: [
        "Adolescents with diabetes have same oral care needs as peers without diabetes",
        "Annual oral exams for periodontal screening starting at age 6 for those with diabetes",
        "Dental visits every 5 years are sufficient until age 18 when adult care begins",
        "No special oral care is needed until diabetes complications develop in adulthood",
      ],
      correct: "B"
    },
    {
      id: 30173,
      question: "A patient with well-controlled type 2 diabetes (A1c 6.7%) has localized moderate periodontitis. Treatment plan includes scaling and root planing with possible adjunctive local antimicrobials. What benefit do local antimicrobials provide in diabetic patients?",
      options: [
        "No benefit as antimicrobials are contraindicated in all patients with diabetes",
        "Additional benefits in probing depth reduction and attachment gain, especially in deep sites",
        "Cure diabetes by eliminating all oral bacteria that cause blood glucose elevation",
        "Local antimicrobials prevent hypoglycemia during dental procedures in diabetic patients",
      ],
      correct: "B"
    },
    {
      id: 30174,
      question: "A patient with type 2 diabetes reports his physician added liraglutide (Victoza) to his treatment regimen. He asks how this medication helps diabetes. What describes GLP-1 receptor agonists like liraglutide?",
      options: [
        "Blocks renal glucose reabsorption promoting urinary excretion of excess glucose",
        "Stimulates incretin effect increasing insulin response to meals and slowing gastric emptying",
        "Decreases hepatic glucose production through inhibition of gluconeogenesis pathways",
        "Increases insulin sensitivity in peripheral tissues allowing better cellular glucose uptake",
      ],
      correct: "B"
    },
    {
      id: 30175,
      question: "A patient with gestational diabetes at 28 weeks gestation reports she had gestational diabetes in her previous pregnancy 3 years ago. She asks about her future diabetes risk. What information should be provided?",
      options: [
        "Prior gestational diabetes has no effect on future diabetes risk after pregnancies end",
        "She is at high risk for recurrent gestational diabetes and future type 2 diabetes development",
        "Prior gestational diabetes indicates type 1 diabetes will develop requiring insulin therapy",
        "Gestational diabetes never recurs in subsequent pregnancies once hormones normalize",
      ],
      correct: "B"
    },
    {
      id: 30176,
      question: "A patient with type 1 diabetes for 30 years reports he can no longer feel symptoms when his blood glucose drops too low. His family has noticed confusion during these episodes. What complication is indicated?",
      options: [
        "Normal diabetes progression that requires no intervention or monitoring changes",
        "Hypoglycemic unawareness from long-standing diabetes and autonomic neuropathy",
        "Improved diabetes control eliminating unnecessary warning symptoms from body",
        "Diabetic ketoacidosis with neurologic complications requiring immediate hospitalization",
      ],
      correct: "B"
    },
    {
      id: 30177,
      question: "A patient with poorly controlled type 2 diabetes (A1c 9.5%) asks if he needs antibiotics before his dental hygiene appointment for scaling and root planing. What antibiotic protocol is appropriate?",
      options: [
        "Prophylactic antibiotics required for all patients with any diabetes diagnosis before all dental procedures",
        "Consider prophylactic antibiotics after physician consultation for patients with uncontrolled diabetes",
        "No antibiotics indicated for dental procedures in patients with type 2 diabetes under any circumstances",
        "Antibiotics are only needed if patient also has prosthetic heart valve or joint replacement",
      ],
      correct: "B"
    },
    {
      id: 30178,
      question: "A patient with diabetes presents with median rhomboid glossitis. The area is erythematous, smooth, and rhomboid-shaped on the dorsal midline tongue. What is the etiology of this condition?",
      options: [
        "Bacterial infection from Streptococcus mutans colonization on tongue dorsum",
        "Viral infection from herpes simplex virus reactivation in immunocompromised state",
        "Fungal infection from Candida albicans associated with diabetes and immunocompromise",
        "Traumatic injury from chronic irritation by maxillary central incisors",
      ],
      correct: "C"
    },
    {
      id: 30179,
      question: "A patient with type 1 diabetes asks about the relationship between stress and blood glucose. She has a fear of dental treatment and becomes very anxious during appointments. What explains stress effects on blood glucose?",
      options: [
        "Stress has no effect on blood glucose levels in patients with type 1 diabetes",
        "Stress causes epinephrine release mobilizing glucose from liver glycogen potentially causing hyperglycemia",
        "Anxiety always causes severe hypoglycemia requiring glucose administration before dental treatment",
        "Stress decreases blood glucose through cortisol suppression requiring increased insulin doses",
      ],
      correct: "B"
    }
  ],
  "3. Cancer and Oral Care (Case Study)": [
    {
      id: 30200,
      question: "A 62-year-old male patient presents for routine dental hygiene care. During the oral examination, you notice a painless, non-healing ulceration on the lateral border of his tongue that has been present for 3 weeks. He reports smoking one pack of cigarettes daily for 40 years and consuming 3-4 alcoholic drinks daily. What is the MOST appropriate action?",
      options: [
        "Monitor the lesion at the next 6-month recall appointment to determine if it has changed",
        "Refer immediately to dentist for evaluation and possible biopsy of the suspicious lesion",
        "Apply topical fluoride to the area and instruct patient to rinse with salt water",
        "Recommend over-the-counter topical anesthetic and schedule follow-up in 3 months",
      ],
      correct: "B"
    },
    {
      id: 30201,
      question: "A 45-year-old female patient recently diagnosed with breast cancer is referred by her oncologist before starting chemotherapy in 2 weeks. Clinical examination reveals a carious maxillary premolar with periapical radiolucency, moderate plaque and calculus, and mild gingivitis. What is the treatment priority before chemotherapy begins?",
      options: [
        "Provide routine prophylaxis and schedule the patient for a 3-month recall appointment",
        "Complete dental treatment including extraction, periodontal therapy, and fabricate fluoride trays",
        "Postpone all dental treatment until after chemotherapy is completed to avoid complications",
        "Provide only emergency care and wait until patient completes cancer treatment",
      ],
      correct: "B"
    },
    {
      id: 30202,
      question: "A patient undergoing radiation therapy for oral cancer complains of severe dry mouth. She reports difficulty eating and speaking. Examination reveals thick, ropy saliva and multiple areas of demineralization on tooth surfaces. What is the PRIMARY cause of xerostomia in this patient?",
      options: [
        "Temporary medication side effect that will resolve when radiation therapy is completed",
        "Psychological stress and anxiety related to cancer diagnosis causing reduced saliva production",
        "Permanent damage to salivary gland tissue from ionizing radiation causing fibrosis and atrophy",
        "Dehydration from inadequate fluid intake during radiation treatment reducing salivary output",
      ],
      correct: "C"
    },
    {
      id: 30203,
      question: "A 28-year-old male patient presents with a cauliflower-like lesion in the oropharyngeal area. He reports having multiple sexual partners and inconsistent condom use. He has not received HPV vaccination. What virus is MOST commonly associated with oropharyngeal cancers?",
      options: [
        "Epstein-Barr virus (EBV) causing infectious mononucleosis and lymphatic system involvement",
        "Human papillomavirus (HPV) types 16 and 18 causing high-risk carcinogenic changes",
        "Herpes simplex virus (HSV) type 1 causing recurrent oral lesions and ulcerations",
        "Cytomegalovirus (CMV) causing immunosuppression and opportunistic oral infections",
      ],
      correct: "B"
    },
    {
      id: 30204,
      question: "A patient completed chemotherapy 3 days ago and presents for continued dental hygiene care. She reports painful oral ulcerations making it difficult to eat. Examination reveals multiple erythematous areas with ulcerations on buccal mucosa and soft palate. What condition is the patient experiencing?",
      options: [
        "Oral candidiasis from fungal overgrowth due to immunosuppression during chemotherapy",
        "Herpes simplex virus reactivation causing vesicular lesions that rupture into ulcers",
        "Oral mucositis from direct cytotoxic effects of chemotherapy on rapidly dividing epithelial cells",
        "Traumatic ulcerations from aggressive toothbrushing techniques during cancer treatment",
      ],
      correct: "C"
    },
    {
      id: 30205,
      question: "A patient with oral cancer is scheduled to begin external-beam radiation therapy to the head and neck area in 3 weeks. The treatment plan includes 7 weeks of daily radiation treatments. What percentage of patients receiving oral radiation therapy develop mucositis?",
      options: [
        "Approximately 25% of patients develop mild mucositis during radiation therapy",
        "Approximately 40% of patients develop moderate mucositis requiring intervention",
        "Approximately 80% of patients develop severe mucositis necessitating treatment modification",
        "Approximately 100% of patients develop some degree of mucositis during treatment",
      ],
      correct: "D"
    },
    {
      id: 30206,
      question: "A 58-year-old patient completed radiation therapy for tongue cancer 6 months ago. She returns for continued care and reports using her custom fluoride trays daily. Examination reveals multiple new carious lesions on cervical areas of several teeth. What factor contributes MOST to radiation-related caries?",
      options: [
        "Increased consumption of sugary foods to combat altered taste sensation during recovery",
        "Decreased salivary flow limiting calcium/phosphate availability and acid buffering capacity",
        "Direct radiation damage to tooth enamel causing structural weakness and demineralization",
        "Poor oral hygiene compliance during radiation therapy allowing plaque biofilm accumulation",
      ],
      correct: "B"
    },
    {
      id: 30207,
      question: "A patient receiving chemotherapy for leukemia presents for emergency care. Clinical examination reveals spontaneous gingival bleeding. Laboratory results show platelet count of 45,000/mm³. What is the MOST appropriate treatment approach?",
      options: [
        "Proceed with routine scaling and root planing using standard instrumentation techniques",
        "Postpone all dental hygiene procedures until platelet count increases above 50,000/mm³",
        "Provide gentle supragingival scaling only and avoid all subgingival instrumentation",
        "Complete full mouth debridement and apply topical hemostatic agents to control bleeding",
      ],
      correct: "B"
    },
    {
      id: 30208,
      question: "A patient who had bone marrow transplant 2 months ago reports dry mouth, difficulty swallowing, and skin rashes. The oncologist diagnosed graft-versus-host disease (GVHD). What describes graft-versus-host disease?",
      options: [
        "Patient's immune system rejects the transplanted bone marrow causing organ failure",
        "Donor's white blood cells react against host tissue antigens causing multiple complications",
        "Bacterial infection of transplanted bone marrow requiring immediate antibiotic therapy",
        "Allergic reaction to immunosuppressive medications causing systemic inflammatory response",
      ],
      correct: "B"
    },
    {
      id: 30209,
      question: "A 70-year-old patient with prostate cancer receives monthly intravenous zoledronic acid (bisphosphonate) to prevent bone metastases. He presents with an exposed, non-healing area of bone in the mandible with pain and swelling. What condition is MOST likely present?",
      options: [
        "Osteoradionecrosis from previous radiation therapy to the head and neck area",
        "Medication-related osteonecrosis of the jaw (MRONJ) from bisphosphonate therapy",
        "Osteomyelitis from bacterial infection requiring immediate antibiotic treatment",
        "Traumatic bone exposure from ill-fitting denture causing chronic irritation",
      ],
      correct: "B"
    },
    {
      id: 30210,
      question: "A patient scheduled for stem cell transplantation asks about oral care during treatment. The oncologist reports the patient will receive total body irradiation and high-dose chemotherapy before transplant. What preventive measure is MOST important?",
      options: [
        "Discontinue all oral hygiene procedures during transplant to avoid tissue trauma",
        "Use only alcohol-based mouthwashes to eliminate all oral bacteria before transplant",
        "Fabricate custom fluoride trays for daily 1.1% neutral sodium fluoride gel application",
        "Extract all teeth before transplant to eliminate any potential source of infection",
      ],
      correct: "C"
    },
    {
      id: 30211,
      question: "A patient undergoing chemotherapy develops severe oral mucositis with painful ulcerations. She asks for recommendations to manage the pain so she can eat. What is the BEST recommendation?",
      options: [
        "Rinse with full-strength hydrogen peroxide four times daily to promote healing",
        "Apply topical anesthetic gel before meals and use bland sodium bicarbonate rinses",
        "Use alcohol-based commercial mouthwash every 2 hours to prevent infection",
        "Brush vigorously with hard-bristled toothbrush to remove debris from ulcerated areas",
      ],
      correct: "B"
    },
    {
      id: 30212,
      question: "A 52-year-old female presents with a white patch on her buccal mucosa that has been present for 6 weeks. She denies pain. The area does not wipe off. She has a 30-year smoking history. What is the MOST appropriate classification for this lesion?",
      options: [
        "Erythroplakia presenting as deep red velvety patch indicating high malignant potential",
        "Leukoplakia presenting as white patch requiring biopsy to rule out malignancy",
        "Candidiasis presenting as pseudomembranous infection that can be wiped away",
        "Traumatic keratosis presenting as white line corresponding to occlusal plane",
      ],
      correct: "B"
    },
    {
      id: 30213,
      question: "A cancer patient completed radiation therapy to the oral cavity 2 years ago. During examination, you notice the patient has difficulty opening their mouth wider than 25mm. The patient reports this has gradually worsened over time. What condition is the patient experiencing?",
      options: [
        "Temporomandibular joint disorder from stress and anxiety related to cancer diagnosis",
        "Trismus from loss of elasticity in masticatory muscles after high-dose radiation",
        "Tetanus infection causing muscle spasms and restricted jaw movement",
        "Arthritis of temporomandibular joint causing degenerative changes and limited opening",
      ],
      correct: "B"
    },
    {
      id: 30214,
      question: "A patient with multiple myeloma has been taking oral alendronate (Fosamax) for 3 years to treat osteoporosis. She requires extraction of a non-restorable tooth. What is an important consideration regarding bisphosphonate use?",
      options: [
        "Oral bisphosphonates have no effect on bone healing so extraction can proceed normally",
        "Bisphosphonates have short half-life of 24 hours eliminating concerns about bone healing",
        "Risk for MRONJ is minimal with oral bisphosphonates but patient should be informed",
        "All dental extractions are contraindicated in patients taking any form of bisphosphonates",
      ],
      correct: "C"
    },
    {
      id: 30215,
      question: "A 17-year-old female presents for routine care. During the health history, you discover she has not received HPV vaccination. Her parent asks if vaccination is still recommended. What is the current CDC recommendation for HPV vaccination?",
      options: [
        "Vaccination is only effective if given before age 12 so it is too late for this patient",
        "Routine vaccination recommended at age 11-12; those up to age 26 if inadequately vaccinated",
        "HPV vaccination is only recommended for males to prevent genital warts transmission",
        "Vaccination is not necessary as HPV infections always resolve without medical intervention",
      ],
      correct: "B"
    },
    {
      id: 30216,
      question: "A patient receiving chemotherapy for lymphoma presents for continued care. Laboratory results show absolute neutrophil count (ANC) of 800/mm³. The treatment plan includes scaling and root planing. What is the MOST appropriate action?",
      options: [
        "Proceed with planned scaling and root planing using standard infection control protocols",
        "Provide only prophylaxis today and postpone scaling and root planing indefinitely",
        "Postpone dental hygiene procedures until ANC increases above 1000/mm³",
        "Complete full mouth debridement today to eliminate all sources of oral infection",
      ],
      correct: "C"
    },
    {
      id: 30217,
      question: "A patient who completed head and neck radiation therapy 5 years ago requires a dental extraction. The dentist is concerned about osteoradionecrosis risk. What characterizes osteoradionecrosis?",
      options: [
        "Temporary bone inflammation that heals within 2 weeks after tooth extraction",
        "Irradiated bone becomes hypervascular with increased healing capacity and blood supply",
        "Irradiated bone becomes hypovascular, hypoxic, hypocellular with permanent damage",
        "Bacterial infection of bone requiring aggressive antibiotic therapy for resolution",
      ],
      correct: "C"
    },
    {
      id: 30218,
      question: "During oral cancer screening, you identify a deep red, velvety patch on a patient's soft palate. The patient is a heavy smoker and alcohol user. The lesion has been present for 3 weeks. What does this clinical presentation suggest?",
      options: [
        "Erythroplakia with high malignant potential requiring immediate referral and biopsy",
        "Traumatic erythema from recent dental appliance causing mechanical irritation",
        "Benign hemangioma requiring observation only with no intervention needed",
        "Candidiasis requiring antifungal medication and improved oral hygiene measures",
      ],
      correct: "A"
    },
    {
      id: 30219,
      question: "A patient undergoing chemotherapy reports severe pain in her lower right jaw area, but clinical and radiographic examination reveals no dental pathology. She received vincristine chemotherapy 2 days ago. What is the MOST likely cause of the pain?",
      options: [
        "Undiagnosed periapical abscess requiring immediate endodontic treatment or extraction",
        "Neurotoxicity from plant alkaloid chemotherapy causing deep bilateral odontogenic-like pain",
        "Temporomandibular disorder from stress and clenching during cancer treatment",
        "Referred pain from maxillary sinus infection requiring antibiotic therapy",
      ],
      correct: "B"
    },
    {
      id: 30220,
      question: "A patient completed radiation therapy for oral cancer 8 months ago. She reports all food tastes like cardboard and she has lost 15 pounds. Custom fluoride trays were provided but she reports difficulty using them. What intervention is MOST appropriate?",
      options: [
        "Discontinue fluoride applications as taste loss is permanent and weight loss is expected",
        "Reassure that taste may return gradually; suggest nutritional counseling and continue fluoride",
        "Recommend high-sugar diet to improve taste sensation and increase caloric intake",
        "Prescribe appetite stimulant medication and postpone all dental care indefinitely",
      ],
      correct: "B"
    },
    {
      id: 30221,
      question: "A 55-year-old patient is diagnosed with stage II oral squamous cell carcinoma. The oncologist recommends surgery followed by radiation therapy. The patient asks about prognosis. What factor MOST significantly affects prognosis?",
      options: [
        "Patient's age at diagnosis with younger patients having uniformly better outcomes",
        "Size of lesion, whether spread to other parts of body, and location when first diagnosed",
        "Type of cancer treatment selected with surgery having best outcomes in all cases",
        "Patient's gender with males having significantly better survival rates than females",
      ],
      correct: "B"
    },
    {
      id: 30222,
      question: "A patient receiving radiation therapy to the salivary glands experiences complete loss of saliva production. She asks if this will improve after treatment ends. What information should be provided?",
      options: [
        "Salivary function will return to normal within 2 weeks after radiation therapy ends",
        "Salivary glands are permanently damaged and xerostomia will not improve significantly",
        "Salivary function gradually improves over 6 months returning to pre-radiation levels",
        "Only parotid glands are affected; sublingual and submandibular glands remain functional",
      ],
      correct: "B"
    },
    {
      id: 30223,
      question: "A patient with oral cancer is scheduled for transoral robotic surgery (TORS) next month. She asks how this differs from traditional surgery. What describes transoral robotic surgery?",
      options: [
        "Computer-controlled robotic arms access tumor through mouth eliminating external incisions",
        "Traditional open surgery using large external incisions to access and remove cancerous tissue",
        "Laser therapy delivered externally to shrink tumor without any surgical intervention",
        "Chemotherapy drugs delivered directly to tumor site via robotic injection system",
      ],
      correct: "A"
    },
    {
      id: 30224,
      question: "A patient who had chemotherapy 6 months ago for colon cancer presents for continued care. She reports being cancer-free. Clinical examination shows no oral complications. What describes this patient's status?",
      options: [
        "The patient remains in active cancer treatment requiring extensive care modifications",
        "The patient is a cancer survivor who may have ongoing oral healthcare needs",
        "The patient is cured and requires no further monitoring or specialized care",
        "The patient is in terminal stages requiring only palliative and comfort care",
      ],
      correct: "B"
    },
    {
      id: 30225,
      question: "A patient scheduled for bone marrow transplant in 3 weeks is referred for pre-treatment dental evaluation. Examination reveals an asymptomatic impacted third molar with no pathology. What is the MOST appropriate recommendation?",
      options: [
        "Extract the impacted tooth 14-21 days before transplant to prevent future complications",
        "Monitor the tooth with radiographs annually as asymptomatic impacted teeth rarely cause problems",
        "Schedule extraction 6 months after transplant when immune system has fully recovered",
        "Leave the tooth in place indefinitely as extraction risks outweigh potential benefits",
      ],
      correct: "A"
    },
    {
      id: 30226,
      question: "A patient undergoing head and neck radiation develops a non-healing ulceration with exposed necrotic bone in the mandible. The lesion has been present for 3 months. What is the MINIMUM time required for exposed bone to be classified as osteoradionecrosis?",
      options: [
        "Exposed devitalized irradiated bone that does not heal for at least 2 weeks",
        "Exposed devitalized irradiated bone that does not heal for at least 4 weeks",
        "Exposed devitalized irradiated bone that does not heal for at least 2 months",
        "Exposed devitalized irradiated bone that does not heal for at least 6 months",
      ],
      correct: "C"
    },
    {
      id: 30227,
      question: "A patient receiving immunotherapy for melanoma asks how this treatment differs from chemotherapy. She wants to understand why her oncologist recommended immunotherapy. What describes immunotherapy mechanism?",
      options: [
        "Directly kills cancer cells using toxic drugs that target rapidly dividing cells",
        "Uses patient's immune system to identify and destroy cancer cells",
        "Removes cancerous tumors surgically using minimally invasive techniques",
        "Delivers high-dose radiation to shrink tumors by damaging cancer cell DNA",
      ],
      correct: "B"
    },
    {
      id: 30228,
      question: "A 38-year-old patient diagnosed with breast cancer will receive chemotherapy through a central venous catheter port. She is scheduled for dental hygiene care today. What precaution may be necessary?",
      options: [
        "No special precautions needed as central venous catheters pose no infection risk",
        "Consult with oncologist regarding possible antibiotic prophylaxis before dental procedures",
        "Postpone all dental care permanently while central venous catheter remains in place",
        "Provide only emergency care and refuse all preventive dental hygiene services",
      ],
      correct: "B"
    },
    {
      id: 30229,
      question: "A patient completed chemotherapy and presents with white patches in her mouth that can be wiped away, leaving red areas underneath. She reports soreness and altered taste. What condition is MOST likely present?",
      options: [
        "Leukoplakia requiring biopsy to rule out malignant transformation and dysplasia",
        "Candidiasis from opportunistic fungal infection requiring antifungal medication",
        "Mucositis from chemotherapy requiring supportive care and pain management",
        "Lichen planus from autoimmune condition requiring corticosteroid therapy",
      ],
      correct: "B"
    },
    {
      id: 30230,
      question: "A patient asks about risk factors for developing oral cancer. He is a 45-year-old male who smokes cigarettes and drinks alcohol regularly. Which combination presents the HIGHEST risk for oral cancer?",
      options: [
        "Tobacco use and excessive alcohol consumption together multiply cancer risk",
        "Family history alone without any behavioral risk factors determines cancer risk",
        "Sun exposure to lips is only significant risk factor for oral cavity cancer",
        "Poor diet lacking fruits and vegetables is sole modifiable risk factor",
      ],
      correct: "A"
    },
    {
      id: 30231,
      question: "A patient with advanced cancer is receiving hormone therapy for prostate cancer. He asks how this treatment works. What is the mechanism of hormone therapy?",
      options: [
        "Delivers high-dose radiation to tumor site causing DNA damage and cell death",
        "Removes tumor surgically using robot-assisted minimally invasive techniques",
        "Slows or stops growth of hormone-dependent tumors by blocking hormone production",
        "Uses chemotherapy drugs to kill rapidly dividing cancer cells throughout body",
      ],
      correct: "C"
    },
    {
      id: 30232,
      question: "A patient completed radiation therapy for oral cancer and returns for 6-month follow-up. She reports compliance with daily fluoride gel application using custom trays. New cervical caries are present on multiple teeth. What additional intervention is indicated?",
      options: [
        "Discontinue fluoride applications as they are ineffective for this patient",
        "Place patient on 2-week chlorhexidine regimen and apply in-office fluoride varnish",
        "Extract all remaining teeth and fabricate complete dentures for the patient",
        "Refer to periodontist for surgical pocket reduction to eliminate bacterial reservoirs",
      ],
      correct: "B"
    },
    {
      id: 30233,
      question: "A 5-year-old child received radiation therapy for brain tumor that included the oral cavity in the radiation field. Parents ask about potential long-term oral effects. What long-term complication may occur in children?",
      options: [
        "Temporary discoloration of primary teeth that resolves when permanent teeth erupt",
        "Altered tooth and jaw development including root malformation and skeletal deformities",
        "Increased salivary flow causing drooling and difficulty with speech development",
        "Enhanced enamel formation creating stronger teeth resistant to decay",
      ],
      correct: "B"
    },
    {
      id: 30234,
      question: "A patient receiving targeted therapy for lung cancer asks how this differs from chemotherapy. She reports fewer side effects than expected. What describes targeted therapy?",
      options: [
        "Interferes with cellular proteins supporting tumor growth and metastasis",
        "Delivers radiation directly to tumor site using external beam technology",
        "Uses patient's immune system to attack and destroy cancer cells",
        "Removes tumor surgically with wide margins to prevent recurrence",
      ],
      correct: "A"
    },
    {
      id: 30235,
      question: "A patient undergoing chemotherapy presents with oral mucositis. She asks what caused the painful ulcerations in her mouth. What explains the pathophysiology of chemositis?",
      options: [
        "Bacterial infection from poor oral hygiene during immunosuppression period",
        "Allergic reaction to chemotherapy drugs causing inflammatory response",
        "Direct cytotoxic effect on rapidly dividing oral epithelial cells during treatment",
        "Fungal overgrowth from antibiotic use eliminating normal oral flora",
      ],
      correct: "C"
    },
    {
      id: 30236,
      question: "A patient with oral cancer completed radiation therapy 10 years ago. She presents with an area of exposed bone in the mandible that developed after recent tooth extraction. What is the MOST important preventive measure for this complication?",
      options: [
        "Prescribe prophylactic antibiotics for life to prevent all oral infections",
        "Extract all teeth before radiation therapy and provide immediate dentures",
        "Complete dental treatment before radiation and avoid surgical trauma to irradiated bone",
        "Use only ultrasonic scalers to avoid traumatizing tissues during dental hygiene care",
      ],
      correct: "C"
    },
    {
      id: 30237,
      question: "A patient is scheduled to begin precision medicine cancer treatment. She asks what makes this approach different from standard chemotherapy. What characterizes precision medicine?",
      options: [
        "Uses same treatment protocol for all patients with identical cancer diagnosis",
        "Based on genetic assessment of patient's disease to tailor therapy individually",
        "Delivers maximum dose chemotherapy regardless of patient's genetic makeup",
        "Provides palliative care only without attempting to cure the cancer",
      ],
      correct: "B"
    },
    {
      id: 30238,
      question: "A patient receiving head and neck radiation therapy reports difficulty opening his mouth. Current maximum opening is 20mm and continues to worsen. What preventive exercise should be recommended?",
      options: [
        "Avoid all jaw movement to allow muscles to rest and heal naturally",
        "Apply ice packs to jaw area three times daily to reduce inflammation",
        "Open and close mouth 20 times three times daily without causing pain",
        "Keep mouth closed as much as possible to prevent further muscle damage",
      ],
      correct: "C"
    },
    {
      id: 30239,
      question: "A patient who completed chemotherapy 2 weeks ago presents for dental hygiene care. She reports her oncologist said her blood counts have fully recovered. Current platelet count is 180,000/mm³. What treatment approach is appropriate?",
      options: [
        "Postpone all treatment until platelet count exceeds 200,000/mm³ for safety",
        "Proceed with planned dental hygiene care including scaling and root planing",
        "Provide only oral hygiene instruction and postpone instrumentation indefinitely",
        "Complete prophylaxis only and avoid any subgingival instrumentation today",
      ],
      correct: "B"
    },
    {
      id: 30240,
      question: "A patient with oral cancer is scheduled for surgery with reconstruction using tissue from her forearm. She asks about rehabilitation after surgery. What interprofessional team approach is needed?",
      options: [
        "Dentist and dental hygienist provide all necessary post-surgical care independently",
        "Patient requires only surgical follow-up with no other healthcare professionals",
        "Multiple professionals including speech therapist, nutritionist, and dental team collaborate",
        "Oncologist assumes sole responsibility for all aspects of post-surgical rehabilitation",
      ],
      correct: "C"
    },
    {
      id: 30241,
      question: "A patient completed radiation therapy 3 months ago and has persistent xerostomia. She asks about saliva stimulant medication. What pharmacologic option may help?",
      options: [
        "Antihistamines to reduce mucus production and thin secretions",
        "Pilocarpine or cevimeline to stimulate functional salivary gland tissue",
        "Antibiotics to eliminate bacteria causing decreased saliva production",
        "Steroids to reduce inflammation in damaged salivary glands",
      ],
      correct: "B"
    },
    {
      id: 30242,
      question: "A patient receiving chemotherapy develops thrombocytopenia with platelet count of 35,000/mm³. She complains of spontaneous gingival bleeding when brushing. What homecare recommendation is MOST appropriate?",
      options: [
        "Discontinue all oral hygiene until blood counts recover to avoid bleeding",
        "Use extra-soft toothbrush and avoid trauma from dental appliances",
        "Brush vigorously to remove all plaque and stimulate tissue keratinization",
        "Use hydrogen peroxide rinses three times daily to cauterize bleeding tissues",
      ],
      correct: "B"
    },
    {
      id: 30243,
      question: "A patient diagnosed with oral squamous cell carcinoma is scheduled for external-beam radiation therapy. Custom fluoride trays are being fabricated. What fluoride concentration is recommended for daily home use?",
      options: [
        "0.05% sodium fluoride rinse used once daily before bedtime",
        "0.4% stannous fluoride gel applied for 1-2 minutes weekly",
        "1.1% neutral sodium fluoride gel applied for 5-10 minutes daily",
        "2.0% neutral sodium fluoride gel applied for 30 seconds twice daily",
      ],
      correct: "C"
    },
    {
      id: 30244,
      question: "A cancer patient reports using glycerin swabs to clean her mouth because toothbrushing is too painful during mucositis. She asks if this is adequate. What information should be provided?",
      options: [
        "Glycerin swabs are effective for plaque removal and should continue to be used",
        "Glycerin swabs are not effective for cleaning; use water-moistened gauze instead",
        "Glycerin swabs are superior to toothbrushes and should replace brushing permanently",
        "Glycerin swabs should be used with hydrogen peroxide for maximum effectiveness",
      ],
      correct: "B"
    },
    {
      id: 30245,
      question: "A patient completed stem cell transplantation 2 months ago and continues taking immunosuppressive medications. She asks when she can resume regular dental care. What is the appropriate timeframe?",
      options: [
        "Resume regular dental care immediately as 2 months is adequate recovery time",
        "Delay elective procedures until full hematologic function returns, possibly one year",
        "Schedule routine 6-month recall appointments with no modifications to care",
        "Avoid all dental care permanently due to lifelong immunosuppression",
      ],
      correct: "B"
    },
    {
      id: 30246,
      question: "A patient receiving radiation therapy complains that bland rinses recommended for mucositis do not provide adequate pain relief. She can barely eat. What additional intervention may be necessary?",
      options: [
        "Discontinue all oral hygiene measures until mucositis resolves completely",
        "Consult with oncologist for prescription analgesics or narcotic pain medications",
        "Recommend switching to alcohol-based mouthwashes for better pain control",
        "Suggest increasing frequency of hydrogen peroxide rinses to promote healing",
      ],
      correct: "B"
    },
    {
      id: 30247,
      question: "A patient is scheduled to receive brachytherapy for tongue cancer. She asks how this differs from external beam radiation. What describes brachytherapy?",
      options: [
        "High-dose radiation delivered from outside body aimed at tumor location",
        "Chemotherapy drugs placed directly into tumor to kill cancer cells",
        "Radioactive material placed inside body near tumor in ribbons or capsules",
        "Surgical removal of tumor using laser technology and intense light",
      ],
      correct: "C"
    },
    {
      id: 30248,
      question: "A patient who completed radiation therapy 5 years ago presents for continued care. Examination reveals new cervical caries on multiple teeth despite reported daily fluoride tray use. What dietary assessment is MOST important?",
      options: [
        "Evaluate intake of sugar, acidic juices, energy drinks, and diet sodas",
        "Assess protein intake to ensure adequate nutrition for tissue repair",
        "Determine fat consumption to prevent cardiovascular disease development",
        "Review vitamin supplementation to optimize immune system function",
      ],
      correct: "A"
    },
    {
      id: 30249,
      question: "A patient receiving chemotherapy asks why the dental team is so concerned about her oral health during cancer treatment. What is the PRIMARY reason for emphasis on oral care?",
      options: [
        "Oral health has no relationship to cancer treatment outcomes or survival",
        "Oral complications can force treatment delays or dose reductions affecting outcomes",
        "Dentists need to generate income during patient's cancer treatment period",
        "Insurance companies require dental clearance before authorizing cancer treatment",
      ],
      correct: "B"
    },
    {
      id: 30250,
      question: "A patient completed radiation therapy and has difficulty with denture retention due to xerostomia. She asks for solutions to help her dentures stay in place. What recommendation is MOST appropriate?",
      options: [
        "Use denture adhesive and recommend saliva substitutes to improve retention",
        "Discontinue denture wear permanently as retention is impossible after radiation",
        "Extract all remaining teeth to create better denture-bearing area",
        "Prescribe antibiotics prophylactically to prevent fungal infections under dentures",
      ],
      correct: "A"
    },
    {
      id: 30251,
      question: "A patient asks about cancer prevention. She has no cancer history but several family members have been diagnosed with various cancers. What lifestyle modifications could prevent cancer?",
      options: [
        "Cancer is entirely genetic so lifestyle changes have no impact on cancer risk",
        "Tobacco cessation, good nutrition, physical activity, sun protection, and certain vaccinations",
        "Only pharmaceutical medications can prevent cancer development effectively",
        "Annual full-body CT scans are only effective cancer prevention strategy",
      ],
      correct: "B"
    },
    {
      id: 30252,
      question: "A patient with oral cancer is receiving targeted therapy and reports diarrhea and mild mucositis. She asks if these are expected side effects. What side effects are associated with targeted therapy?",
      options: [
        "Complete hair loss, severe nausea, and bone marrow suppression",
        "Diarrhea, liver dysfunction, and mucositis are possible effects",
        "No side effects occur as targeted therapy only affects cancer cells",
        "Kidney failure and heart damage are only significant side effects",
      ],
      correct: "B"
    },
    {
      id: 30253,
      question: "A 35-year-old patient presents with rapidly growing mass in floor of mouth. Biopsy reveals squamous cell carcinoma. She asks about survival rates. What factor indicates BEST prognosis?",
      options: [
        "Large tumor size with metastasis to distant sites indicates excellent prognosis",
        "Small localized lesion detected early with no metastasis indicates best prognosis",
        "All oral cancers have same prognosis regardless of size or stage at diagnosis",
        "Patient's age is only factor determining prognosis with younger patients doing better",
      ],
      correct: "B"
    },
    {
      id: 30254,
      question: "A patient receiving chemotherapy presents for emergency care with fever of 101°F and oral ulcerations with purulent drainage. Laboratory results show severe neutropenia. What is the MOST significant concern?",
      options: [
        "Mild discomfort that can be managed with over-the-counter pain medication",
        "Risk of systemic septicemia and death from oral infection during immunosuppression",
        "Cosmetic appearance of oral ulcerations affecting patient's self-esteem",
        "Temporary condition requiring no intervention or referral to physician",
      ],
      correct: "B"
    },
    {
      id: 30255,
      question: "A patient who received head and neck radiation 15 years ago requires extraction due to non-restorable caries. The referring dentist is concerned about osteoradionecrosis risk. What factor increases osteoradionecrosis risk?",
      options: [
        "Extractions performed more than 10 years after radiation have zero risk",
        "Higher radiation doses and larger volume of irradiated bone increase risk",
        "Mandible is less susceptible than maxilla due to increased blood supply",
        "Osteoradionecrosis only occurs in first 2 years after radiation therapy",
      ],
      correct: "B"
    },
    {
      id: 30256,
      question: "A patient undergoing chemotherapy reports her mouth tastes metallic and food has no flavor. She has lost 10 pounds in 2 weeks. What intervention is MOST important?",
      options: [
        "Reassure that taste changes are normal and weight loss is expected during cancer treatment",
        "Refer to nutritionist for dietary counseling to prevent malnutrition and maintain weight",
        "Discontinue chemotherapy immediately as taste changes indicate serious complications",
        "Recommend high-sugar candy and beverages to stimulate appetite and increase calories",
      ],
      correct: "B"
    },
    {
      id: 30257,
      question: "A patient scheduled for radiation therapy to the oral cavity asks if she should have her teeth extracted before treatment to avoid future problems. What is the BEST recommendation?",
      options: [
        "Extract all teeth before radiation as this prevents all future dental problems",
        "Remove only teeth with poor prognosis; maintain healthy teeth with preventive care",
        "Keep all teeth regardless of condition as extractions are always contraindicated",
        "Extract teeth only after radiation therapy when pathology develops requiring treatment",
      ],
      correct: "B"
    },
    {
      id: 30258,
      question: "A patient with oral cancer is scheduled to begin chemotherapy and radiation concurrently. The oncologist states this combined approach improves outcomes. What is the rationale for concurrent chemoradiation?",
      options: [
        "Chemotherapy and radiation have no synergistic effect when combined",
        "Combined therapy destroys cancer cells more effectively than single modality",
        "Concurrent treatment is more convenient for patient scheduling purposes only",
        "Insurance companies require both treatments be given simultaneously for coverage",
      ],
      correct: "B"
    },
    {
      id: 30259,
      question: "A patient receiving chemotherapy presents with candidiasis. The oncologist prescribes antifungal medication. The patient asks about preventive measures. What recommendation helps prevent oral fungal infections?",
      options: [
        "Discontinue all oral hygiene to allow tissues to heal naturally",
        "Increase frequency of hydration and maintain excellent plaque control",
        "Use alcohol-based mouthwashes to create inhospitable environment for fungi",
        "Apply petroleum jelly to tongue and mucosa to prevent fungal attachment",
      ],
      correct: "B"
    },
    {
      id: 30260,
      question: "A cancer survivor returns 5 years after completing treatment. She asks how often she should receive dental care now that treatment is complete. What recall interval is appropriate?",
      options: [
        "Annual recall visits are adequate for all cancer survivors regardless of treatment history",
        "Frequency based on individual needs considering cancer treatment effects on oral tissues",
        "Dental care is no longer necessary once cancer treatment is completed successfully",
        "Monthly dental visits required permanently for all cancer survivors",
      ],
      correct: "B"
    },
    {
      id: 30261,
      question: "A patient scheduled for oral cancer surgery asks about potential complications. The tumor involves the tongue and floor of mouth requiring extensive resection. What long-term complication may occur?",
      options: [
        "Enhanced speech and swallowing abilities after tumor removal",
        "Speech impairment and difficulty swallowing requiring rehabilitation therapy",
        "Improved nutrition from better chewing ability after surgery",
        "No complications expected as oral tissues regenerate completely",
      ],
      correct: "B"
    },
    {
      id: 30262,
      question: "A patient with multiple myeloma receiving intravenous bisphosphonates develops painful exposed bone in the mandible. The oncologist asks for dental management recommendations. What management strategy is indicated for MRONJ?",
      options: [
        "Aggressive surgical debridement of all necrotic bone at first sign of exposure",
        "Conservative management with antimicrobial rinses and possibly hyperbaric oxygen therapy",
        "Immediate extraction of all remaining teeth to prevent future complications",
        "Discontinue cancer treatment permanently to allow bone healing",
      ],
      correct: "B"
    },
    {
      id: 30263,
      question: "A patient receiving immunotherapy for melanoma asks about oral side effects she should watch for during treatment. What side effects are associated with immunotherapy?",
      options: [
        "Severe mucositis and xerostomia affecting all patients receiving treatment",
        "Skin reactions at injection site and flu-like symptoms including fever and fatigue",
        "Complete hair loss and severe nausea similar to chemotherapy effects",
        "No side effects occur as immunotherapy is completely safe and well-tolerated",
      ],
      correct: "B"
    },
    {
      id: 30264,
      question: "A patient who completed radiation therapy asks when custom fluoride trays can be discontinued. Treatment ended 5 years ago with no new caries. What is the appropriate recommendation?",
      options: [
        "Discontinue fluoride trays immediately as 5 years post-treatment is sufficient",
        "Continue lifelong daily fluoride gel application due to permanent salivary gland damage",
        "Reduce to weekly fluoride application with monitoring for new decay",
        "Switch to over-the-counter fluoride rinse used once weekly",
      ],
      correct: "B"
    },
    {
      id: 30265,
      question: "A patient scheduled for chemotherapy has a central venous catheter surgically placed for drug administration. She asks if this affects dental care. What consideration is necessary?",
      options: [
        "No precautions needed as central catheters pose no risk during dental procedures",
        "Medical consult may be warranted regarding possible bacterial endocarditis risk",
        "All dental care must be discontinued immediately until catheter is removed",
        "Only emergency care permitted while catheter remains in place for chemotherapy",
      ],
      correct: "B"
    },
    {
      id: 30266,
      question: "A patient receiving radiation therapy to the parotid gland area experiences taste loss. She reports all food tastes the same with no flavor distinction. What explains this alteration in taste?",
      options: [
        "Psychological depression from cancer diagnosis causing perceived taste changes",
        "Direct radiation damage to taste buds on tongue affecting taste perception",
        "Medication side effects unrelated to radiation therapy causing taste alterations",
        "Poor oral hygiene allowing bacterial overgrowth that blocks taste receptors",
      ],
      correct: "B"
    },
    {
      id: 30267,
      question: "A patient with head and neck cancer completed radiation therapy 1 year ago. She reports continued difficulty with thick, ropy saliva that is hard to clear. What recommendation may help?",
      options: [
        "Increase intake of dairy products to thin secretions naturally",
        "Rinse frequently with baking soda and salt water solution",
        "Use alcohol-based mouthwash to dissolve thick mucus strands",
        "Discontinue all oral hygiene as it stimulates ropy saliva production",
      ],
      correct: "B"
    },
    {
      id: 30268,
      question: "A patient receiving chemotherapy asks why she must brush her teeth when her mouth is so painful with mucositis. What is the rationale for continued oral hygiene?",
      options: [
        "Oral hygiene has no impact on mucositis severity or infection risk",
        "Continued gentle oral hygiene prevents infection and may reduce mucositis severity",
        "Aggressive brushing will toughen tissues making them resistant to mucositis",
        "Oral hygiene should be completely discontinued until mucositis resolves",
      ],
      correct: "B"
    },
    {
      id: 30269,
      question: "A patient with oral cancer asks about tobacco cessation. He has smoked for 30 years and states he will quit after cancer treatment ends. What information should be provided?",
      options: [
        "Quitting after treatment is acceptable as timing of cessation doesn't affect outcomes",
        "Immediate tobacco cessation is essential to support best possible treatment outcomes",
        "Tobacco cessation is unnecessary as damage is already done and cannot be reversed",
        "Continue tobacco use during treatment to avoid withdrawal symptoms and stress",
      ],
      correct: "B"
    },
    {
      id: 30270,
      question: "A patient is scheduled for oral cancer surgery in 2 weeks. Current dental examination reveals moderate periodontal disease with 5-6mm pockets and bleeding on probing. What treatment is indicated before surgery?",
      options: [
        "Postpone all periodontal treatment until after cancer surgery and recovery period",
        "Complete scaling and root planing at least 7 days before cancer surgery",
        "Extract all teeth with periodontal involvement to eliminate infection source",
        "Provide antibiotics only without any mechanical debridement before surgery",
      ],
      correct: "B"
    },
    {
      id: 30271,
      question: "A cancer patient asks about interprofessional collaborative practice (ICP) for her cancer care. She wants to understand who will be involved in her treatment. What defines interprofessional collaborative practice?",
      options: [
        "Single physician makes all decisions without input from other healthcare professionals",
        "Communication and decision-making by different disciplines to improve patient outcomes",
        "Patient receives care only from oncology team with no other professional involvement",
        "Dental team provides oral care independently without consulting oncology team",
      ],
      correct: "B"
    },
    {
      id: 30272,
      question: "A patient received stem cell transplant 6 weeks ago and continues to have oral mucositis and candidiasis. She asks why her mouth has not healed yet. What explains persistent oral complications?",
      options: [
        "Patient is not compliant with oral hygiene recommendations during recovery",
        "Immunosuppression from medications delays healing and increases infection risk",
        "All oral complications should resolve within 2 weeks after transplant completion",
        "Persistent symptoms indicate treatment failure requiring additional transplantation",
      ],
      correct: "B"
    },
    {
      id: 30273,
      question: "A patient diagnosed with oral cancer asks what percentage of oral malignancies are squamous cell carcinomas. What percentage represents squamous cell carcinomas?",
      options: [
        "Approximately 30% of oral malignancies are squamous cell carcinomas",
        "Approximately 50% of oral malignancies are squamous cell carcinomas",
        "Approximately 75% of oral malignancies are squamous cell carcinomas",
        "Approximately 90% of oral malignancies are squamous cell carcinomas",
      ],
      correct: "D"
    },
    {
      id: 30274,
      question: "A patient receiving targeted therapy for colon cancer with liver metastases develops mucositis. She thought only chemotherapy and radiation caused oral complications. What information should be provided?",
      options: [
        "Targeted therapy never causes oral complications; mucositis must be from other cause",
        "Targeted therapy can cause mucositis and other oral side effects in some patients",
        "Mucositis from targeted therapy is impossible so patient must be misdiagnosed",
        "Only chemotherapy causes mucositis; all other cancer therapies are safe for oral tissues",
      ],
      correct: "B"
    },
    {
      id: 30275,
      question: "A patient with oral cancer completed surgery and will begin radiation therapy in 3 weeks. She has several areas of enamel demineralization on cervical areas of teeth. What preventive intervention is indicated?",
      options: [
        "Extract all teeth with demineralization before radiation therapy begins",
        "Apply fluoride varnish and fabricate custom trays for daily fluoride gel application",
        "Monitor demineralization areas and provide treatment after radiation is completed",
        "No intervention needed as demineralization does not progress during radiation therapy",
      ],
      correct: "B"
    },
    {
      id: 30276,
      question: "A patient asks about the relationship between cancer deaths and smoking. He wants to quit smoking but doesn't think it will make a difference. What percentage of cancer deaths are caused by cigarette smoking?",
      options: [
        "Less than 5% of cancer deaths are caused by cigarette smoking",
        "Approximately 21% of cancer deaths (130,180 deaths) are caused by cigarette smoking",
        "Approximately 50% of cancer deaths are caused by cigarette smoking",
        "Approximately 75% of cancer deaths are caused by cigarette smoking",
      ],
      correct: "B"
    },
    {
      id: 30277,
      question: "A patient receiving head and neck radiation develops hearing loss. She asks if this is related to her cancer treatment. What explains this complication?",
      options: [
        "Hearing loss is unrelated to radiation therapy and indicates undiagnosed ear infection",
        "Radiation therapy to head and neck area can cause hearing loss as side effect",
        "Hearing loss only occurs with chemotherapy, never with radiation therapy",
        "Psychological stress from cancer diagnosis causes perceived hearing difficulties",
      ],
      correct: "B"
    },
    {
      id: 30278,
      question: "A patient completed chemotherapy 6 months ago and presents with multiple carious lesions. She reports excellent oral hygiene compliance. Her salivary flow appears normal. What factor may explain caries development?",
      options: [
        "Frequent snacking on high-carbohydrate foods during cancer treatment to maintain calories",
        "Genetic predisposition to caries unrelated to cancer treatment or dietary habits",
        "Bacterial resistance to fluoride making preventive measures ineffective",
        "Normal saliva production eliminates any risk for caries during cancer recovery",
      ],
      correct: "A"
    },
    {
      id: 30279,
      question: "A patient who completed oral cancer treatment 3 years ago asks about self-examination at home. She wants to detect any cancer recurrence early. What should be included in oral self-examination education?",
      options: [
        "Self-examination is unnecessary as only professionals can detect oral cancer recurrence",
        "Teach patient to look for lumps, non-healing sores, color changes, and unusual symptoms",
        "Self-examination should replace professional examinations to reduce healthcare costs",
        "Cancer recurrence is impossible after 3 years so self-examination is unnecessary",
      ],
      correct: "B"
    }
  ],
  "4. HIV and Oral Health (Case Study)": [
    {
      id: 30300,
      question: "A 45-year-old male patient presents for routine dental hygiene care. During the health history review, he reports being diagnosed with HIV 5 years ago. He states he takes antiretroviral medications daily and his last CD4+ count was 550 cells/mm³. He asks about the risk of transmission during dental procedures. What is the MOST accurate statement regarding HIV transmission in the dental setting?",
      options: [
        "Healthcare workers have zero risk when following standard precautions during all patient care",
        "Risk of occupational HIV infection is approximately 0.23% through percutaneous exposure",
        "Aerosols generated during dental procedures are a primary mode of HIV transmission",
        "All dental procedures on HIV-positive patients require antibiotic prophylaxis to prevent infection",
      ],
      correct: "B"
    },
    {
      id: 30301,
      question: "A 32-year-old patient arrives for her appointment and reports she takes a daily medication for HIV prevention because her partner is HIV-positive. She indicates on her medical history that she is taking emtricitabine/tenofovir and checks \"negative\" for HIV status. What medication regimen is this patient MOST likely taking?",
      options: [
        "Post-exposure prophylaxis (PEP) taken after known HIV exposure for emergency prevention",
        "Pre-exposure prophylaxis (PrEP) taken daily to reduce transmission risk with proper adherence",
        "Antiretroviral therapy (ART) for treating diagnosed HIV infection to achieve viral suppression",
        "Prophylactic antibiotic therapy to prevent opportunistic infections in immunocompromised individuals",
      ],
      correct: "B"
    },
    {
      id: 30302,
      question: "A 28-year-old patient presents with white, curd-like plaques on the hard palate and buccal mucosa. When you attempt to wipe the plaques away with gauze, the underlying tissue appears red and bleeds slightly. The patient reports no pain but has a \"cottony\" taste. What condition is MOST likely present?",
      options: [
        "Erythematous candidiasis presenting as smooth red patches on oral mucosa",
        "Pseudomembranous candidiasis presenting as removable white plaques leaving red areas",
        "Hairy leukoplakia presenting as white corrugated lesions on lateral tongue",
        "Aphthous ulcers presenting as white lesions with inflammatory halos on mucosa",
      ],
      correct: "B"
    },
    {
      id: 30303,
      question: "A patient with HIV presents with severe gingival pain, fetid odor, bleeding, and loose teeth. Clinical examination reveals rapid bone loss, soft tissue necrosis, and ulcerations. His CD4+ count is 180 cells/mm³. What condition requires immediate and aggressive treatment?",
      options: [
        "Chronic periodontitis requiring standard scaling and root planing over multiple appointments",
        "Acute herpetic gingivostomatitis requiring antiviral therapy and symptomatic treatment",
        "Necrotizing ulcerative periodontitis requiring systemic antibiotics and aggressive local debridement",
        "Pseudomembranous candidiasis requiring topical antifungal medications and improved oral hygiene",
      ],
      correct: "C"
    },
    {
      id: 30304,
      question: "During examination, you note a white, corrugated, vertically-oriented lesion on the lateral border of the patient's tongue. The patient reports no symptoms. You attempt to wipe it off but it cannot be removed. The patient is HIV-positive with a CD4+ count of 380 cells/mm³. What is the MOST likely diagnosis?",
      options: [
        "Pseudomembranous candidiasis caused by Candida albicans overgrowth requiring antifungal therapy",
        "Hairy leukoplakia associated with Epstein-Barr virus that is painless and requires no treatment",
        "Squamous cell carcinoma requiring immediate biopsy and referral for oncology treatment",
        "Erythematous candidiasis requiring systemic antifungal medications and appliance treatment",
      ],
      correct: "B"
    },
    {
      id: 30305,
      question: "A 50-year-old HIV-positive patient reports taking Stribild once daily. He asks how this medication helps control his infection. What describes the mechanism of combination antiretroviral therapy?",
      options: [
        "Targets HIV at various stages in its life cycle to reduce circulating virus",
        "Cures HIV infection by eliminating all viral particles from the body",
        "Provides temporary symptom relief without affecting viral replication",
        "Prevents only the initial HIV infection but cannot treat established disease",
      ],
      correct: "A"
    },
    {
      id: 30306,
      question: "A patient with HIV presents with redness, cracks, and fissures at the corners of his lips. The lesions are moderately painful and eroded. He reports difficulty opening his mouth wide. What condition is present?",
      options: [
        "Herpes simplex virus infection requiring postponement of elective dental treatment",
        "Hairy leukoplakia requiring observation only without active treatment intervention",
        "Angular cheilitis requiring antifungal treatment and evaluation of dental appliances",
        "Aphthous ulcers requiring topical analgesics and corticosteroid therapy",
      ],
      correct: "C"
    },
    {
      id: 30307,
      question: "A 35-year-old patient with HIV (CD4+ count 650 cells/mm³, undetectable viral load) presents for scaling and root planing. He is adherent to his ART regimen and has no active oral infections. What treatment approach is indicated?",
      options: [
        "Postpone all treatment until CD4+ count exceeds 800 cells/mm³ for safety",
        "Provide routine dental hygiene care following standard precautions for all patients",
        "Administer prophylactic antibiotics before any tissue manipulation or instrumentation",
        "Use only hand instruments avoiding ultrasonic scalers due to aerosol generation",
      ],
      correct: "B"
    },
    {
      id: 30308,
      question: "During health history review, a patient reports being diagnosed with HIV 3 months ago. He states he is not currently taking any medications because he \"feels fine\" and his doctor said he could wait. According to current treatment guidelines, when is ART recommended?",
      options: [
        "Only when CD4+ count drops below 200 cells/mm³ or AIDS-defining illness appears",
        "For everyone diagnosed with HIV to preserve immune system and improve outcomes",
        "After waiting 1-2 years to allow the immune system to fight infection naturally",
        "Only for pregnant women to prevent vertical transmission during pregnancy and birth",
      ],
      correct: "B"
    },
    {
      id: 30309,
      question: "A patient with HIV presents with purplish-red nodules on the hard palate and gingiva. The lesions are flat to slightly raised. His CD4+ count is 150 cells/mm³ and he reports not taking HIV medications regularly. What neoplastic lesion requires biopsy confirmation?",
      options: [
        "Squamous cell carcinoma from tobacco use requiring excision and radiation therapy",
        "Kaposi sarcoma associated with human herpesvirus-8 requiring systemic chemotherapy",
        "Oral warts from human papillomavirus requiring surgical excision or observation",
        "Aphthous ulcers from immunosuppression requiring topical corticosteroids and analgesics",
      ],
      correct: "B"
    },
    {
      id: 30310,
      question: "A patient experiences a needlestick injury with a contaminated instrument during treatment of an HIV-positive patient. The exposure occurred 30 minutes ago. What is the MOST appropriate management?",
      options: [
        "Wait 72 hours to begin antiretroviral medications to confirm HIV transmission occurred",
        "Initiate post-exposure prophylaxis (PEP) immediately, ideally within 2 hours of exposure",
        "Test for HIV antibodies immediately to determine if infection occurred from exposure",
        "Prescribe prophylactic antibiotics for 10 days to prevent secondary bacterial infections",
      ],
      correct: "B"
    },
    {
      id: 30311,
      question: "A patient presents with smooth, red, denuded patches on the tongue and red patches on the palatal mucosa. She reports burning when eating spicy foods. She wears a maxillary partial denture. What condition requires treatment of both tissues and appliance?",
      options: [
        "Pseudomembranous candidiasis requiring removal of white plaques before antifungal therapy",
        "Erythematous candidiasis requiring antifungal treatment for tissues and denture",
        "Hairy leukoplakia requiring observation only without active treatment intervention",
        "Necrotizing ulcerative periodontitis requiring antibiotics and aggressive debridement",
      ],
      correct: "B"
    },
    {
      id: 30312,
      question: "A patient reports taking zidovudine (AZT) during pregnancy to prevent transmission to her baby. She asks how effective this treatment is. What statement is MOST accurate regarding vertical HIV transmission?",
      options: [
        "Mother-to-child transmission is inevitable regardless of treatment during pregnancy",
        "Near elimination of vertical transmission is possible when mother receives treatment before birth",
        "Transmission only occurs during breastfeeding, not during pregnancy or delivery",
        "ART during pregnancy increases transmission risk due to medication side effects",
      ],
      correct: "B"
    },
    {
      id: 30313,
      question: "During examination of an HIV-positive patient, you observe shallow ulcerations on the keratinized gingiva and vermilion border of the lip. The patient reports tingling before the lesions appeared. What is the recommended treatment approach?",
      options: [
        "Proceed with all planned dental treatment as HSV is not contagious in this stage",
        "Postpone elective dental treatment until lesions heal; treat with antiviral therapy",
        "Provide immediate scaling and root planing to prevent secondary bacterial infection",
        "Apply topical antibiotics to prevent progression to systemic bacterial infection",
      ],
      correct: "B"
    },
    {
      id: 30314,
      question: "A patient with HIV asks about the relationship between viral load and transmission risk. His most recent test showed undetectable viral load (<50 copies/mL). What concept should be explained?",
      options: [
        "Undetectable = Untransmittable (U=U); viral suppression prevents sexual transmission",
        "Undetectable viral load means HIV is cured and no longer present in the body",
        "Low viral load increases transmission risk compared to high viral load states",
        "Viral load testing is inaccurate and cannot predict transmission risk reliably",
      ],
      correct: "A"
    },
    {
      id: 30315,
      question: "A 60-year-old patient with HIV for 25 years presents for continued care. He reports taking medications for osteoporosis and asks if this affects dental treatment planning. What consideration is important for older adults with HIV?",
      options: [
        "HIV infection prevents age-associated comorbidities from developing in older patients",
        "Bisphosphonates or RANKL inhibitors may potentially impact dental treatment decisions",
        "All dental procedures are contraindicated in HIV-positive patients over age 60",
        "Older adults with HIV have no increased risk for cardiovascular or bone density issues",
      ],
      correct: "B"
    },
    {
      id: 30316,
      question: "A patient presents with fever, lymphadenopathy, headache, malaise, rash, and pharyngitis. He reports possible HIV exposure 3 weeks ago. He has not been tested for HIV. What phase of HIV infection is MOST consistent with these symptoms?",
      options: [
        "Chronic asymptomatic latency period lasting months to years without symptoms",
        "AIDS stage with CD4+ count below 200 cells/mm³ and opportunistic infections",
        "Acute HIV infection syndrome occurring 6 to 56 days after exposure",
        "Terminal stage HIV with complete immune system failure and multiple organ involvement",
      ],
      correct: "C"
    },
    {
      id: 30317,
      question: "During health history, a patient reports his HIV viral load is undetectable and CD4+ count is 720 cells/mm³. He asks what the CD4+ count measures. What does CD4+ T lymphocyte count indicate?",
      options: [
        "The amount of HIV virus circulating in bloodstream measured in copies per milliliter",
        "The immune system status measured by counting important white blood cells",
        "The effectiveness of antiretroviral medications in eliminating HIV from body",
        "The presence of opportunistic infections requiring prophylactic antibiotic therapy",
      ],
      correct: "B"
    },
    {
      id: 30318,
      question: "A patient with HIV presents with nonkeratinized ulcers on the buccal mucosa with a halo of inflammation and gray/yellow covering. He reports severe pain affecting his ability to eat. What treatment addresses both the ulcer and pain management?",
      options: [
        "Systemic antibiotics to treat bacterial infection causing ulceration",
        "Topical analgesics, anti-inflammatory agents, and corticosteroid therapy",
        "Antiviral medications to treat herpes simplex virus lesions",
        "Antifungal medications to treat Candida albicans overgrowth",
      ],
      correct: "B"
    },
    {
      id: 30319,
      question: "A patient asks about HIV testing recommendations. He is 45 years old, sexually active, and has never been tested for HIV. What are current CDC screening recommendations?",
      options: [
        "HIV testing only for individuals with known risk factors or symptoms",
        "All adults and adolescents aged 13 to 64 should be tested at least once",
        "HIV testing only for healthcare workers and pregnant women",
        "Annual HIV testing required for all adults regardless of risk factors",
      ],
      correct: "B"
    },
    {
      id: 30320,
      question: "A patient with HIV reports xerostomia affecting his ability to eat and speak. He takes multiple antiretroviral medications and reports chronic dry mouth for the past year. What recommendation is MOST appropriate for managing xerostomia?",
      options: [
        "Discontinue all HIV medications until xerostomia resolves completely",
        "Drink more water, avoid caffeine/tobacco, use saliva stimulants and topical fluorides",
        "Prescribe prophylactic antibiotics to prevent oral infections from dry mouth",
        "Extract all remaining teeth and provide complete dentures for improved function",
      ],
      correct: "B"
    },
    {
      id: 30321,
      question: "A patient with HIV presents with singular and multifocal cauliflower-like lesions in the oral cavity. Biopsy confirms human papillomavirus (HPV). The patient asks about treatment and prognosis. What information is MOST accurate?",
      options: [
        "HPV oral warts never recur after surgical excision or treatment",
        "All HPV types cause oral cancer requiring immediate aggressive treatment",
        "Recurrence is common after treatment; close monitoring of all lesions indicated",
        "HPV oral warts are not contagious and pose no risk to dental healthcare workers",
      ],
      correct: "C"
    },
    {
      id: 30322,
      question: "During the HIV Care Continuum assessment, you determine that your patient with HIV is not currently linked to medical care and is not taking antiretroviral therapy. What is the dental hygienist's role in the HIV Care Continuum?",
      options: [
        "Prescribe antiretroviral medications directly to ensure patient receives treatment",
        "Discuss importance of medical care and advise patient to see primary care provider",
        "Refuse dental treatment until patient demonstrates compliance with HIV treatment",
        "Report patient to public health authorities for mandatory HIV treatment enrollment",
      ],
      correct: "B"
    },
    {
      id: 30323,
      question: "A patient with HIV asks what percentage of HIV-infected individuals will experience at least one oral manifestation during the course of their disease. What is the estimated percentage?",
      options: [
        "Approximately 25% will have at least one HIV-related oral manifestation",
        "Approximately 50% will have at least one HIV-related oral manifestation",
        "Approximately 75% will have at least one HIV-related oral manifestation",
        "More than 90% will have at least one HIV-related oral manifestation",
      ],
      correct: "D"
    },
    {
      id: 30324,
      question: "A patient's medical history indicates a CD4+ count of 180 cells/mm³. He asks what stage of HIV infection this represents. Based on CD4+ count, what is the HIV infection stage for adults (≥6 years)?",
      options: [
        "Stage 1: CD4+ count ≥500 cells/mm³ indicating early HIV infection",
        "Stage 2: CD4+ count 200-499 cells/mm³ indicating moderate immunosuppression",
        "Stage 3: CD4+ count <200 cells/mm³ indicating AIDS diagnosis criteria met",
        "Stage 4: CD4+ count <100 cells/mm³ indicating terminal AIDS with imminent death",
      ],
      correct: "C"
    },
    {
      id: 30325,
      question: "A patient with HIV reports taking medication \"holidays\" by stopping his antiretroviral therapy for several days when he feels well. He asks if this practice is acceptable. What statement is MOST accurate regarding drug holidays?",
      options: [
        "Drug holidays are recommended to give the immune system rest from medications",
        "Drug holidays have been shown to be detrimental and are not commonly used",
        "Drug holidays improve medication effectiveness by preventing drug tolerance",
        "Drug holidays are required monthly to prevent cumulative medication toxicity",
      ],
      correct: "B"
    },
    {
      id: 30326,
      question: "A patient diagnosed with stage 3 HIV (AIDS) is scheduled for scaling and root planing. He has no active oral infections and his medical team confirms he is stable for dental treatment. What prophylactic antibiotic protocol is indicated?",
      options: [
        "Prophylactic antibiotics required for all HIV-positive patients before all procedures",
        "Prophylactic antibiotics indicated only if patient has central venous catheter",
        "Prophylactic antibiotics required only for patients with CD4+ count below 500",
        "Prophylactic antibiotics mandatory for all AIDS patients regardless of procedure type",
      ],
      correct: "B"
    },
    {
      id: 30327,
      question: "According to the 2019 HIV surveillance data, what percentage of Americans living with HIV were diagnosed and aware of their status?",
      options: [
        "Approximately 50% were diagnosed, with half unaware of their infection",
        "Approximately 65% were diagnosed, with one-third unaware of infection",
        "Approximately 75% were diagnosed, with one-quarter unaware of infection",
        "Approximately 87% were diagnosed, with 14% unaware of their infection",
      ],
      correct: "D"
    },
    {
      id: 30328,
      question: "A patient presents with oral warts and reports being treated for HIV infection. He asks about HPV vaccination to prevent additional oral HPV lesions. What information about HPV vaccination is accurate?",
      options: [
        "HPV vaccination is only effective before any HPV exposure occurs",
        "Gardasil 9 prevents HPV 16, 18, 31, 33, 45, 52, 58 and genital wart viruses",
        "HPV vaccination is contraindicated in all HIV-positive individuals",
        "HPV vaccination only prevents cervical cancer, not oral HPV infections",
      ],
      correct: "B"
    },
    {
      id: 30329,
      question: "A patient with HIV presents for necrotizing ulcerative periodontitis treatment. After initial systemic antibiotics and local debridement, what adjunct therapy is recommended?",
      options: [
        "Complete extraction of all affected teeth to eliminate infection source",
        "Postpone all oral hygiene until tissues heal to avoid further trauma",
        "Local irrigation with 0.12% chlorhexidine gluconate and twice-daily rinses",
        "Prescribe prophylactic antifungal medications to prevent secondary candidiasis",
      ],
      correct: "C"
    },
    {
      id: 30330,
      question: "A patient with HIV reports he tested positive for HIV antibodies 2 weeks after a potential exposure. He asks what this means. What does HIV seroconversion indicate?",
      options: [
        "The acquisition of HIV-specific antibodies in the blood serum after infection",
        "The elimination of HIV from the body through natural immune response",
        "The development of resistance to HIV antiretroviral medications",
        "The transmission of HIV from one person to another through exposure",
      ],
      correct: "A"
    },
    {
      id: 30331,
      question: "During examination, you note your patient takes dolutegravir and emtricitabine/tenofovir for HIV treatment. What class of medication is dolutegravir?",
      options: [
        "Nucleoside reverse transcriptase inhibitor (NRTI) blocking reverse transcription",
        "Non-nucleoside reverse transcriptase inhibitor (NNRTI) blocking enzyme function",
        "Protease inhibitor (PI) preventing viral protein chain cleavage",
        "Integrase inhibitor preventing viral DNA integration into host genome",
      ],
      correct: "D"
    },
    {
      id: 30332,
      question: "A 55-year-old African American male presents for new patient examination. During health history, you identify multiple HIV risk factors. He has never been tested for HIV. What disparity exists in HIV prevalence among racial groups?",
      options: [
        "White Americans represent 60% of people with HIV while being 70% of population",
        "African Americans represent 40% of people with HIV while being 13% of population",
        "Hispanic/Latino Americans represent 10% of people with HIV and 18% of population",
        "Asian Americans represent 30% of people with HIV while being 6% of population",
      ],
      correct: "B"
    },
    {
      id: 30333,
      question: "A patient asks about the eight stages of the HIV life cycle. In what stage does HIV convert its RNA into DNA using reverse transcriptase?",
      options: [
        "Stage 1: Binding (attachment) of HIV to CD4+ cell receptors",
        "Stage 2: Fusion of HIV envelope with CD4+ cell membrane",
        "Stage 3: Reverse transcription converting viral RNA into DNA",
        "Stage 4: Integration of viral DNA into host cell genome",
      ],
      correct: "C"
    },
    {
      id: 30334,
      question: "A patient with HIV presents with oral lesions that appear as smooth red patches on the palate. She reports pain when eating acidic foods. The white patches you see can be wiped off, leaving bleeding tissue. What combination of conditions is MOST likely present?",
      options: [
        "Pseudomembranous candidiasis only, requiring single antifungal treatment approach",
        "Pseudomembranous and erythematous candidiasis requiring comprehensive antifungal therapy",
        "Hairy leukoplakia and herpes simplex requiring antiviral therapy",
        "Necrotizing ulcerative periodontitis requiring antibiotics and surgical debridement",
      ],
      correct: "B"
    },
    {
      id: 30335,
      question: "A patient's medical history indicates he is taking Cabenuva for HIV treatment. He asks how this medication differs from his previous daily pills. What describes long-acting injectable HIV treatment?",
      options: [
        "Short-acting injectable requiring daily injections to maintain therapeutic levels",
        "Long-lasting injectable reducing burden of daily medication and improving adherence",
        "Oral medication in liquid form administered through feeding tube",
        "Topical medication applied to skin for transdermal absorption",
      ],
      correct: "B"
    },
    {
      id: 30336,
      question: "A patient with HIV is concerned about discrimination. She asks about legal protections regarding dental care. What legal and ethical responsibility exists?",
      options: [
        "Dentists may refuse treatment to HIV-positive patients to protect other patients",
        "Withholding or altering treatment based on HIV status is discriminatory under ADA",
        "HIV-positive patients must disclose status to all staff and patients in waiting room",
        "Dental offices may charge higher fees to HIV-positive patients due to infection risk",
      ],
      correct: "B"
    },
    {
      id: 30337,
      question: "A patient with HIV presents with chronic intestinal cryptosporidiosis lasting 6 weeks, along with a CD4+ count of 190 cells/mm³. What does this clinical presentation indicate?",
      options: [
        "Stage 1 HIV infection with asymptomatic primary infection",
        "Stage 2 HIV infection with symptomatic conditions but no AIDS-defining illnesses",
        "Stage 3 HIV infection (AIDS) with AIDS-defining opportunistic infection",
        "HIV latency period with no clinical significance for infection staging",
      ],
      correct: "C"
    },
    {
      id: 30338,
      question: "According to the Ending the HIV Epidemic (EHE) initiative, what are the four pillars?",
      options: [
        "Diagnose, treat, prevent, and respond to control the HIV epidemic",
        "Screen, medicate, monitor, and educate to eliminate new infections",
        "Test, hospitalize, quarantine, and cure to stop HIV transmission",
        "Identify, isolate, treat, and track to reduce HIV prevalence rates",
      ],
      correct: "A"
    },
    {
      id: 30339,
      question: "A patient with HIV (CD4+ count 520 cells/mm³) presents for treatment planning. He has generalized moderate periodontitis with 5-6mm probing depths and bleeding on probing. What treatment plan is MOST appropriate?",
      options: [
        "Scaling and root planing identical to treatment for HIV-negative patients with periodontitis",
        "Immediate extraction of all teeth with periodontal involvement to prevent systemic infection",
        "Defer all periodontal treatment indefinitely due to HIV status and infection risk",
        "Prescribe antibiotics only without mechanical debridement to avoid bacteremia",
      ],
      correct: "A"
    },
    {
      id: 30340,
      question: "A patient presents with a history of receiving blood transfusions in the 1980s. He has never been tested for HIV despite being in a high-risk group. What year marked the first significant decrease in AIDS mortality?",
      options: [
        "1981 when HIV was first reported by the CDC",
        "1985 when HIV blood test screening became available",
        "1996 when first protease inhibitor was introduced",
        "2009 when integrase inhibitors were approved",
      ],
      correct: "C"
    },
    {
      id: 30341,
      question: "During health history review, a patient reports his CD4+ count has decreased approximately 10% per year since his HIV diagnosis 3 years ago. He is not taking antiretroviral therapy. What HIV infection phase is characterized by this CD4+ decline?",
      options: [
        "Acute HIV infection with primary viremia and flu-like symptoms",
        "Asymptomatic latency period despite ongoing viral replication and CD4+ depletion",
        "AIDS stage with multiple opportunistic infections and malignancies",
        "Terminal stage with complete immune system failure and organ damage",
      ],
      correct: "B"
    },
    {
      id: 30342,
      question: "A patient taking antiretroviral therapy asks about the difference between HIV-1 and HIV-2. What statement about HIV subtypes is MOST accurate?",
      options: [
        "HIV-1 is predominant worldwide including United States; HIV-2 primarily in West Africa",
        "HIV-2 is more common globally and more aggressive than HIV-1 infections",
        "HIV-1 only affects men who have sex with men; HIV-2 affects heterosexual populations",
        "No difference exists between HIV-1 and HIV-2 in terms of treatment or prognosis",
      ],
      correct: "A"
    },
    {
      id: 30343,
      question: "A patient with HIV presents for treatment. You notice the exposure control manual does not include postexposure management protocols. What timeframe is critical for initiating post-exposure prophylaxis?",
      options: [
        "PEP must be started within 24 hours but is effective up to 7 days post-exposure",
        "PEP must be started within 72 hours, ideally within 2 hours of exposure",
        "PEP must be started within 1 week but remains effective up to 30 days",
        "PEP timing is not critical; medications are effective regardless of delay",
      ],
      correct: "B"
    },
    {
      id: 30344,
      question: "A patient asks about oral health screening's role in HIV diagnosis. The dental office does not currently offer HIV testing. What is the appropriate action per current recommendations?",
      options: [
        "Refuse to discuss HIV testing as it is outside the dental hygienist's scope of practice",
        "Recommend patient be tested at least once in lifetime and refer to testing facilities",
        "Inform patient that HIV testing is not necessary unless symptoms are present",
        "Advise patient that only high-risk individuals need HIV testing and screening",
      ],
      correct: "B"
    },
    {
      id: 30345,
      question: "A 62-year-old patient with HIV asks if older adults should continue to be tested or screened for HIV. What CDC guideline addresses HIV testing in older adults?",
      options: [
        "HIV testing not recommended after age 60 as infection is rare in elderly",
        "HIV screening recommended through age 64; older adults with risk factors test more frequently",
        "HIV testing only indicated in older adults with known exposure or symptoms",
        "Annual HIV testing mandatory for all adults over age 50 regardless of risk",
      ],
      correct: "B"
    },
    {
      id: 30346,
      question: "A patient with HIV reports taking enfuvirtide in the past but no longer uses this medication. He asks why it's rarely used today. What describes enfuvirtide?",
      options: [
        "Integrase inhibitor commonly used in first-line HIV treatment regimens",
        "Fusion inhibitor rarely used today due to cost, inconvenience, and poor safety profile",
        "Protease inhibitor introduced in 1995 that dramatically improved HIV prognosis",
        "Nucleoside reverse transcriptase inhibitor used as monotherapy for HIV treatment",
      ],
      correct: "B"
    },
    {
      id: 30347,
      question: "A patient with HIV experiences oral burning and taste changes. Examination reveals red, smooth patches on the dorsal tongue with no white removable plaques. What instruction is MOST important for this patient?",
      options: [
        "Increase intake of spicy and acidic foods to stimulate taste sensation",
        "Apply antiviral cream to tongue three times daily to treat herpes infection",
        "Avoid salty, spicy foods and acidic beverages that exacerbate burning sensation",
        "Use alcohol-based mouthwash four times daily to eliminate causative bacteria",
      ],
      correct: "C"
    },
    {
      id: 30348,
      question: "During clinical examination, you observe a patient has oral manifestations consistent with severe immunosuppression. His CD4+ count is 95 cells/mm³. What vaccination recommendations would you communicate to the medical team?",
      options: [
        "No vaccinations recommended for immunocompromised patients due to safety concerns",
        "Vaccinations for vaccine-preventable diseases like flu, COVID-19, as recommended for general population",
        "Live vaccines only, as killed vaccines are ineffective in immunosuppressed individuals",
        "Delay all vaccinations until CD4+ count exceeds 500 cells/mm³",
      ],
      correct: "B"
    },
    {
      id: 30349,
      question: "A patient presents with NUP requiring chlorhexidine rinses. She asks about potential side effects. What side effects should be discussed?",
      options: [
        "Increased bleeding and gingival hyperplasia requiring discontinuation",
        "Staining of teeth, discoloration of mucosa, calculus accumulation, altered taste",
        "Bone loss and tooth mobility from chemical damage to periodontal tissues",
        "Systemic toxicity causing liver damage and requiring laboratory monitoring",
      ],
      correct: "B"
    },
    {
      id: 30350,
      question: "A patient with HIV reports taking maraviroc (Selzentry). What class of medication is this?",
      options: [
        "Protease inhibitor (PI) preventing viral maturation",
        "Integrase inhibitor preventing DNA integration",
        "CCR5 antagonist (chemokine receptor antagonist) component of ART",
        "Fusion inhibitor preventing viral entry into cells",
      ],
      correct: "C"
    },
    {
      id: 30351,
      question: "A patient presents with cytomegalovirus retinitis and vision loss, along with a CD4+ count of 140 cells/mm³. What does cytomegalovirus retinitis with vision loss indicate?",
      options: [
        "Stage 1 HIV with mild immunosuppression not meeting AIDS criteria",
        "Stage 2 HIV with symptomatic conditions but no AIDS diagnosis",
        "AIDS-defining condition consistent with stage 3 HIV infection",
        "Normal opportunistic infection unrelated to HIV status or immune function",
      ],
      correct: "C"
    },
    {
      id: 30352,
      question: "A patient with HIV undergoes periodontal therapy. Four weeks later, you reevaluate to assess healing. Why is 4-week reevaluation timing recommended?",
      options: [
        "Immediate reevaluation provides most accurate assessment of treatment outcomes",
        "Four weeks allows connective tissue healing for accurate probing and assessment",
        "Waiting longer than 2 weeks risks reinfection requiring retreatment",
        "Four-week interval required by infection control regulations for HIV-positive patients",
      ],
      correct: "B"
    },
    {
      id: 30353,
      question: "A patient with HIV asks what conditions triggered the initial recognition of HIV/AIDS in 1981. What was observed in early HIV cases?",
      options: [
        "Seasonal influenza outbreaks affecting general population in urban areas",
        "Opportunistic illnesses typically seen in older immunocompromised individuals in young MSM",
        "Bacterial pneumonia cases in elderly patients with no risk factors",
        "Viral hepatitis outbreaks among intravenous drug users in rural communities",
      ],
      correct: "B"
    },
    {
      id: 30354,
      question: "A patient with HIV presents with Pneumocystis jirovecii pneumonia, CD4+ count of 175 cells/mm³, and oral candidiasis. What category of HIV classification does this represent?",
      options: [
        "Category A: Asymptomatic, acute primary HIV infection",
        "Category B: Symptomatic conditions not in Category C",
        "Category C: AIDS-indicator conditions including PCP",
        "Category D: Terminal AIDS with complete organ failure",
      ],
      correct: "C"
    },
    {
      id: 30355,
      question: "A patient with HIV asks about transmission through occupational exposure for dental healthcare workers since 1999. How many documented HIV transmissions have occurred in dental healthcare workers since 1999?",
      options: [
        "None documented in dental healthcare workers since 1999",
        "Approximately 50 cases in dental healthcare workers since 1999",
        "Over 100 documented cases in dental healthcare workers since 1999",
        "Exact number unknown as dental worker infections are not tracked",
      ],
      correct: "A"
    },
    {
      id: 30356,
      question: "A patient with HIV presents with herpes simplex with chronic ulcers lasting 6 weeks, CD4+ count of 185 cells/mm³. What does herpes simplex with chronic ulcer >1 month duration indicate?",
      options: [
        "Common viral infection unrelated to HIV status or immune function",
        "AIDS-defining condition meeting diagnostic criteria for stage 3 HIV",
        "Stage 1 HIV with asymptomatic infection and normal immune function",
        "Medication side effect from antiretroviral therapy requiring drug change",
      ],
      correct: "B"
    },
    {
      id: 30357,
      question: "A patient with well-controlled HIV (undetectable viral load, CD4+ 680 cells/mm³) asks if standard precautions are still necessary during dental treatment. What statement about infection control is MOST accurate?",
      options: [
        "Standard precautions not necessary for patients with undetectable viral loads",
        "Enhanced precautions beyond standard required for all HIV-positive patients regardless of status",
        "Standard precautions must be used for all patients regardless of known infection status",
        "Special HIV-specific protocols replace standard precautions for HIV-positive patients",
      ],
      correct: "C"
    },
    {
      id: 30358,
      question: "A patient with HIV presents with disseminated Mycobacterium avium complex, CD4+ count 120 cells/mm³. What does disseminated or extrapulmonary M. avium complex indicate?",
      options: [
        "Common bacterial infection treatable with standard oral antibiotics",
        "AIDS-defining condition consistent with stage 3 HIV infection diagnosis",
        "Normal flora overgrowth from antiretroviral medication side effects",
        "Vaccine-preventable disease indicating need for immunization update",
      ],
      correct: "B"
    },
    {
      id: 30359,
      question: "A patient with HIV asks about the risk of HIV transmission through exposure via eye, nose, or mouth. What is the estimated transmission risk through mucous membrane exposure?",
      options: [
        "Approximately 0.1% through eye, nose, or mouth exposure",
        "Approximately 1% through eye, nose, or mouth exposure",
        "Approximately 5% through eye, nose, or mouth exposure",
        "Approximately 10% through eye, nose, or mouth exposure",
      ],
      correct: "A"
    }
  ],
  "5. Autoimmune Diseases (Case Study)": [
    {
      id: 30400,
      question: "A 45-year-old female patient presents with complaints of chronic fatigue, joint pain, and multiple autoimmune conditions including rheumatoid arthritis and hypothyroidism. She reports experiencing symptoms for over 2 years before receiving a definitive diagnosis. During the health history review, she mentions feeling frustrated with the lengthy diagnostic process. What characteristic of autoimmune diseases does this patient's experience BEST exemplify?",
      options: [
        "Patients often present with cluster disorders and multisystem involvement with nondescript symptoms, leading to lengthy periods without definitive diagnosis",
        "Patients with autoimmune diseases typically experience rapid diagnosis due to distinctive symptoms that are easily identified by healthcare providers",
        "Autoimmune diseases primarily affect single organ systems, making diagnosis straightforward once the affected organ is identified by specialists",
        "The diagnostic process is typically brief because autoimmune diseases produce highly specific symptoms that are unique to each condition",
      ],
      correct: "A"
    },
    {
      id: 30401,
      question: "A 52-year-old male patient with systemic lupus erythematosus presents for a routine dental hygiene appointment. His medical history reveals he had pericarditis 2 years ago and is currently taking cyclophosphamide, an immunosuppressant. Recent lab work shows a low white blood cell count. What is the MOST appropriate action for the dental hygienist before beginning periodontal debridement?",
      options: [
        "Consult with the patient's physician regarding the need for antibiotic premedication due to history of pericarditis and immunosuppression",
        "Proceed with treatment as planned since the patient's pericarditis occurred over a year ago and antibiotic premedication is no longer necessary",
        "Delay all treatment indefinitely until the patient discontinues cyclophosphamide therapy to eliminate the risk of opportunistic infections",
        "Begin periodontal therapy immediately using only hand instruments to minimize bleeding risk associated with immunosuppressant medications",
      ],
      correct: "A"
    },
    {
      id: 30402,
      question: "A 60-year-old patient with rheumatoid arthritis has been taking high-dose aspirin and NSAIDs for pain management over the past 6 months. She presents for periodontal maintenance and reports increased bruising and occasional gingival bleeding when brushing her teeth. What is the MOST likely cause of the patient's bleeding symptoms?",
      options: [
        "The medications inhibit cyclooxygenase enzyme, reducing prostaglandin synthesis and affecting hemostasis and platelet function",
        "The medications cause direct bone marrow suppression, leading to severe thrombocytopenia and decreased platelet production",
        "The medications stimulate excessive production of clotting factors, paradoxically causing spontaneous bleeding in oral tissues",
        "The medications induce xerostomia that causes tissue friability, making the gingiva more susceptible to mechanical trauma",
      ],
      correct: "A"
    },
    {
      id: 30403,
      question: "A 42-year-old patient taking chronic corticosteroid therapy (20 mg prednisone daily for 18 months) is scheduled for a surgical extraction. The patient reports taking his usual morning dose of prednisone 1.5 hours before the appointment. Local anesthesia with epinephrine will be used. What is the MOST appropriate approach regarding steroid supplementation for this patient?",
      options: [
        "The patient likely has adequate steroid levels from his usual dose taken within 2 hours, and local anesthesia reduces stress response",
        "Administer 100 mg intravenous hydrocortisone immediately before surgery because all patients on chronic steroids require supplementation",
        "Discontinue all corticosteroid medications 48 hours before surgery to allow the patient's adrenal glands to resume normal function",
        "Double the patient's usual prednisone dose for 3 days before and after surgery regardless of the surgical procedure complexity",
      ],
      correct: "A"
    },
    {
      id: 30404,
      question: "During a periodontal maintenance appointment, a 48-year-old patient with an undiagnosed condition reports chronic fatigue, widespread muscle and joint pain, difficulty sleeping, and symptoms that worsen during winter months. She mentions having multiple consultations with various specialists without receiving a definitive diagnosis. These symptoms are MOST consistent with which aspect of autoimmune disease development?",
      options: [
        "The patient is exhibiting characteristics of autoimmune disease including nondescript symptoms and potential environmental triggers like seasonal infections",
        "The patient is experiencing acute adrenal crisis requiring immediate hospitalization and intravenous hydrocortisone administration",
        "The patient likely has primary adrenal insufficiency from destruction of adrenal glands, causing secondary autoimmune manifestations",
        "The patient is demonstrating clear symptoms of medication-induced lupus from prolonged NSAID use requiring immediate drug discontinuation",
      ],
      correct: "A"
    },
    {
      id: 30405,
      question: "A dental hygienist is reviewing the health history of a new patient who reports having an autoimmune condition. The patient describes a \"butterfly rash\" on her face, sensitivity to sunlight, joint pain, and occasional oral ulcerations on the palate and buccal mucosa. She takes hydroxychloroquine and prednisone. These clinical findings are MOST consistent with which autoimmune disease?",
      options: [
        "Systemic lupus erythematosus, which affects multiple organ systems and may present with malar rash and oral lesions",
        "Pemphigus vulgaris, which causes bullae that rupture and form painful ulcers on skin and mucous membranes",
        "Psoriasis with associated psoriatic arthritis, characterized by white or red plaques and joint involvement",
        "Pernicious anemia, which presents with painful red burning tongue, oral ulcerations, and vitamin B12 deficiency",
      ],
      correct: "A"
    },
    {
      id: 30406,
      question: "A patient with rheumatoid arthritis who underwent total knee replacement surgery 8 months ago is scheduled for periodontal scaling and root planing. The patient is currently taking methotrexate and reports well-controlled disease with no active joint inflammation. What should the dental hygienist do regarding antibiotic prophylaxis for this patient?",
      options: [
        "Consult the American Academy of Orthopedic Surgeons Appropriate Use Criteria to determine if antibiotic premedication is indicated",
        "Automatically prescribe prophylactic antibiotics for all patients with joint replacements regardless of time since surgery or current health status",
        "Avoid all periodontal instrumentation permanently because patients with prosthetic joints cannot safely receive subgingival scaling procedures",
        "Delay treatment until the patient discontinues methotrexate therapy since immunosuppressants contraindicate all dental procedures",
      ],
      correct: "A"
    },
    {
      id: 30407,
      question: "During a patient assessment, the dental hygienist notes the patient is taking tofacitinib, a JAK inhibitor, along with other disease-modifying antirheumatic drugs (DMARDs). The patient reports that this medication was recently added to her treatment regimen and has provided rapid pain relief. This medication is MOST likely being used to treat which condition?",
      options: [
        "Rheumatoid arthritis, by suppressing intracellular signaling mediated by cytokines involved in joint inflammation",
        "Hyperthyroidism, by suppressing thyroid hormone production and reducing metabolic rate and associated symptoms",
        "Multiple sclerosis, by promoting remyelination of nerve fibers in the central nervous system affected by chronic inflammation",
        "Pernicious anemia, by enhancing intrinsic factor production in the stomach and improving vitamin B12 absorption",
      ],
      correct: "A"
    },
    {
      id: 30408,
      question: "A 47-year-old female patient reports chronic widespread pain in muscles and joints, severe fatigue, sleep disturbances, and TMJ dysfunction. She has visited multiple healthcare providers and received various diagnoses. She also has a history of rheumatoid arthritis. These symptoms are MOST characteristic of which autoimmune condition?",
      options: [
        "Fibromyalgia, a musculoskeletal disorder with frequent comorbidity with other autoimmune conditions including rheumatoid arthritis",
        "Hypothyroidism, which causes muscle weakness, fatigue, and delayed reflexes due to insufficient thyroid hormone production",
        "Pemphigus vulgaris, a severe progressive disease affecting skin and mucous membranes with bullae formation",
        "Adrenal insufficiency, which results from destruction of adrenal glands causing fatigue and muscle weakness",
      ],
      correct: "A"
    },
    {
      id: 30409,
      question: "A patient with confirmed autoimmune disease presents with blue-black pigmentation on the oral mucosa, multiple areas of alopecia, and reports persistent skin rashes. The patient is taking penicillamine and gold compounds for disease management. These oral and systemic findings are MOST likely adverse effects of which medication category?",
      options: [
        "Disease-modifying antirheumatic drugs (DMARDs) that have known dermatologic toxicities including oral lesions and hair loss",
        "Anticytokine therapies that block tumor necrosis factor-alpha and cause paradoxical autoimmune reactions in some patients",
        "Corticosteroids that suppress collagen synthesis leading to tissue pigmentation changes and dermatologic manifestations",
        "Nonsteroidal anti-inflammatory drugs (NSAIDs) that inhibit prostaglandin synthesis causing mucosal melanosis and skin eruptions",
      ],
      correct: "A"
    },
    {
      id: 30410,
      question: "A 58-year-old patient with Graves disease (hyperthyroidism) presents for emergency dental care due to acute infection. The patient appears anxious, has a rapid pulse, and exhibits a visible tremor in the tongue. The patient's thyroid gland appears enlarged. What precaution is MOST important for the dental hygienist to take?",
      options: [
        "Avoid overpalpation of the thyroid gland and limit vasoconstrictor use or avoid it if hyperthyroidism is uncontrolled",
        "Administer high doses of vasoconstrictor with local anesthesia to ensure adequate pain control and reduce patient anxiety",
        "Prescribe prophylactic antibiotics to all hyperthyroid patients before any dental procedure to prevent thyroid storm",
        "Use only general anesthesia for all procedures because local anesthetics are contraindicated in patients with thyroid disorders",
      ],
      correct: "A"
    },
    {
      id: 30411,
      question: "A dental hygienist is conducting a risk assessment for a patient with suspected autoimmune disease. The patient reports a 20-pound unintentional weight loss over 6 months, chronic fatigue, frequent cold-like symptoms, difficulty performing routine daily activities, and loss of interest in hobbies. What is the MOST appropriate action for the dental hygienist?",
      options: [
        "Make a prompt referral to the patient's physician for medical evaluation because these signs suggest possible autoimmune disease",
        "Proceed with routine dental hygiene treatment since these symptoms are common in the general population and not concerning",
        "Recommend over-the-counter vitamin supplements and dietary changes to address fatigue without involving other healthcare providers",
        "Schedule the patient for periodontal surgery immediately to address potential oral manifestations of undiagnosed disease",
      ],
      correct: "A"
    },
    {
      id: 30412,
      question: "A 41-year-old patient with pernicious anemia presents for dental hygiene care. She reports a painful, burning sensation on her tongue. Clinical examination reveals a red, inflamed tongue with atrophy of the filiform papillae and several oral ulcerations. What is the underlying cause of this patient's oral symptoms?",
      options: [
        "Failure to produce intrinsic factor in the stomach and subsequent cobalamin (vitamin B12) deficiency",
        "Excessive vitamin B12 production causing hypervitaminosis and direct toxic effects on oral epithelial tissues",
        "Overproduction of intrinsic factor leading to malabsorption of iron and resulting in glossitis and ulcerations",
        "Autoimmune destruction of parietal cells causing excessive gastric acid secretion that damages oral mucosa",
      ],
      correct: "A"
    },
    {
      id: 30413,
      question: "A 39-year-old patient with systemic lupus erythematosus presents for emergency dental treatment during an active disease flare. The patient reports severe fatigue, joint pain, and has developed new oral lesions. She is taking immunosuppressive medications. What education about environmental factors should the dental hygienist provide?",
      options: [
        "Low vitamin D levels, UV radiation exposure, and fluctuations in melatonin may contribute to autoimmunity and disease flares",
        "High vitamin D levels, minimal sun exposure, and stable melatonin levels that maintain immune system balance",
        "Excessive protein intake, dehydration, and high altitude living that alter immune system function",
        "Carbohydrate restriction, ketogenic diets, and intermittent fasting that modify autoimmune responses",
      ],
      correct: "A"
    },
    {
      id: 30414,
      question: "A patient with systemic lupus erythematosus reports recently experiencing a severe flare-up during winter following an upper respiratory infection. The patient asks why the disease seems to worsen during certain seasons. What is the BEST explanation for this pattern?",
      options: [
        "Seasonal patterns of infections correlate with autoimmune flare-ups, such as Epstein-Barr virus in winter triggering lupus exacerbations",
        "Cold temperatures directly damage immune cells, causing temporary immunodeficiency that allows unchecked autoimmune reactions",
        "Winter weather increases vitamin D levels that paradoxically stimulate autoimmune responses in genetically susceptible individuals",
        "Decreased humidity in winter causes dehydration that concentrates autoantibodies in tissues, worsening disease symptoms",
      ],
      correct: "A"
    },
    {
      id: 30415,
      question: "During an oral examination, the dental hygienist observes bilateral enlargement of the parotid glands in a 57-year-old female patient. The patient reports dry eyes, extreme dry mouth, and difficulty wearing her partial denture. Intraoral examination reveals multiple cervical caries. What assessment tool would be MOST useful for evaluating this patient's quality of life?",
      options: [
        "The modified Oral Health Impact Profile (OHIP) or Mouth Handicap in Systemic Sclerosis scale (MHISS)",
        "The Plaque Index and Gingival Index to measure biofilm levels and gingival inflammation objectively",
        "The Periodontal Screening and Recording (PSR) system to assess periodontal status in all sextants",
        "The Decayed Missing Filled Teeth (DMFT) index to quantify the patient's caries experience",
      ],
      correct: "A"
    },
    {
      id: 30416,
      question: "A patient with systemic sclerosis presents for dental hygiene care. The patient has microstomia with limited mouth opening of 25mm. The dental hygienist is planning the treatment approach. What modification is MOST important for this patient's care?",
      options: [
        "Teach isometric exercises to maintain facial muscle mobility and use modified instruments for limited access",
        "Recommend immediate surgical intervention to increase mouth opening before providing any dental hygiene treatment",
        "Refer for full mouth extraction and immediate dentures since oral hygiene will be impossible with limited opening",
        "Provide treatment only with ultrasonic instrumentation positioned from the facial aspect without accessing lingual surfaces",
      ],
      correct: "A"
    },
    {
      id: 30417,
      question: "A 51-year-old patient with rheumatoid arthritis reports taking large doses of NSAIDs daily for pain control. The patient presents with gastrointestinal complaints and multiple areas of gingival bleeding. Periodontal probing reveals bleeding on probing in all quadrants. What is the MOST likely explanation for the gingival bleeding?",
      options: [
        "The NSAIDs inhibit cyclooxygenase and prostaglandin synthesis, affecting hemostasis and increasing bleeding tendency",
        "The NSAIDs are causing direct toxic injury to gingival tissues, resulting in tissue necrosis and spontaneous bleeding",
        "The patient has developed severe thrombocytosis from NSAID use, causing excessive clotting and paradoxical bleeding",
        "The gingival bleeding is unrelated to NSAID use and indicates acute necrotizing ulcerative gingivitis requiring antibiotics",
      ],
      correct: "A"
    },
    {
      id: 30418,
      question: "A patient taking disease-modifying antirheumatic drugs (DMARDs) for 8 months reports no improvement in symptoms and asks about changing medications. The patient expected faster results. What information should the dental hygienist provide about DMARDs?",
      options: [
        "DMARDs have relatively slow onset and patients may need to take them for up to 4 months before seeing effects",
        "DMARDs work immediately and lack of response indicates drug resistance requiring different therapy",
        "The patient is likely not taking the medication correctly and needs detailed instructions for proper administration",
        "All DMARDs are equally effective and switching medications will not improve outcomes",
      ],
      correct: "A"
    },
    {
      id: 30419,
      question: "A 53-year-old patient with hypothyroidism presents with an enlarged tongue and facial swelling. The patient reports feeling cold, fatigued, and has gained significant weight. The patient is scheduled for a minor surgical procedure with sedation. What medication adjustment is MOST important for this patient?",
      options: [
        "Use lower doses of sedatives and opiates because hypothyroid patients are more sensitive to CNS depressants",
        "Increase sedative doses significantly since hypothyroid patients metabolize drugs more rapidly",
        "Avoid all pain medications completely since hypothyroid patients cannot safely metabolize any drugs",
        "Administer standard medication doses without adjustment since thyroid function doesn't affect drug metabolism",
      ],
      correct: "A"
    },
    {
      id: 30420,
      question: "A 38-year-old patient with a confirmed autoimmune disease arrives for a dental hygiene appointment. During the pharmacologic history review, the patient reports taking methotrexate and prednisone daily. The patient mentions starting these medications 3 months ago and asks about potential oral side effects. What is the MOST important oral health concern the dental hygienist should monitor in this patient?",
      options: [
        "The patient is at increased risk for gingival recession due to the vasoconstrictive effects of methotrexate on periodontal blood vessels",
        "The patient is at high risk for candidiasis due to xerostomic effects and immune suppression from corticosteroid therapy",
        "The patient may develop severe tooth sensitivity because both medications cause enamel hypoplasia and dentin exposure in adult patients",
        "The patient will likely experience rapid tooth movement and malocclusion from the bone-softening effects of long-term prednisone use",
      ],
      correct: "B"
    },
    {
      id: 30421,
      question: "A 29-year-old female patient presents with painful oral lesions and reports avoiding toothpaste, spicy foods, and cinnamon due to severe discomfort. Clinical examination reveals generalized desquamative gingivitis with friable, erythematous, ulcerated tissue. The patient also has a mucous membrane covering part of her right eye. Based on these findings, which autoimmune disease should the dental hygienist MOST likely suspect?",
      options: [
        "Sjögren syndrome, characterized by severe xerostomia, enlarged parotid glands, and difficulty wearing dentures",
        "Cicatricial pemphigoid, characterized by blistering disease affecting oral mucosa, conjunctiva, and healing with scarring",
        "Systemic sclerosis, characterized by microstomia, widened periodontal ligaments, and firm hypomobile tongue",
        "Multiple sclerosis, characterized by trigeminal neuralgia, orofacial numbness, and paresthesia in oral tissues",
      ],
      correct: "B"
    },
    {
      id: 30422,
      question: "A 55-year-old patient with confirmed Sjögren syndrome presents for a dental hygiene appointment. She reports severe dry mouth, difficulty swallowing, and burning sensations on her tongue. Clinical examination reveals erythematous oral mucosa, enlarged parotid glands, cervical caries, and a fissured tongue with papillary atrophy. Which intervention should be the HIGHEST priority in the dental hygiene care plan?",
      options: [
        "Recommend isometric exercises to improve jaw mobility and prevent the development of microstomia and limited mouth opening",
        "Implement daily fluoride application, remineralization therapy, and xylitol products to prevent xerostomia-induced dental caries",
        "Prescribe a soft diet with moist heat applications to reduce temporomandibular joint inflammation and associated pain",
        "Provide orthodontic consultation for anterior open bite correction and mandibular repositioning to improve occlusion",
      ],
      correct: "B"
    },
    {
      id: 30423,
      question: "A 35-year-old patient with myasthenia gravis presents for dental hygiene treatment. She reports drooping eyelids, double vision, difficulty chewing and swallowing, and weakness in facial muscles. The patient expresses concern about tolerating the appointment. What modifications should the dental hygienist implement to provide safe care?",
      options: [
        "Schedule long afternoon appointments when acetylcholine levels are highest, and avoid using any mouth props that might stress facial muscles",
        "Schedule short early morning appointments, use rubber dam and evacuation, monitor breathing ease, and support the lower jaw as needed",
        "Use aggressive mechanical instrumentation without breaks to complete treatment quickly before muscle fatigue becomes problematic",
        "Prescribe muscle relaxants before the appointment to reduce facial tension and improve the patient's ability to maintain mouth opening",
      ],
      correct: "B"
    },
    {
      id: 30424,
      question: "A 50-year-old female patient with systemic sclerosis presents for evaluation. Radiographic examination reveals widened periodontal ligament spaces around multiple teeth. Clinical examination shows microstomia, limited mouth opening, xerostomia, generalized gingival recession, and a firm, hypomobile tongue. Which intervention is MOST appropriate for managing this patient's oral health needs?",
      options: [
        "Recommend immediate extraction of all teeth with widened PDL spaces to prevent pathologic jaw fractures during routine function",
        "Implement modified oral hygiene devices, salivary replacement therapy, fluoride regimen, and isometric exercises to maintain facial muscle mobility",
        "Prescribe high-dose NSAIDs to reduce periodontal inflammation and restore normal periodontal ligament width around affected teeth",
        "Refer for orthodontic treatment to correct the anterior open bite before addressing any other oral health concerns",
      ],
      correct: "B"
    },
    {
      id: 30425,
      question: "A 44-year-old patient presents with complaints of dry eyes and extremely dry mouth that have persisted for over 6 months. She reports difficulty wearing her dentures and an altered sense of taste. Clinical examination reveals erythematous mucosa, bilaterally enlarged parotid glands, a fissured tongue with atrophied papillae, and multiple cervical carious lesions. What is the MOST important factor the dental hygienist should explain regarding this patient's caries risk?",
      options: [
        "The cervical caries are caused by excessive consumption of acidic beverages to relieve dry mouth symptoms and can be controlled with dietary counseling",
        "The severe xerostomia creates an oral environment conducive to Streptococcus mutans proliferation and significantly increases caries risk",
        "The carious lesions result from medication-induced enamel hypoplasia that makes teeth structurally weak and prone to rapid decay",
        "The tooth decay is primarily due to inadequate oral hygiene practices related to denture-wearing difficulties and can be resolved with better brushing",
      ],
      correct: "B"
    },
    {
      id: 30426,
      question: "A 56-year-old patient with multiple sclerosis arrives for a dental hygiene appointment during an active disease exacerbation. The patient reports increased muscle weakness, difficulty with ambulation, and recent trigeminal neuralgia. She is currently taking immunosuppressive medications and corticosteroids. What is the MOST appropriate action for the dental hygienist?",
      options: [
        "Proceed with aggressive periodontal debridement immediately to prevent oral infection during the period of immunosuppression",
        "Defer dental hygiene treatment until the patient is in remission and schedule treatment for periods when disease is not active",
        "Provide treatment using only ultrasonic instrumentation to reduce appointment time and minimize physical demands on the patient",
        "Complete all planned procedures today regardless of disease activity because delaying treatment will worsen the patient's periodontal status",
      ],
      correct: "B"
    },
    {
      id: 30427,
      question: "A 62-year-old patient with chronic corticosteroid use presents for routine dental hygiene care. During the appointment, the dental hygienist measures the patient's blood pressure and obtains a reading of 95/58 mm Hg. The patient appears pale, is sweating profusely, and complains of feeling weak. What condition should the dental hygienist suspect, and what is the immediate action?",
      options: [
        "The patient is experiencing hyperglycemia from steroid use; administer glucose tablets and monitor vital signs for improvement",
        "The patient may be experiencing adrenal crisis; position with feet elevated, prepare for emergency response and possible hospitalization",
        "The patient is having an allergic reaction to latex gloves; remove all latex products and administer antihistamine medication",
        "The patient is demonstrating orthostatic hypotension; have the patient stand and walk around the operatory to improve circulation",
      ],
      correct: "B"
    },
    {
      id: 30428,
      question: "A 33-year-old patient presents with vesicles and bullae on the oral mucosa that rupture easily, leaving large areas of painful, ulcerated tissue. The lesions have persisted for several weeks. The patient reports difficulty eating and speaking. Similar lesions are present on the skin. Based on these clinical findings, what is the MOST likely diagnosis?",
      options: [
        "Cicatricial pemphigoid, which heals with scarring and primarily affects elderly patients with chronic blistering",
        "Pemphigus vulgaris, a progressive severe disease characterized by bullae that rupture and form painful ulcers",
        "Systemic sclerosis, which causes microstomia, xerostomia, and firm hypomobile tongue with tissue induration",
        "Lichen planus, which presents with white striae on buccal mucosa and occasionally causes erosive lesions",
      ],
      correct: "B"
    },
    {
      id: 30429,
      question: "A patient with systemic sclerosis presents for periodontal maintenance. Radiographic examination reveals significant resorption of the mandibular angle and condyle, along with osseous destruction of the temporomandibular joint. The patient reports difficulty chewing due to limited jaw opening. What is the MOST serious concern related to these radiographic findings?",
      options: [
        "The patient requires immediate orthodontic intervention to correct the anterior open bite before it progresses further",
        "The patient is at increased risk for pathologic jaw fractures late in the disease process due to mandibular bone destruction",
        "The patient will develop severe bruxism that will rapidly destroy remaining tooth structure without immediate splint therapy",
        "The patient needs surgical reconstruction of the TMJ to restore normal jaw function and prevent complete ankylosis",
      ],
      correct: "B"
    },
    {
      id: 30430,
      question: "A patient taking chronic corticosteroids for autoimmune disease management complains of persistent white patches in the mouth that can be wiped away, leaving a red, raw surface. The patient reports decreased saliva production and difficulty tasting food. What is the MOST likely diagnosis and appropriate intervention?",
      options: [
        "Leukoplakia requiring immediate biopsy to rule out malignant transformation and surgical excision if dysplasia is present",
        "Candidiasis secondary to xerostomia and immunosuppression requiring antifungal therapy and salivary replacement",
        "Lichen planus requiring topical corticosteroid application to reduce inflammation and prevent erosive changes",
        "Hairy leukoplakia indicating HIV infection requiring antiretroviral therapy and referral to infectious disease specialist",
      ],
      correct: "B"
    },
    {
      id: 30431,
      question: "A 39-year-old patient with systemic lupus erythematosus presents with painful oral lesions on the palate and buccal mucosa. The lesions appear lichenoid with areas of ulceration, erythema, and hyperkeratosis. The patient also reports altered taste and oral mucosal pain when eating. What interventions should the dental hygienist include in the care plan?",
      options: [
        "Recommend extraction of all teeth adjacent to lesions to prevent spread of disease and eliminate source of oral bacteria",
        "Apply topical pain control agents, monitor nutrition, implement fluoride therapy, and educate about avoiding spicy foods",
        "Prescribe high-dose systemic antibiotics to treat the underlying bacterial infection causing the oral lesions",
        "Refer immediately for oral surgery and tissue grafting to reconstruct areas of tissue loss before lesions worsen",
      ],
      correct: "B"
    },
    {
      id: 30432,
      question: "During a health history update, a patient reveals she was recently diagnosed with an autoimmune disease after experiencing a severe upper respiratory infection followed by persistent fever and joint pain. She asks why the infection might have triggered her autoimmune condition. What is the BEST explanation for this phenomenon?",
      options: [
        "Infections cause temporary immunosuppression that allows dormant autoimmune diseases to become active and symptomatic",
        "Infections trigger local immune response with cytokine release that can activate self-reactive T cells and initiate autoimmunity",
        "Viral infections directly destroy self-antigens, eliminating the body's tolerance and causing permanent autoimmune disease",
        "Bacterial infections produce toxins that permanently alter DNA, causing genetic mutations that create autoimmune diseases",
      ],
      correct: "B"
    },
    {
      id: 30433,
      question: "A patient with rheumatoid arthritis reports having difficulty performing oral hygiene due to limited manual dexterity and joint pain in the hands. The patient has moderate biofilm accumulation and localized areas of gingival inflammation. What is the MOST appropriate recommendation to improve the patient's oral hygiene?",
      options: [
        "Discontinue all home care practices and rely exclusively on professional cleanings every 2 weeks to maintain oral health",
        "Recommend powered toothbrush and modified interdental aids with enlarged handles to accommodate limited dexterity",
        "Prescribe systemic antibiotics for daily use as a substitute for mechanical biofilm removal the patient cannot perform",
        "Advise the patient to use only mouthrinse twice daily since physical toothbrushing is too difficult with joint limitations",
      ],
      correct: "B"
    },
    {
      id: 30434,
      question: "A 54-year-old patient taking azathioprine and cyclophosphamide for refractory rheumatoid arthritis is scheduled for scaling and root planing. Recent laboratory results show leukopenia and thrombocytopenia. What is the MOST important consideration before proceeding with treatment?",
      options: [
        "Proceed with treatment as planned using ultrasonic instrumentation only to minimize tissue trauma and bleeding",
        "Evaluate complete blood count and consult with physician regarding infection risk and need for antibiotic prophylaxis",
        "Prescribe prophylactic antifungal medication to prevent candidiasis during the immunosuppressed state",
        "Delay treatment for 6 months until immunosuppressive medications are discontinued and blood counts normalize",
      ],
      correct: "B"
    },
    {
      id: 30435,
      question: "A patient presents with geographic tongue, white plaques on the buccal mucosa, and reports having psoriasis with associated arthritis. The patient is concerned about the oral lesions and asks if they are related to the skin condition. What should the dental hygienist explain to the patient?",
      options: [
        "The oral lesions are completely unrelated to psoriasis and indicate a separate infectious disease requiring antibiotic treatment",
        "Oral manifestations of psoriasis are rare but can include white or red plaques, and geographic tongue may occur with psoriasis",
        "All patients with psoriasis automatically develop severe oral lesions that require surgical excision to prevent malignant transformation",
        "The oral lesions indicate that the psoriatic arthritis is progressing rapidly and the patient needs immediate rheumatology referral",
      ],
      correct: "B"
    },
    {
      id: 30436,
      question: "A dental hygienist is reviewing medications with a patient who has an autoimmune disease. The patient is taking etanercept, an anticytokine therapy that blocks tumor necrosis factor-alpha. This medication is MOST likely prescribed for which condition and purpose?",
      options: [
        "Hypothyroidism to stimulate thyroid hormone production and increase metabolic rate in patients unresponsive to hormone replacement",
        "Severe rheumatoid arthritis to block inflammatory cytokines, reduce cartilage degradation, and inhibit bone resorption",
        "Multiple sclerosis to promote remyelination of nerves and prevent further demyelination in the central nervous system",
        "Pernicious anemia to enhance intrinsic factor synthesis and improve vitamin B12 absorption in the gastrointestinal tract",
      ],
      correct: "B"
    },
    {
      id: 30437,
      question: "A 36-year-old patient with cicatricial pemphigoid presents with painful oral lesions and reports difficulty speaking. The patient is being treated with systemic corticosteroids. During examination, the dental hygienist notices the patient has ocular involvement. What is the MOST important recommendation for this patient?",
      options: [
        "Discontinue all oral hygiene practices until lesions completely heal to prevent further trauma to affected tissues",
        "Consult with physician regarding eye protection and monitor for difficulty speaking or breathing due to lesion progression",
        "Increase frequency of dental visits to once per week for professional debridement to control oral biofilm",
        "Extract all teeth immediately to eliminate sources of oral bacteria that could worsen the autoimmune condition",
      ],
      correct: "B"
    },
    {
      id: 30438,
      question: "A patient with Sjögren syndrome asks about products to help manage severe xerostomia. The patient reports using artificial saliva occasionally but wants to know about other options to stimulate natural saliva production. What is the MOST appropriate recommendation?",
      options: [
        "Prescribe high-dose antibiotics to reduce oral bacterial load since salivary flow cannot be improved in Sjögren patients",
        "Recommend salivary stimulants like pilocarpine or cevimeline, along with xylitol gum to stimulate flow and reduce caries risk",
        "Advise drinking caffeinated beverages frequently throughout the day to systemically stimulate all salivary gland function",
        "Suggest discontinuing all current medications since drug-induced xerostomia is the only cause of dry mouth in these patients",
      ],
      correct: "B"
    },
    {
      id: 30439,
      question: "A patient taking hydroxychloroquine (antimalarial agent) for rheumatoid arthritis presents for periodontal maintenance. The patient reports taking the medication for 4 months but has not yet experienced significant pain relief. What should the dental hygienist explain about this medication?",
      options: [
        "The medication is ineffective and should be discontinued immediately in favor of more potent immunosuppressive drugs",
        "Disease-modifying antirheumatic drugs like hydroxychloroquine have slow onset and may require up to 4 months to show effects",
        "The patient is not taking a high enough dose and needs to double the current dosage for therapeutic effect",
        "This medication works immediately upon administration and the continued pain indicates drug resistance requiring different therapy",
      ],
      correct: "B"
    },
    {
      id: 30440,
      question: "A 45-year-old patient with confirmed autoimmune disease is taking corticosteroids and develops osteoporosis. Radiographic examination reveals diffuse demineralization of the mandible and marked loss of alveolar process. This finding is MOST consistent with which autoimmune condition?",
      options: [
        "Myasthenia gravis, which causes progressive muscle weakness but does not typically affect bone density or structure",
        "Hypothyroidism, which causes delayed dental development in children but increased bone density in adults",
        "Hyperthyroidism, which can cause osteoporosis in skull bones, accelerated tooth eruption, and rapid periodontal disease progression",
        "Fibromyalgia, which affects muscles and soft tissues without causing any changes in bone mineralization",
      ],
      correct: "C"
    },
    {
      id: 30441,
      question: "A patient with multiple sclerosis taking medications that cause xerostomia presents with multiple areas of hypersensitivity and new carious lesions. The patient reports difficulty maintaining oral hygiene due to hand tremors and muscle weakness. What combination of interventions would be MOST beneficial?",
      options: [
        "Prescribe systemic antibiotics for long-term daily use and recommend eliminating all carbohydrates from the diet",
        "Advise using only water for oral hygiene and avoiding all dental products that might cause adverse reactions",
        "Recommend power toothbrush for biofilm control, fluoride therapy for caries prevention, and salivary replacement for xerostomia",
        "Suggest extraction of all sensitive teeth and immediate denture fabrication to eliminate need for complex home care",
      ],
      correct: "C"
    },
    {
      id: 30442,
      question: "A patient with pemphigus vulgaris presents with superficial erosions and ulcerations on the palate, buccal mucosa, and gingiva. The lesions have a \"ragged\" appearance with haphazard distribution. The patient reports severe pain when eating. What is the MOST appropriate intervention for this patient?",
      options: [
        "Perform aggressive periodontal debridement to remove all biofilm and promote rapid healing of the ulcerated tissues",
        "Apply concentrated hydrogen peroxide to lesions at each visit to disinfect tissues and prevent secondary infections",
        "Provide topical pain control agents and consult with physician for early diagnosis and systemic corticosteroid treatment",
        "Recommend high-frequency ultrasonic scaling to stimulate tissue regeneration and accelerate lesion resolution",
      ],
      correct: "C"
    },
    {
      id: 30443,
      question: "A dental hygienist is providing patient education to a 60-year-old with Sjögren syndrome who has severe xerostomia and multiple cervical caries. The patient asks about the relationship between dry mouth and tooth decay. What is the MOST accurate explanation?",
      options: [
        "Dry mouth causes direct demineralization of enamel through chemical processes unrelated to bacterial activity",
        "The medications used to treat Sjögren syndrome directly soften tooth structure, making teeth vulnerable to caries",
        "Xerostomia creates an environment that favors Streptococcus mutans proliferation, significantly increasing caries risk",
        "Saliva contains excessive fluoride in Sjögren patients, which paradoxically weakens enamel and promotes decay",
      ],
      correct: "C"
    },
    {
      id: 30444,
      question: "A 43-year-old patient with systemic lupus erythematosus who takes immunosuppressive medication presents for routine care. The patient mentions experiencing frequent respiratory infections. Recent lab work shows normal white blood cell count. What is the MOST appropriate treatment approach?",
      options: [
        "Postpone all dental hygiene treatment indefinitely until the patient discontinues immunosuppressive therapy completely",
        "Provide treatment using only chemotherapeutic agents without any mechanical instrumentation to minimize infection risk",
        "Proceed with planned treatment after reviewing current lab work and confirming adequate immune function with physician",
        "Prescribe prophylactic antibiotics for daily use throughout the year to prevent all possible oral infections",
      ],
      correct: "C"
    },
    {
      id: 30445,
      question: "A patient with hyperthyroidism arrives for emergency treatment of an acute dental abscess. The patient appears extremely anxious, has a rapid heartbeat (120 bpm), and is perspiring heavily. The patient reports feeling very warm and nervous. What precaution is MOST critical when managing this patient?",
      options: [
        "Administer maximum allowable dose of epinephrine with local anesthesia to ensure complete pain control",
        "Perform vigorous palpation of the thyroid gland to assess size and nodularity before proceeding with treatment",
        "Manage stress and anxiety carefully, limit or avoid vasoconstrictors, and monitor vital signs to minimize thyroid storm risk",
        "Prescribe high doses of central nervous system depressants since hyperthyroid patients are more tolerant to sedatives",
      ],
      correct: "C"
    },
    {
      id: 30446,
      question: "A 38-year-old patient with confirmed autoimmune disease presents with depression, frustration, and reports seeing multiple healthcare providers over 3 years before receiving a diagnosis. The patient expresses anxiety about oral health. What aspect of autoimmune disease does this scenario illustrate?",
      options: [
        "All autoimmune diseases cause direct neurological damage leading to psychiatric disorders requiring antidepressant medication",
        "Depression in autoimmune patients is unrelated to the diagnostic process and is caused solely by medication side effects",
        "Patients often experience psychiatric difficulties like depression from numerous consultations without definitive diagnosis for lengthy periods",
        "Anxiety and frustration are not legitimate concerns in autoimmune patients and should be dismissed by healthcare providers",
      ],
      correct: "C"
    },
    {
      id: 30447,
      question: "A patient taking methotrexate for rheumatoid arthritis develops oral ulcerations and inflammation. The patient has been taking the medication for 6 weeks and asks if these oral symptoms are related to the drug. What is the MOST appropriate response?",
      options: [
        "These symptoms indicate drug allergy requiring immediate discontinuation and emergency medical treatment for anaphylaxis",
        "The oral lesions are unrelated to methotrexate and indicate a new autoimmune disease requiring additional immunosuppression",
        "Methotrexate can cause oral mucosal lesions as an adverse effect, and the patient should consult their physician about symptoms",
        "This is a normal expected effect that requires no intervention and will resolve spontaneously without treatment",
      ],
      correct: "C"
    },
    {
      id: 30448,
      question: "A 55-year-old patient with scleroderma presents with anterior open bite, limited mouth opening, and difficulty with speech and swallowing due to a firm, hypomobile tongue. Radiographs reveal widened periodontal ligament spaces. What is the clinical significance of the widened PDL spaces?",
      options: [
        "This finding indicates acute periodontal abscess requiring immediate incision and drainage with antibiotic therapy",
        "This radiographic finding proves the patient has undiagnosed periodontal disease requiring immediate surgical intervention",
        "Widened PDL spaces are characteristic of systemic sclerosis and reflect the systemic nature of the disease process",
        "Widened PDL indicates root resorption from orthodontic forces and requires immediate cessation of appliance therapy",
      ],
      correct: "C"
    },
    {
      id: 30449,
      question: "A patient with chronic fatigue syndrome and fibromyalgia presents with TMJ dysfunction and reports widespread musculoskeletal pain. The patient asks about the relationship between these conditions. What should the dental hygienist explain about the comorbidity?",
      options: [
        "Fibromyalgia never coexists with other conditions and the patient must have received an incorrect diagnosis",
        "These are completely unrelated conditions that coincidentally occur in the same patient without any connection",
        "Fibromyalgia has frequent comorbidity with other autoimmune conditions and can include TMJ dysfunction",
        "The TMJ pain is causing the fibromyalgia symptoms and will resolve completely with occlusal splint therapy",
      ],
      correct: "C"
    },
    {
      id: 30450,
      question: "A 47-year-old patient with myasthenia gravis is scheduled for a restorative procedure requiring local anesthesia. The dentist plans to prescribe an antibiotic and muscle relaxant for post-operative management. What is the MOST important consideration regarding the medication plan?",
      options: [
        "Prescribe double doses of both medications since myasthenia patients require higher concentrations for therapeutic effect",
        "Muscle relaxants are the primary treatment for myasthenia gravis and should be prescribed at maximum doses",
        "Consult before prescribing because some antibiotics have muscle relaxant properties that could worsen myasthenic symptoms",
        "All antibiotics are completely safe in myasthenia gravis and can be prescribed without any special precautions",
      ],
      correct: "C"
    },
    {
      id: 30451,
      question: "A patient with pernicious anemia presents for dental hygiene care. Clinical examination reveals premature graying of hair, yellowing of the skin and eyes, and a painful red tongue with loss of filiform papillae. What is the underlying pathophysiology causing these symptoms?",
      options: [
        "Excessive production of intrinsic factor causing hypervitaminosis B12 and toxic accumulation in tissues",
        "Autoimmune destruction of red blood cells in the spleen causing hemolytic anemia and organ damage",
        "Failure of the stomach to produce intrinsic factor leading to lack of cobalamin (vitamin B12) absorption",
        "Overproduction of hydrochloric acid in the stomach causing malabsorption of iron and folic acid",
      ],
      correct: "C"
    },
    {
      id: 30452,
      question: "A 52-year-old patient with rheumatoid arthritis reports difficulty opening pill bottles, holding eating utensils, and performing oral hygiene due to joint deformities in the hands. The patient has moderate biofilm accumulation and gingivitis. What intervention would be MOST helpful for improving this patient's oral hygiene?",
      options: [
        "Recommend professional prophylaxis every week to compensate for inability to perform adequate home care",
        "Advise the patient that home care is impossible with joint limitations and professional care is the only option",
        "Suggest power toothbrush with enlarged grip, floss holders, and interdental brushes with modified handles",
        "Prescribe chlorhexidine rinse as complete substitute for mechanical biofilm removal the patient cannot perform",
      ],
      correct: "C"
    },
    {
      id: 30453,
      question: "A patient with systemic lupus erythematosus presents with oral lesions that appear similar to erosive lichen planus. The lesions are painful and located on the buccal mucosa and palate. The patient is photosensitive and has a characteristic malar rash. What patient education is MOST important regarding oral and systemic health?",
      options: [
        "Explain that sun exposure will improve both the skin rash and oral lesions through vitamin D production",
        "Recommend increasing direct sunlight exposure to 4 hours daily to boost immune system function",
        "Advise meticulous oral hygiene, avoiding spicy foods for comfort, and limiting excessive sun exposure",
        "Instruct patient to discontinue all medications immediately since they are causing the oral lesions",
      ],
      correct: "C"
    },
    {
      id: 30454,
      question: "A 44-year-old patient with an autoimmune disease is taking chronic corticosteroids. During the health history review, the patient reports difficulty sleeping, weight gain, and recent cataract diagnosis. The patient asks if these problems are related to the medication. What should the dental hygienist explain about chronic corticosteroid use?",
      options: [
        "These symptoms are unrelated to corticosteroids and indicate separate diseases requiring additional specialist consultations",
        "These are normal signs of aging and are not associated with medication use or autoimmune disease",
        "Complications of chronic corticosteroid use include insomnia, weight gain, cataract formation, and other systemic effects",
        "All of these symptoms indicate corticosteroid deficiency and the patient needs to increase medication dosage immediately",
      ],
      correct: "C"
    },
    {
      id: 30455,
      question: "A patient with cicatricial pemphigoid presents with scarring of oral lesions and reports similar problems with eyes and genital mucosa. The patient is being treated with topical and systemic corticosteroids. What is the MOST important consideration for this patient's dental hygiene care plan?",
      options: [
        "Provide aggressive scaling and root planing to all areas of scarred tissue to promote revascularization",
        "Apply undiluted hydrogen peroxide to all lesions to disinfect tissues and accelerate healing process",
        "Use gentle techniques to avoid trauma, provide topical pain control, and monitor for difficulty with breathing or speaking",
        "Recommend extraction of all teeth to eliminate oral bacterial sources that trigger autoimmune reactions",
      ],
      correct: "C"
    },
    {
      id: 30456,
      question: "A 59-year-old patient with Sjögren syndrome complains of difficulty tasting food and reports burning sensations in the mouth. Clinical examination reveals erythematous candidiasis on the palate and dorsum of tongue. What treatment is MOST appropriate for this patient?",
      options: [
        "Prescribe systemic antibiotics to treat the bacterial infection causing taste alterations and burning",
        "Recommend increasing sugar intake to stimulate taste sensation and provide energy for healing",
        "Provide antifungal therapy for candidiasis and recommend salivary replacement therapy for xerostomia",
        "Advise using undiluted lemon juice rinses to stimulate salivary flow and restore normal taste",
      ],
      correct: "C"
    },
    {
      id: 30457,
      question: "A patient with multiple sclerosis experiencing an exacerbation reports increased difficulty with motor control and coordination. The patient is scheduled for routine periodontal maintenance but appears fatigued and reports recent worsening of symptoms. What is the MOST appropriate scheduling modification?",
      options: [
        "Schedule a 3-hour appointment to complete all necessary treatment in one visit while the patient is present",
        "Complete treatment as planned without modifications since delaying care will worsen periodontal status",
        "Defer treatment until the patient is in remission and schedule shorter appointments during stable periods",
        "Proceed with full-length appointment using general anesthesia to ensure patient comfort during exacerbation",
      ],
      correct: "C"
    },
    {
      id: 30458,
      question: "A 41-year-old patient with hyperthyroidism presents with an enlarged tongue, mild tongue tremor, and reports increased sensitivity to pain during dental procedures. The patient is currently taking antithyroid medication. What modification should be made for pain management in this patient?",
      options: [
        "Use standard doses of local anesthesia since hyperthyroid patients have normal pain sensitivity",
        "Avoid all local anesthetics completely and provide treatment without pain control for safety",
        "Patient may require more local anesthesia due to increased pain sensitivity associated with hyperthyroidism",
        "Use only topical anesthetics since hyperthyroid patients cannot safely receive injectable anesthesia",
      ],
      correct: "C"
    },
    {
      id: 30459,
      question: "A patient with psoriatic arthritis presents with geographic tongue and occasional white plaques on the buccal mucosa. The patient asks whether treatment is needed for these oral findings. What is the MOST appropriate response?",
      options: [
        "All oral lesions in psoriasis patients are precancerous and require immediate surgical excision",
        "Prescribe high-dose systemic antibiotics to treat the underlying bacterial infection",
        "Oral manifestations of psoriasis are rare; consult with dermatologist if lesions become symptomatic",
        "These oral findings indicate severe systemic disease requiring immediate hospitalization",
      ],
      correct: "C"
    },
    {
      id: 30460,
      question: "A 63-year-old patient with scleroderma reports difficulty maintaining oral hygiene due to microstomia and limited manual dexterity. The patient has xerostomia, generalized recession, and high caries risk. What comprehensive care plan would be MOST beneficial?",
      options: [
        "Recommend full mouth extraction followed by conventional dentures to eliminate need for complex home care",
        "Schedule weekly professional cleanings and eliminate all patient responsibility for home care",
        "Provide treatment only with chemotherapeutic agents and eliminate all mechanical instrumentation",
        "Implement modified oral hygiene devices, fluoride therapy, salivary replacement, and isometric facial exercises",
      ],
      correct: "D"
    },
    {
      id: 30461,
      question: "A patient with rheumatoid arthritis presents with TMJ involvement, clicking, and limited mouth opening of 30mm. The patient reports preauricular pain and difficulty chewing. What interventions should be included in the treatment plan?",
      options: [
        "Recommend immediate surgical reconstruction of the TMJ to restore normal anatomy and function",
        "Advise extracting all posterior teeth to eliminate chewing forces and reduce TMJ stress",
        "Prescribe high-dose narcotics for pain control and discourage any jaw movement until pain resolves",
        "Suggest soft diet, moist heat or ice applications, regular panoramic radiographs, and possible occlusal appliance",
      ],
      correct: "D"
    },
    {
      id: 30462,
      question: "A 48-year-old patient with systemic lupus erythematosus reports experiencing a flare-up of oral lesions after spending a day at the beach. The patient has painful ulcerations on the palate and buccal mucosa. What education should the dental hygienist provide?",
      options: [
        "Encourage increased sun exposure to boost vitamin D levels and improve immune function",
        "Recommend tanning bed use as a controlled alternative to natural sunlight exposure",
        "Explain that sun exposure is unrelated to lupus symptoms and the lesions are coincidental",
        "Advise limiting excessive sun exposure as UV radiation may contribute to disease flare-ups",
      ],
      correct: "D"
    },
    {
      id: 30463,
      question: "A 56-year-old patient with Graves disease presents with exophthalmos (bulging eyes) and an enlarged thyroid gland. The patient appears anxious and has tachycardia. Emergency dental treatment is needed for acute pain. What is the MOST important consideration for managing this patient?",
      options: [
        "Provide treatment using maximum epinephrine doses to ensure adequate pain control and anxiety reduction",
        "Use only general anesthesia for treatment since local anesthesia is absolutely contraindicated",
        "Delay all treatment indefinitely until the hyperthyroidism is surgically corrected with thyroidectomy",
        "Manage stress carefully, monitor vital signs, and avoid or limit vasoconstrictors to minimize thyroid storm risk",
      ],
      correct: "D"
    },
    {
      id: 30464,
      question: "A patient with fibromyalgia and temporomandibular dysfunction presents with xerostomia and reports widespread chronic pain. The patient is taking multiple medications for pain management. What interventions are MOST appropriate for this patient?",
      options: [
        "Recommend extraction of all teeth to eliminate potential sources of chronic oral pain",
        "Advise eliminating all dental visits since the stress of appointments will worsen fibromyalgia symptoms",
        "Prescribe additional narcotic pain medications to treat the TMJ dysfunction and widespread pain",
        "Implement caries prevention with fluoride and remineralization, provide TMJ consultation, and address xerostomia",
      ],
      correct: "D"
    },
    {
      id: 30465,
      question: "A patient with pemphigus vulgaris presents with painful oral erosions and ulcerations on the gingiva. The patient is being treated with high-dose corticosteroids and immunosuppressants. The patient is concerned about appearance and discomfort. What is the MOST appropriate dental hygiene intervention?",
      options: [
        "Perform vigorous scaling to remove all biofilm and accelerate healing of ulcerated tissues",
        "Apply caustic agents to lesions to remove diseased tissue and promote rapid epithelialization",
        "Recommend immediate discontinuation of all medications since they are causing the oral lesions",
        "Provide gentle care, topical pain control, and monitor patient for long-term effects of immunosuppressive treatment",
      ],
      correct: "D"
    },
    {
      id: 30466,
      question: "A 49-year-old patient with systemic sclerosis has developed gastroparesis and gastroesophageal reflux disease. The patient is scheduled for dental hygiene treatment. What positioning modification is MOST appropriate for this patient?",
      options: [
        "Place patient in fully supine position to facilitate access and maximize clinician visibility",
        "Have patient stand during treatment to prevent any reflux symptoms from occurring",
        "Position patient in Trendelenburg position with head lower than feet throughout appointment",
        "Use semi-reclined positioning if gastrointestinal problems are present to improve patient comfort",
      ],
      correct: "D"
    },
    {
      id: 30467,
      question: "A patient with multiple autoimmune conditions asks about the relationship between immune dysfunction and autoimmune disease. The patient wants to understand why the immune system attacks the body's own tissues. What is the BEST explanation of autoimmunity?",
      options: [
        "Autoimmunity occurs when the immune system becomes hyperactive and attacks all foreign antigens excessively",
        "Autoimmune diseases result from complete absence of immune system function allowing tissues to degenerate",
        "Autoimmunity is caused by excessive production of antibodies that have no specific target and randomly attack tissues",
        "Autoimmunity develops when mechanisms preventing immune system attack on self-antigens fail and activated T cells and antibodies attack own tissues",
      ],
      correct: "D"
    },
    {
      id: 30468,
      question: "A 57-year-old patient with rheumatoid arthritis who had bilateral knee replacement 3 years ago is scheduled for periodontal scaling. The patient has well-controlled disease and no active inflammation. What is the MOST appropriate action regarding antibiotic prophylaxis?",
      options: [
        "Automatically prescribe antibiotics for all dental procedures since the patient has prosthetic joints",
        "Consult American Academy of Orthopedic Surgeons Appropriate Use Criteria to determine if prophylaxis is indicated",
        "Refuse to provide any dental treatment permanently because joint replacement is absolute contraindication",
        "Prescribe prophylactic antibiotics for every dental visit indefinitely regardless of procedure type",
      ],
      correct: "D (Note"
    },
    {
      id: 30469,
      question: "A patient with Sjögren syndrome presents with severely fissured tongue, atrophy of papillae, and multiple areas of erythematous candidiasis. The patient reports burning mouth and altered taste. What is the MOST comprehensive treatment approach?",
      options: [
        "Prescribe antibiotics for bacterial infection and recommend increasing acidic food intake",
        "Recommend using concentrated mouthwash containing alcohol to kill fungi and bacteria",
        "Advise increasing caffeine intake throughout the day to stimulate salivary gland function",
        "Provide antifungal therapy for candidiasis, salivary replacement for xerostomia, and avoid spicy/acidic foods",
      ],
      correct: "D"
    },
    {
      id: 30470,
      question: "A 42-year-old patient with systemic lupus erythematosus presents with painful oral lesions, reports taste alteration, and has xerostomia. The patient is taking hydroxychloroquine and prednisone. What interventions should be prioritized in the care plan?",
      options: [
        "Discontinue all medications immediately and rely exclusively on alternative therapies for disease management",
        "Prescribe additional corticosteroids to treat the oral lesions without consulting the physician",
        "Recommend eliminating all food intake until lesions heal completely to prevent further irritation",
        "Provide topical pain control for lesions, monitor nutrition if taste altered, implement caries prevention, and provide salivary therapy",
      ],
      correct: "D"
    },
    {
      id: 30471,
      question: "A patient with chronic corticosteroid use is scheduled for scaling and root planing. During treatment planning, the dental hygienist considers potential complications related to the medication. What adverse effect is MOST likely to impact periodontal healing?",
      options: [
        "Corticosteroids cause increased collagen synthesis leading to excessive scar tissue formation",
        "Corticosteroids have no effect on oral tissues and healing proceeds normally in all cases",
        "Corticosteroids accelerate epithelial regeneration causing abnormally rapid healing with hyperplastic tissue",
        "Corticosteroids may cause delayed wound healing after dental hygiene therapy due to anti-inflammatory effects",
      ],
      correct: "D"
    },
    {
      id: 30472,
      question: "A 60-year-old patient with rheumatoid arthritis reports taking gold compounds and penicillamine for disease management. The patient presents with bluish-black pigmentation on the oral mucosa and areas of hair loss. What is the MOST likely cause of these findings?",
      options: [
        "These symptoms indicate mercury poisoning from dental amalgam restorations requiring immediate removal",
        "The findings suggest oral melanoma requiring immediate biopsy and referral to oral surgeon",
        "These changes result from vitamin deficiency and require nutritional supplementation therapy",
        "These are known dermatologic toxicities and adverse effects associated with DMARD medications",
      ],
      correct: "D"
    },
    {
      id: 30473,
      question: "A patient with myasthenia gravis reports difficulty chewing food and swallowing. The patient has drooping eyelids and experiences progressive muscle fatigue throughout the day. What is the underlying pathophysiology of this condition?",
      options: [
        "Excessive acetylcholine production causing overstimulation and eventual exhaustion of muscle fibers",
        "Genetic mutation affecting muscle fiber composition causing structural weakness and atrophy",
        "Autoimmune destruction of motor neurons in the spinal cord leading to permanent paralysis",
        "Decrease in acetylcholine receptors in muscle fibers causing progressive fatigability and weakness of skeletal muscles",
      ],
      correct: "D"
    },
    {
      id: 30474,
      question: "A 46-year-old patient with scleroderma presents with Raynaud phenomenon, digital ulcerations, and reports difficulty with fine motor tasks. The patient has microstomia and asks about oral hygiene methods. What recommendation is MOST appropriate?",
      options: [
        "Advise patient that oral hygiene is impossible with scleroderma and recommend full mouth extraction",
        "Recommend relying exclusively on antiseptic mouthrinses without any mechanical biofilm removal",
        "Instruct patient to brush only once weekly to avoid tissue trauma from repeated mechanical action",
        "Suggest modified oral hygiene devices with enlarged handles and power devices to accommodate limitations",
      ],
      correct: "D"
    },
    {
      id: 30475,
      question: "A patient with systemic lupus erythematosus who has history of pericarditis 18 months ago presents for treatment. Current medications include azathioprine (immunosuppressant) and prednisone. Recent labs show mild leukopenia. What consultation is MOST important before beginning periodontal therapy?",
      options: [
        "Proceed immediately with treatment without consultation since pericarditis resolved over a year ago",
        "Consult physician regarding antibiotic premedication need due to cardiac history and current immunosuppression",
        "Delay all treatment for minimum of 5 years after any cardiac involvement in lupus patients",
        "Provide treatment using only ultrasonic instrumentation without considering antibiotic prophylaxis",
      ],
      correct: "D (Note"
    },
    {
      id: 30476,
      question: "A 54-year-old patient with hyperthyroidism presents with osteoporosis, rapid pulse, weight loss, and heat intolerance. The patient is scheduled for local anesthesia with vasoconstrictor. What precaution is MOST important regarding vasoconstrictor use?",
      options: [
        "Use maximum allowable epinephrine concentrations since hyperthyroid patients are resistant to vasoconstrictors",
        "Increase epinephrine to double the normal dose to overcome increased metabolic rate",
        "Vasoconstrictors have no effect in hyperthyroid patients and should be eliminated from anesthesia",
        "Limit vasoconstrictor use because hyperthyroid patients are more sensitive to catecholamines",
      ],
      correct: "D"
    },
    {
      id: 30477,
      question: "A patient with fibromyalgia reports temporomandibular dysfunction, widespread musculoskeletal pain, chronic fatigue, and difficulty sleeping. The patient also has rheumatoid arthritis and hypothyroidism. What does this patient's presentation demonstrate about autoimmune diseases?",
      options: [
        "Fibromyalgia is a distinct condition that never occurs alongside other autoimmune diseases",
        "The coexistence of multiple conditions indicates misdiagnosis and only one condition is actually present",
        "Autoimmune diseases cannot coexist and the patient needs reevaluation by specialists",
        "Fibromyalgia has frequent comorbidity with other autoimmune conditions including RA and hypothyroidism",
      ],
      correct: "D"
    },
    {
      id: 30478,
      question: "A 51-year-old patient with Sjögren syndrome presents for periodontal maintenance. The patient uses artificial saliva occasionally and xylitol gum. Clinical examination reveals new cervical carious lesions and erythematous candidiasis. What additional interventions are MOST important for this patient?",
      options: [
        "Recommend eliminating xylitol products since they are causing the carious lesions to develop",
        "Advise discontinuing artificial saliva products since they contain sugar alcohols that promote decay",
        "Recommend full mouth extraction and immediate dentures to eliminate caries risk permanently",
        "Prescribe antifungal therapy for candidiasis, implement daily fluoride regimen, and consider salivary stimulants like pilocarpine",
      ],
      correct: "D"
    },
    {
      id: 30479,
      question: "A patient with an autoimmune disease presents for care and mentions having inherited genes that created a genetic predisposition for developing the condition. The patient's mother and sister also have autoimmune diseases. The patient asks what factors are necessary for autoimmune disease development. What information should the dental hygienist provide?",
      options: [
        "Genetic predisposition alone is sufficient to cause autoimmune disease without any other contributing factors",
        "Environmental triggers are the sole cause of autoimmunity and genetics play no role in disease development",
        "Autoimmune diseases develop randomly without any identifiable genetic or environmental risk factors",
        "Both genetic predisposition and environmental triggers (like infections, fever, or trauma) are necessary for autoimmune disease development",
      ],
      correct: "D"
    }
  ],
  "6. Organ Transplant and Kidney Disease (Case Study)": [
    {
      id: 30500,
      question: "A 45-year-old male patient with end-stage renal disease has been on the UNOS waiting list for a kidney transplant for 18 months. He undergoes in-center hemodialysis three times per week. The patient presents for a comprehensive dental evaluation before transplantation. What is the PRIMARY reason for completing dental treatment BEFORE solid organ transplantation?",
      options: [
        "To avoid postoperative complications from poor oral health and minimize bacteremia and infection risk after immunosuppression begins",
        "To ensure the patient can tolerate sitting in the dental chair for extended periods before undergoing major surgery",
        "To eliminate all dental restorations that might interfere with post-transplant radiographic imaging of the head and neck",
        "To establish baseline oral health records that insurance companies require before approving transplant surgery procedures",
      ],
      correct: "A"
    },
    {
      id: 30501,
      question: "A 52-year-old female patient received a liver transplant 4 months ago and is currently taking cyclosporine, prednisone, and mycophenolate mofetil. She presents for her first dental hygiene appointment since the transplant. What is the MOST appropriate time frame for providing routine dental hygiene care after organ transplantation?",
      options: [
        "Dental treatment should begin immediately after hospital discharge to prevent oral infections during recovery",
        "Patients should avoid dental treatment for up to 6 months except for emergencies, waiting until the graft stabilizes",
        "Routine dental care can resume within 2 weeks after transplant surgery with proper antibiotic prophylaxis",
        "There are no time restrictions for dental care after transplantation as long as vital signs are stable",
      ],
      correct: "A (Note"
    },
    {
      id: 30502,
      question: "A 52-year-old female patient received a liver transplant 4 months ago and is currently taking cyclosporine, prednisone, and mycophenolate mofetil. She presents for her first dental hygiene appointment since the transplant. What is the MOST appropriate action before beginning dental hygiene treatment?",
      options: [
        "Obtain medical clearance from the transplant team to confirm medical stability and determine if antibiotic prophylaxis is needed",
        "Proceed with treatment immediately since 4 months have passed and the graft is likely stable by this time",
        "Perform only visual examination without instrumentation until at least 12 months have passed since transplantation",
        "Schedule emergency extraction of all teeth with restorations to eliminate potential infection sources",
      ],
      correct: "A"
    },
    {
      id: 30503,
      question: "A 38-year-old male kidney transplant recipient presents with generalized gingival enlargement. He reports taking cyclosporine daily as part of his immunosuppressive regimen. The tissue appears firm, pink, and nodular. What is the MOST likely cause of this patient's gingival condition?",
      options: [
        "Drug-influenced gingival enlargement associated with cyclosporine therapy, which may be exacerbated by poor oral hygiene",
        "Acute necrotizing ulcerative gingivitis resulting from severe immunosuppression and opportunistic bacterial infection",
        "Hereditary gingival fibromatosis that coincidentally manifested at the same time as the transplant procedure",
        "Leukemic infiltration of gingival tissues indicating development of post-transplant malignancy in the oral cavity",
      ],
      correct: "A"
    },
    {
      id: 30504,
      question: "A 60-year-old patient with chronic kidney disease stage 4 (GFR 20) presents for periodontal maintenance. Recent lab work shows hemoglobin of 9.5 g/dL and hematocrit of 30%. The patient reports fatigue and weakness. These laboratory values and symptoms are MOST consistent with which complication of chronic kidney disease?",
      options: [
        "Anemia resulting from decreased erythropoietin production by the diseased kidneys and reduced red blood cell formation",
        "Polycythemia causing excessive red blood cell production and increased blood viscosity from kidney dysfunction",
        "Thrombocytopenia indicating severe platelet destruction and impaired clotting ability from renal failure",
        "Leukocytosis demonstrating elevated white blood cell count and active systemic infection requiring antibiotics",
      ],
      correct: "A"
    },
    {
      id: 30505,
      question: "A 55-year-old patient presents for dental hygiene care. The patient has been on the organ transplant waiting list for 2 years. The dental hygienist notices the patient has a visible arteriovenous fistula in the left forearm. What is the MOST important precaution regarding this dialysis access?",
      options: [
        "Avoid taking blood pressure readings in the dialysis access arm because this could cause occlusion or infection",
        "Palpate the dialysis access site before treatment to ensure it is functioning properly and blood is flowing",
        "Encourage the patient to exercise the arm vigorously before appointments to improve circulation through the fistula",
        "Apply a tourniquet above the fistula site when taking blood pressure to get more accurate readings",
      ],
      correct: "A"
    },
    {
      id: 30506,
      question: "A 48-year-old liver transplant candidate presents with active periodontal disease and several nonrestorable teeth. The pretransplant coordinator has requested dental clearance before the patient can be listed for transplantation. What is the PRIMARY reason for removing nonrestorable teeth BEFORE transplantation?",
      options: [
        "To reduce the likelihood of post-transplant infection during the period of aggressive immunosuppression following surgery",
        "To improve the patient's appearance and self-esteem before undergoing the stressful transplant surgery process",
        "To eliminate the need for any dental appointments during the first year after transplantation when patients are immunosuppressed",
        "To ensure adequate bone healing occurs before corticosteroid therapy begins and impairs the healing process",
      ],
      correct: "A"
    },
    {
      id: 30507,
      question: "A 42-year-old patient with end-stage renal disease receives hemodialysis treatments on Monday, Wednesday, and Friday afternoons. The patient needs extensive restorative dental work and scaling and root planing. On which day should invasive dental treatment be scheduled for this patient?",
      options: [
        "Schedule on Tuesday or Thursday to avoid coagulation complications from heparin administered during dialysis",
        "Schedule immediately after dialysis on Monday, Wednesday, or Friday while heparin levels are highest",
        "Schedule on Monday, Wednesday, or Friday mornings before the patient goes to dialysis treatment",
        "Schedule on weekends when the patient has recovered from the previous dialysis treatment session",
      ],
      correct: "A"
    },
    {
      id: 30508,
      question: "A 67-year-old kidney transplant recipient presents for dental hygiene care. The patient takes tacrolimus (immunosuppressant) and reports a history of recurrent oral candidiasis since the transplant 2 years ago. What is the MOST likely cause of the recurrent fungal infections?",
      options: [
        "Immunosuppressive therapy increases susceptibility to opportunistic infections including bacterial, viral, and fungal organisms",
        "Poor oral hygiene practices alone are causing the candidiasis without any contribution from medications",
        "Age-related immune system decline is the sole factor responsible for the recurring fungal infections",
        "Dietary changes after transplantation have increased sugar intake, directly causing the candidiasis",
      ],
      correct: "A"
    },
    {
      id: 30509,
      question: "A 51-year-old patient with chronic kidney disease stage 3 (GFR 45) presents for evaluation. The patient's medical history reveals hypertension and type 2 diabetes mellitus. Recent lab work shows elevated creatinine and urea levels. What should be the PRIMARY treatment goal at this stage of chronic kidney disease?",
      options: [
        "Delay the progression of CKD and reduce the risk of cardiovascular disease through medical management",
        "Prepare immediately for dialysis initiation since stage 3 CKD requires urgent renal replacement therapy",
        "Schedule kidney transplant evaluation since GFR below 60 indicates need for immediate transplantation",
        "Discontinue all antihypertensive medications since they are causing the decline in kidney function",
      ],
      correct: "A"
    },
    {
      id: 30510,
      question: "A 44-year-old heart transplant recipient presents with multiple areas of white patches on the tongue and palate that can be wiped off easily, leaving erythematous tissue underneath. The patient takes prednisone and cyclosporine. What is the MOST appropriate management for this condition?",
      options: [
        "Collaborate with the transplant team to determine appropriate antifungal treatment for candidiasis",
        "Perform aggressive scaling to remove the white deposits and improve oral hygiene immediately",
        "Ignore the condition since it will resolve spontaneously when immunosuppressive drugs are discontinued",
        "Prescribe topical antibiotic ointment to treat the bacterial infection causing the white patches",
      ],
      correct: "A"
    },
    {
      id: 30511,
      question: "A 58-year-old patient on peritoneal dialysis presents for dental hygiene care. The patient received peritoneal dialysis treatment yesterday evening. The nephrologist confirms the patient did not receive heparin during the last treatment. What is the MOST appropriate action regarding today's dental hygiene appointment?",
      options: [
        "Proceed with planned treatment since heparin was not used and 24 hours have passed since dialysis",
        "Postpone all treatment indefinitely because peritoneal dialysis patients can never receive dental care",
        "Provide only emergency treatment and reschedule routine care for 6 months after dialysis ends",
        "Cancel the appointment and wait 72 hours after any peritoneal dialysis treatment before proceeding",
      ],
      correct: "A"
    },
    {
      id: 30512,
      question: "A 35-year-old kidney transplant recipient presents with enlarged gingiva covering approximately 50% of the clinical crown height. The patient has excellent oral hygiene. The transplant physician is reluctant to change immunosuppressive therapy because the patient's medical condition is stable. What is the MOST appropriate preventive strategy for managing drug-influenced gingival enlargement?",
      options: [
        "Emphasize meticulous daily biofilm removal and frequent 3-to-4-month professional debridement appointments",
        "Recommend immediate surgical gingivectomy to remove all excess tissue before it progresses further",
        "Discontinue all oral hygiene practices to avoid traumatizing the inflamed gingival tissues",
        "Prescribe systemic antibiotics for long-term daily use to reduce gingival inflammation",
      ],
      correct: "A"
    },
    {
      id: 30513,
      question: "A 63-year-old patient with end-stage renal disease presents for dental evaluation. Panoramic radiograph reveals loss of lamina dura, ground glass appearance of bone, and a radiolucent lesion in the mandible. Lab results show elevated parathyroid hormone levels. These findings are MOST consistent with which complication of chronic kidney disease?",
      options: [
        "Mineral and bone disorder (secondary hyperparathyroidism) causing abnormal calcium metabolism and osseous changes",
        "Osteomyelitis indicating severe bacterial infection of the mandible requiring immediate surgical intervention",
        "Osteoporosis from normal aging process unrelated to kidney disease or metabolic dysfunction",
        "Bone metastases from primary kidney cancer that has spread to the jaw bones",
      ],
      correct: "A"
    },
    {
      id: 30514,
      question: "A 47-year-old liver transplant recipient with a history of tobacco use and alcoholism presents for oral cancer screening. The patient received the transplant 3 years ago. Why is frequent oral cancer screening particularly important for this patient?",
      options: [
        "Organ transplant recipients have increased incidence of squamous and basal cell carcinomas, especially with tobacco/alcohol history",
        "All transplant patients develop oral cancer within 5 years and require monthly biopsies of all tissues",
        "Immunosuppressive medications directly cause malignant transformation of oral epithelial cells in all patients",
        "Liver transplantation specifically targets oral mucosa cells, making them more susceptible to cancer development",
      ],
      correct: "A"
    },
    {
      id: 30515,
      question: "A 56-year-old patient on hemodialysis presents with multiple areas of spontaneous gingival bleeding, petechiae on the soft palate, and ecchymoses on the buccal mucosa. The patient's last dialysis treatment was yesterday. What is the MOST likely cause of these bleeding manifestations?",
      options: [
        "Thrombocytopenia, anticoagulant use during dialysis, and platelet dysfunction associated with renal disease",
        "Vitamin K deficiency from dietary restrictions causing impaired synthesis of clotting factors",
        "Gingival hyperplasia from medication use causing tissue friability and spontaneous bleeding",
        "Normal aging changes in oral mucosa that occur in all patients over age 50 regardless of health",
      ],
      correct: "A"
    },
    {
      id: 30516,
      question: "A 41-year-old kidney transplant candidate presents with severe xerostomia, multiple carious lesions, and high levels of supragingival calculus. The patient is currently on hemodialysis and has fluid intake restrictions of 1000 mL per day. What is the MOST important factor contributing to this patient's xerostomia?",
      options: [
        "Fluid restriction from renal diet, adverse effects of antihypertensive medications, and salivary gland hypofunction",
        "Excessive caffeine intake causing diuretic effect and dehydration throughout the day and night",
        "Psychological stress from waiting for transplant causing decreased saliva production through anxiety",
        "Normal aging process that reduces salivary flow in all individuals over age 40",
      ],
      correct: "A"
    },
    {
      id: 30517,
      question: "A 50-year-old patient with chronic kidney disease presents for dental hygiene care. The patient asks about dietary recommendations for oral health products. The patient is currently working with a renal dietitian on a kidney-friendly diet. What is the MOST appropriate action regarding oral health product recommendations?",
      options: [
        "Collaborate with the renal dietitian to ensure all recommended dental products are within the prescribed renal diet",
        "Provide standard fluoride and xylitol product recommendations without consulting any other healthcare providers",
        "Recommend high-phosphorus dental products to strengthen teeth since renal patients need extra minerals",
        "Advise eliminating all oral health products since they interfere with kidney function and dialysis",
      ],
      correct: "A"
    },
    {
      id: 30518,
      question: "A 39-year-old pancreas-kidney transplant recipient presents 8 months post-transplant with a blood pressure reading of 165/105 mm Hg. The patient takes immunosuppressive medications and has a history of diabetes mellitus. What is the MOST appropriate action for the dental hygienist?",
      options: [
        "Contact the patient's treating physician immediately, discontinue treatment, and refer for medical consultation",
        "Continue with planned treatment since elevated blood pressure is normal for transplant patients on immunosuppressants",
        "Administer antihypertensive medication in the dental office and proceed with treatment once pressure normalizes",
        "Ignore the blood pressure reading since transplant patients always have hypertension from their medications",
      ],
      correct: "A"
    },
    {
      id: 30519,
      question: "A 54-year-old patient with end-stage renal disease reports a metallic taste, ammonia-like breath odor, and altered taste sensation. The patient is on hemodialysis awaiting kidney transplantation. What term BEST describes the altered taste sensation associated with uremia?",
      options: [
        "Dysgeusia, resulting from high urea content in saliva and accumulation of nitrogenous waste products",
        "Ageusia, indicating complete loss of all taste sensation from damage to taste receptor cells",
        "Hypergeusia, demonstrating enhanced taste sensitivity from elevated sensory receptor function",
        "Parageusia, showing inverted taste responses where sweet tastes bitter and salty tastes sweet",
      ],
      correct: "A"
    },
    {
      id: 30520,
      question: "A 46-year-old patient presents for dental evaluation before being added to the kidney transplant waiting list. The patient has been on hemodialysis for 6 months. Oral examination reveals heavy calculus deposits, periodontal disease, and xerostomia. According to UNOS data, what is the average waiting time for a deceased donor kidney transplant?",
      options: [
        "At least 2 years, which allows time to develop and implement a comprehensive dental hygiene care plan",
        "Approximately 2 weeks, requiring immediate completion of all dental treatment before listing",
        "About 6 months, providing adequate time for basic dental care but not extensive treatment",
        "Generally 5 years or more, allowing unlimited time for dental treatment and oral rehabilitation",
      ],
      correct: "A"
    },
    {
      id: 30521,
      question: "A 43-year-old heart transplant recipient presents 5 months post-transplant for emergency dental care due to acute periapical abscess. The patient takes cyclosporine, prednisone, and azathioprine. The transplant coordinator confirms the patient is medically stable. What is the MOST important consideration regarding antibiotic prophylaxis for this patient?",
      options: [
        "Prophylaxis may be indicated since immunosuppressed patients are at higher risk for systemic infection",
        "Evaluate the patient individually for infection risk and consult with the transplant team to determine prophylaxis need",
        "Antibiotic prophylaxis is never needed for transplant patients regardless of procedure or medical status",
        "All transplant patients automatically require prophylaxis according to American Heart Association guidelines",
      ],
      correct: "B"
    },
    {
      id: 30522,
      question: "A 57-year-old patient with chronic kidney disease stage 5 (GFR <15) presents for dental evaluation. The patient is not yet on dialysis but the nephrologist indicates dialysis will be needed soon. What does stage 5 chronic kidney disease indicate?",
      options: [
        "Mild decrease in kidney function with GFR between 60-89, requiring lifestyle modifications only",
        "End-stage renal disease or kidney failure where the patient cannot maintain life functions without dialysis",
        "Moderate kidney damage with GFR 30-59, managed with medications and dietary changes",
        "Normal kidney function with GFR above 90, requiring no medical intervention or treatment",
      ],
      correct: "B"
    },
    {
      id: 30523,
      question: "A 49-year-old kidney transplant recipient presents with painful oral ulcerations on the palate and buccal mucosa. The patient has been taking methotrexate for 6 months as part of immunosuppressive therapy. What is the MOST appropriate management for these oral lesions?",
      options: [
        "Perform aggressive mechanical debridement to stimulate healing and remove necrotic tissue",
        "Apply topical anesthetic agents and consult with physician about medication-related oral side effects",
        "Ignore the lesions since they are normal expected findings in all transplant recipients",
        "Extract all teeth adjacent to ulcerations to eliminate potential sources of infection",
      ],
      correct: "B"
    },
    {
      id: 30524,
      question: "A 36-year-old patient on peritoneal dialysis asks about the difference between the dialysis treatments. The patient wants to understand why peritoneal dialysis was chosen over hemodialysis. What is a PRIMARY advantage of peritoneal dialysis compared to in-center hemodialysis?",
      options: [
        "Peritoneal dialysis requires less frequent treatment, only once per week compared to three times weekly",
        "Peritoneal dialysis offers flexibility of self-administered at-home treatment without intravenous access",
        "Peritoneal dialysis is medically superior with better clinical outcomes for all patients",
        "Peritoneal dialysis eliminates all dietary restrictions and allows unlimited fluid intake daily",
      ],
      correct: "B"
    },
    {
      id: 30525,
      question: "A 61-year-old liver transplant recipient presents for dental hygiene care. The patient received the transplant 2 years ago. During the health history review, the patient reports taking \"herbs and supplements\" but cannot remember the names. Why is it important to identify specific herbs and supplements this patient is taking?",
      options: [
        "All herbs are completely safe and have no interactions with any prescription medications",
        "Some herbs can disrupt cyclosporine levels, endangering the delicate balance of immunosuppression",
        "Herbs directly cure transplant rejection and should be encouraged in all transplant recipients",
        "The dental hygienist needs to prescribe additional herbs to supplement the patient's regimen",
      ],
      correct: "B"
    },
    {
      id: 30526,
      question: "A 45-year-old kidney transplant candidate is currently on hemodialysis. The patient needs extensive periodontal therapy including scaling and root planing in all quadrants before transplant clearance. How should dental hygiene appointments be scheduled for this patient?",
      options: [
        "Schedule all four quadrants in one long appointment on a dialysis day to complete treatment quickly",
        "Schedule on non-dialysis days (Tuesday, Thursday, or weekend) to avoid heparin-related bleeding complications",
        "Refuse to provide treatment since dialysis patients can never receive periodontal therapy safely",
        "Schedule appointments only during dialysis treatment so medical personnel can monitor the patient",
      ],
      correct: "B"
    },
    {
      id: 30527,
      question: "A 53-year-old heart-lung transplant recipient presents 9 months post-transplant for dental hygiene care. The patient takes tacrolimus and has developed gingival enlargement despite good oral hygiene. What immunosuppressive medication has been associated with gingival enlargement?",
      options: [
        "Mycophenolate mofetil, which causes gingival enlargement in all patients within 3 months",
        "Tacrolimus, which has been associated with drug-influenced gingival enlargement in some patients",
        "Azathioprine, which directly stimulates gingival fibroblasts to produce excessive tissue",
        "Sirolimus, which causes immediate gingival hyperplasia in 100% of transplant recipients",
      ],
      correct: "B"
    },
    {
      id: 30528,
      question: "A 38-year-old patient with chronic kidney disease presents with pallor of oral mucosa, glossitis, recurrent aphthous ulcers, and angular cheilitis. Lab work shows hemoglobin of 9.0 g/dL. What oral manifestations are associated with anemia in renal disease patients?",
      options: [
        "Gingival hyperplasia, xerostomia, increased calculus formation, and uremic frost on tissues",
        "Pallor of oral mucosa, glossitis, recurrent aphthous ulcers, and angular stomatitis",
        "Severe tooth mobility, rapid periodontal attachment loss, and spontaneous tooth exfoliation",
        "White patches on tongue, bilateral parotid enlargement, and multiple root caries",
      ],
      correct: "B"
    },
    {
      id: 30529,
      question: "A 47-year-old kidney transplant recipient presents for continuing care. The patient has been taking cyclosporine, prednisone, and mycophenolate mofetil since transplantation 3 years ago. The patient asks why these three medications are prescribed together. What is the standard immunosuppressive medication regimen for most transplant recipients?",
      options: [
        "Single high-dose corticosteroid medication to completely suppress the immune system",
        "Trio of cyclosporine, prednisone, and mycophenolate mofetil to prevent organ rejection",
        "Daily aspirin and anticoagulants to prevent blood clots in the transplanted organ",
        "Combination of antibiotics, antifungals, and antivirals to prevent all infections",
      ],
      correct: "B"
    },
    {
      id: 30530,
      question: "A 55-year-old patient with end-stage renal disease receiving hemodialysis presents with crystallized white powder-like deposits on the oral mucosa. The patient has extremely elevated blood urea nitrogen levels. What condition does this clinical presentation represent?",
      options: [
        "Candidiasis indicating fungal infection from immunosuppression requiring antifungal treatment",
        "Uremic frost caused by excretion of nitrogenous compounds through oral tissues in severe uremia",
        "Normal aging changes in oral epithelium that occur in all patients over age 50",
        "Early-stage oral cancer requiring immediate biopsy and referral to oral surgeon",
      ],
      correct: "B"
    },
    {
      id: 30531,
      question: "A 42-year-old lung transplant recipient presents 4 months post-transplant with recurrent herpes simplex virus outbreaks. The patient is taking immunosuppressive medications. What is the MOST likely cause of recurrent herpetic infections in this patient?",
      options: [
        "Poor oral hygiene practices allowing bacterial superinfection of existing viral lesions",
        "Immunosuppression increasing susceptibility to reactivation of latent viral infections",
        "Normal aging process causing decreased immune function in middle-aged adults",
        "Direct toxic effect of transplanted lung tissue on oral mucosal immunity",
      ],
      correct: "B"
    },
    {
      id: 30532,
      question: "A 59-year-old patient on hemodialysis three times per week presents with severe periodontal disease. The patient has heavy calculus deposits, deep periodontal pockets, and significant attachment loss. What factors contribute to increased periodontal disease risk in hemodialysis patients?",
      options: [
        "Decreased calculus formation and improved oral hygiene practices from regular medical care",
        "Increased calculus formation, altered host defenses, and exaggerated inflammatory response",
        "Enhanced immune function from dialysis treatment protecting against periodontal pathogens",
        "Reduced inflammation and improved healing from hemodialysis filtration of blood",
      ],
      correct: "B"
    },
    {
      id: 30533,
      question: "A 48-year-old kidney-pancreas transplant recipient presents for dental hygiene care. The patient takes long-term high-dose prednisone and reports recent stress from family illness. What life-threatening complication is this patient at risk for during stressful dental procedures?",
      options: [
        "Gingival hyperplasia requiring immediate surgical intervention to remove excess tissue",
        "Acute adrenal crisis from chronic steroid use and inability to produce adequate cortisol response",
        "Spontaneous tooth loss from steroid-induced severe periodontal disease progression",
        "Immediate transplant rejection triggered by stress hormones released during dental treatment",
      ],
      correct: "B"
    },
    {
      id: 30534,
      question: "A 44-year-old patient with chronic kidney disease stage 3 asks about the function of healthy kidneys. The patient wants to understand what goes wrong in kidney disease. What are the three essential functions performed by healthy kidneys?",
      options: [
        "Digestion of nutrients, absorption of vitamins, and elimination of dietary fiber waste",
        "Excretion of waste products, regulation of fluid and electrolyte balance, and hormone synthesis",
        "Production of white blood cells, storage of red blood cells, and filtration of lymphatic fluid",
        "Secretion of digestive enzymes, production of bile, and metabolism of medications",
      ],
      correct: "B"
    },
    {
      id: 30535,
      question: "A 51-year-old liver transplant candidate presents with active dental caries and periodontal disease. The pretransplant coordinator emphasizes the importance of completing all dental treatment before transplantation. Why is dental clearance required BEFORE solid organ transplantation?",
      options: [
        "Dental treatment is impossible to provide after transplantation due to medication interactions",
        "Active infections must be eliminated to reduce risk of systemic complications during immunosuppression",
        "Transplant surgery physically damages oral structures making future dental care impractical",
        "Insurance companies refuse to cover dental treatment after transplant surgery is completed",
      ],
      correct: "B"
    },
    {
      id: 30536,
      question: "A 37-year-old kidney transplant recipient presents with xerostomia and asks about products to relieve dry mouth. The patient has fluid restrictions of 1200 mL per day. What xerostomia management strategy is MOST appropriate for dialysis patients with fluid restrictions?",
      options: [
        "Drink unlimited amounts of water throughout the day to maintain adequate hydration",
        "Use sugar-free candies, xylitol gum, saliva substitutes, and consult renal dietitian for appropriate products",
        "Consume high-sugar beverages continuously to stimulate salivary flow and relieve symptoms",
        "Avoid all oral hygiene products since they contain ingredients restricted in renal diets",
      ],
      correct: "B"
    },
    {
      id: 30537,
      question: "A 63-year-old patient on peritoneal dialysis presents for dental care. The patient performs continuous ambulatory peritoneal dialysis (CAPD) four times daily. What characterizes continuous ambulatory peritoneal dialysis?",
      options: [
        "Dialysate is delivered using a peritoneal dialysis machine requiring electricity for operation",
        "Dialysate is delivered manually without a machine, allowing the patient to walk freely during treatment",
        "Treatment is performed only at night during sleep, freeing daytime hours for activities",
        "Treatment requires hospitalization and cannot be performed at home by the patient",
      ],
      correct: "B"
    },
    {
      id: 30538,
      question: "A 46-year-old kidney transplant recipient presents 1 year post-transplant with multiple new carious lesions. The patient reports excellent oral hygiene but severe xerostomia from medications. What caries prevention strategy should be emphasized for this patient?",
      options: [
        "Eliminate all fluoride products since they are contraindicated in kidney transplant recipients",
        "Implement daily fluoride application, remineralization therapy, and xylitol products for xerostomia-induced caries prevention",
        "Recommend extracting all teeth with caries and placing complete dentures immediately",
        "Advise discontinuing all oral hygiene practices until xerostomia resolves spontaneously",
      ],
      correct: "B"
    },
    {
      id: 30539,
      question: "A 52-year-old patient with end-stage renal disease presents with red-orange pigmentation of the cheeks and oral mucosa. The patient reports severe itching of the skin. What causes this clinical presentation in renal disease patients?",
      options: [
        "Allergic reaction to dialysis treatment requiring immediate antihistamine administration",
        "Deposition of carotene-like pigmentation from decreased renal filtration and pruritus",
        "Early sign of oral squamous cell carcinoma requiring urgent biopsy",
        "Normal aging changes that occur in all individuals over age 50",
      ],
      correct: "B"
    },
    {
      id: 30540,
      question: "A 40-year-old heart transplant recipient asks about the role of the United Network for Organ Sharing (UNOS). The patient wants to understand how organs are allocated. What is the primary function of UNOS in organ transplantation?",
      options: [
        "UNOS performs all organ transplant surgeries in designated hospitals across the country",
        "UNOS manages the national transplant waiting list, establishes policies, and facilitates organ matching",
        "UNOS provides financial assistance to all transplant patients to cover surgery costs",
        "UNOS manufactures artificial organs for patients who cannot receive donor organs",
      ],
      correct: "B"
    },
    {
      id: 30541,
      question: "A 56-year-old patient on hemodialysis presents for dental hygiene care. The patient asks about peritoneal dialysis as an alternative treatment option. Where does peritoneal dialysis filter the patient's blood?",
      options: [
        "Through an artificial kidney machine that filters blood outside the body three times weekly",
        "Through a vascular access in the forearm where blood is removed and returned after filtration",
        "Through the patient's peritoneal lining in the abdomen using dialysate solution",
        "Through the patient's lungs where oxygen helps filter waste products from blood",
      ],
      correct: "C"
    },
    {
      id: 30542,
      question: "A 45-year-old liver transplant recipient presents with painful oral ulcerations. The patient is 8 months post-transplant and takes multiple immunosuppressive medications. Intraoral examination reveals two forms of lesions: erythematous burning areas with gray exudates and frank ulcerations. What condition do these clinical findings represent?",
      options: [
        "Aphthous stomatitis from trauma caused by rough foods in the patient's diet",
        "Oral lichen planus indicating autoimmune reaction against oral epithelium",
        "Uremic stomatitis with erythemopultaceous and ulcerative forms from renal disease",
        "Herpetic gingivostomatitis caused by primary herpes simplex virus infection",
      ],
      correct: "C"
    },
    {
      id: 30543,
      question: "A 53-year-old kidney transplant candidate on hemodialysis presents with severe periodontal disease. Before transplant clearance, the dentist recommends extraction of hopeless teeth and extensive scaling and root planing. What is the MOST important laboratory test to review before invasive periodontal procedures?",
      options: [
        "Blood glucose and hemoglobin A1c to assess diabetes control and infection risk",
        "Liver function tests including ALT and AST to evaluate hepatic metabolism",
        "Partial thromboplastin time (aPTT) and platelet count to assess hemostasis and bleeding risk",
        "Serum cholesterol and triglycerides to determine cardiovascular disease risk",
      ],
      correct: "C"
    },
    {
      id: 30544,
      question: "A 41-year-old patient with chronic kidney disease presents for dental evaluation. Panoramic radiograph shows radiolucent lesion in the posterior mandible, loss of lamina dura, and ground glass appearance of bone. Lab results show elevated parathyroid hormone (PTH). What is the radiolucent lesion likely to represent?",
      options: [
        "Periapical abscess from pulpal necrosis requiring immediate endodontic therapy",
        "Metastatic cancer to the jaw requiring oncology referral and chemotherapy",
        "Central giant cell granuloma (brown tumor) from mineral and bone disorder",
        "Dentigerous cyst from impacted tooth requiring surgical removal",
      ],
      correct: "C"
    },
    {
      id: 30545,
      question: "A 48-year-old patient with end-stage renal disease receiving hemodialysis presents with elevated serum phosphorus levels and low serum calcium. The nephrologist has prescribed phosphate binders. What dietary modification is required for patients with mineral and bone disorder?",
      options: [
        "Increase phosphorus intake through dairy products and processed foods",
        "Eliminate all calcium from the diet to prevent kidney stone formation",
        "Limit phosphorus intake and take vitamin D supplements as prescribed",
        "Consume unlimited phosphorus since kidneys need extra minerals",
      ],
      correct: "C"
    },
    {
      id: 30546,
      question: "A 59-year-old kidney transplant recipient presents 2 years post-transplant for dental hygiene care. The patient has well-controlled immunosuppression and no active medical problems. What continued care interval is MOST appropriate for successful kidney transplant recipients?",
      options: [
        "Weekly professional cleanings are required indefinitely for all transplant recipients",
        "Annual dental visits are adequate since transplant recipients have normal periodontal disease risk",
        "Three-to-four-month continued care intervals are recommended to monitor oral health",
        "No continued care is needed after transplantation since immune function is restored",
      ],
      correct: "C"
    },
    {
      id: 30547,
      question: "A 44-year-old patient on peritoneal dialysis using continuous cyclic-assisted peritoneal dialysis (CCPD) asks about the treatment process. What characterizes continuous cyclic-assisted peritoneal dialysis?",
      options: [
        "Dialysate is delivered manually four times daily without any mechanical assistance",
        "Treatment is performed at the dialysis center three times per week by trained staff",
        "A peritoneal dialysis machine delivers solution during evening/night while the patient sleeps",
        "Treatment requires surgical creation of arteriovenous fistula in the forearm",
      ],
      correct: "C"
    },
    {
      id: 30548,
      question: "A 37-year-old kidney transplant candidate presents with multiple carious lesions and periodontal disease. The patient has been on the waiting list for 6 months and asks when dental treatment should be completed. When should dental treatment be completed for pretransplant patients?",
      options: [
        "After transplantation when the patient has recovered and immune function is restored",
        "Dental treatment is not necessary since transplantation cures all oral health problems",
        "During the pretransplant waiting phase before surgery to avoid postoperative complications",
        "Exactly one week before transplant surgery regardless of how long patient has been listed",
      ],
      correct: "C"
    },
    {
      id: 30549,
      question: "A 51-year-old patient with chronic kidney disease has a glomerular filtration rate (GFR) of 48. The patient asks what this number means. What stage of chronic kidney disease does this GFR indicate?",
      options: [
        "Stage 1 with normal kidney function requiring no treatment or intervention",
        "Stage 2 with mild kidney damage managed with lifestyle modifications only",
        "Stage 3 with moderate decrease in GFR where anemia and bone disorders become more common",
        "Stage 5 end-stage renal disease requiring immediate dialysis to sustain life",
      ],
      correct: "C"
    },
    {
      id: 30550,
      question: "A 46-year-old liver transplant recipient presents with history of alcoholism and tobacco use. The patient received the transplant 4 years ago and continues smoking. For which condition is this patient at particularly HIGH risk?",
      options: [
        "Dental caries from xerostomia caused by immunosuppressive medications",
        "Periodontal disease from poor oral hygiene and inadequate biofilm removal",
        "Oropharyngeal cancer due to transplant status combined with tobacco and alcohol history",
        "Temporomandibular joint disorder from stress related to chronic illness",
      ],
      correct: "C"
    },
    {
      id: 30551,
      question: "A 55-year-old patient on hemodialysis presents with elevated blood urea nitrogen (BUN) and creatinine levels. The patient asks what these laboratory values indicate. What do elevated BUN and creatinine levels indicate in renal disease?",
      options: [
        "Normal kidney function with healthy filtration of blood and removal of waste",
        "Overhydration requiring immediate fluid restriction and dietary sodium reduction",
        "Accumulation of nitrogenous waste products from impaired kidney filtration",
        "Excessive protein intake requiring elimination of all dietary protein sources",
      ],
      correct: "C"
    },
    {
      id: 30552,
      question: "A 39-year-old kidney transplant recipient presents with multiple oral findings including pallor, glossitis, and angular cheilitis. Lab work shows hemoglobin of 8.5 g/dL. What treatment might the nephrologist prescribe for this patient's anemia?",
      options: [
        "High-dose vitamin C supplements to enhance iron absorption from foods",
        "Blood transfusions three times per week to maintain hemoglobin levels",
        "Genetically engineered erythropoietin hormone and iron supplements",
        "Immediate kidney transplantation to restore normal red blood cell production",
      ],
      correct: "C"
    },
    {
      id: 30553,
      question: "A 47-year-old patient with chronic kidney disease presents with fatigue, weakness, and pale oral mucosa. The patient asks why kidney disease causes these symptoms. Why does chronic kidney disease result in anemia?",
      options: [
        "Kidneys produce excess erythropoietin causing overproduction of defective red blood cells",
        "Kidney disease causes bone marrow hyperactivity producing too many white blood cells",
        "Diseased kidneys fail to produce adequate erythropoietin needed to stimulate red blood cell production",
        "Kidney failure causes excessive iron absorption leading to hemochromatosis and anemia",
      ],
      correct: "C"
    },
    {
      id: 30554,
      question: "A 62-year-old heart transplant recipient presents 10 months post-transplant. The patient takes chronic high-dose prednisone and reports recent weight gain, difficulty sleeping, and diagnosed cataracts. What do these symptoms represent?",
      options: [
        "Normal expected changes that occur in all patients over age 60 regardless of health",
        "Signs of acute transplant rejection requiring immediate hospitalization",
        "Complications of chronic corticosteroid use including weight gain, insomnia, and cataracts",
        "Symptoms of underlying heart disease unrelated to transplant or medications",
      ],
      correct: "C"
    },
    {
      id: 30555,
      question: "A 43-year-old patient on peritoneal dialysis presents for dental care. The patient's nephrologist confirms the patient received heparin during dialysis treatment 18 hours ago. What is the MOST appropriate action regarding dental treatment?",
      options: [
        "Proceed immediately with all planned invasive procedures since 18 hours have passed",
        "Provide only prophylaxis without any subgingival instrumentation or periodontal probing",
        "Postpone invasive treatment if heparin was used within the last 24 hours during peritoneal dialysis",
        "Perform all planned procedures using only ultrasonic instrumentation for hemostasis",
      ],
      correct: "C"
    },
    {
      id: 30556,
      question: "A 54-year-old kidney transplant recipient presents 6 months post-transplant with drug-influenced gingival enlargement. The patient has excellent oral hygiene but the condition continues to worsen. If optimal oral hygiene and frequent debridement fail to control gingival enlargement, what might be considered?",
      options: [
        "Immediate extraction of all teeth to eliminate the source of gingival tissue",
        "Long-term daily antibiotic therapy to reduce inflammation in gingival tissues",
        "Consultation with transplant physician about modifying immunosuppressive therapy",
        "Discontinuation of all oral hygiene practices to avoid traumatizing tissues",
      ],
      correct: "C"
    },
    {
      id: 30557,
      question: "A 49-year-old patient with end-stage renal disease presents with dental erosion of lingual tooth surfaces. The patient reports frequent vomiting and nausea. What is the cause of dental erosion in this patient?",
      options: [
        "Excessive consumption of acidic beverages throughout the day and night",
        "Chronic use of chewable vitamin C tablets causing chemical erosion",
        "Regurgitation and persistent vomiting from high levels of uremia",
        "Aggressive toothbrushing technique using hard-bristled toothbrush",
      ],
      correct: "C"
    },
    {
      id: 30558,
      question: "A 58-year-old kidney transplant candidate presents with chronic kidney disease. The patient asks about medications that might help preserve remaining kidney function. What medications are used to delay progression of chronic kidney disease?",
      options: [
        "High-dose diuretics to increase urine output and flush toxins from kidneys",
        "Nonsteroidal anti-inflammatory drugs to reduce kidney inflammation",
        "Angiotensin-converting enzyme (ACE) inhibitors and angiotensin receptor blockers (ARBs)",
        "Calcium channel blockers exclusively without any other cardiovascular medications",
      ],
      correct: "C"
    },
    {
      id: 30559,
      question: "A 41-year-old liver transplant recipient presents with cyclosporine-related nephrotoxicity. The patient asks what this term means. What does nephrotoxicity indicate?",
      options: [
        "Beneficial therapeutic effect of cyclosporine on kidney function and filtration",
        "Normal expected outcome of immunosuppression without any negative effects",
        "Damage to kidney cells caused by toxic effects of drugs like cyclosporine",
        "Improved kidney function resulting from liver transplant and better blood flow",
      ],
      correct: "C"
    },
    {
      id: 30560,
      question: "A 52-year-old patient with chronic kidney disease stage 4 presents with multiple systemic conditions including anemia, high potassium levels, and excess fluid retention. Which complication related to high potassium levels (hyperkalemia) is of GREATEST concern?",
      options: [
        "Increased susceptibility to dental caries from altered salivary composition",
        "Accelerated periodontal disease progression from electrolyte imbalance",
        "Irregular heartbeat or cardiac arrhythmia that could be life-threatening",
        "Severe xerostomia requiring multiple salivary substitute products",
      ],
      correct: "C"
    },
    {
      id: 30561,
      question: "A 48-year-old kidney transplant recipient presents 3 years post-transplant for dental hygiene care. The patient has controlled immunosuppression and stable medical status. The patient asks about the success rate and long-term outlook after kidney transplantation. Although kidney transplantation improves quality of life, what is important to understand?",
      options: [
        "Kidney transplantation provides a complete cure and eliminates all future medical problems",
        "Transplanted kidneys function perfectly for life without any immunosuppressive medication",
        "Patients can discontinue all medications after one year since rejection no longer occurs",
        "Renal transplantation is not a cure but provides a less restricted lifestyle than dialysis",
      ],
      correct: "D"
    },
    {
      id: 30562,
      question: "A 56-year-old patient on hemodialysis presents with severe xerostomia and multiple cervical carious lesions. The patient has strict fluid restrictions and takes multiple antihypertensive medications. What factors contribute to xerostomia in dialysis patients?",
      options: [
        "Excessive fluid intake causing dilution of saliva and reduced salivary concentration",
        "Overactive salivary glands producing thin watery saliva with poor lubricating properties",
        "Normal aging process that affects all individuals over age 50 regardless of health",
        "Fluid restrictions, antihypertensive drug side effects, salivary hypofunction, and mouth breathing",
      ],
      correct: "D"
    },
    {
      id: 30563,
      question: "A 43-year-old heart transplant recipient presents for dental hygiene care. The patient asks about the different types of organ donation. What term describes organ donation between unrelated individuals?",
      options: [
        "Syngeneic transplant where organs are donated between identical twins",
        "Allogeneic transplant where organs are donated from one living relative to another",
        "Autogenic transplant where organs are donated from one part of body to another",
        "Xenograft transplant where organs are donated between unrelated individuals",
      ],
      correct: "D"
    },
    {
      id: 30564,
      question: "A 51-year-old kidney transplant candidate on hemodialysis presents with cardiovascular disease, diabetes, and hypertension. The patient asks about risks associated with chronic kidney disease. What is a major complication and cause of death in patients with chronic kidney disease?",
      options: [
        "Dental caries and tooth loss from xerostomia and poor oral hygiene",
        "Periodontal disease progression leading to tooth mobility and extraction",
        "Oral cancer development in the tongue and floor of mouth",
        "Cardiovascular disease, heart disease, and stroke from inflammation and multiple risk factors",
      ],
      correct: "D"
    },
    {
      id: 30565,
      question: "A 39-year-old patient with end-stage renal disease on hemodialysis presents for dental evaluation. The patient asks which organ transplant has the largest number of recipients. According to UNOS data, which solid organ transplant has the largest population of recipients?",
      options: [
        "Liver transplant recipients represent the largest group of solid organ recipients",
        "Heart transplant recipients outnumber all other solid organ transplant types",
        "Lung transplant recipients comprise the majority of all transplant recipients",
        "Kidney transplant recipients represent the largest population by organ type",
      ],
      correct: "D"
    },
    {
      id: 30566,
      question: "A 47-year-old liver transplant recipient presents 15 months post-transplant. During health history review, the patient reports taking multiple over-the-counter medications including NSAIDs and herbal supplements. Why is it critical to consult with the transplant team about over-the-counter medications?",
      options: [
        "All over-the-counter medications are completely safe and have no side effects",
        "Over-the-counter products are more effective than prescription medications",
        "The dental hygienist must prescribe all over-the-counter medications for patients",
        "Many common over-the-counter medications and herbs are nephrotoxic to transplant recipients",
      ],
      correct: "D"
    },
    {
      id: 30567,
      question: "A 54-year-old patient with chronic kidney disease presents with periodontal disease. The patient asks about the relationship between kidney disease and periodontal disease. What is the relationship between periodontal disease and renal insufficiency?",
      options: [
        "Kidney disease directly causes severe periodontal disease in all affected patients",
        "Periodontal disease always leads to kidney failure requiring dialysis or transplantation",
        "No relationship exists between periodontal disease and kidney disease of any type",
        "A moderate relationship exists with increased periodontal risk in severe renal disease or hemodialysis patients",
      ],
      correct: "D"
    },
    {
      id: 30568,
      question: "A 44-year-old kidney transplant recipient presents with gingival enlargement from cyclosporine. The patient maintains meticulous oral hygiene and attends 3-month continuing care appointments, but the condition persists. Why might the transplant physician be reluctant to modify immunosuppressive therapy?",
      options: [
        "Changing medications always improves gingival enlargement within one week",
        "All immunosuppressive medications cause identical side effects and tissue changes",
        "Gingival enlargement indicates the medications are not working effectively",
        "The physician prioritizes medical stability and prevention of rejection over gingival concerns",
      ],
      correct: "D"
    },
    {
      id: 30569,
      question: "A 58-year-old patient on hemodialysis presents with heavy calculus deposits despite regular oral hygiene. The patient asks why calculus formation increases with kidney disease. What causes increased calculus formation in patients with renal disease?",
      options: [
        "Improved kidney function leading to enhanced mineral absorption and deposition",
        "Decreased saliva production causing lack of minerals available for calculus formation",
        "Excessive oral hygiene practices that stimulate calculus production on teeth",
        "Uremic status and duration of renal disease affecting salivary composition",
      ],
      correct: "D"
    },
    {
      id: 30570,
      question: "A 46-year-old kidney transplant candidate presents with Stage 2 chronic kidney disease (GFR 72). The patient asks about treatment goals at this stage. What is the PRIMARY treatment goal for Stage 2 chronic kidney disease?",
      options: [
        "Immediate dialysis initiation to prevent further kidney damage and failure",
        "Urgent kidney transplant evaluation since GFR below 90 indicates transplant need",
        "No treatment is needed since Stage 2 represents normal kidney function",
        "Delay CKD progression and reduce cardiovascular disease risk through medical management",
      ],
      correct: "D"
    },
    {
      id: 30571,
      question: "A 52-year-old liver transplant recipient presents 8 months post-transplant with poor wound healing after periodontal surgery. The patient takes prednisone, cyclosporine, and mycophenolate mofetil. What medication effect is MOST likely responsible for delayed healing?",
      options: [
        "Cyclosporine increases collagen synthesis causing excessive scar tissue formation",
        "Mycophenolate mofetil stimulates rapid epithelialization and accelerated healing",
        "Combined medications have no effect on wound healing processes in oral tissues",
        "Immunosuppressive drugs can cause poor and slow healing as an adverse effect",
      ],
      correct: "D"
    },
    {
      id: 30572,
      question: "A 41-year-old patient with end-stage renal disease on hemodialysis presents with anemia. The patient asks what complications can result from anemia. What complications are associated with anemia in renal disease patients?",
      options: [
        "Improved cardiovascular function and enhanced oxygen delivery to tissues",
        "Increased energy levels and enhanced ability to perform daily activities",
        "Better healing ability and reduced infection risk from improved immunity",
        "Fatigue, increased infection risk, and potential cardiovascular complications",
      ],
      correct: "D"
    },
    {
      id: 30573,
      question: "A 49-year-old kidney transplant recipient presents for dental hygiene care. The patient asks about the nephrology team members involved in transplant care. Which healthcare professional on the nephrology team specializes in dietary management?",
      options: [
        "Nephrologist who prescribes all dietary restrictions and nutritional supplements",
        "Nephrology nurse who educates patients about food groups and meal planning",
        "Patient care technician who monitors weight and fluid intake during dialysis",
        "Renal dietitian who works with the nephrologist to plan kidney-friendly diets",
      ],
      correct: "D"
    },
    {
      id: 30574,
      question: "A 55-year-old heart transplant recipient presents 2 years post-transplant. The patient reports taking long-term steroids and has osteoporosis. The patient needs multiple tooth extractions. What metabolic complication is associated with long-term prednisone use?",
      options: [
        "Enhanced bone density and increased calcium deposition in skeletal structures",
        "Improved bone metabolism with accelerated healing after extractions",
        "No effect on bone structure or mineral metabolism in any patient",
        "Bone metabolism complications and osteoporosis from chronic corticosteroid use",
      ],
      correct: "D"
    },
    {
      id: 30575,
      question: "A 38-year-old kidney transplant candidate on hemodialysis presents with multiple systemic conditions. The patient has diabetes mellitus, hypertension, and cardiovascular disease. What is the MOST common cause of end-stage renal disease?",
      options: [
        "Acute kidney injury from trauma or toxic medication exposure in emergency situations",
        "Hereditary polycystic kidney disease inherited from affected family members",
        "Recurrent urinary tract infections causing progressive kidney damage over time",
        "Diabetes mellitus and hypertension, which are the most prevalent causes of ESRD",
      ],
      correct: "D"
    },
    {
      id: 30576,
      question: "A 44-year-old patient with chronic kidney disease presents with severe pruritus (itching). Oral examination reveals red-orange pigmentation of the oral mucosa and skin. What laboratory finding would be expected in this patient?",
      options: [
        "Decreased blood urea nitrogen indicating improved kidney function",
        "Normal creatinine levels demonstrating adequate waste product filtration",
        "Low serum phosphorus from enhanced kidney excretion of minerals",
        "Elevated serum urea, creatinine, and other waste products from decreased filtration",
      ],
      correct: "D"
    },
    {
      id: 30577,
      question: "A 59-year-old liver transplant recipient presents for dental hygiene care. The patient asks about immunosuppressive medication that provided a breakthrough in solid organ transplantation. Which drug discovery provided a major breakthrough in solid organ transplantation?",
      options: [
        "Penicillin, which prevents bacterial infections during post-transplant recovery",
        "Aspirin, which prevents blood clots in transplanted organs",
        "Morphine, which controls pain after transplant surgery",
        "Cyclosporine, which prevents organ rejection through effective immunosuppression",
      ],
      correct: "D"
    },
    {
      id: 30578,
      question: "A 50-year-old patient on peritoneal dialysis presents with well-controlled medical status. The patient has no cardiovascular risk factors or other comorbidities. The patient needs scaling and root planing. According to current guidelines, does this patient require antibiotic prophylaxis?",
      options: [
        "Yes, all peritoneal dialysis patients require prophylaxis for any dental procedure",
        "Yes, antibiotic prophylaxis is mandatory for dialysis patients regardless of medical status",
        "Yes, the American Heart Association guidelines specifically require prophylaxis for dialysis",
        "No, patients without cardiovascular risk factors usually don't require prophylaxis based on dialysis alone",
      ],
      correct: "D"
    },
    {
      id: 30579,
      question: "A 46-year-old kidney transplant recipient presents with multiple systemic conditions including hypertension, anemia, and bone disease. The patient asks why kidney disease affects so many body systems. Why does chronic kidney disease affect multiple organ systems?",
      options: [
        "Kidney disease only affects the urinary system without involving other body systems",
        "Kidneys have no connection to other organs and function completely independently",
        "Only the cardiovascular system is affected by kidney disease and renal failure",
        "Kidneys perform essential functions affecting fluid balance, electrolytes, blood pressure, and hormone production",
      ],
      correct: "D"
    },
    {
      id: 30580,
      question: "A 53-year-old patient with end-stage renal disease on hemodialysis asks about the role of inflammation in cardiovascular disease. What role does inflammation play in cardiovascular complications of renal disease?",
      options: [
        "Inflammation has no relationship to cardiovascular disease in renal patients",
        "Inflammation only affects oral tissues without any systemic effects",
        "Inflammation improves cardiovascular function by stimulating repair processes",
        "Inflammation plays an important role in cardiovascular disease and affects clinical outcomes",
      ],
      correct: "D"
    }
  ],
  "7. Respiratory Diseases (Case Study)": [
    {
      id: 30600,
      question: "A 22-year-old female patient presents for routine dental hygiene care. Her health history reveals a diagnosis of intermittent asthma for the past 8 years. She reports using an albuterol inhaler approximately 2-3 times per week, primarily triggered by exercise and seasonal pollen. She mentions experiencing an unpleasant taste after using her inhaler and has increased her consumption of sugary mints to combat this. Clinical examination reveals moderate biofilm accumulation and early white lesions on the buccal mucosa. What is the MOST appropriate initial patient education topic for this patient?",
      options: [
        "Recommend rinsing with water and expectorating after inhaler use to reduce risk of oral candidiasis and dental caries",
        "Suggest discontinuing the albuterol inhaler and consulting her physician about alternative asthma medications",
        "Advise her to use a dental dam during all future dental procedures to prevent aspiration of dental materials",
        "Instruct her to avoid all dental appointments during high pollen season to prevent asthmatic episodes in the office",
      ],
      correct: "A"
    },
    {
      id: 30601,
      question: "A 45-year-old male patient with a 20-year history of cigarette smoking (1 pack per day) presents with complaints of chronic cough and difficulty breathing, especially when lying flat. He reports producing large amounts of phlegm most mornings and has experienced three respiratory infections in the past year. His medication list includes Spiriva (tiotropium bromide) once daily and albuterol as needed. Vital signs: BP 128/82, pulse 88, respirations 22. Based on this patient's presentation, which dental hygiene care modification is MOST appropriate?",
      options: [
        "Position the patient in semi-supine or upright position and plan shorter appointments with breaks as needed",
        "Schedule appointments in the late afternoon to accommodate the patient's morning phlegm production and position patient supine throughout treatment",
        "Use nitrous oxide-oxygen analgesia liberally to reduce anxiety and assist with breathing during lengthy procedures",
        "Defer all dental hygiene treatment until the patient has been symptom-free for at least six consecutive months",
      ],
      correct: "A"
    },
    {
      id: 30602,
      question: "An 18-year-old patient presents for dental hygiene care with a history of persistent moderate asthma. His current medications include Proventil (albuterol) inhaler and prednisone 10mg daily. He reports recent acne treatment with doxycycline. Clinical findings show gingival enlargement with rolled margins throughout, particularly in the maxillary anterior region with 4-5mm pocket depths. The patient reports brushing twice daily but no flossing. He admits to smoking approximately 7 cigarettes per week. Which factor is MOST likely contributing to this patient's periodontal condition?",
      options: [
        "The direct inflammatory effects of the albuterol inhaler on gingival tissues causing localized medication-induced enlargement",
        "An allergic reaction to the doxycycline creating an immune-mediated periodontal response in susceptible individuals",
        "The systemic effects of cigarette smoke causing acute necrotizing periodontal disease limited to anterior regions",
        "The combination of mouth breathing, inadequate oral hygiene, and possible medication-induced xerostomia affecting tissue health",
      ],
      correct: "D"
    },
    {
      id: 30603,
      question: "A 35-year-old patient with severe persistent asthma arrives for dental hygiene care. She reports experiencing an asthma attack two weeks ago that required emergency room treatment. Her current medications include Advair (fluticasone/salmeterol) twice daily and a rescue inhaler. During the health history review, she mentions she is allergic to sulfites. You plan to use local anesthesia for this appointment. What is the MOST appropriate local anesthetic selection for this patient?",
      options: [
        "Lidocaine with epinephrine 1:100,000 to ensure adequate hemostasis and longer duration of anesthesia",
        "Articaine with epinephrine 1:200,000 as it provides superior pulpal anesthesia with minimal systemic absorption",
        "Prilocaine with levonordefrin to provide vasoconstriction while avoiding the epinephrine-sulfite combination",
        "Mepivacaine 3% plain without vasoconstrictor to avoid potential sulfite sensitivity from preservatives",
      ],
      correct: "D"
    },
    {
      id: 30604,
      question: "During a dental hygiene appointment, your 28-year-old asthmatic patient suddenly begins wheezing and experiencing difficulty breathing. She appears anxious and is sitting upright in the chair. Her respiratory rate increases to 32 breaths per minute, and she reports chest tightness. She has her prescribed albuterol inhaler with her. What is the FIRST step in managing this acute asthmatic episode?",
      options: [
        "Immediately administer parenteral epinephrine before the attack progresses to status asthmaticus requiring hospitalization",
        "Terminate the dental procedure, remove all materials from the patient's mouth, and activate the office emergency protocol",
        "Place the patient in a supine position with legs elevated to improve cerebral perfusion during the breathing crisis",
        "Call emergency medical services first, then begin rescue breathing with supplemental oxygen at 15 liters per minute",
      ],
      correct: "B"
    },
    {
      id: 30605,
      question: "A 58-year-old female patient presents for dental hygiene care with a diagnosis of COPD. Her medication list includes Symbicort (budesonide/formoterol) inhaler twice daily and uses supplemental oxygen at home at night. She appears short of breath upon entering the operatory and mentions she becomes breathless with minimal exertion. Clinical examination reveals generalized moderate xerostomia and a \"barrel chest\" appearance. Which technique should be AVOIDED or used with extreme caution during this patient's treatment?",
      options: [
        "Application of topical fluoride varnish due to increased risk of aspiration in patients with compromised respiratory function",
        "Use of nitrous oxide-oxygen inhalation sedation as it may produce apnea if oxygen levels are improperly adjusted",
        "Ultrasonic scaling with preprocedural antimicrobial rinse and high-speed evacuation to control aerosols during treatment",
        "Administration of profound local anesthesia with epinephrine-containing solutions for quadrant scaling procedures",
      ],
      correct: "B"
    },
    {
      id: 30606,
      question: "A 52-year-old male patient with chronic bronchitis presents for dental hygiene care. He has a chronic productive cough and reports being a current smoker (1.5 packs/day for 30 years). His medications include Theo-Dur (theophylline) 300mg twice daily and an albuterol inhaler. The dentist plans to prescribe antibiotics following periodontal therapy due to the patient's compromised health status. Which antibiotic would be CONTRAINDICATED for this patient?",
      options: [
        "Amoxicillin because it may interact with theophylline causing decreased effectiveness of the bronchodilator medication",
        "Clindamycin because it is contraindicated in all patients with chronic respiratory diseases due to aspiration risk",
        "Metronidazole because it can cause bronchospasm in patients taking long-acting beta-2 agonist medications",
        "Erythromycin because it may increase theophylline blood levels potentially resulting in toxic effects",
      ],
      correct: "D"
    },
    {
      id: 30607,
      question: "A new 62-year-old patient presents for initial dental hygiene assessment. Her health history indicates Stage III (severe) COPD with a recent hospitalization for acute exacerbation three weeks ago. Current medications include Anoro Ellipta (umeclidinium/vilanterol), oral prednisone 20mg daily, and home oxygen therapy. She appears cachectic with visible use of accessory respiratory muscles. She reports difficulty tolerating dental treatment in the past. What is the MOST appropriate treatment planning modification for this patient?",
      options: [
        "Defer all elective dental hygiene care for six months until the patient's COPD is better controlled and prednisone is discontinued",
        "Provide treatment in a hospital setting with an anesthesiologist present due to the severity of her respiratory compromise",
        "Plan short appointments with frequent breaks, position semi-upright, and ensure her usual prednisone dose on appointment day",
        "Schedule appointments only in the morning before fatigue sets in and complete all treatment in one extended visit",
      ],
      correct: "C"
    },
    {
      id: 30608,
      question: "A 19-year-old college student presents with complaints of chronic fatigue, low-grade fever, and a persistent cough lasting approximately 6 weeks. He recently traveled internationally to volunteer in a region with high tuberculosis prevalence. He mentions night sweats and unintentional weight loss of 15 pounds. Clinical examination reveals no significant oral findings. What is the MOST appropriate action by the dental hygienist?",
      options: [
        "Proceed with routine dental hygiene care using standard precautions and document findings in the patient record",
        "Postpone treatment, refer to physician for medical evaluation, and use strict respiratory hygiene protocols if emergency treatment needed",
        "Provide treatment in an isolated operatory while wearing an N95 respirator and having patient wear a surgical mask",
        "Perform dental hygiene assessment only, avoiding any aerosol-producing procedures until symptoms completely resolve",
      ],
      correct: "B"
    },
    {
      id: 30609,
      question: "A patient with a history of tuberculosis presents for dental hygiene care. He reports being diagnosed 18 months ago and treated with isoniazid (INH) daily for 9 months. He completed treatment 6 months ago and has documentation from his physician showing negative sputum cultures, normal chest x-ray, and complete resolution of symptoms. He reports feeling completely healthy with no current medications. What is the appropriate infection control protocol for this patient?",
      options: [
        "Treat using standard precautions only, as the patient has completed treatment and shows no signs of active disease",
        "Use airborne precautions with N95 respirator and isolate patient for all appointments indefinitely due to TB history",
        "Defer all treatment permanently and refer to a hospital-based dental clinic equipped for tuberculosis patient care",
        "Require annual chest x-rays and physician clearance before each dental appointment for the remainder of patient's life",
      ],
      correct: "A"
    },
    {
      id: 30610,
      question: "You are providing an in-service education program for nursing staff at a long-term care facility regarding oral care for their residents. Many residents are elderly, frail, and have difficulty swallowing. The facility has had several cases of aspiration pneumonia in the past year. The nurses report that oral care is often inconsistent due to time constraints and lack of knowledge. Which recommendation would be MOST effective in reducing aspiration pneumonia risk?",
      options: [
        "Focus exclusively on denture care by removing and soaking dentures overnight in commercial denture cleanser solution",
        "Implement a protocol of tooth brushing after meals, daily flossing, and use of chlorhexidine rinse for oral debridement",
        "Recommend that residents avoid all oral intake for 2 hours before bedtime to reduce aspiration risk during sleep",
        "Suggest that nursing staff substitute foam swabs for toothbrushes as they are gentler and pose less aspiration risk",
      ],
      correct: "B"
    },
    {
      id: 30611,
      question: "A 70-year-old patient in an intensive care unit has been intubated and mechanically ventilated for 72 hours following a stroke. The nursing staff requests guidance on oral care to prevent ventilator-associated pneumonia (VAP). The patient has an endotracheal tube, oral gastric tube, and bite block in place, making access to the oral cavity challenging. What oral care recommendation is MOST appropriate for preventing VAP in this patient?",
      options: [
        "Avoid all oral care procedures including tooth brushing due to risk of increasing intracranial pressure in stroke patients",
        "Use only foam swabs with water every 8 hours as toothbrushing is contraindicated in intubated patients",
        "Brush teeth twice daily, use chlorhexidine foam swabs every 2-4 hours, and maintain head elevation 30-45 degrees",
        "Remove the endotracheal tube daily for comprehensive oral care, then reinsert after thorough tooth brushing and flossing",
      ],
      correct: "C"
    },
    {
      id: 30612,
      question: "A 42-year-old female patient reports chronic loud snoring according to her spouse, frequent morning headaches, excessive daytime sleepiness, and waking with a choking sensation. Clinical examination reveals a retrognathic mandible with Class II malocclusion, scalloped tongue borders, and notable anterior tooth wear. Her BMI is 34. She reports no current treatment for these symptoms. Based on these findings, what condition should the dental hygienist suspect?",
      options: [
        "Severe temporomandibular disorder with nocturnal bruxism causing chronic facial pain and sleep disruption",
        "Obstructive sleep apnea characterized by airway collapse during sleep with associated oral manifestations",
        "Chronic obstructive pulmonary disease with nocturnal dyspnea requiring immediate respiratory intervention",
        "Gastroesophageal reflux disease causing aspiration during sleep with resultant morning symptoms and tooth erosion",
      ],
      correct: "B"
    },
    {
      id: 30613,
      question: "A 55-year-old male patient with obstructive sleep apnea uses a CPAP device nightly. He reports good compliance with the device but complains of severe morning dry mouth, increased dental sensitivity, and difficulty controlling plaque despite brushing twice daily. Clinical examination reveals generalized xerostomia, red and edematous anterior gingival tissues, and multiple areas of root surface exposure with early carious lesions. What is the MOST appropriate intervention to address this patient's oral complications?",
      options: [
        "Recommend discontinuing CPAP use and consult with physician about surgical treatment options for sleep apnea",
        "Advise the patient to breathe through his nose only during sleep to avoid the xerostomia caused by the device",
        "Suggest using a chlorhexidine mouth rinse before bed to reduce bacterial load and prevent further carious lesions",
        "Prescribe high-fluoride toothpaste, xylitol products for salivary stimulation, and verify proper CPAP humidification",
      ],
      correct: "D"
    },
    {
      id: 30614,
      question: "An 8-year-old pediatric patient presents with his mother who reports the child snores loudly every night and frequently breathes through his mouth during the day. The mother mentions concerns about his academic performance and behavior problems at school. Clinical examination reveals significantly enlarged tonsils, constricted maxillary and mandibular arches, anterior open bite, and red edematous anterior gingival tissues. What is the MOST important referral recommendation for this patient?",
      options: [
        "Refer to an orthodontist immediately for palatal expansion to address the constricted arches and prevent future TMD",
        "Refer to a physician or ENT specialist for evaluation of enlarged tonsils and possible sleep-related breathing disorder",
        "Refer to a pediatric dentist for comprehensive treatment of the anterior open bite under general anesthesia",
        "Refer to a periodontist for treatment of the inflamed gingival tissues before providing any dental hygiene care",
      ],
      correct: "B"
    },
    {
      id: 30615,
      question: "During your initial assessment, a 38-year-old patient reports using Flovent (fluticasone) inhaler twice daily for asthma management. She mentions that she usually uses the inhaler right before bed and first thing in the morning but does not rinse her mouth afterward. Clinical examination reveals multiple white, creamy patches on the buccal mucosa and palate that can be wiped away, leaving a raw erythematous surface. What oral condition is MOST likely present, and what is the primary causative factor?",
      options: [
        "Pseudomembranous candidiasis (thrush) caused by inhaled corticosteroid use without proper post-use oral rinsing",
        "Lichen planus exacerbated by the chronic inflammatory effects of poorly controlled asthma on oral tissues",
        "Chemical burn from the propellant in the metered-dose inhaler causing mucosal irritation and desquamation",
        "Leukoplakia secondary to chronic mouth breathing and xerostomia associated with long-term asthma medication use",
      ],
      correct: "A"
    },
    {
      id: 30616,
      question: "A 67-year-old patient with COPD presents for dental hygiene care. His health history reveals he is currently taking methylprednisolone 8mg daily for the past 3 years to manage his condition. He is scheduled for periodontal scaling and root planing under local anesthesia today, which he reports makes him very anxious. What medication consideration is MOST important for this patient?",
      options: [
        "The patient should discontinue methylprednisolone 48 hours before the appointment to prevent drug interactions with local anesthesia",
        "The patient requires antibiotic prophylaxis due to chronic corticosteroid use suppressing his immune system function",
        "The patient should double his methylprednisolone dose before the appointment to prevent an acute exacerbation of COPD",
        "The patient should take his usual dose of methylprednisolone on the day of the appointment, especially for this stressful procedure",
      ],
      correct: "D"
    },
    {
      id: 30617,
      question: "A patient diagnosed with active pulmonary tuberculosis six weeks ago calls your dental office with a severe dental emergency involving facial swelling and pain. He is currently taking isoniazid, rifampin, pyrazinamide, and ethambutol as prescribed by his physician. His physician confirms he is still infectious and must maintain isolation precautions. What is the MOST appropriate management of this patient's emergency?",
      options: [
        "Schedule the patient as the last appointment of the day, treat in an isolated operatory using airborne precautions with N95 respirator",
        "Refer the patient to a hospital-based dental clinic with appropriate isolation facilities and administrative environmental controls",
        "Prescribe antibiotics and analgesics over the phone and defer treatment until he completes tuberculosis medication regimen",
        "Treat the patient immediately using standard precautions only, as tuberculosis is transmitted through direct contact not airborne",
      ],
      correct: "B"
    },
    {
      id: 30618,
      question: "A 50-year-old female patient presents with emphysema secondary to alpha-1 antitrypsin deficiency. She has never smoked and reports this genetic condition runs in her family. She appears cachectic with a barrel-chest appearance and uses pursed-lip breathing. She uses home oxygen therapy at 2 liters per minute continuously. She reports having difficulty breathing when lying flat. What is the PRIMARY pathophysiologic mechanism causing this patient's emphysema?",
      options: [
        "Chronic bacterial infection causing progressive destruction of bronchial walls and mucus gland hyperplasia over time",
        "Autoimmune response targeting pulmonary tissue causing chronic inflammation and fibrosis of lung parenchyma",
        "Congenital structural abnormality of the alveoli causing inadequate gas exchange and progressive hypoxemia",
        "Genetic deficiency of protective enzyme allowing elastase to destroy alveolar elastic tissue leading to hyperinflation",
      ],
      correct: "D"
    },
    {
      id: 30619,
      question: "You are treating a patient with moderate persistent asthma. Halfway through the scaling procedure, you notice the patient begins to have mild wheezing and reports feeling slightly short of breath. She appears anxious but is able to speak in full sentences. Her prescribed albuterol inhaler is available. What is the MOST appropriate immediate action?",
      options: [
        "Continue the procedure quickly to completion as mild symptoms will likely resolve spontaneously without intervention",
        "Stop the procedure, remove materials from mouth, position patient comfortably, and have her use her bronchodilator",
        "Immediately activate emergency medical services and administer parenteral epinephrine from the emergency drug kit",
        "Place the patient supine with feet elevated and administer high-flow oxygen at 15 liters per minute via face mask",
      ],
      correct: "B"
    },
    {
      id: 30620,
      question: "A 44-year-old patient with chronic bronchitis presents for dental hygiene care. She reports producing large amounts of sputum, particularly in the morning, and has had these symptoms for at least 4 months out of the year for the past 3 consecutive years. She is a current smoker. Clinical examination reveals generalized moderate to heavy biofilm, calculus, and bleeding on probing throughout. How is chronic bronchitis clinically DEFINED?",
      options: [
        "Presence of a productive cough with sputum for at least 3 months per year for more than 2 consecutive years",
        "Irreversible destruction of alveolar walls causing hyperinflation and decreased lung elasticity over a 5-year period",
        "Acute respiratory infection requiring hospitalization at least twice within a 12-month period with complete recovery",
        "Progressive dyspnea on exertion accompanied by wheezing and chest tightness occurring daily for 6 months minimum",
      ],
      correct: "A"
    },
    {
      id: 30621,
      question: "A patient with COPD is taking Combivent (albuterol/ipratropium bromide) inhaler. During the dental hygiene appointment, you plan to use an ultrasonic scaler for calculus removal. The patient expresses concern about the aerosol spray and reports increased shortness of breath when exposed to strong scents or airborne particles. What is the MOST appropriate modification to minimize risk during treatment?",
      options: [
        "Use preprocedural antimicrobial rinse, high-speed evacuation, and short activation intervals with the ultrasonic scaler",
        "Avoid use of ultrasonic scaler entirely and rely solely on hand instrumentation for calculus removal procedures",
        "Use the ultrasonic scaler at maximum power settings for shortest possible treatment time to minimize aerosol exposure",
        "Pre-medicate the patient with supplemental oxygen during the procedure and have the patient use their inhaler continuously",
      ],
      correct: "A"
    },
    {
      id: 30622,
      question: "A 29-year-old patient with asthma reports using Singulair (montelukast) once daily for long-term control and prevention of symptoms. She mentions she rarely needs her rescue inhaler since starting this medication. She asks about potential oral side effects of her medication during her dental hygiene appointment. What is the MOST accurate information regarding oral side effects of leukotriene modifiers?",
      options: [
        "Leukotriene modifiers commonly cause severe gingival hyperplasia requiring gingivectomy in most patients within 2 years",
        "These medications typically cause xerostomia, increased dental caries risk, and require prescription fluoride supplementation",
        "Side effects may include headache and nausea, but significant oral manifestations are uncommon with this drug class",
        "Leukotriene modifiers cause oral candidiasis in all patients and prophylactic antifungal medication is required concurrently",
      ],
      correct: "C"
    },
    {
      id: 30623,
      question: "A patient with severe COPD is scheduled for extensive periodontal debridement. The dentist suggests using nitrous oxide-oxygen conscious sedation to help manage the patient's anxiety during the lengthy procedure. The patient uses supplemental oxygen at home and appears to have significant respiratory compromise. What is the PRIMARY concern with using nitrous oxide-oxygen sedation for this patient?",
      options: [
        "Nitrous oxide may cause severe bronchospasm requiring immediate administration of emergency corticosteroids",
        "The combination of nitrous oxide with COPD medications may result in fatal cardiac arrhythmias during treatment",
        "High oxygen levels may suppress the hypoxic drive to breathe potentially causing respiratory apnea in COPD patients",
        "Nitrous oxide is contraindicated in all respiratory patients due to increased risk of pneumothorax during administration",
      ],
      correct: "C"
    },
    {
      id: 30624,
      question: "An 85-year-old nursing home resident is referred for dental hygiene care. The nursing staff reports he has difficulty swallowing, frequently pockets food in his mouth, and has had two episodes of aspiration pneumonia in the past year. He wears complete maxillary and mandibular dentures. The staff mentions they usually just wipe his mouth with a cloth after meals due to time constraints. What is the MOST important oral care recommendation to prevent future aspiration pneumonia?",
      options: [
        "Recommend the patient stop wearing his dentures entirely to eliminate the risk of denture aspiration during meals",
        "Suggest pureed-only diet and no oral care for 3 hours after meals to allow adequate time for swallowing reflexes",
        "Instruct staff to remove and clean dentures daily, brush any remaining oral tissues, and avoid having him wear dentures while sleeping",
        "Advise that cloth wiping is adequate for denture wearers and additional oral care increases aspiration risk unnecessarily",
      ],
      correct: "C"
    },
    {
      id: 30625,
      question: "During a new patient examination, you note a 35-year-old patient has significant bruxism-related tooth wear, a scalloped tongue, a long facial appearance, and a retrognathic mandible. He reports his spouse complains about his loud snoring and has noticed periods where he stops breathing during sleep. He denies any treatment and says he's \"always tired.\" What is the MOST appropriate initial response to these findings?",
      options: [
        "Fabricate an occlusal guard immediately to prevent further tooth structure loss from the severe bruxism",
        "Discuss findings suggesting possible sleep apnea, explain oral manifestations, and refer to physician for sleep study evaluation",
        "Recommend immediate orthodontic consultation for mandibular advancement surgery to permanently resolve the condition",
        "Prescribe a sedative medication to help the patient sleep through the night without the breathing disturbances",
      ],
      correct: "B"
    },
    {
      id: 30626,
      question: "A 15-year-old patient presents with poorly controlled asthma and reports frequent use of his albuterol rescue inhaler (8-10 times per week) and multiple nighttime awakenings requiring medication. His Advair (fluticasone/salmeterol) inhaler was prescribed but he admits he \"forgets to use it most days.\" Clinical examination reveals xerostomia and early white spot lesions on multiple teeth. What is the MOST appropriate patient education approach?",
      options: [
        "Explain the importance of medication compliance, proper inhaler technique, post-use rinsing, and fluoride therapy for oral health",
        "Recommend the patient discontinue Advair and rely solely on the rescue inhaler since he uses it regularly anyway",
        "Advise the patient that his asthma is too poorly controlled for dental treatment and defer all care for one year",
        "Suggest the patient switch to oral corticosteroid tablets as they are easier to remember and equally effective for asthma",
      ],
      correct: "A"
    },
    {
      id: 30627,
      question: "A patient with active tuberculosis who is hospitalized requires emergency dental treatment. The hospital dental service will provide care. As the consulting dental hygienist, what environmental infection control measures should be implemented for this patient?",
      options: [
        "Treat in a standard operatory using universal precautions with routine surgical masks and eyewear protection only",
        "Provide treatment in any available room as long as all staff wear N95 respirators throughout the procedure",
        "Schedule treatment in the hospital parking garage with all doors and windows open to maximize air circulation",
        "Use an isolation room with negative air pressure, HEPA filtration, and minimum 6-12 air changes per hour requirements",
      ],
      correct: "D"
    },
    {
      id: 30628,
      question: "A 48-year-old patient with newly diagnosed COPD asks about the connection between his periodontal disease and his lung condition. He has generalized moderate to severe periodontitis with significant bone loss. He continues to smoke one pack per day and is interested in how oral health might affect his COPD. What is the MOST accurate information to provide this patient?",
      options: [
        "There is no established connection between oral health and respiratory disease; focus should be solely on smoking cessation",
        "Poor oral health has been associated with COPD exacerbations; improved oral hygiene and smoking cessation are both important",
        "Periodontal disease causes COPD; once periodontal health is restored the lung disease will completely resolve",
        "Treating COPD will automatically improve periodontal health; oral hygiene efforts are unnecessary until lungs are healthy",
      ],
      correct: "B"
    },
    {
      id: 30629,
      question: "During pre-operative assessment, your patient with moderate persistent asthma mentions she is allergic to aspirin, which triggers severe asthma attacks. The dentist plans to prescribe post-operative pain medication following her upcoming periodontal surgery. Which medication should be AVOIDED for this patient's post-operative pain management?",
      options: [
        "Acetaminophen (Tylenol) because it is metabolized similarly to aspirin and will cause cross-reactivity in aspirin-sensitive patients",
        "Oxycodone (narcotic analgesic) because it is contraindicated in all patients with any form of respiratory disease",
        "Tramadol (Ultram) because it interacts dangerously with all asthma medications causing respiratory depression",
        "Ibuprofen (Advil, Motrin) because NSAIDs may precipitate asthma attacks in aspirin-sensitive individuals",
      ],
      correct: "D"
    },
    {
      id: 30630,
      question: "A patient reports a positive tuberculin skin test (PPD) from a workplace screening but has no symptoms and a normal chest x-ray. Her physician prescribed isoniazid (INH) for 9 months as preventive therapy, which she completed 2 months ago. She asks if it's safe to receive dental treatment. What is the MOST appropriate response regarding her dental treatment?",
      options: [
        "She can receive routine dental care using standard precautions as she has latent TB infection with completed preventive treatment",
        "Defer all dental treatment indefinitely as positive PPD indicates permanent infectious status regardless of preventive therapy",
        "Require airborne precautions with N95 respirators for all appointments as PPD remains positive permanently after TB exposure",
        "Provide treatment only in a hospital isolation room even though she completed therapy, due to multi-drug resistant TB risk",
      ],
      correct: "A"
    },
    {
      id: 30631,
      question: "A 72-year-old patient with COPD presents for dental hygiene care. Her medication list includes Spiriva (tiotropium bromide), which she mentions makes her mouth very dry. She reports difficulty maintaining adequate oral hygiene due to fatigue and shortness of breath. Clinical examination shows heavy biofilm, xerostomia, and multiple root caries. What combination of interventions would be MOST beneficial for this patient?",
      options: [
        "Prescribe chlorhexidine rinse only and defer all mechanical debridement until the patient's COPD improves significantly",
        "Advise the patient to discontinue Spiriva due to xerostomic side effects and substitute with over-the-counter cough medicine",
        "Extract all teeth and fabricate complete dentures to eliminate oral hygiene burden and caries risk in this compromised patient",
        "Recommend high-fluoride toothpaste, saliva substitutes, power toothbrush, short appointments, and frequent recall intervals",
      ],
      correct: "D"
    },
    {
      id: 30632,
      question: "An intubated patient in ICU has been mechanically ventilated for 5 days. The critical care nurse asks about preventing ventilator-associated pneumonia. Current oral care consists of foam swabs with water every 12 hours. There is visible biofilm accumulation on the teeth. What change in the oral care protocol would MOST effectively reduce VAP risk?",
      options: [
        "Continue current protocol but increase frequency to every 8 hours, as foam swabs are superior to toothbrushes for intubated patients",
        "Discontinue all oral care to avoid disrupting the oral biofilm which actually protects against respiratory pathogen colonization",
        "Implement tooth brushing twice daily with chlorhexidine oral care swabs every 2-4 hours using a VAP prevention oral care kit",
        "Remove the endotracheal tube daily for complete oral hygiene, then reintubate after thorough cleaning is accomplished",
      ],
      correct: "C"
    },
    {
      id: 30633,
      question: "A 33-year-old pregnant patient in her second trimester presents with asthma managed with Flovent (fluticasone) inhaler. She expresses concern about using her inhaler during pregnancy and asks if it's safe to continue dental treatment. She needs scaling and root planing for generalized moderate periodontitis. What is the MOST appropriate management approach?",
      options: [
        "Proceed with necessary dental treatment; advise continuing asthma medication as prescribed by her physician is important for maternal and fetal health",
        "Defer all dental treatment until after delivery as pregnancy contraindicates treatment of asthmatic patients",
        "Recommend discontinuing all asthma medications during pregnancy and substitute with herbal remedies to avoid fetal exposure",
        "Provide treatment only with patient in left lateral recumbent position to prevent supine hypotensive syndrome and asthma attack",
      ],
      correct: "A"
    },
    {
      id: 30634,
      question: "A patient using a CPAP device for obstructive sleep apnea reports the mask leaves marks on his face and sometimes leaks during the night. He admits he frequently removes it because it's uncomfortable, resulting in poor compliance. He asks if there are alternatives to CPAP therapy. What is the MOST appropriate response regarding alternative treatments?",
      options: [
        "Inform him CPAP is the only evidence-based treatment for OSA and he must use it nightly despite discomfort",
        "Recommend he discontinue CPAP entirely as poor compliance makes it ineffective and potential harm outweighs benefits",
        "Explain that oral appliances fabricated by dentists, surgical options, and behavioral modifications are possible alternatives worth discussing with his physician",
        "Suggest simply sleeping in a seated position as this is equally effective as CPAP therapy for managing sleep apnea",
      ],
      correct: "C"
    },
    {
      id: 30635,
      question: "During new patient assessment, a 53-year-old reports a chronic cough, night sweats, and recent unintentional 20-pound weight loss over 3 months. He recently immigrated from a country with high tuberculosis prevalence. He has not seen a physician since arriving. He presents for emergency treatment of a painful tooth. What is the MOST appropriate action?",
      options: [
        "Proceed with emergency treatment using standard precautions and refer to a physician for follow-up after dental treatment is complete",
        "Postpone emergency treatment, refer immediately to physician for medical evaluation, and document findings with return pending medical clearance",
        "Provide emergency treatment in a negative pressure room wearing N95 respirator and diagnose the patient with active tuberculosis",
        "Extract the painful tooth immediately without local anesthesia to minimize appointment time and aerosol production during treatment",
      ],
      correct: "B"
    },
    {
      id: 30636,
      question: "A 68-year-old patient with severe COPD reports taking theophylline (Theo-Dur) 400mg twice daily. He mentions he likes to drink 3-4 alcoholic beverages daily and takes several herbal supplements. During the dental hygiene appointment, he begins experiencing hand tremors, nausea, and headache. What do these symptoms potentially indicate?",
      options: [
        "These are normal side effects of COPD and require no intervention or concern during dental treatment",
        "These symptoms confirm acute COPD exacerbation requiring immediate administration of supplemental oxygen",
        "These are signs of alcohol withdrawal and the patient should consume alcohol immediately before dental treatment",
        "These may indicate theophylline toxicity potentially related to drug interactions with alcohol or herbal supplements",
      ],
      correct: "D"
    },
    {
      id: 30637,
      question: "A 5-year-old child presents with his mother who reports he snores loudly every night. Clinical examination reveals significantly enlarged tonsils with constricted arches, anterior open bite, high palatal vault, and mouth breathing habit. The child appears tired and the mother mentions behavioral problems in school. What is the MOST likely consequence if this condition remains untreated?",
      options: [
        "The condition will spontaneously resolve at puberty when hormonal changes reduce tonsillar size to normal dimensions",
        "Continued airway obstruction during sleep may lead to sleep-related breathing disorder affecting growth, development, and learning",
        "The enlarged tonsils will cause severe difficulty swallowing requiring emergency tonsillectomy before age 6 to prevent malnutrition",
        "Mouth breathing will strengthen orofacial muscles resulting in improved facial development and reduced orthodontic needs",
      ],
      correct: "B"
    },
    {
      id: 30638,
      question: "A patient with newly diagnosed postacute COVID-19 syndrome (long COVID) presents reporting persistent fatigue, brain fog, and shortness of breath that began after her COVID-19 infection 4 months ago. She has difficulty concentrating and becomes easily exhausted. She needs comprehensive periodontal therapy. How should the dental hygiene care plan be modified for this patient?",
      options: [
        "Plan short appointments with rest periods, position for comfort, monitor for breathing difficulty, and provide stress reduction",
        "Defer all care for minimum two years until long COVID research establishes definitive treatment protocols and contraindications",
        "Complete all necessary treatment in one extended appointment to minimize frequency of exposure to potential respiratory triggers",
        "Refer to hospital-based dental clinic as long COVID patients require general anesthesia for any dental procedures",
      ],
      correct: "A"
    },
    {
      id: 30639,
      question: "A 60-year-old patient with moderate COPD presents for dental hygiene care. You plan to use an air polisher for stain removal. His health history indicates his COPD is poorly controlled with frequent exacerbations requiring emergency treatment. He reports severe shortness of breath with any exertion. What is the MOST appropriate decision regarding air polisher use?",
      options: [
        "Use the air polisher at reduced pressure settings with frequent breaks to minimize respiratory distress during the procedure",
        "Pre-medicate with bronchodilators 30 minutes before using air polisher at maximum efficiency to minimize treatment time",
        "Use air polisher liberally as sodium bicarbonate powder has bronchodilator properties that will benefit his COPD symptoms",
        "Avoid air polisher use as aerosols may precipitate breathing difficulty; consider hand scaling or power-driven polishing cautiously",
      ],
      correct: "D"
    },
    {
      id: 30640,
      question: "A patient reports using Symbicort (budesonide/formoterol) twice daily for COPD management. He asks whether he should use his inhaler before his dental appointment. He reports feeling more anxious than usual about today's treatment, which involves extensive scaling and root planing. What is the MOST appropriate recommendation?",
      options: [
        "Advise him not to use his inhaler before the appointment as the medication may interfere with local anesthesia effectiveness",
        "Tell him to double his usual dose of Symbicort before the appointment to prevent any breathing problems during treatment",
        "Recommend he skip his morning dose since the inhaler may interact dangerously with anxiety during stressful procedures",
        "Instruct him to use his prescribed inhaler before the appointment and bring it with him for use during treatment if needed",
      ],
      correct: "D"
    },
    {
      id: 30641,
      question: "A dental hygienist is providing education to nursing staff about oral care for residents in a long-term care facility. Several residents have had aspiration pneumonia. The nurses state they avoid brushing teeth vigorously because they're concerned about residents aspirating toothpaste and water. What is the MOST important information to provide?",
      options: [
        "Proper tooth brushing technique with suctioning and positioning is more effective than foam swabs at removing pathogenic oral bacteria",
        "Foam swabs are superior to toothbrushes for frail elderly and should replace tooth brushing to minimize aspiration risk",
        "All oral care should be avoided in residents with swallowing difficulties as any intervention increases aspiration pneumonia risk",
        "Residents should perform their own oral care without staff assistance to preserve autonomy and reduce facility liability",
      ],
      correct: "A"
    },
    {
      id: 30642,
      question: "A 26-year-old patient with severe persistent asthma presents for routine dental hygiene care. He reports using Dulera (mometasone/formoterol) twice daily and his albuterol rescue inhaler 2-3 times weekly. He is interested in tooth whitening and asks about using whitening products. What information about whitening is MOST important for this patient?",
      options: [
        "All whitening products are absolutely contraindicated in asthma patients due to risk of bronchospasm from peroxide exposure",
        "Only over-the-counter whitening strips are safe for asthmatics; professional whitening concentrations will trigger severe attacks",
        "Professional whitening can be provided with caution; monitor for sensitivity and respiratory symptoms, ensure rescue inhaler availability",
        "Whitening must be performed under general anesthesia in a hospital setting for all patients with any type of respiratory disease",
      ],
      correct: "C"
    },
    {
      id: 30643,
      question: "A patient with COPD is scheduled for dental hygiene treatment. Her medication list includes Anoro Ellipta (umeclidinium/vilanterol). During the health history update, she mentions she has been having more difficulty breathing over the past week, increased sputum production, and feels like she might be developing a cold. What is the MOST appropriate action?",
      options: [
        "Proceed with treatment as scheduled since these symptoms are normal for COPD patients and require no special consideration",
        "Provide treatment but avoid all power-driven and ultrasonic instruments and complete treatment using hand instruments only",
        "Postpone elective treatment and recommend she contact her physician about these symptoms suggesting possible infection or exacerbation",
        "Administer prophylactic antibiotics before proceeding with treatment to prevent the suspected infection from worsening",
      ],
      correct: "C"
    },
    {
      id: 30644,
      question: "A 55-year-old patient with chronic bronchitis has generalized moderate periodontitis requiring scaling and root planing. He is a current smoker. The dentist suggests the dental hygienist provide smoking cessation counseling as part of comprehensive care planning. What is the MOST important reason to emphasize smoking cessation for this patient?",
      options: [
        "Smoking cessation will immediately cure his chronic bronchitis eliminating need for medications or lifestyle modifications",
        "Continuing to smoke will cause oral cancer within 5 years requiring extensive surgery and radiation therapy",
        "Smoking cessation will reverse all existing COPD-related lung damage and restore normal pulmonary function completely",
        "Smoking is the primary modifiable risk factor for both his respiratory disease progression and periodontal disease severity",
      ],
      correct: "D"
    },
    {
      id: 30645,
      question: "An intubated patient in ICU has been mechanically ventilated for 10 days. The medical team is concerned about the patient developing ventilator-associated pneumonia. The dental hygienist is consulted about oral care protocols. What factor is MOST critical in the pathogenesis of VAP that oral care addresses?",
      options: [
        "Dental biofilm on teeth serves as a reservoir for respiratory pathogens that migrate to lungs via the endotracheal tube",
        "Aspiration of sterile saliva from the oropharynx causing chemical pneumonitis in the lower respiratory tract",
        "Intubation causes direct mechanical trauma to lung tissue making it susceptible to any type of infection",
        "Mechanical ventilation itself introduces bacteria regardless of oral hygiene status making oral care ineffective for prevention",
      ],
      correct: "A"
    },
    {
      id: 30646,
      question: "A 41-year-old patient presents for dental hygiene care with obstructive sleep apnea being treated with a mandibular advancement oral appliance fabricated by her dentist. She reports good compliance and symptom improvement. Clinical examination reveals mild temporomandibular discomfort and some tooth mobility on the mandibular anterior teeth. What is the MOST appropriate management?",
      options: [
        "Recommend immediate discontinuation of the oral appliance due to tooth mobility and TMJ symptoms indicating permanent damage",
        "These findings are normal expected outcomes of oral appliance therapy and require no intervention or provider notification",
        "Document findings, advise patient to inform prescribing dentist, and schedule follow-up evaluation and possible appliance adjustment",
        "Extract the mobile teeth immediately as they will be lost anyway and mobility indicates severe periodontal disease",
      ],
      correct: "C"
    },
    {
      id: 30647,
      question: "A patient with moderate persistent asthma arrives for dental hygiene care appearing anxious. During the procedure, you notice his breathing becoming slightly more rapid and shallow. He does not report any symptoms but appears tense. His rescue inhaler is on the bracket table. What is the MOST appropriate initial action?",
      options: [
        "Immediately stop treatment and administer his bronchodilator prophylactically before symptoms progress to acute attack",
        "Continue treatment quickly to completion as stopping will only increase his anxiety and make breathing problems worse",
        "Activate emergency protocol and administer parenteral epinephrine from the emergency kit to prevent status asthmaticus",
        "Pause briefly, use calming communication techniques, assess his comfort level, and be prepared to stop if symptoms develop",
      ],
      correct: "D"
    },
    {
      id: 30648,
      question: "During a community health screening at a senior center, you identify several elderly individuals with poor oral hygiene, xerostomia, and difficulty performing oral self-care. The facility director asks for recommendations to prevent aspiration pneumonia among residents. What is the MOST effective community-level intervention?",
      options: [
        "Provide staff education on proper oral care techniques, ensure availability of oral hygiene supplies, and implement daily care protocols",
        "Recommend all residents receive prophylactic antibiotics daily to prevent development of pneumonia regardless of oral health status",
        "Advise extraction of all teeth and immediate complete denture fabrication for all residents to eliminate oral care needs",
        "Suggest residents avoid all oral intake after 6 PM to prevent nighttime aspiration events during sleep",
      ],
      correct: "A"
    },
    {
      id: 30649,
      question: "A 47-year-old patient with newly diagnosed obstructive sleep apnea asks about the connection between his condition and his oral health. He has generalized moderate periodontitis, significant tooth wear, and scalloped tongue borders. He is interested in how treating his sleep apnea might affect his dental health. What is the MOST accurate information to provide?",
      options: [
        "There is no relationship between sleep apnea and oral health; they are completely separate conditions requiring independent treatment",
        "Once sleep apnea treatment begins, all oral health problems will spontaneously resolve requiring no dental intervention",
        "Sleep apnea causes periodontal disease; treating sleep apnea first will cure periodontitis eliminating need for scaling",
        "Treating sleep apnea may help reduce some oral manifestations like bruxism-related wear; however, periodontal disease requires separate active treatment",
      ],
      correct: "D"
    }
  ],
  "8. Substance Use Disorders (Case Study)": [
    {
      id: 30700,
      question: "A 28-year-old male patient presents for his first dental appointment in 5 years. His health history reveals completion of a drug rehabilitation program 8 months ago for cocaine addiction. He reports feeling anxious about dental treatment and mentions he \"took something\" before the appointment to calm his nerves. Clinical examination reveals localized gingival necrosis in the maxillary premolar area, heavy calculus, and multiple carious lesions. What is the MOST appropriate immediate action by the dental hygienist?",
      options: [
        "Proceed with scaling and root planing using local anesthetic with epinephrine to ensure adequate hemostasis",
        "Postpone treatment, explain the life-threatening interaction risk between cocaine and epinephrine, and reschedule when drug-free",
        "Complete only supragingival scaling without anesthesia and recommend over-the-counter pain medication if needed",
        "Administer nitrous oxide sedation to reduce anxiety and proceed with comprehensive periodontal debridement today",
      ],
      correct: "B"
    },
    {
      id: 30701,
      question: "A 45-year-old female patient with a 20-year history of alcohol use disorder presents for dental hygiene care. She completed an alcohol treatment program 6 months ago and takes disulfiram (Antabuse) daily. She requests a fluoride treatment and asks about using an antimicrobial mouth rinse at home for her gingivitis. Which product recommendation is MOST appropriate for this patient?",
      options: [
        "Prescribe chlorhexidine gluconate 0.12% mouth rinse and any over-the-counter fluoride rinse for daily home use",
        "Recommend alcohol-free antimicrobial rinse and alcohol-free fluoride products to avoid interaction with disulfiram",
        "Suggest she discontinue disulfiram temporarily when using dental products to prevent any potential complications",
        "Advise that all mouth rinses are contraindicated for recovering alcoholics regardless of alcohol content",
      ],
      correct: "B"
    },
    {
      id: 30702,
      question: "A 32-year-old patient arrives 45 minutes late for his scheduled 1-hour appointment. This is his third consecutive late arrival. His health history indicates he is in a methadone maintenance program for heroin addiction. He reports experiencing severe dental pain and requests specific pain medication. What is the MOST appropriate management approach?",
      options: [
        "Accommodate the patient by providing treatment in the remaining 15 minutes and prescribe the requested pain medication",
        "Cancel today's appointment, maintain firm boundaries, and explain that repeated lateness is not acceptable behavior",
        "Provide emergency treatment only, then refer immediately to a hospital-based dental clinic for all future care",
        "Complete the full appointment as scheduled even if it requires staying past normal office hours to be compassionate",
      ],
      correct: "B"
    },
    {
      id: 30703,
      question: "During health history review, a 24-year-old patient reports daily marijuana use for the past 3 years, stating it's \"legal in my state.\" Clinical examination reveals generalized gingival inflammation, moderate calculus, and early periodontitis unusual for his age. The dental hygienist plans to use local anesthesia with epinephrine for scaling procedures. What is the MOST important consideration regarding anesthetic selection?",
      options: [
        "Marijuana use has no interaction with dental anesthetics; proceed with standard lidocaine with epinephrine protocol",
        "All local anesthetics are contraindicated in marijuana users; complete treatment without any pain control measures",
        "Local anesthetic containing epinephrine may prolong tachycardia following recent marijuana use; verify time of last use",
        "Marijuana users require higher doses of anesthetic due to tolerance; double the standard cartridge amount automatically",
      ],
      correct: "C"
    },
    {
      id: 30704,
      question: "A 19-year-old college student presents with facial trauma, missing maxillary central incisors, and multiple oral lacerations. During the health history interview, she appears disoriented and confused. Her pupils are extremely dilated, and she exhibits rapid mood swings between euphoria and agitation within minutes. These signs are MOST consistent with use of which substance category?",
      options: [
        "Central nervous system depressants such as barbiturates causing sedation and reduced consciousness",
        "Opioid analgesics such as heroin causing pinpoint pupils and respiratory depression",
        "Central nervous system stimulants such as methamphetamine causing hyperactivity and dilated pupils",
        "Hallucinogens such as marijuana causing relaxation, red eyes, and increased appetite",
      ],
      correct: "C"
    },
    {
      id: 30705,
      question: "A 50-year-old male patient with a 30-year history of alcohol abuse presents for dental hygiene care. Medical history includes liver cirrhosis. The dentist plans to perform periodontal surgery next week and asks the dental hygienist to coordinate appropriate medical consultation. What is the PRIMARY reason for medical consultation before surgery?",
      options: [
        "Determine if patient requires higher doses of local anesthetic due to tolerance from chronic alcohol consumption",
        "Evaluate need for antianxiety medication prescription since alcoholics cannot tolerate dental procedures without sedation",
        "Confirm patient can safely receive nitrous oxide sedation without risk of respiratory depression complications",
        "Assess liver function and ability to produce clotting factors to control bleeding during surgical procedures",
      ],
      correct: "D"
    },
    {
      id: 30706,
      question: "A dental hygiene student notices a classmate frequently arriving to clinic late, appearing disheveled with declining clinical performance. The classmate has bloodshot eyes, slurred speech on several occasions, and recently requested to borrow prescription pain medication \"for a headache.\" What factors make healthcare students particularly vulnerable to substance use disorders?",
      options: [
        "Healthcare students have lower stress levels than the general population but higher access to controlled substances",
        "Professional programs effectively screen out students with predisposition to addiction during admissions processes",
        "Competitive academic environment, continuous criticism, sleep deprivation, and easy access to medications increase risk",
        "Healthcare education provides immunity to addiction because students learn to recognize symptoms in themselves",
      ],
      correct: "C"
    },
    {
      id: 30707,
      question: "A 35-year-old patient in recovery from methamphetamine addiction presents with \"meth mouth\" - severe tooth decay, periodontal disease, and extensive tooth wear. He reports being drug-free for 4 months and is motivated to restore his oral health. He experiences significant dental anxiety. What is the MOST appropriate initial treatment approach?",
      options: [
        "Complete all necessary treatment in one extended appointment under general anesthesia to avoid multiple anxiety-producing visits",
        "Require psychiatric clearance and sedation prescription before providing any dental hygiene services to this patient",
        "Begin with short 20-minute appointments focusing on basic supragingival debridement and building trust before advancing treatment",
        "Defer all dental treatment for minimum one year until patient has been drug-free longer to ensure commitment",
      ],
      correct: "C"
    },
    {
      id: 30708,
      question: "A 26-year-old patient reports IV heroin use for 5 years but states he has been \"clean\" for 6 weeks. Clinical examination reveals healing needle marks in the antecubital fossa and numerous oral lesions consistent with candidiasis. The dental hygienist plans scaling and root planing. What additional assessment information is MOST critical before beginning treatment?",
      options: [
        "Determine if patient has been tested for HIV, hepatitis B, C, D, and evaluate need for antibiotic premedication",
        "Confirm patient brought prescribed pain medication to the appointment for use immediately after treatment",
        "Assess if patient's dental insurance will cover treatment costs since many IV drug users are uninsured",
        "Verify patient has reliable transportation home since all substance abusers require sedation for dental procedures",
      ],
      correct: "A"
    },
    {
      id: 30709,
      question: "During a community health screening, the dental hygienist identifies several adolescents with oral burns on lips, \"glue-sniffer's rash\" around the mouth, and erythema of oral mucosa. When questioned, the teens admit to frequent inhalant use at parties. What is the PRIMARY health risk associated with inhalant abuse?",
      options: [
        "Inhalants cause only minor oral tissue irritation with no systemic effects or serious health consequences",
        "Psychological addiction only occurs; inhalants do not cause physical dependence or withdrawal symptoms",
        "Inhalants are the least dangerous recreational drugs because they contain only natural household substances",
        "Brain, liver, kidney, nervous system damage, cardiac arrhythmia, and risk of sudden death from use",
      ],
      correct: "D"
    },
    {
      id: 30710,
      question: "A 40-year-old patient presents with yellowish facial skin, spider petechiae on the nose, red swollen eyes, angular cheilitis, and glossitis. She reports drinking \"socially\" but becomes defensive when asked specific quantities. Clinical examination reveals poor oral hygiene, cervical carious lesions, and generalized gingival bleeding. These findings are MOST consistent with which condition?",
      options: [
        "Chronic methamphetamine abuse causing dental decay, xerostomia, and extreme tooth wear from bruxism",
        "Cocaine abuse causing gingival necrosis, nasal septal perforation, and burns on dominant thumb",
        "Chronic alcohol use disorder causing nutritional deficiencies, liver disease, and poor self-care",
        "Marijuana use disorder causing xerostomia, increased caries, and gingival inflammation from smoking",
      ],
      correct: "C"
    },
    {
      id: 30711,
      question: "A patient in a methadone maintenance program for opioid addiction requires extensive periodontal treatment. He expresses concern about pain management, stating his daily methadone dose \"doesn't help with dental pain anymore\" due to tolerance. The dentist considers prescribing postoperative analgesics. What is the MOST appropriate pain management strategy?",
      options: [
        "Prescribe high-dose opioid analgesics since patient has tolerance and requires more medication than typical patients",
        "Recommend combination therapy of ibuprofen and acetaminophen as effective alternative to opioid analgesics",
        "Advise patient that pain management is impossible for those in methadone programs and treatment must proceed without analgesics",
        "Suggest patient stop methadone program temporarily to allow opioid analgesics to work effectively for dental pain",
      ],
      correct: "B"
    },
    {
      id: 30712,
      question: "A 22-year-old college student presents with severe bruxism, extreme tooth wear, xerostomia, and reports using \"Ecstasy\" (MDMA) regularly at weekend parties. She requires scaling and local anesthesia. Her blood pressure is 148/92, and pulse is 110 bpm. What is the MOST critical consideration before administering local anesthesia?",
      options: [
        "MDMA users always require general anesthesia because local anesthetics are completely ineffective due to drug tolerance",
        "MDMA has no interaction with local anesthetics; proceed immediately with standard lidocaine with epinephrine",
        "Prescribe prophylactic antibiotics before any dental treatment because all club drug users are immunocompromised",
        "Wait minimum 6 hours after last MDMA use and avoid anesthetics with vasoconstrictors to prevent hypertensive crisis",
      ],
      correct: "D"
    },
    {
      id: 30713,
      question: "During new patient assessment, a 38-year-old patient admits to daily alcohol consumption of approximately 6-8 drinks. When asked if she has ever felt guilty about drinking or needed a morning drink, she answers \"yes\" to both questions. What do these responses indicate about the patient's alcohol use?",
      options: [
        "Positive responses to two or more CAGE questions strongly suggest alcohol use disorder requiring intervention",
        "Patient has normal social drinking patterns with no cause for concern or need for further assessment",
        "These questions are not valid screening tools; blood alcohol testing is the only accurate assessment method",
        "Patient is exaggerating alcohol use; most people answer yes to feel important during health interviews",
      ],
      correct: "A"
    },
    {
      id: 30714,
      question: "A dental hygienist notices a colleague arriving late to work frequently, missing appointments, and appearing disheveled. The colleague's hands tremble during patient treatment, and prescription pads have gone missing from the office on several occasions. What is the MOST appropriate action?",
      options: [
        "Ignore the situation because substance abuse is a personal problem and should not involve workplace intervention",
        "Immediately report the colleague to law enforcement and demand drug testing before allowing patient treatment",
        "Contact the state dental association's health and well-being committee for confidential referral and assistance",
        "Confront the colleague publicly in front of office staff to shame them into seeking addiction treatment",
      ],
      correct: "C"
    },
    {
      id: 30715,
      question: "A 29-year-old patient with schizophrenia and co-occurring substance use disorder presents for dental hygiene care. His medications include antipsychotic drugs causing severe xerostomia. He has poor oral hygiene and multiple carious lesions. What does the term \"co-occurring disorder\" mean in this case?",
      options: [
        "Patient has two completely unrelated diseases that developed independently with no connection between conditions",
        "Patient developed mental illness as a direct result of substance abuse; treating addiction will cure mental illness",
        "The coexistence of both a substance use disorder and a mental health disorder in the same individual",
        "Mental illness caused substance abuse; once psychiatric symptoms resolve, addiction will automatically disappear",
      ],
      correct: "C"
    },
    {
      id: 30716,
      question: "A 33-year-old patient reports taking buprenorphine (Suboxone) for opioid addiction treatment. She is pregnant in her second trimester and concerned about continuing the medication. She needs periodontal scaling and asks about using local anesthesia. What is the MOST appropriate response regarding her medication?",
      options: [
        "Advise patient to immediately discontinue buprenorphine during pregnancy to avoid fetal exposure to opioids",
        "Defer all dental treatment including emergency care until after delivery because pregnancy contraindicates any medications",
        "Explain that continuing addiction treatment medication as prescribed by her physician is important for her health and fetal well-being",
        "Recommend switching to methadone during pregnancy since buprenorphine always causes fetal alcohol spectrum disorders",
      ],
      correct: "C"
    },
    {
      id: 30717,
      question: "A patient's medical history indicates he takes naltrexone (Vivitrol) injections monthly as part of his alcohol use disorder treatment. He presents with acute dental pain requiring emergency treatment and prescription pain medication. What is the PRIMARY consideration regarding pain medication for this patient?",
      options: [
        "Naltrexone blocks opioid receptors; opioid analgesics will be ineffective, recommend NSAIDs instead",
        "Naltrexone enhances opioid effects; patient requires only half the standard dose of opioid analgesics",
        "Naltrexone has no effect on dental pain medication; prescribe standard doses of any opioid analgesic",
        "Naltrexone is contraindicated with NSAIDs; only opioid medications can be safely prescribed",
      ],
      correct: "A"
    },
    {
      id: 30718,
      question: "A 27-year-old patient presents with severe nasal damage, perforated nasal septum, chronic sinusitis, and gingival ulcerations in the maxillary anterior region. He admits to \"snorting\" cocaine regularly for the past 4 years. What is the mechanism by which cocaine causes these oral manifestations?",
      options: [
        "Cocaine placed in maxillary vestibule to test purity causes localized gingival and alveolar bone necrosis",
        "Cocaine causes severe xerostomia leading to rampant caries but has no effect on soft tissues",
        "Cocaine is mixed with sugar causing increased bacterial growth and tissue inflammation",
        "Intranasal cocaine use has no oral manifestations; these findings indicate unrelated periodontal disease",
      ],
      correct: "A"
    },
    {
      id: 30719,
      question: "During health history review, a 52-year-old patient reports being in recovery from alcoholism for 18 months. He states he attends Alcoholics Anonymous meetings regularly and follows his physician's treatment plan. He appears well-groomed, cooperative, and motivated to restore his oral health. What is the PRIMARY reason patients in recovery may be BETTER candidates for comprehensive dental treatment?",
      options: [
        "Recovered patients have no oral manifestations remaining from past substance use requiring intervention",
        "Patients in recovery often seek dental treatment as part of achieving total body health and improved self-esteem",
        "Insurance companies only provide dental coverage once patients complete addiction treatment programs",
        "Dental professionals are legally required to treat recovered addicts but may refuse those currently using substances",
      ],
      correct: "B"
    },
    {
      id: 30720,
      question: "A 19-year-old patient presents to the emergency department with acute psychosis, paranoia, and severe anxiety after attending a nightclub party. She is unable to provide accurate medical history. Physical examination reveals dilated pupils, hyperthermia, and dehydration. Which \"club drug\" is MOST likely responsible for these symptoms?",
      options: [
        "Gamma-hydroxybutyrate (GHB) causing sedation, amnesia, and loss of consciousness",
        "Methylenedioxymethamphetamine (MDMA/Ecstasy) causing stimulation, hyperthermia, and altered consciousness",
        "Rohypnol causing profound sedation, muscle relaxation, and anterograde amnesia",
        "Ketamine causing dissociative anesthesia, decreased pain sensation, and lowered blood pressure",
      ],
      correct: "B"
    },
    {
      id: 30721,
      question: "A 45-year-old patient with history of IV drug use presents for dental hygiene care. The dental hygienist observes healing needle marks and asks about previous infections. The patient reports a history of endocarditis caused by Staphylococcus aureus. What is the MOST appropriate premedication protocol for this patient?",
      options: [
        "No premedication needed; history of endocarditis does not require prophylactic antibiotics for dental procedures",
        "Automatically prescribe standard prophylactic antibiotic regimen without physician consultation since IV drug history exists",
        "Defer all dental hygiene treatment permanently; patients with endocarditis history cannot receive dental care safely",
        "Consult with physician to determine if cardiac damage exists requiring antibiotic premedication before scaling",
      ],
      correct: "D"
    },
    {
      id: 30722,
      question: "A patient completing health history questionnaire marks \"yes\" to drug/alcohol addiction but leaves the section blank when asked to specify details. During the interview, the patient appears uncomfortable and states \"I'd rather not discuss it.\" What is the MOST appropriate response by the dental hygienist?",
      options: [
        "Respect patient confidentiality concerns but explain information is needed to protect patient from health risks during treatment",
        "Refuse to provide treatment until patient provides complete detailed substance use history including specific drugs and amounts",
        "Assume patient is currently intoxicated and immediately dismiss patient from practice for dishonesty",
        "Skip the substance use discussion entirely to avoid making patient uncomfortable or violating their privacy rights",
      ],
      correct: "A"
    },
    {
      id: 30723,
      question: "A 31-year-old pregnant patient in her first trimester reports marijuana use throughout pregnancy to manage nausea. She asks the dental hygienist if this could affect her baby or if she should continue using marijuana. What is the MOST appropriate information to provide?",
      options: [
        "Marijuana is completely safe during pregnancy since it's a natural plant product with no synthetic chemicals",
        "Marijuana use during pregnancy may increase risk for pregnancy complications; recommend discussing alternatives with her physician",
        "Only synthetic marijuana (K2/Spice) is dangerous during pregnancy; natural marijuana poses no fetal risks",
        "Stop marijuana immediately without physician consultation since any substance use automatically causes fetal abnormalities",
      ],
      correct: "B"
    },
    {
      id: 30724,
      question: "A 24-year-old patient presents with \"meth mouth\" - severe tooth decay, broken teeth, and advanced periodontal disease. She reports being methamphetamine-free for 2 weeks and wants to begin dental treatment immediately. She appears anxious and requests prescription pain medication in advance. What is the MOST appropriate initial response?",
      options: [
        "Prescribe requested pain medication immediately to demonstrate trust and support her recovery efforts",
        "Recognize potential drug-seeking behavior; defer prescription medications and begin with conservative supportive care",
        "Refuse all treatment permanently because all former methamphetamine users inevitably relapse within months",
        "Require patient to bring police records proving she has no arrest history before providing any dental care",
      ],
      correct: "B"
    },
    {
      id: 30725,
      question: "A 36-year-old patient reports daily use of prescription opioids (oxycodone) for chronic back pain for the past 3 years. He states he needs increasingly higher doses to control pain. Clinical examination reveals normal oral findings. What phenomenon explains the need for increasing doses?",
      options: [
        "Physiological dependence and tolerance requiring larger doses to achieve the same effect obtained with smaller initial doses",
        "Patient is malingering and exaggerating pain symptoms to obtain unnecessary controlled substance prescriptions",
        "Opioids lose potency over time when stored improperly; patient needs fresh prescriptions with higher medication potency",
        "Chronic pain naturally intensifies over time requiring higher doses; this is unrelated to the medication itself",
      ],
      correct: "A"
    },
    {
      id: 30726,
      question: "During periodontal charting, the dental hygienist observes track marks (needle scars) on a patient's forearms. The patient wears long sleeves despite warm weather and becomes defensive when asked about the marks. What is the MOST appropriate documentation in the patient record?",
      options: [
        "Write subjective opinion: \"Patient is obviously a drug addict who is lying about substance use history\"",
        "Document nothing about the scars to protect patient confidentiality and avoid potential discrimination",
        "Immediately photograph the marks without consent as legal evidence of drug use for law enforcement",
        "Record objective observations: \"Healing linear scars noted on bilateral antecubital fossae and forearms. Patient declined to discuss.\"",
      ],
      correct: "D"
    },
    {
      id: 30727,
      question: "A 42-year-old patient with alcohol use disorder presents for treatment. Extraoral examination reveals facial petechiae, jaundice, and tremors of hands and eyelids. He reports his last drink was approximately 6 hours ago. What do these findings suggest about the patient's current status?",
      options: [
        "Patient is currently intoxicated and should be sent home immediately without any assessment or treatment",
        "These are normal chronic findings in alcoholics with no immediate health concerns requiring attention",
        "Signs suggest alcohol withdrawal; proceed cautiously and be prepared for potential medical emergency",
        "Patient requires immediate administration of alcohol to prevent fatal withdrawal seizures in the dental chair",
      ],
      correct: "C"
    },
    {
      id: 30728,
      question: "A patient in recovery from opioid addiction receives buprenorphine/naloxone (Suboxone) sublingual film daily. He places the film under his tongue during the dental hygiene appointment while waiting in the chair. What is the PRIMARY purpose of the naloxone component in this medication?",
      options: [
        "Naloxone enhances the pain-relieving effects of buprenorphine for patients with chronic pain conditions",
        "Naloxone is an antibiotic preventing infections in immunocompromised patients recovering from opioid addiction",
        "Naloxone reverses all effects of buprenorphine, making this combination medication completely ineffective for treatment",
        "Naloxone prevents misuse by causing withdrawal if the combination medication is injected rather than taken sublingually",
      ],
      correct: "D"
    },
    {
      id: 30729,
      question: "A 28-year-old patient presents with bilateral parotid gland enlargement (sialosis), tooth erosion, and multiple carious lesions. She becomes tearful during the interview and admits to binge drinking on weekends followed by vomiting. What is the MOST likely cause of the tooth erosion?",
      options: [
        "Gastric acid exposure from frequent alcohol-induced vomiting causing enamel demineralization",
        "Direct chemical erosion from high sugar content in alcoholic beverages consumed during binge episodes",
        "Dry mouth from alcohol consumption leading to increased bacterial acid production and enamel breakdown",
        "Physical trauma from aggressive tooth brushing immediately after drinking to remove alcohol taste",
      ],
      correct: "A"
    },
    {
      id: 30730,
      question: "A 55-year-old patient reports taking acamprosate (Campral) as part of alcohol use disorder treatment. She asks the dental hygienist how this medication works and if it will interfere with dental treatment. What is the PRIMARY mechanism of action of acamprosate?",
      options: [
        "Blocks alcohol metabolism causing severe illness if alcohol is consumed; creates negative association with drinking",
        "Provides controlled alcohol substitute allowing gradual weaning without withdrawal symptoms",
        "Blocks euphoric effects of alcohol making drinking unrewarding but allows patient to consume safely",
        "Decreases cravings and urges for alcohol by normalizing brain chemistry disrupted by chronic alcohol use",
      ],
      correct: "D"
    },
    {
      id: 30731,
      question: "A 17-year-old patient presents with parents for orthodontic consultation. The dental hygienist notices the teen has burns on the thumb of his dominant hand, chronic nosebleeds, nasal crusting, and appears disoriented. What substance abuse should be suspected based on these signs?",
      options: [
        "Crack cocaine abuse causing burns from disposable lighter use and nasal damage from smoke inhalation",
        "Inhalant abuse causing oral frostbite and nasal irritation from direct chemical exposure",
        "Marijuana abuse causing increased appetite, red eyes, and impaired coordination",
        "Prescription opioid abuse causing pinpoint pupils, sedation, and respiratory depression",
      ],
      correct: "A"
    },
    {
      id: 30732,
      question: "A patient with severe alcohol use disorder is scheduled for multiple tooth extractions. The dentist plans to prescribe postoperative pain medication and asks the dental hygienist about appropriate options. Which medication recommendation is MOST appropriate?",
      options: [
        "High-dose opioid analgesics since alcoholics have cross-tolerance and require higher doses than typical patients",
        "Prescribe alcohol-based mouth rinses for pain relief since patient already has alcohol tolerance",
        "Nonsteroidal anti-inflammatory drugs (NSAIDs) as first-line choice since they are non-addictive and effective",
        "Refuse pain medication entirely; addicts must learn to tolerate pain to prevent enabling addictive behaviors",
      ],
      correct: "C"
    },
    {
      id: 30733,
      question: "During a community health education program, parents ask about warning signs that their teenagers might be using drugs. They request information about behavioral and physical indicators. Which of the following is a RELIABLE warning sign of possible substance use?",
      options: [
        "Improved academic performance, increased motivation, and enhanced focus on long-term goals",
        "Increased interest in family activities and seeking more time with parents and siblings",
        "Consistent sleep schedule, improved personal hygiene, and taking on additional responsibilities",
        "Rapid mood swings, declining grades, secretive behavior, and unexplained need for money",
      ],
      correct: "D"
    },
    {
      id: 30734,
      question: "A 44-year-old patient in methadone treatment presents with \"meth mouth\" despite being in an opioid treatment program, not methamphetamine treatment. She is confused why her teeth are so decayed. What is the MOST likely cause of the rampant caries in this methadone patient?",
      options: [
        "Methadone is administered as sugary syrup taken orally daily, increasing caries risk significantly",
        "Methadone has no cariogenic properties; decay is caused by pre-existing poor oral hygiene only",
        "Methadone causes enamel hypoplasia making teeth structurally weak and prone to fracture",
        "Name \"meth mouth\" only refers to methamphetamine; methadone patients never develop this condition",
      ],
      correct: "A"
    },
    {
      id: 30735,
      question: "A 39-year-old patient presents with severe periodontal disease, xerostomia, and oral candidiasis. Medical history reveals HIV infection contracted through IV drug use 8 years ago. Current CD4 count is 180 cells/mm³. What is the PRIMARY reason for increased oral infections in this patient?",
      options: [
        "Direct toxic effects of injected drugs causing immediate tissue destruction and opportunistic infections",
        "Periodontal disease causes HIV infection; treating periodontal disease will cure the HIV",
        "Poor oral hygiene is the only factor; HIV status has no effect on oral infection susceptibility",
        "Immunosuppression from HIV infection making patient susceptible to oral candidiasis and other infections",
      ],
      correct: "D"
    },
    {
      id: 30736,
      question: "The dental office implements a policy requiring payment in advance from patients with documented substance use disorders. The office manager explains this reduces lost revenue from missed appointments. What is the PRIMARY ethical justification for this policy?",
      options: [
        "Advance payment provides incentive for appointment compliance given pattern of unreliability in this population",
        "Discrimination against substance use disorder patients is legally required to protect dental practices",
        "All patients with substance use disorders are financially irresponsible and will never pay bills",
        "Charging higher fees to substance abuse patients helps fund treatment for more deserving patients",
      ],
      correct: "A"
    },
    {
      id: 30737,
      question: "A 26-year-old patient admits to daily marijuana use. She states she read online that marijuana is \"completely safe medicine\" with \"no side effects\" and questions why the dental hygienist is concerned. What is the MOST accurate information about marijuana's health effects?",
      options: [
        "Marijuana has absolutely no negative health effects and is completely safe for all individuals including pregnant women",
        "Only synthetic marijuana (K2/Spice) has health risks; natural marijuana from cannabis plants is always safe",
        "Marijuana directly affects the brain impacting memory, learning, attention, and decision-making, especially in developing brains",
        "Marijuana's only health effect is increased appetite; there are no other physiological or psychological effects",
      ],
      correct: "C"
    },
    {
      id: 30738,
      question: "A dental hygienist suspects a 16-year-old patient is using inhalants based on \"glue-sniffer's rash\" around the mouth and erythematous oral mucosa. State law requires parental notification of medical conditions discovered during examination. What is the MOST appropriate action?",
      options: [
        "Maintain absolute confidentiality; never inform parents regardless of state law to preserve patient trust",
        "Report directly to police and child protective services before notifying parents of suspected drug use",
        "Confront the patient publicly in front of parents to shame them into stopping drug use immediately",
        "Inform parents of findings as required by state parental notification statutes for minors' health conditions",
      ],
      correct: "D"
    },
    {
      id: 30739,
      question: "A 33-year-old patient in recovery reports attending Narcotics Anonymous meetings and working with a sponsor. She explains the 12-step program emphasizes taking responsibility for past behaviors and making amends. What is the dental hygienist's role in supporting this patient's recovery?",
      options: [
        "Provide judgmental lectures about past drug use and require patient to apologize for previous missed appointments",
        "Support recovery efforts by offering encouragement, maintaining professional boundaries, and providing quality oral healthcare",
        "Assume complete responsibility for patient's oral health since recovering addicts cannot be trusted with self-care",
        "Require patient to bring sponsor to all appointments to ensure compliance with treatment recommendations",
      ],
      correct: "B"
    },
    {
      id: 30740,
      question: "A 41-year-old patient with history of benzodiazepine abuse requires oral surgery. The oral surgeon plans conscious sedation and asks about the patient's tolerance to sedative medications. What is the MOST important consideration regarding sedation for this patient?",
      options: [
        "Chronic benzodiazepine use creates tolerance to sedative effects; higher doses may be required for adequate sedation",
        "Benzodiazepine abusers have no tolerance; use pediatric doses to prevent oversedation complications",
        "All sedatives are permanently contraindicated in anyone with history of benzodiazepine use",
        "Benzodiazepine abuse causes reverse tolerance; any dose will cause fatal respiratory depression",
      ],
      correct: "A"
    },
    {
      id: 30741,
      question: "During new patient examination, a 29-year-old patient reports using \"bath salts\" (synthetic cathinones) purchased online. She presents with severe bruxism, xerostomia, and aggressive behavior during the appointment. What is the PRIMARY danger associated with synthetic drug use?",
      options: [
        "Synthetic drugs are government-regulated for purity and safety; they are safer than natural substances",
        "Only natural drugs cause health problems; synthetic laboratory-made drugs are always safe",
        "Synthetic drugs are completely legal everywhere with no health risks or potential for addiction",
        "Unregulated synthetic drugs have unknown potency and composition leading to unpredictable and dangerous effects",
      ],
      correct: "D"
    },
    {
      id: 30742,
      question: "A 52-year-old patient in alcohol recovery program reports attending rehabilitation for 90 days and participating in aftercare support groups. He expresses concern about relapse during stressful times. What is the MOST accurate information about relapse in substance use disorders?",
      options: [
        "Relapse never occurs in patients who complete formal treatment programs; recovery is permanent",
        "Any relapse means treatment failed completely; patient should not attempt recovery again",
        "Relapse is a return to heavy substance use; it is common and considered part of the chronic, cyclic nature of addiction",
        "Relapse only happens to people who were not serious about recovery during initial treatment",
      ],
      correct: "C"
    },
    {
      id: 30743,
      question: "A 24-year-old patient presents with bilateral parotid enlargement, severe tooth wear, and reports daily vomiting after meals. She denies substance use but admits to an eating disorder with purging behaviors. What is the connection between eating disorders and substance use disorders?",
      options: [
        "There is no connection; eating disorders and substance use disorders are completely unrelated conditions",
        "Eating disorders always cause substance use disorders; treating the eating disorder prevents drug addiction",
        "Substance use disorders always cause eating disorders; people use drugs to suppress appetite only",
        "Both disorders share similar underlying psychological factors including control issues, low self-esteem, and maladaptive coping",
      ],
      correct: "D"
    },
    {
      id: 30744,
      question: "A patient's medical history indicates he participates in a needle exchange program. He asks the dental hygienist to explain how this program relates to his oral healthcare needs. What is the PRIMARY purpose of needle exchange programs?",
      options: [
        "Reduce transmission of blood-borne diseases like HIV and hepatitis by providing sterile injection equipment",
        "Needle exchange programs have no health benefits and only enable continued drug use",
        "Needle exchange programs provide free drugs to addicts preventing them from seeking treatment",
        "These programs exist only to arrest drug users when they attempt to exchange contaminated needles",
      ],
      correct: "A"
    },
    {
      id: 30745,
      question: "A 47-year-old patient with chronic pain receives a prescription for oxycodone from his physician. He reports taking the medication exactly as prescribed but fears becoming addicted. What is the MOST important distinction between appropriate medical use and addiction?",
      options: [
        "Anyone who takes opioid medication for any reason is automatically addicted regardless of medical necessity",
        "Taking prescribed opioids can never lead to physical dependence, tolerance, or any addiction risk",
        "Doctors never prescribe addictive medications; only drugs obtained illegally can cause addiction",
        "Addiction is compulsive use despite adverse consequences; appropriate medical use follows prescribed regimen under medical supervision",
      ],
      correct: "D"
    },
    {
      id: 30746,
      question: "A 35-year-old patient reports smoking marijuana daily to manage anxiety instead of taking prescribed medication. Clinical examination reveals periodontal disease unusual for her age, cannabis stomatitis, and leukoedema of buccal mucosa. What oral health education is MOST important for this patient?",
      options: [
        "Chronic marijuana smoking increases risk of oral leukoplakia, oral cancer, candidiasis, and periodontal disease",
        "Marijuana smoking has no oral health effects; periodontal disease is caused only by bacteria",
        "Only tobacco smoking causes oral cancer; marijuana smoke is completely safe for oral tissues",
        "Cannabis prevents oral disease; increased disease indicates patient is not smoking enough marijuana",
      ],
      correct: "A"
    },
    {
      id: 30747,
      question: "A dental hygiene student learns that approximately 40.3 million Americans had a substance use disorder in 2020, and about half also experienced co-occurring mental illness. What is the MOST accurate statement about the relationship between SUDs and mental illness?",
      options: [
        "Substance use disorders always cause mental illness; eliminating drug use cures psychiatric conditions",
        "Mental illness always causes substance use disorders; treating psychiatric conditions prevents addiction",
        "Co-occurring disorders can exist together, but one condition does not necessarily cause the other",
        "There is no relationship between substance use disorders and mental illness; correlation is coincidental",
      ],
      correct: "C"
    },
    {
      id: 30748,
      question: "A 38-year-old patient in recovery asks about using nitrous oxide-oxygen sedation for dental anxiety. Her substance abuse counselor advised against it. What is the PRIMARY reason nitrous oxide may be contraindicated for patients in recovery?",
      options: [
        "Nitrous oxide has no psychoactive properties and poses absolutely no relapse risk for recovering patients",
        "Nitrous oxide is more dangerous than illicit drugs; all recovering patients die if exposed",
        "Insurance companies refuse to cover nitrous oxide for any patient with history of substance abuse",
        "Nitrous oxide is a mood-altering substance that may trigger relapse or interfere with recovery progress",
      ],
      correct: "D"
    },
    {
      id: 30749,
      question: "The dental office receives a subpoena requesting complete records for a patient being prosecuted for drug-related crimes. The patient has not provided written consent for record release. What is the MOST appropriate action?",
      options: [
        "Immediately comply with subpoena and send complete records including confidential substance abuse information to court",
        "Consult with legal counsel regarding proper response to subpoena while protecting patient confidentiality rights",
        "Refuse to comply with subpoena under any circumstances even if held in contempt of court",
        "Send records but remove all information about substance use to protect patient from prosecution",
      ],
      correct: "B"
    }
  ],
  "9. Eating Disorders (Case Study)": [
    {
      id: 30800,
      question: "A 20-year-old female patient, Linda, presents for dental hygiene care. The dental hygienist notices she has lost approximately 20 pounds since her appointment 2 months ago. Linda appears evasive when answering health history questions and becomes uncomfortable when asked about her weight loss. The hygienist suspects an eating disorder but hesitates to address it. What is the MOST appropriate action by the dental hygienist?",
      options: [
        "Avoid discussing the weight loss as it is a personal matter outside the scope of dental hygiene practice",
        "Document observations and directly ask about eating habits, weight loss causes, and potential eating disorder in a nonjudgmental manner",
        "Wait until the patient voluntarily discloses information about weight loss during future appointments",
        "Contact the patient's family members without consent to inquire about suspected eating disorder behaviors",
      ],
      correct: "B"
    },
    {
      id: 30801,
      question: "A 17-year-old patient, Jayden, is brought to an eating disorder clinic by their parents. After several team meetings, Jayden discloses they have been forcing themselves to vomit five times daily for the past 7 months and complains of sensitive teeth. The healthcare team recommends Jayden see their dental hygienist as part of the interprofessional treatment approach. What is the PRIMARY role of the dental hygienist in this interprofessional healthcare team?",
      options: [
        "Provide primary psychological counseling and cognitive behavioral therapy for the eating disorder diagnosis",
        "Manage oral health complications, prevent further damage, reinforce recovery messages, and inform team of oral conditions",
        "Prescribe psychiatric medications to address underlying mental health issues causing the eating disorder",
        "Develop meal plans and nutritional counseling to address dietary deficiencies and promote weight restoration",
      ],
      correct: "B"
    },
    {
      id: 30802,
      question: "A 22-year-old patient, Clare, tells her dental hygienist that during treatment for anorexia nervosa, she learned to call her disorder \"Annie\" to personify the illness. She explains this helped her separate her own identity from the eating disorder's controlling voice. What concept does this personification strategy represent in eating disorder treatment?",
      options: [
        "The eating disorder eclipses the person's thinking and identity; separating the disorder from self aids recovery",
        "Personification indicates severe psychosis requiring immediate psychiatric hospitalization and medication",
        "This strategy is contraindicated as it prevents patients from taking personal responsibility for their behaviors",
        "Naming the disorder shows the patient is not serious about recovery and is manipulating healthcare providers",
      ],
      correct: "A"
    },
    {
      id: 30803,
      question: "A 15-year-old male patient, Ben, presents with significant weight loss over several months. His mother reports he exercises excessively despite playing high school volleyball and swimming. She also noticed him tapping his teeth together, which concerns her about possible drug use to lose weight. What should the dental hygienist assess FIRST regarding this patient?",
      options: [
        "Immediately report suspected drug use to law enforcement before conducting any oral examination",
        "Assess for oral manifestations of both eating disorders and substance abuse, including tooth wear patterns and soft tissue changes",
        "Dismiss mother's concerns as teenage athletes naturally lose weight during competitive sports seasons",
        "Focus only on routine dental hygiene care without addressing weight loss or behavioral concerns",
      ],
      correct: "B"
    },
    {
      id: 30804,
      question: "A patient with bulimia nervosa presents with severe perimylolysis (enamel erosion) on the lingual surfaces of maxillary anterior teeth. The patient reports abstinence from purging for 2 weeks and wants immediate full-mouth reconstruction with veneers. What is the MOST appropriate recommendation regarding dental reconstruction?",
      options: [
        "Proceed immediately with veneers as patient motivation is high and teeth are severely damaged",
        "Coordinate timing of reconstruction with eating disorder treatment team; reconstruction during active illness may enable continued purging",
        "Refuse all dental treatment permanently as eating disorder patients will destroy any restorative work",
        "Complete reconstruction without consulting other healthcare providers as this is strictly a dental issue",
      ],
      correct: "B"
    },
    {
      id: 30805,
      question: "A 23-year-old patient, Amanda, discloses to her dental hygienist that she discovered she could vomit after eating to prevent weight gain. She reports doing this occasionally \"when feeling too full.\" The dental hygienist notices slight enamel erosion on her teeth. What is the MOST appropriate initial response by the dental hygienist?",
      options: [
        "Immediately diagnose the patient with bulimia nervosa and prescribe antidepressant medications",
        "Acknowledge the disclosure, ask if she has sought help for this behavior, and discuss oral health implications",
        "Ignore the disclosure and continue with routine prophylaxis without addressing the patient's statement",
        "Lecture the patient about the immorality of eating disorder behaviors and demand she stop immediately",
      ],
      correct: "B"
    },
    {
      id: 30806,
      question: "A patient presents with bilateral parotid gland enlargement giving the jaw an enlarged appearance. The patient expresses concern about the unesthetic appearance. Palpation reveals the enlargement is soft and generally painless. What information should the dental hygienist provide about this condition?",
      options: [
        "Parotid enlargement is permanent and will require surgical removal regardless of behavior changes",
        "The enlargement is noninflammatory and usually decreases when eating disorder behaviors are brought under control",
        "This finding is unrelated to eating disorders and indicates serious salivary gland cancer requiring immediate oncology referral",
        "Parotid enlargement only occurs with anorexia nervosa restricting type and never with bulimia nervosa",
      ],
      correct: "B"
    },
    {
      id: 30807,
      question: "During intraoral examination of a patient who orally purges, the dental hygienist observes calloused knuckles on the patient's hands, traumatic lesions on the hard palate, and ulcerations on the soft palate. What do these findings indicate?",
      options: [
        "These are normal variations requiring no documentation or follow-up discussion with the patient",
        "Repetitive friction from digital stimulation during purging and trauma from fingers or objects used to induce vomiting",
        "The patient engages in self-injurious cutting behaviors unrelated to any eating disorder activities",
        "Evidence of physical abuse by another person requiring mandatory reporting to law enforcement immediately",
      ],
      correct: "B"
    },
    {
      id: 30808,
      question: "A patient with anorexia nervosa, restricting type, presents wearing inappropriately warm clothing on a mild temperature day. The dental hygienist notices fine, downy hair (lanugo) on the lower half of the patient's face and reports feeling cold constantly. What do these physical findings represent?",
      options: [
        "Unrelated genetic conditions inherited from parents that have no connection to the eating disorder",
        "Advanced stage manifestations of starvation including hypothermia, lanugo growth, and cold sensitivity",
        "Early signs of eating disorder that typically appear within first week of food restriction",
        "Side effects of psychiatric medications used to treat underlying depression causing the eating disorder",
      ],
      correct: "B"
    },
    {
      id: 30809,
      question: "A patient with bulimia nervosa exhibits \"raised-island appearance\" of amalgam restorations surrounded by loss of enamel. The maxillary anterior teeth show translucent appearance with pitting on incisal surfaces. What oral condition is MOST consistent with these findings?",
      options: [
        "Normal tooth wear from aging requiring no intervention or preventive strategies",
        "Perimylolysis (enamel erosion) from repeated exposure to gastric acid during oral purging episodes",
        "Dental caries from high sugar diet requiring immediate restoration of all affected teeth",
        "Attrition from severe bruxism unrelated to eating disorder requiring occlusal guard fabrication",
      ],
      correct: "B"
    },
    {
      id: 30810,
      question: "A patient with eating disorder reports taking antidepressant medications as part of treatment. Clinical examination reveals xerostomia, increased dental biofilm, and multiple new carious lesions since last appointment 6 months ago. What is the MOST likely contributing factor to the increased caries rate?",
      options: [
        "Antidepressant medications causing xerostomia reduce protective salivary flow leading to increased caries risk",
        "All patients with eating disorders develop caries regardless of oral hygiene or salivary function",
        "The caries are caused directly by binge eating behaviors and unrelated to medication side effects",
        "Xerostomia is unrelated to medications; caries result only from poor oral hygiene compliance",
      ],
      correct: "A"
    },
    {
      id: 30811,
      question: "A 24-year-old patient presents with commissure lesions, dry chapped lips, and xerostomia. The dental hygienist suspects these findings may be related to an eating disorder. Which additional assessment is MOST important to differentiate eating disorder from other causes?",
      options: [
        "Automatically diagnose eating disorder without considering other potential causes of these oral manifestations",
        "Assess for dehydration from vomiting/laxative abuse, medication side effects, and recent illnesses causing similar symptoms",
        "Assume findings are normal variations requiring no further investigation or health history questions",
        "Immediately hospitalize patient for psychiatric evaluation based solely on these oral findings",
      ],
      correct: "B"
    },
    {
      id: 30812,
      question: "A dental hygienist notices a patient has enamel erosion. Before concluding it results from an eating disorder, the hygienist asks about dietary habits. The patient reports consuming 4-6 diet sodas daily and frequently sucking on sweet-and-sour candies. What does this case illustrate about differential diagnosis?",
      options: [
        "Enamel erosion always indicates eating disorder; dietary questions are unnecessary and waste appointment time",
        "Multiple causes for erosion exist including high citric acid intake and low pH beverages; thorough assessment prevents premature conclusions",
        "Diet has no relationship to enamel erosion; erosion only results from oral purging behaviors",
        "Sweet-and-sour candy consumption definitively rules out eating disorder as the cause of erosion",
      ],
      correct: "B"
    },
    {
      id: 30813,
      question: "A patient with diagnosed bulimia nervosa presents for dental hygiene care. The dental hygienist plans to use fluoride varnish application and provide home fluoride recommendations. What is the PRIMARY purpose of fluoride therapy for this patient?",
      options: [
        "Fluoride has no benefit for patients with eating disorders and should not be recommended",
        "Strengthen existing tooth structure, promote remineralization, and prevent further enamel erosion from acid exposure",
        "Fluoride completely reverses all existing enamel erosion restoring teeth to original condition immediately",
        "Substitute for psychological treatment; fluoride application eliminates need for eating disorder therapy",
      ],
      correct: "B"
    },
    {
      id: 30814,
      question: "A patient who purges orally asks the dental hygienist about ways to protect teeth. The hygienist wants to provide harm reduction strategies while the patient is in active treatment. What is the MOST appropriate harm reduction recommendation?",
      options: [
        "Brush teeth immediately after purging to remove all stomach acid from tooth surfaces",
        "Rinse immediately after purging with pH-neutralizing solution like sodium bicarbonate, then wait 30-40 minutes before brushing",
        "There are no effective strategies; patient must stop purging completely before any recommendations can help",
        "Use highly abrasive toothpaste with hard-bristle brush immediately after vomiting to remove acid",
      ],
      correct: "B"
    },
    {
      id: 30815,
      question: "A patient with anorexia nervosa diagnosis presents for dental hygiene care. The patient's BMI is 15.8 and vital signs show blood pressure 88/52, pulse 52 bpm, and body temperature 96.2°F. What do these vital signs indicate about this patient's condition?",
      options: [
        "Normal vital signs for young adults requiring no special considerations during dental hygiene treatment",
        "Cardiovascular compromise from malnutrition showing hypotension, bradycardia, and hypothermia requiring cautious treatment",
        "These vital signs indicate pregnancy; patient should be referred for prenatal care immediately",
        "Vital signs are within normal limits; proceed with routine scaling using ultrasonic instrumentation",
      ],
      correct: "B"
    },
    {
      id: 30816,
      question: "A patient with bulimia nervosa experiences severe dentinal hypersensitivity to cold and sweets. The patient states this sensitivity is the primary reason for seeking dental care. What is the MOST likely cause of the hypersensitivity?",
      options: [
        "Normal age-related gingival recession unrelated to eating disorder requiring no specific intervention",
        "Perimylolysis causing dentinal exposure with opened dentinal tubules resulting in sensitivity to stimuli",
        "Hypersensitivity is psychological manifestation of mental illness not actual physical dental condition",
        "Excessive fluoride exposure during childhood causing fluorosis and inherent sensitivity in all teeth",
      ],
      correct: "B"
    },
    {
      id: 30817,
      question: "During treatment planning for a patient with suspected eating disorder, the dental hygienist considers taking intraoral photographs, study models, and measuring teeth with dental erosion indices. What is the PRIMARY purpose of these diagnostic records?",
      options: [
        "Use photographs to shame patient into stopping eating disorder behaviors immediately",
        "Establish baseline documentation for objective comparison of progressive erosion at subsequent appointments",
        "These records have no clinical value and waste appointment time that should focus on prophylaxis",
        "Create evidence for legal proceedings if patient refuses to accept eating disorder diagnosis",
      ],
      correct: "B"
    },
    {
      id: 30818,
      question: "A patient discloses bulimia nervosa to the dental hygienist. The hygienist wants to refer the patient to appropriate treatment providers and establish interprofessional collaboration. What is the FIRST step in the referral process?",
      options: [
        "Report patient to authorities against patient's will without informed consent for disclosure",
        "Research credible local eating disorder treatment centers, offer referral information, and encourage patient to schedule evaluation",
        "Prescribe psychiatric medications directly without involving mental health professionals in treatment",
        "Refuse to provide any dental treatment until patient proves eating disorder is completely cured",
      ],
      correct: "B"
    },
    {
      id: 30819,
      question: "A patient signs a consent form allowing the dental hygienist to collaborate with the eating disorder treatment team. The patient's psychologist contacts the dental hygienist to discuss timing of extensive dental reconstruction. Why is this interprofessional communication important?",
      options: [
        "Interprofessional collaboration is illegal and violates patient confidentiality regardless of signed consent",
        "Coordination prevents dental failure if reconstruction occurs before adequate progress with eating disorder treatment is achieved",
        "Dentists and dental hygienists should make all decisions independently without input from mental health team",
        "Communication with eating disorder team has no impact on success of dental treatment outcomes",
      ],
      correct: "B"
    },
    {
      id: 30820,
      question: "The dental hygienist asks a patient with suspected eating disorder, \"Do you make yourself sick because you feel uncomfortably full?\" This is part of a screening questionnaire.",
      options: [
        "The SCOFF questionnaire designed to screen for eating disorders with questions about control and body image",
        "The CAGE questionnaire used exclusively for alcohol use disorder screening",
        "The PHQ-9 depression screening tool unrelated to eating disorders",
        "The Beck Anxiety Inventory focused only on anxiety symptoms",
      ],
      correct: "A"
    },
    {
      id: 30821,
      question: "A patient with anorexia nervosa reports amenorrhea (loss of menstrual periods) for 8 months. The patient also mentions frequent bone pain and recent stress fracture. What physiological consequence of anorexia nervosa do these findings suggest?",
      options: [
        "These are normal findings in all young women unrelated to nutritional status or eating disorders",
        "Hormonal abnormalities with decreased estrogen and body fat causing amenorrhea and decreased bone density (osteoporosis)",
        "The patient has undiagnosed pregnancy causing amenorrhea; bone pain is unrelated coincidence",
        "Amenorrhea results from excessive exercise only; nutritional restriction has no effect on menstruation",
      ],
      correct: "B"
    },
    {
      id: 30822,
      question: "A patient with bulimia nervosa complains of altered taste sensation. The patient reports food \"doesn't taste the same\" and has difficulty enjoying meals. What is the MOST likely explanation for this diminished taste acuity?",
      options: [
        "Psychological manifestation only; taste perception is normal but mental illness affects food enjoyment",
        "Malnutrition causing trace metal deficiency or hormonal abnormalities affecting taste and smell sensations",
        "Direct permanent damage to taste buds from stomach acid making recovery impossible",
        "Side effect of fluoride therapy recommended by dental hygienist for enamel protection",
      ],
      correct: "B"
    },
    {
      id: 30823,
      question: "A patient with eating disorder has extensive perimylolysis requiring dental rehabilitation. The dental hygienist plans to use rubber cup prophylaxis with prophy paste before impressions. What is the MOST appropriate modification to this treatment?",
      options: [
        "Use most abrasive pumice available to remove all stains regardless of tooth structure damage",
        "Avoid polishing or use minimally abrasive paste cautiously due to already eroded, weakened tooth structure",
        "Rubber cup prophylaxis is contraindicated for all patients and should never be performed",
        "Polish vigorously to strengthen weakened enamel through mechanical stimulation of remineralization",
      ],
      correct: "B"
    },
    {
      id: 30824,
      question: "A patient in recovery from bulimia nervosa experiences relapse after 6 months of abstinence from purging. The patient is ashamed and hesitant to inform the dental hygienist. What is the MOST appropriate response when patient discloses the relapse?",
      options: [
        "Express extreme disappointment and refuse to provide further care until patient achieves permanent abstinence",
        "Acknowledge relapse is common in recovery, provide support, recommend reconnecting with treatment team, and continue oral care",
        "Report the relapse to patient's employer and family members without patient consent",
        "Terminate dental hygiene relationship immediately as relapse indicates patient is unmotivated and hopeless",
      ],
      correct: "B"
    },
    {
      id: 30825,
      question: "A patient with anorexia nervosa shows subtle progressive enamel loss when current examination findings are compared with study models from 6 months ago. The patient reports eating disorder behaviors have been \"under control.\" What does this objective evidence suggest?",
      options: [
        "The study models are inaccurate; subtle changes in enamel are impossible to detect objectively",
        "Objective findings conflict with subjective report; progressive erosion suggests continued purging behavior despite patient's statement",
        "Enamel loss occurs naturally with aging; these findings have no relationship to eating disorder activity",
        "The patient is being completely honest; enamel erosion takes years to develop after purging stops",
      ],
      correct: "B"
    },
    {
      id: 30826,
      question: "A dental hygienist suspects a teenage patient has an eating disorder but feels uncomfortable discussing it. The patient is a long-time patient of the practice. What ethical responsibility does the dental hygienist have?",
      options: [
        "Avoid all discussion of suspected eating disorder to preserve the patient-provider relationship",
        "Professional responsibility as healthcare provider requires addressing concern and referring for evaluation despite discomfort",
        "Wait for patient to reach age 18 before addressing eating disorder concerns with the adult patient",
        "Ethical obligations only apply to dental issues; eating disorders are outside dental hygiene scope",
      ],
      correct: "B"
    },
    {
      id: 30827,
      question: "A patient presents with lanugo, dry skin and hair, hair loss, and amenorrhea. The patient reports feeling cold constantly despite warm environmental temperatures. These findings are MOST consistent with which eating disorder type?",
      options: [
        "Bulimia nervosa bingeing/purging type due to electrolyte imbalances from vomiting",
        "Anorexia nervosa restricting type showing advanced signs of starvation and malnutrition",
        "Binge eating disorder characterized by consumption of large amounts without purging",
        "Night eating syndrome with delayed circadian pattern of food consumption",
      ],
      correct: "B"
    },
    {
      id: 30828,
      question: "A patient with bulimia nervosa asks about using a custom-fabricated mouthguard to wear during vomiting episodes to protect teeth. What is the MOST appropriate response?",
      options: [
        "Immediately fabricate mouthguard as this completely prevents all tooth damage from stomach acid exposure",
        "Discuss that mouthguard use has no evidence of effectiveness; focus on harm reduction strategies like pH neutralization",
        "Mouthguards are dangerous and will cause patient to choke during vomiting episodes",
        "Providing mouthguard enables disorder; refuse all treatment until patient achieves complete recovery",
      ],
      correct: "B"
    },
    {
      id: 30829,
      question: "A patient with eating disorder takes ipecac syrup to induce vomiting. The dental hygienist learns about this practice during health history review. What is the MOST serious health risk associated with ipecac use?",
      options: [
        "Ipecac is completely safe with no health risks when used to induce vomiting",
        "Ipecac contains emetine which can destroy heart muscle fibers causing fatal myocardial dysfunction with chronic use",
        "The only concern is gastrointestinal upset; no serious systemic effects occur",
        "Ipecac damages only oral tissues causing tooth staining but has no other health effects",
      ],
      correct: "B"
    },
    {
      id: 30830,
      question: "A patient reports excessive use of laxatives and diuretics as part of eating disorder behaviors. Clinical examination reveals xerostomia and angular cheilitis-like lesions at commissures. What is the MOST likely cause of these oral findings?",
      options: [
        "Viral infection unrelated to eating disorder requiring antiviral medication prescription",
        "Dehydration from laxative and diuretic abuse leading to reduced salivary flow and dry oral environment",
        "Allergic reaction to toothpaste ingredients causing localized contact dermatitis",
        "Normal age-related changes in oral tissues occurring in all patients over age 25",
      ],
      correct: "B"
    },
    {
      id: 30831,
      question: "A patient with anorexia nervosa presents with leukopenia (low white blood cell count) documented by recent medical laboratory results. What is the PRIMARY clinical concern regarding this finding for dental hygiene care?",
      options: [
        "Leukopenia has no impact on dental hygiene treatment; proceed with routine aggressive scaling",
        "Immunosuppression from leukopenia increases infection risk; consider antibiotic premedication and cautious treatment approach",
        "Cancel all dental appointments permanently as dental treatment is impossible with any blood abnormality",
        "Leukopenia only affects medical care; oral healthcare is completely unrelated to immune system function",
      ],
      correct: "B"
    },
    {
      id: 30832,
      question: "During oral health education, a patient with bulimia nervosa asks why she should wait 30-40 minutes after vomiting before brushing teeth. What is the correct explanation?",
      options: [
        "Waiting period allows stomach acid to strengthen enamel through prolonged contact before brushing",
        "Tooth surface is softened by acid exposure; immediate brushing causes mechanical abrasion of already chemically eroded enamel",
        "There is no scientific reason for waiting; patient should brush immediately after every purging episode",
        "The 30-40 minute wait allows stomach acid to completely evaporate from tooth surfaces",
      ],
      correct: "B"
    },
    {
      id: 30833,
      question: "A patient with eating disorder has multiple comorbid conditions including major depression, anxiety disorder, and self-injurious behavior (cutting). The patient presents with unexplained bruising and healing cuts on arms. What does this presentation indicate about eating disorder complexity?",
      options: [
        "Eating disorders exist in isolation with no relationship to other mental health conditions",
        "Eating disorders commonly have comorbid associations with other psychiatric conditions requiring comprehensive assessment",
        "Self-injurious behavior rules out eating disorder; patients cannot have both conditions simultaneously",
        "Comorbid conditions are rare and should not be considered during eating disorder treatment",
      ],
      correct: "B"
    },
    {
      id: 30834,
      question: "A patient asks the dental hygienist about the crude mortality rate associated with eating disorders. The patient has been diagnosed with anorexia nervosa. What information should the dental hygienist provide about anorexia nervosa mortality?",
      options: [
        "Anorexia nervosa has no mortality risk; patients always recover completely without medical intervention",
        "Anorexia nervosa has crude mortality rate of approximately 5% per decade; early intervention is critical",
        "The mortality rate is 50% within first year of diagnosis making treatment futile",
        "Mortality only occurs with bulimia nervosa; anorexia nervosa patients do not die from the disorder",
      ],
      correct: "B"
    },
    {
      id: 30835,
      question: "A patient with bulimia nervosa reports bingeing on large amounts of cookies, cake, and candy followed by purging. The patient has multiple carious lesions. What is the MOST likely contributing factor to the increased caries rate?",
      options: [
        "Caries are unrelated to eating behaviors; all tooth decay results from inadequate fluoride exposure",
        "Repeated binge eating of simple carbohydrates combined with xerostomia and frequent sucrose intake increases caries risk",
        "Purging behavior prevents caries by removing sugar from oral cavity immediately after consumption",
        "Eating disorder patients never develop caries regardless of dietary habits or oral hygiene",
      ],
      correct: "B"
    },
    {
      id: 30836,
      question: "A patient with eating disorder exhibits evidence of malnutrition. The dental hygienist notes generalized marginal gingivitis with bleeding on probing. What is the relationship between malnutrition and periodontal disease in this patient?",
      options: [
        "Malnutrition has no effect on periodontal health; gingivitis results only from biofilm accumulation",
        "Nutritional deprivation increases periodontal disease risk as body cannot properly maintain tissues; immune function is compromised",
        "Malnutrition prevents periodontal disease by reducing inflammatory response in gingival tissues",
        "Eating disorders cause periodontal disease through direct bacterial transmission from stomach during vomiting",
      ],
      correct: "B"
    },
    {
      id: 30837,
      question: "A patient with anorexia nervosa appears very thin with BMI of 14.5. The patient reports normal eating habits and denies any problem. The patient's family expresses concern. What does this patient response demonstrate?",
      options: [
        "The patient is being completely honest; family members are overreacting to normal body weight",
        "Denial and lack of recognition of health challenges related to restrictions is diagnostic criterion for anorexia nervosa",
        "If patient reports normal eating, the dental hygienist must accept this without further assessment",
        "Patient dishonesty indicates moral failure rather than symptom of mental illness affecting perception",
      ],
      correct: "B"
    },
    {
      id: 30838,
      question: "A patient recovering from bulimia nervosa asks about dietary recommendations to support oral health during recovery. What is the MOST appropriate dietary education for this patient?",
      options: [
        "Recommend continued binge eating on high-sugar foods as this supports weight restoration goals",
        "Educate about effects of frequent sucrose intake and low-pH beverages on erosion; encourage balanced diet with eating disorder dietitian",
        "Instruct patient to avoid all food consumption to prevent further oral health deterioration",
        "Dietary counseling is outside dental hygiene scope; refuse to discuss nutrition with eating disorder patients",
      ],
      correct: "B"
    },
    {
      id: 30839,
      question: "A patient with eating disorder uses excessive amounts of sports drinks and carbonated diet beverages throughout the day. The patient has generalized enamel erosion. What is the concern with these beverage choices?",
      options: [
        "Sports drinks and diet sodas have neutral pH and strengthen enamel through mineral content",
        "Continual consumption of low-pH beverages combined with diminished salivary flow enhances dental erosion and sensitivity",
        "Beverage choice has no relationship to dental erosion; erosion only results from oral purging",
        "Sports drinks prevent dental erosion by providing electrolytes that remineralize enamel surfaces",
      ],
      correct: "B"
    },
    {
      id: 30840,
      question: "A patient presents with open bite deformity and severe loss of vertical dimension on anterior teeth. The patient has long history of bulimia nervosa with oral purging. What is the MOST likely cause of these findings?",
      options: [
        "Normal occlusal development unrelated to eating disorder; open bite is genetic trait only",
        "Progressive perimylolysis causing vertical height loss of anterior teeth from repeated acid exposure during purging",
        "Orthodontic treatment during childhood caused permanent open bite unrelated to current condition",
        "Open bite develops from excessive fluoride therapy recommended by previous dental providers",
      ],
      correct: "B"
    },
    {
      id: 30841,
      question: "A patient with bulimia nervosa asks why salivary flow rate and pH testing might be beneficial during dental hygiene appointments. What is the PRIMARY value of salivary testing for this patient?",
      options: [
        "Salivary testing has no clinical value and wastes appointment time and resources",
        "Helps understand salivary differences (flow rate, pH, composition) related to eating disorder and identify active illness periods",
        "Salivary testing definitively diagnoses eating disorders eliminating need for psychological evaluation",
        "Testing is only done to satisfy insurance requirements and has no clinical application",
      ],
      correct: "B"
    },
    {
      id: 30842,
      question: "A dental hygienist observes a patient has evidence of perimylolysis. Before making conclusions about causation, the hygienist asks about gastroesophageal reflux disease (GERD), medications, and recent illnesses. What does this approach demonstrate?",
      options: [
        "Complete waste of time as perimylolysis only results from eating disorder behaviors",
        "Thorough differential diagnosis considering multiple potential causes before drawing conclusions about eating disorder",
        "The hygienist lacks confidence and should immediately diagnose eating disorder without additional questions",
        "These questions are inappropriate invasion of privacy; only ask about oral hygiene habits",
      ],
      correct: "B"
    },
    {
      id: 30843,
      question: "A patient with eating disorder reports recent period of excessive binge eating and purging behaviors. Gingival tissues appear red, edematous, and bleed easily. The patient admits poor oral hygiene compliance. What factors contribute to this periodontal condition?",
      options: [
        "Periodontal disease results only from bacteria; eating disorder behaviors have no effect on tissues",
        "Depression combined with eating disorder may cause oral hygiene apathy; xerostomia exacerbates biofilm growth",
        "Gingival inflammation only occurs with gingivitis; eating disorders do not affect periodontal status",
        "Red gingival tissues are normal healthy appearance; no intervention or assessment needed",
      ],
      correct: "B"
    },
    {
      id: 30844,
      question: "A parent brings 14-year-old daughter for dental hygiene appointment. The hygienist notices significant weight loss and suspects eating disorder but is concerned about confidentiality and parental notification laws. What is the MOST appropriate action regarding confidentiality?",
      options: [
        "Never inform parents under any circumstances even if state law requires notification",
        "Know state parental notification statutes for minors; inform parents of health findings as required by law",
        "Ignore signs of eating disorder completely to avoid any confidentiality concerns",
        "Post patient's private health information on social media to warn others about eating disorders",
      ],
      correct: "B"
    },
    {
      id: 30845,
      question: "A patient with diagnosed bulimia nervosa is prescribed fluoxetine (Prozac) by their psychiatrist. The patient asks the dental hygienist about this medication. What is the PRIMARY purpose of this medication in eating disorder treatment?",
      options: [
        "Fluoxetine is antibiotic prescribed for oral infections caused by purging behaviors",
        "Antidepressant medication to address comorbid depression; medication alone rarely treats eating disorder effectively",
        "This medication completely cures bulimia nervosa eliminating need for any psychological therapy",
        "Fluoxetine is antifungal prescribed for oral candidiasis associated with immunosuppression",
      ],
      correct: "B"
    },
    {
      id: 30846,
      question: "A patient recovering from anorexia nervosa asks about incorporating exercise back into daily routine. The patient has achieved healthy weight and is progressing in treatment. What role does the physical education therapist play in eating disorder treatment?",
      options: [
        "Exercise should be completely prohibited permanently for all eating disorder patients",
        "After healthy weight restoration, therapist helps establish healthy approach to physical fitness avoiding overexercise patterns",
        "Patients should exercise excessively to burn calories as primary treatment for eating disorders",
        "Physical education therapy is unnecessary; patients can resume unlimited exercise immediately",
      ],
      correct: "B"
    },
    {
      id: 30847,
      question: "A patient presents with clinical signs suggesting eating disorder but repeatedly denies any problem. The patient avoids eye contact when discussing weight and eating habits. What do these nonverbal cues indicate?",
      options: [
        "Avoidance of eye contact proves patient is being completely truthful about not having disorder",
        "Nonverbal discomfort often indicates clinician is asking relevant questions despite patient's verbal denial",
        "Lack of eye contact is culturally normal for all patients and should be ignored completely",
        "These cues indicate patient is fabricating eating disorder for attention; dismiss all concerns",
      ],
      correct: "B"
    },
    {
      id: 30848,
      question: "A patient with eating disorder completed extensive dental reconstruction 1 year ago. Current examination reveals new enamel erosion on recently placed restorations. What does this finding indicate about tertiary prevention?",
      options: [
        "Dental reconstruction is pointless; never provide restorative care to eating disorder patients",
        "Continued eating disorder behaviors during recovery destroy reconstructed dentition; illustrates importance of continued treatment",
        "New erosion is impossible on restored teeth; these findings represent faulty documentation only",
        "Reconstruction prevents all future erosion; new findings must result from different causative factors",
      ],
      correct: "B"
    },
    {
      id: 30849,
      question: "A patient with eating disorder asks about resources for additional support and information. The dental hygienist wants to provide credible, evidence-based resources. What is the MOST appropriate resource recommendation?",
      options: [
        "Suggest patient research eating disorders independently online without guidance on credible sources",
        "Provide information about credible organizations like National Eating Disorders Association (NEDA), NEDIC, and local treatment centers",
        "Tell patient that no legitimate resources exist; eating disorder treatment is ineffective waste of time",
        "Recommend patient avoid all professional help and handle eating disorder independently",
      ],
      correct: "B"
    }
  ],
};
